webpackJsonp([0],{

/***/ "+1lI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Contracts")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Contracts To All")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("  Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Contracts To All")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-success btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Contract")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"contractFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileContractsUpload}}),_vm._v(" "),_vm._l((_vm.contractFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                           "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                     "),_c('span',{on:{"click":function($event){_vm.removeContractFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-success btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-contracts', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Contract")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Ayq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Huq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+KMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('position')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+S+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_notification_config__ = __webpack_require__("aYbs");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        notificationConfig: __WEBPACK_IMPORTED_MODULE_0__todo_notification_config__["a" /* default */]
    }
});

/***/ }),

/***/ "+baM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+f2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('h3',{staticClass:"card-title"},[_vm._v("Designations ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Designations")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.add-new-item",modifiers:{"add-new-item":true}}],staticClass:"btn  btn-primary float-right"},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" New Designation")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped"},[_c('tbody',_vm._l((_vm.positionData),function(item){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-positions",modifiers:{"update-positions":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"link-default-positions",attrs:{"href":"#","title":"click to update designation item and position name"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v(_vm._s(_vm._f("capitalize")(item.pos_name)))])]),_vm._v(" "),_c('br'),_c('i',[_vm._v(_vm._s(_vm._f("capitalize")(item.dep_name)))])]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(item.created_at)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(item.updated_at)}}),_vm._v(" "),_c('td',[_c('h4',[_c('i',{staticClass:"fa fa-user"}),_vm._v("  Employees "),_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v(_vm._s(item.emp))])])])]],2)}),0)]),_vm._v(" "),_c('b-modal',{ref:"add-new-positions",attrs:{"id":"add-new-item","size":"l","title":"Add New Position","hide-footer":""}},[_c('h3',[_vm._v("Job Position")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Deparment Name:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.department_id),expression:"department_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.department_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("-- Select Department --")]),_vm._v(" "),_vm._l((_vm.department_items),function(dep){return _c('option',{domProps:{"value":dep.dep_id}},[_vm._v(_vm._s(dep.department))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Position Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position_name),expression:"position_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.position_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.add_pos_name}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit form")])])]),_vm._v(" "),_c('b-modal',{ref:"hide-positions",attrs:{"id":"update-positions","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v("Job Position")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Deparment Name:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.dep_id),expression:"selected_user.dep_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_user, "dep_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.department_items),function(dep){return _c('option',{domProps:{"value":dep.dep_id}},[_vm._v(_vm._s(dep.department))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Position Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.pos_name),expression:"selected_user.pos_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.pos_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "pos_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_positions}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],1),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+me+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_vue__ = __webpack_require__("qMc5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d99643e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_vue__ = __webpack_require__("uAM/");
function injectStyle (ssrContext) {
  __webpack_require__("MsHV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d99643e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+qne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_undertime_request_vue__ = __webpack_require__("jZ97");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4a18f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_undertime_request_vue__ = __webpack_require__("SqAx");
function injectStyle (ssrContext) {
  __webpack_require__("f3UM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_undertime_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4a18f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_undertime_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/+7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_dependents_vue__ = __webpack_require__("Wdxi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2132e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_dependents_vue__ = __webpack_require__("bSUm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_dependents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2132e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_dependents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5S6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/PbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_notification_config_vue__ = __webpack_require__("+S+Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e7daf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_notification_config_vue__ = __webpack_require__("kCpJ");
function injectStyle (ssrContext) {
  __webpack_require__("WxFy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_notification_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e7daf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_notification_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/S0l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      //ITEMS
      item: [],
      notice_for_decision: ''
    };
  },


  mounted: function mounted() {
    this.getItem();
  },

  methods: {
    printPreview: function printPreview() {

      var newstr = document.getElementById('printme').innerHTML;
      document.body.innerHTML = newstr;
      var oldstr = document.body.innerHTML;
      window.close();
      window.focus();
      window.print();
      document.body.innerHTML = oldstr;
      window.location.reload();
    },
    getItem: function getItem() {
      var _this = this;

      axios.get('api/nterequestbyhr/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
      });
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      // alert(this.item.id);
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to submit this request',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/notice/for/decision/' + _this2.item.id, {
            id: _this2.item.id,
            notice_for_decision: _this2.notice_for_decision
          }).then(function (resp) {
            _this2.$swal('Success', 'You successfully submitted this request.', 'success');
            _this2.$router.push({
              name: 'nte-request'
            });
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this2.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  }

});

/***/ }),

/***/ "/bX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_all_vue__ = __webpack_require__("ZmR1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce70ea9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_all_vue__ = __webpack_require__("VioB");
function injectStyle (ssrContext) {
  __webpack_require__("r6O+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce70ea9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/dp2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/e6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/rJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_contracts_vue__ = __webpack_require__("dlC8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967a91c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_contracts_vue__ = __webpack_require__("wW7i");
function injectStyle (ssrContext) {
  __webpack_require__("aHtN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_contracts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967a91c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_contracts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/uT+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0093":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      dependent_item: [],
      loading: true,
      //filter
      filter_by_position: '',
      filter_by_status: '',
      search: '',
      order_by: '',
      page_limit: '',
      start_page: 1,
      sortAsc: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      //Indicator
      display_indicator: ''
    };
  },


  mounted: function mounted() {
    this.get_employees();
  },

  methods: {
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/dependents').then(function (response) {
        _this.dependent_item = response.data;
        _this.display_indicator = 2;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    deleteItem: function deleteItem(id, index) {
      var _this2 = this;

      /* USING SWEET ALERT */

      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/dependents/delete/' + id).then(function (response) {
            _this2.dependent_item.splice(index, 1); //--> reloader 
            _this2.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response);
            _this2.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    }
  },
  computed: {
    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.dependent_item.length;
    },
    computedEmployee: function computedEmployee() {
      var _this3 = this;

      var filtered = this.dependent_item;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this3.order_by : -_this3.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }
});

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae54d5b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("sRSZ");
function injectStyle (ssrContext) {
  __webpack_require__("Iud5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae54d5b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0K9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_va_nz_au__ = __webpack_require__("7Bkh");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosVaNzAu: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_va_nz_au__["a" /* default */]
    }
});

/***/ }),

/***/ "0Qgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Usk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      reason: false,
      reason_to_declined: ''
    };
  },

  created: function created() {
    this.getItem();
  },
  methods: {
    reasonRejected: function reasonRejected() {
      if (this.item.hr_status == 'rejected') {
        this.reason = true;
      } else {
        this.reason = false;
      }
    },
    getItem: function getItem() {
      var _this = this;

      axios.get('api/undertimerequest/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
      });
    },
    update_form: function update_form(e) {
      var _this2 = this;

      e.preventDefault();
      axios.post('api/undertime/approval/' + this.item.id, {
        hr_status: this.item.hr_status,
        hr_reason_to_declined: this.reason_to_declined,
        hr_date_approved: new Date()
      }).then(function (response) {
        _this2.$swal({
          type: 'success',
          title: 'Updated',
          html: 'Undertime request has been <br/> successfully  updated.<br/><br/><br/><br/>',
          showConfirmButton: false,
          timer: 2000
        });

        _this2.$router.push({
          name: 'undertime-request'
        });
        console.log(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "0WJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-collections')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0WW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_settings__ = __webpack_require__("SncP");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SystemSettings: __WEBPACK_IMPORTED_MODULE_0__todo_settings__["a" /* default */]
    }
});

/***/ }),

/***/ "0bmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dependents-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0lgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-va-nz-au')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1/Wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Adjustment Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Adjustment Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Employee Name")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id },on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.selected_employee]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Employee Adjustment Request")]),_vm._v(" "),_c('div',{staticClass:"border-box-adjustment"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_filled),expression:"date_filled"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_filled },attrs:{"type":"date"},domProps:{"value":(_vm.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_filled=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_filled)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_filled[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Of Request:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_of_request),expression:"date_of_request"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_of_request },attrs:{"type":"date"},domProps:{"value":(_vm.date_of_request)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_of_request=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_of_request)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_of_request[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Current Shift:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sched_item.time),expression:"sched_item.time"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.current_shift },attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.sched_item.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sched_item, "time", $event.target.value)}}}),_vm._v(" "),(_vm.error_handler.current_shift)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.current_shift[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Requested Shift:")]),_vm._v(" "),(_vm.error_handler.requested_shift)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.requested_shift[0]))]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requested_shift),expression:"requested_shift"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.requested_shift },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.requested_shift=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"9PM - 6AM"}},[_vm._v("9PM - 6AM")]),_vm._v(" "),_c('option',{attrs:{"value":"10PM - 7AM"}},[_vm._v("10PM - 7AM")]),_vm._v(" "),_c('option',{attrs:{"value":"11PM - 8AM"}},[_vm._v("11PM - 8AM")]),_vm._v(" "),_c('option',{attrs:{"value":"12PM - 9AM"}},[_vm._v("12PM - 9AM")]),_vm._v(" "),_c('option',{attrs:{"value":"1PM - 10AM"}},[_vm._v("1PM - 10AM")]),_vm._v(" "),_c('option',{attrs:{"value":"2PM - 11AM"}},[_vm._v("2PM - 11AM")]),_vm._v(" "),_c('option',{attrs:{"value":"6AM - 3PM"}},[_vm._v("6AM - 3PM")]),_vm._v(" "),_c('option',{attrs:{"value":"7AM - 4PM"}},[_vm._v("7AM - 4PM")]),_vm._v(" "),_c('option',{attrs:{"value":"8AM - 5PM"}},[_vm._v("8AM - 6PM")]),_vm._v(" "),_c('option',{attrs:{"value":"9AM - 7PM"}},[_vm._v("9AM - 7PM")]),_vm._v(" "),_c('option',{attrs:{"value":"10AM - 8PM"}},[_vm._v("10AM - 8PM")]),_vm._v(" "),_c('option',{attrs:{"value":"3PM - 12PM"}},[_vm._v("3PM - 12PM")]),_vm._v(" "),_c('option',{attrs:{"value":"4PM - 1AM"}},[_vm._v("4PM - 1AM")])]),_vm._v(" "),(_vm.error_handler.requested_shift)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.requested_shift[0]))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reason for Change")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason_for_change),expression:"reason_for_change"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.reason_for_change },attrs:{"rows":"8"},domProps:{"value":(_vm.reason_for_change)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason_for_change=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.reason_for_change)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.reason_for_change[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Approval Status")]),_vm._v(" "),_c('div',{staticClass:"border-box-adjustment"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_status),expression:"tl_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tl_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.tl_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_status),expression:"asm_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.asm_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.asm_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_status),expression:"hr_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.hr_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.hr_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_status[0]))]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_date_approved),expression:"tl_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.tl_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tl_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.tl_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_date_approved),expression:"asm_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.asm_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.asm_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_date_approved),expression:"hr_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.hr_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hr_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hr_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_date_approved[0]))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "11xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Tu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      department_name: "",
      functionality: "",
      selected_item: "",
      loading: true,
      display_indicator: ""
    };
  },


  mounted: function mounted() {
    this.get_departments();
  },

  methods: {
    get_departments: function get_departments() {
      var _this = this;

      axios.get("api/departments").then(function (response) {
        _this.items = response.data;
        _this.display_indicator = 2;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    add_departments: function add_departments() {
      var _this2 = this;

      axios.post("api/departments/add", {
        department_name: this.department_name,
        functionality: this.functionality
      }).then(function (resp) {
        if (resp.data.response == "success") {
          _this2.$swal({
            type: "success",
            title: "Save",
            text: resp.data.message,
            showConfirmButton: true,
            timer: 2000
          });
          _this2.department_name = "";
          _this2.get_departments();
          _this2.$refs["add-new-department"].hide();
        } else if (resp.data.response == "error") {
          _this2.$swal({
            type: "error",
            title: "Error",
            text: resp.data.message,
            showConfirmButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_selected_id: function get_selected_id(item) {
      this.selected_item = item;
    },
    update_departments: function update_departments() {
      var _this3 = this;

      axios.post("api/departments/update/" + this.selected_item.dep_id, {
        department_name: this.selected_item.department,
        functionality: this.selected_item.functionality
      }).then(function (response) {
        _this3.$swal({
          type: "success",
          title: "Save",
          text: "You successfully save",
          showConfirmButton: true,
          timer: 2000
        });
        _this3.department_name = "";
        _this3.get_departments();
        _this3.$refs["hide-department"].hide();
        console.log(response.data);
      }).catch(function (e) {
        console.log(e.response);
      });
    }
  },
  computed: {
    departmentItem: function departmentItem() {
      var filterd = this.items;
      if (filterd.length > 0) {
        filterd.slice().reverse();
      }
      return filterd;
    }
  }

});

/***/ }),

/***/ "1X3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_account_user__ = __webpack_require__("6hmn");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        accountUser: __WEBPACK_IMPORTED_MODULE_0__todo_account_user__["a" /* default */]
    }
});

/***/ }),

/***/ "1bGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v("HRIS - (Human Resource Information System)")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler navbar-toggler-right",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button","aria-controls":"navigation-index","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/logout"}},[_vm._v("\n            Logout\n          ")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('i',{staticClass:"nc-icon nc-palette"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_vm._v("\n           Hello!"),_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("HR Admin")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1cAu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1dTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Undertime Request")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Undertime Request")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":"/hr/undertimeform"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Encode Undertime Manually")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Date Filled")]),_vm._v(" "),_c('th',[_vm._v("Date of Undertime")]),_vm._v(" "),_c('th',[_vm._v("Hours")]),_vm._v(" "),_c('th',[_vm._v("Purpose")]),_vm._v(" "),_c('th',[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.position_name))])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v(" "+_vm._s(_vm.getDate(item.date_filled)))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v(" "+_vm._s(_vm.getDate(item.date_of_undertime)))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-pill badge-info"},[_vm._v(_vm._s(item.total_hours))])]),_vm._v(" "),_c('td',[(item.purpose.length < 30)?[_vm._v(_vm._s(item.purpose))]:_vm._e(),_vm._v(" "),(item.purpose.length >= 30)?[_vm._v(_vm._s(item.purpose.substring(0,30)+"..."))]:_vm._e()],2),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('button',{staticClass:"pending"},[_vm._v("Pending")])]):(item.hr_status === 'approved')?_c('span',[_c('button',{staticClass:"approved "},[_vm._v("Approved")])]):(item.hr_status === 'rejected')?_c('span',[_c('button',{staticClass:"rejected"},[_vm._v("Rejected")])]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"width":"165"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"to":{name: 'edit-undertime-request-form', params: { id: item.id }},"title":"click to view details and modify records"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"title":"Delete Entry"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('li',{staticClass:"fa fa-trash-o"}),_vm._v(" Delete")])],1)])}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "225H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/users"}},[_vm._v("Users")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/groupaccess"}},[_vm._v("Staff Level")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/supervisoraccess"}},[_vm._v("Supervisory Level")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/assistantmanager"}},[_vm._v("Managerial Level")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":'accountuser'}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  Create New Account")])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "24Ms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('h3',{staticClass:"card-title"},[_vm._v("Departments")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Departments")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"subdepartment"}},[_vm._v(" Sub Departments")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.add-new-item",modifiers:{"add-new-item":true}}],staticClass:"btn btn-primary float-right"},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Departments")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('tbody',_vm._l((_vm.departmentItem),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-deparment",modifiers:{"update-deparment":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"link-default-departments",attrs:{"href":"#","title":"click to update department item and functionality"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v(_vm._s(_vm._f("capitalize")(item.department)))])]),_vm._v(" "),_c('p',[_c('i',[_vm._v(_vm._s(_vm._f("capitalize")(item.functionality)))])])]),_vm._v(" "),_c('td',[_c('h4',[_c('i',{staticClass:"fa fa-address-card-o"}),_vm._v("  Designations  "),_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v(_vm._s(item.disignations))])])]),_vm._v(" "),_c('td',[_c('h4',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Employees "),_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v(_vm._s(item.employee))])])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"add-new-department",attrs:{"id":"add-new-item","size":"l","title":"New Department","hide-footer":""}},[_c('h3',[_vm._v("Department")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Deparment Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.department_name),expression:"department_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.department_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.department_name=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Functionality:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.functionality),expression:"functionality"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.functionality)},on:{"input":function($event){if($event.target.composing){ return; }_vm.functionality=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.add_departments}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit form")])])]),_vm._v(" "),_c('b-modal',{ref:"hide-department",attrs:{"id":"update-deparment","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v("Department")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Deparment Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.department),expression:"selected_item.department"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.department)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "department", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Functionality:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.functionality),expression:"selected_item.functionality"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.selected_item.functionality)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "functionality", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_departments}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "24TF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },

   data: function data() {
      return {
         department_items: [],
         position_items: [],
         department_id: '',
         position_name: '',
         selected_user: '',
         loading: true,
         //Indicator
         display_indicator: ''
      };
   },


   mounted: function mounted() {
      this.get_departments();
      this.get_positions();
   },

   methods: {
      get_positions: function get_positions() {
         var _this = this;

         axios.get('api/positions').then(function (response) {
            _this.position_items = response.data;
            _this.display_indicator = 2;
            _this.loading = false;
         }).catch(function (error) {
            console.log(error);
            _this.display_indicator = 1;
         });
      },
      get_departments: function get_departments() {
         var _this2 = this;

         axios.get('api/departments').then(function (response) {
            _this2.department_items = response.data;
         }).catch(function (error) {
            console.log(error);
         });
      },
      add_pos_name: function add_pos_name() {
         var _this3 = this;

         axios.post('api/positions/add', {
            position_name: this.position_name,
            department_id: this.department_id
         }).then(function (response) {
            _this3.$swal({
               type: 'success',
               title: 'Save',
               text: 'You successfully save',
               showConfirmButton: false,
               timer: 2000
            });
            //this.pos_name = ''
            _this3.get_positions();
            _this3.$refs['add-new-positions'].hide();
            console.log(response);
         }).catch(function (error) {
            console.log(error);
         });
      },
      get_selected_id: function get_selected_id(pos) {
         this.selected_user = pos;
      },
      update_positions: function update_positions() {
         var _this4 = this;

         axios.post('api/positions/update/' + this.selected_user.pos_id, {
            position_name: this.selected_user.pos_name,
            department_id: this.selected_user.dep_id
         }).then(function (response) {
            _this4.$swal({
               type: 'success',
               title: 'Save',
               text: 'You successfully save',
               showConfirmButton: false,
               timer: 2000
            });
            _this4.pos_name = '';
            _this4.get_positions();
            _this4.$refs['hide-positions'].hide();
            console.log(response);
         }).catch(function (error) {
            console.log(error);
         });
      }
   },

   computed: {
      positionData: function positionData() {
         var filterd = this.position_items;
         if (filterd.length > 0) {
            filterd.slice().reverse();
         }
         return filterd;
      }
   }

});

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
    Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
  }
});

/***/ }),

/***/ "2N99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-cd-pq')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2NP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_collections_vue__ = __webpack_require__("Jf0Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee38933c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_collections_vue__ = __webpack_require__("0WJW");
function injectStyle (ssrContext) {
  __webpack_require__("+baM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_collections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee38933c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_collections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2NdQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2UL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Manager Access")])]),_vm._v(" "),_c('breadcrumb-menu'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20"}},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"500"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('td',[(item.belong == null)?_vm._t("default",[_vm._v("No team supervisor")]):_vm._t("default",[_vm._v("\n                          Has"),_c('i',{staticClass:"fa fa-long-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v("\n                                "+_vm._s(item.belong)+"  \n                            ")]),_vm._v(" "),_c('b',[_vm._v(" Team Supervisor ")])])],2),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-subordinate",modifiers:{"update-subordinate":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_empId(item)}}},[_c('u',[_vm._v("Subordinates")])])]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-user-account",modifiers:{"update-user-account":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v("Change Access")])])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-user-modal",attrs:{"id":"update-user-account","size":"l","hide-footer":""},on:{"hide":_vm.modalClose}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_item.full_name)))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Account Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.options),expression:"options"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.options=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_subtitute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("ADMIN STAFF")]),_vm._v(" "),_c('option',{attrs:{"value":"staff"}},[_vm._v("OFFICE STAFF")])])]),_vm._v(" "),(_vm.subtitute_item == true)?_vm._t("default",[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Manager to Subtitute")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sup_subtitute_id),expression:"sup_subtitute_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sup_subtitute_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_vm._l((_vm.managers),function(mag){return _c('option',{domProps:{"value":mag.id}},[_vm._v(_vm._s(_vm._f("capitalize")(mag.full_name))+" - "+_vm._s(mag.position_name))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.supervisor_choosen == true)?_vm._t("default",[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Employee Supervisor")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sup_choosen_id),expression:"sup_choosen_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sup_choosen_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(sup.position_name))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_user}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('b-modal',{ref:"hide-subordinate-modal",attrs:{"id":"update-subordinate","size":"l","hide-footer":""},on:{"hide":_vm.modalClose}},[_c('h1',[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.subordinate_item.full_name)))])]),_vm._v(" "),_c('p',[_vm._v("Select Subordinates for Managerial Position:")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("SUB DEPARTMENT / SUBORDINATES")]),_vm._v(" "),_c('div',{staticClass:"subordinatesSytle"},_vm._l((_vm.sub_department),function(item){return _c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPerm_Id),expression:"checkedPerm_Id"}],staticClass:"perm_id",attrs:{"type":"checkbox","name":"perm_id","id":"perm_name"},domProps:{"value":item.id,"checked":Array.isArray(_vm.checkedPerm_Id)?_vm._i(_vm.checkedPerm_Id,item.id)>-1:(_vm.checkedPerm_Id)},on:{"change":function($event){var $$a=_vm.checkedPerm_Id,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPerm_Id=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPerm_Id=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPerm_Id=$$c}}}}),_vm._v(" "+_vm._s(item.sub_department_name)),_c('br')])}),0),_vm._v(" "),_c('div',{staticClass:"form-group mt-3"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_subordinate}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2VMc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-dependent')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0480accb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("1bGF");
function injectStyle (ssrContext) {
  __webpack_require__("QGNG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0480accb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2lrU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2neH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_leave_credits__ = __webpack_require__("x92b");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        leaveCredits: __WEBPACK_IMPORTED_MODULE_0__todo_leave_credits__["a" /* default */]
    }
});

/***/ }),

/***/ "2oLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_add_responsibility_form_vue__ = __webpack_require__("FqER");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09cafb5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_add_responsibility_form_vue__ = __webpack_require__("3U3j");
function injectStyle (ssrContext) {
  __webpack_require__("s/R8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_add_responsibility_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09cafb5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_add_responsibility_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "35GX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      contractFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemo', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileContractsUpload: function handleFileContractsUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.contractFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeContractFilesUpload: function removeContractFilesUpload(key) {
      this.contractFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.contractFiles.length > 0) {
            for (var i = 0; i < _this5.contractFiles.length; i++) {
              var file = _this5.contractFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assigncontracts/all', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Contract has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "3Gch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
     components: {},

     data: function data() {
          return {
               token: '',
               email: '',
               new_password: '',
               confirm_password: '',

               //error handler
               error_handler: ''
          };
     },


     methods: {
          requestNewPassword: function requestNewPassword(e) {
               var _this = this;

               e.preventDefault();
               __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/reset', {
                    token: this.$route.params.token,
                    email: this.email,
                    new_password: this.new_password,
                    confirm_password: this.confirm_password
               }).then(function (resp) {
                    console.log(resp.data.response);
                    if (resp.data.response == 'success') {
                         console.log(resp.data.message);
                         _this.$swal({
                              type: 'success',
                              title: 'Success',
                              text: resp.data.message,
                              showConfirmButton: true,
                              timer: 3000 });

                         _this.$router.push({ name: 'Login-Layout' });
                    }
               }).catch(function (error) {

                    if (error.response.status == 422) {
                         _this.error_handler = error.response.data.message;
                         _this.$swal('Opps', _this.error_handler, 'error');
                         console.log(_this.error_handler);
                    }
               });
          }
     }

});

/***/ }),

/***/ "3KYm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__ = __webpack_require__("8y+h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736b5eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__ = __webpack_require__("+Ayq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736b5eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    }
  },
  props: {
    link: {
      type: [String, Object],
      default: function _default() {
        return {
          name: '',
          path: '',
          icon: ''
        };
      }
    },
    tag: {
      type: String,
      default: 'router-link'
    }
  },
  methods: {
    hideSidebar: function hideSidebar() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "3RLs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('update-leave')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3U3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('add-responsibility')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3dd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_contracts_all_vue__ = __webpack_require__("35GX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286e10ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_contracts_all_vue__ = __webpack_require__("+1lI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_contracts_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286e10ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_contracts_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ije":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_edit_schedule_adjustment__ = __webpack_require__("Ui1z");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        editScheduleAdjustment: __WEBPACK_IMPORTED_MODULE_0__todo_edit_schedule_adjustment__["a" /* default */]
    }
});

/***/ }),

/***/ "3ldW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_position_vue__ = __webpack_require__("91bO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_170ebd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_position_vue__ = __webpack_require__("+KMd");
function injectStyle (ssrContext) {
  __webpack_require__("Llef")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_position_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_170ebd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_position_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3vwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Employees Contact")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Contacts")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search Contact ... "},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.contact_items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Personal Email")]),_vm._v(" "),_c('th',[_vm._v("Blueprint Email")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedContacts),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name))+" "),_c('i',{staticClass:"fa fa-mobile"}),_vm._v("+"+_vm._s(item.contact))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email_address))]),_vm._v(" "),_c('td',[(item.blueprint_address == null)?_c('span',[_c('font',{attrs:{"color":"#dc3545"}},[_vm._v("NOT YET REGISTER")])],1):_c('span',[_vm._v("\n                     "+_vm._s(item.blueprint_address)+"\n                     ")])]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.view-contact-info",modifiers:{"view-contact-info":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn  btn-xs",attrs:{"href":"javascript:void(0)","title":"click to view employee contact info"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-eye "}),_vm._v("View")]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-contact-info",modifiers:{"update-contact-info":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn  btn-xs",attrs:{"href":"javascript:void(0)","title":"click to update employee contact info"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")])])]],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.contact_items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])]),_vm._v(" "),_c('b-modal',{ref:"hide-contact-modal",attrs:{"id":"view-contact-info","size":"xl","hide-footer":""}},[_c('h2',[_vm._v("Contact Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Employee Name: "),_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.full_name)))])]),_vm._v(" "),_c('h4',[_vm._v("Personal Number: "),_c('b',[_c('i',{staticClass:"fa fa-mobile"}),_vm._v(_vm._s(_vm.selected_user.contact))])]),_vm._v(" "),_c('h4',[_vm._v("Personal Email: "),_c('b',[_vm._v(_vm._s(_vm.selected_user.email_address))])]),_vm._v(" "),_c('h4',[_vm._v("Contact Person: "),_c('b',[_c('i',{staticClass:"fa fa-mobile"}),_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.contact_person)))])]),_vm._v(" "),_c('h4',[_vm._v("Relationship: "),_c('b',[_vm._v(_vm._s(_vm.selected_user.relationship))])]),_vm._v(" "),_c('h4',[_vm._v("Blueprint Email: \n               "),(_vm.selected_user.blueprint_address == null)?_c('span',[_c('font',{attrs:{"color":"#dc3545"}},[_vm._v("NOT YET REGISTER")])],1):_c('span',[_c('b',[_vm._v(_vm._s(_vm.selected_user.blueprint_address))])])])])])]),_vm._v(" "),_c('b-modal',{ref:"hide-contact-modal",attrs:{"id":"update-contact-info","size":"xl","title":"Update Contact","hide-footer":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.full_name)))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Personal No. :")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-#######']),expression:"['####-#######']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.contact),expression:"selected_user.contact"}],staticClass:"form-control",attrs:{"type":"tel"},domProps:{"value":(_vm.selected_user.contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "contact", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Personal Email. :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.email_address),expression:"selected_user.email_address"}],staticClass:"form-control",attrs:{"type":"email"},domProps:{"value":(_vm.selected_user.email_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "email_address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company Email. :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.blueprint_address),expression:"selected_user.blueprint_address"}],staticClass:"form-control",attrs:{"type":"email"},domProps:{"value":(_vm.selected_user.blueprint_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "blueprint_address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emergency No. :")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-#######']),expression:"['####-#######']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.emergency_no),expression:"selected_user.emergency_no"}],staticClass:"form-control",attrs:{"type":"tel"},domProps:{"value":(_vm.selected_user.emergency_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "emergency_no", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Contact Person :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.contact_person),expression:"selected_user.contact_person"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}"},domProps:{"value":(_vm.selected_user.contact_person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "contact_person", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Relationship : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.relationship),expression:"selected_user.relationship"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_user, "relationship", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Mother"}},[_vm._v("Mother")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Father")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Daughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Son"}},[_vm._v("Son")]),_vm._v(" "),_c('option',{attrs:{"value":"Sister"}},[_vm._v("Sister")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Brother")]),_vm._v(" "),_c('option',{attrs:{"value":"Aunt"}},[_vm._v("Aunt")]),_vm._v(" "),_c('option',{attrs:{"value":"Uncle"}},[_vm._v("Uncle")]),_vm._v(" "),_c('option',{attrs:{"value":"Niece"}},[_vm._v("Niece")]),_vm._v(" "),_c('option',{attrs:{"value":"Nephew"}},[_vm._v("Nephew")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Sibling")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Guardian")]),_vm._v(" "),_c('option',{attrs:{"value":"Live in Partner"}},[_vm._v("Live in Partner")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Female)"}},[_vm._v("Cousin(Female)")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Male)"}},[_vm._v("Cousin(Male)")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandmother"}},[_vm._v("Grandmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Grandfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Granddaughter"}},[_vm._v("Granddaughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandson"}},[_vm._v("Grandson")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepsister"}},[_vm._v("Stepsister")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepbrother"}},[_vm._v("Stepbrother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepmother"}},[_vm._v("Stepmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepfather"}},[_vm._v("Stepfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Girlfreind"}},[_vm._v("Girlfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Boyfreind"}},[_vm._v("Boyfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Wife"}},[_vm._v("Wife")]),_vm._v(" "),_c('option',{attrs:{"value":"Husband"}},[_vm._v("Husband")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_contact}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")]),_c('br'),_c('br')])])])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3yeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4DDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_edit_request_vue__ = __webpack_require__("BcDR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681fd355_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_edit_request_vue__ = __webpack_require__("8Tx0");
function injectStyle (ssrContext) {
  __webpack_require__("j7wH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_edit_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681fd355_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_edit_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4J9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_performance__ = __webpack_require__("utBc");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Performance: __WEBPACK_IMPORTED_MODULE_0__todo_performance__["a" /* default */]
   }
});

/***/ }),

/***/ "4Oz2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4PEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4QKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_vue__ = __webpack_require__("qL5R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3267729e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_vue__ = __webpack_require__("NFK8");
function injectStyle (ssrContext) {
  __webpack_require__("7w8K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3267729e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4XAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4eA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_approval__ = __webpack_require__("HRIV");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteApproval: __WEBPACK_IMPORTED_MODULE_0__todo_nte_approval__["a" /* default */]
    }
});

/***/ }),

/***/ "4fJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('performance')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4mU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_request_leave_vue__ = __webpack_require__("gos+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f022331_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_request_leave_vue__ = __webpack_require__("TCjG");
function injectStyle (ssrContext) {
  __webpack_require__("zg1b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_request_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f022331_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_request_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_approval_vue__ = __webpack_require__("K2eJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d446a9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_approval_vue__ = __webpack_require__("pePw");
function injectStyle (ssrContext) {
  __webpack_require__("/5S6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d446a9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4vc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Loan & Contributions")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.$router.push('/')}}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Loan & Contributions List")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('router-link',{staticClass:"btn  btn-primary float-right",attrs:{"to":"/hr/contributions/form"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Encode Loan & Contributions")])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"50"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"300"}},[_vm._v("Employee")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("SSS CONTRB")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("PHIC CONTRB")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("HDMF CONTRB")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("HMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("SSS Loan")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("HDMF Loan")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Tax")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Others")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}},[_vm._v("Date Created")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}},[_vm._v("Actions")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.sss_cont))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.phic_cont))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.hdmf_pagibig_cont))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.hmo))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.sss_loan))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.hdmf_loan))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.withholding_tax))]),_vm._v(" "),_c('td',[_vm._v("₱"+_vm._s(item.others))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v(" "+_vm._s(_vm.getDate(item.created_at)))]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'contributions-details', params: { id: item.id, employee_id: item.employee_id}}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" View Details")])],1),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Remove Data from list"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('i',{staticClass:"fa fa-times"})])])])}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4wqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),(_vm.$route.meta.roles == 'hr')?_c('div',[_c('sidebar-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "),_c('p',[_vm._v("Dashboard")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/newemployee"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" "),_c('p',[_vm._v("New Employee")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/employeelist"}},[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('p',[_vm._v("Employee Management")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/absenceleave"}},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('p',[_vm._v("Leave Management")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/payslip"}},[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "),_c('p',[_vm._v("Employee Payslip")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/performance"}},[_c('i',{staticClass:"fa fa-balance-scale"}),_vm._v(" "),_c('p',[_vm._v("Employee Evaluation")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/jobinformation"}},[_c('i',{staticClass:"fa fa-folder-open-o"}),_vm._v(" "),_c('p',[_vm._v("Job Information")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/contributions/list"}},[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "),_c('p',[_vm._v("Loan & Contributions")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/contactinfo"}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" "),_c('p',[_vm._v("Contact List")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/requirements"}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" "),_c('p',[_vm._v("Requirements Tracker")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/calendar"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('p',[_vm._v("Calendar")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/responsibilityform"}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('p',[_vm._v("Responsibility form")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/department"}},[_c('i',{staticClass:"fa fa-sitemap"}),_vm._v(" "),_c('p',[_vm._v("Departments")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/position"}},[_c('i',{staticClass:"fa fa-address-book-o"}),_vm._v(" "),_c('p',[_vm._v("Designations")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/timeattendance"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "),_c('p',[_vm._v("Time & Attendance")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/contractsmemo"}},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" "),_c('p',[_vm._v("Contracts and Memos")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/users"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('p',[_vm._v("User Management")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/usersroles"}},[_c('i',{staticClass:"fa fa-envira"}),_vm._v(" "),_c('p',[_vm._v("User Roles")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/hr/settings"}},[_c('i',{staticClass:"fa fa-gear"}),_vm._v(" "),_c('p',[_vm._v("Settings")])]),_vm._v(" "),_c('hr',{staticStyle:{"background":"rgba(255, 255, 255, 0.2)","margin-top":"4px","margin-bottom":"4px","width":"85%"}}),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/logout"}},[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v(" "),_c('p',[_vm._v("Logout")])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "52xl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('holidays')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "57A+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_requirements_vue__ = __webpack_require__("9ppo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03053716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_requirements_vue__ = __webpack_require__("Ftyv");
function injectStyle (ssrContext) {
  __webpack_require__("4PEJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_requirements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03053716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Baz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f9e72d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("9nho");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f9e72d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5GF2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5JwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_leave_vue__ = __webpack_require__("UGQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4396b70c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_leave_vue__ = __webpack_require__("rJbq");
function injectStyle (ssrContext) {
  __webpack_require__("SY0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4396b70c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5KKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5PUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-admin')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5iK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contributions-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5n5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },

    data: function data() {
        return {
            item: {}
        };
    },


    created: function created() {
        this.getItem();
    },

    methods: {
        getItem: function getItem() {
            var _this = this;

            axios.get('api/contributions/' + this.$route.params.id + '/' + this.$route.params.employee_id).then(function (resp) {
                console.log('response => detailts:', resp);
                _this.item = resp.data;
            });
        }
    }

});

/***/ }),

/***/ "6/qy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('adjustment-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "62bg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_calendar__ = __webpack_require__("O5y+");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        calendar: __WEBPACK_IMPORTED_MODULE_0__todo_calendar__["a" /* default */]
    }
});

/***/ }),

/***/ "65qH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66Af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            email: '',
            password: ''
        };
    },

    created: function created() {},
    methods: {
        formSubmit: function formSubmit(e) {
            e.preventDefault();
        }
    }
});

/***/ }),

/***/ "66G3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_performance_details_vue__ = __webpack_require__("LAfU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c12c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_performance_details_vue__ = __webpack_require__("uD4b");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_performance_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c12c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_performance_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6CPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Undertime Approval")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Undertime Approval")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update_form($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.item.hr_status == 'pending')?_c('b-alert',{attrs:{"show":"","dismissible":""}},[_c('strong',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.full_name)))]),_vm._v(" - Request for a Undertime approval.\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_filled),expression:"item.date_filled"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.item.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_filled", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of Undertime:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_of_undertime),expression:"item.date_of_undertime"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.item.date_of_undertime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_of_undertime", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Total Hours:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.total_hours),expression:"item.total_hours"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.item.total_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "total_hours", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("HR Department Approval: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.hr_status),expression:"item.hr_status"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "hr_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.reasonRejected]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("Approve Request")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("Decline Request")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("Pending Request")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Purpose")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.purpose),expression:"item.purpose"}],staticClass:"form-control",attrs:{"rows":"11","disabled":""},domProps:{"value":(_vm.item.purpose)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "purpose", $event.target.value)}}})])])]),_vm._v(" "),(_vm.reason==true)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('b',[_vm._v("Reason:")])]),_vm._v(" "),_c('small',[_c('i',[_vm._v("Please write a reason why you decline his/her leave request.")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason_to_declined),expression:"reason_to_declined"}],staticClass:"form-control reason",attrs:{"rows":"5"},domProps:{"value":(_vm.reason_to_declined)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason_to_declined=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Subtmit Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6KaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assistant_manager__ = __webpack_require__("KsgB");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        assistantManager: __WEBPACK_IMPORTED_MODULE_0__todo_assistant_manager__["a" /* default */]
    }
});

/***/ }),

/***/ "6OK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_employee_list__ = __webpack_require__("oPlk");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        EmployeeList: __WEBPACK_IMPORTED_MODULE_0__todo_employee_list__["a" /* default */]
    }
});

/***/ }),

/***/ "6dvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Responsibility Details")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/responsibilityform"}},[_vm._v("Responsibilities Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Responsibility Details")])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"responsibility-form-body"},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 border-form"},[_c('center',[_c('h3',[_vm._v("EMPLOYEE RESPONSIBILITY FORM")])])],1),_vm._v(" "),_c('div',{staticClass:"division-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 border-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"top-gatter"},[_c('b',[_vm._v("Employee Name :")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.first_name))+" , "+_vm._s(_vm._f("capitalize")(_vm.item.last_name))+"\n                   \n               ")]),_vm._v(" "),_c('p',{staticClass:"top-gatter"},[_c('b',[_vm._v("Department:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"top-gatter"},[_c('b',[_vm._v("Employee Number :")]),_vm._v(" "+_vm._s(_vm.item.emp_id))]),_vm._v(" "),_c('p',{staticClass:"top-gatter"},[_c('b',[_vm._v("Position :")]),_vm._v("  "+_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"top-gatter"},[_vm._v("I hereby acknowledge that I have received the following company property:")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-12 border-form"},[_c('table',{attrs:{"width":"100%"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Name of Item")]),_vm._v(" "),_c('th',[_vm._v("Description / Serial Number")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("Date Received")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.item.res),function(resp,i){return _c('tr',[_c('td',[_vm._v(_vm._s(i+1)+".  "+_vm._s(resp.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resp.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resp.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resp.received))])])}),0)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"top-gatter"},[_vm._v("I aggree to keep the property in working condition, and to notify management should the property \n            malfunction in any way, or should the property be lost or stolen. Further, I agree to return this property\n            at the end of my employment.When I no longer need one or more of the items, I will return it/them\n            immediately to my immediate supervisor.\n         ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-5"}),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('img',{staticClass:"get_image",attrs:{"src":_vm.item.signature,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"line-divider"}),_vm._v(" "),_c('div',{staticClass:"noted-date"},[_vm._v("Employee Signature")]),_vm._v(" "),_c('div',{staticClass:"div-spliter"})])]),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0003")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6hmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_account_user_vue__ = __webpack_require__("zkGz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7014f81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_account_user_vue__ = __webpack_require__("iiJf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_account_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7014f81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_account_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7/bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Office Responsibilities Record")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Office Responsibilities")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/wfh/responsibility"}},[_vm._v("WFH Responsibilities")])],1)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":'addresponsibilityform'}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  Encode Responsibility Manually")])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10"}}),_vm._v(" "),_c('th',{attrs:{"width":"700"}},[_vm._v("Employee Name")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Date Submitted")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedResponsibility),function(emp,i){return _c('tr',[(emp === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(emp.created)))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"to":{name: 'view-responsibility', params: { id: emp.res_id }},"title":"click to view full details of responsibility form"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"to":{name: 'edit-responsibility-form', params: { id: emp.res_id }},"title":"Modify Entry"}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("Update")]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"title":"Delete Entry"},on:{"click":function($event){_vm.deleteItem(emp.res_id, i)}}},[_c('li',{staticClass:"fa fa-trash-o"}),_vm._v(" Delete")])],1)]],2)}),0)])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7/ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_job_information_vue__ = __webpack_require__("fwtG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9ada8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_job_information_vue__ = __webpack_require__("CR8J");
function injectStyle (ssrContext) {
  __webpack_require__("NEa/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_job_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9ada8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_job_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Bkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_va_nz_au_vue__ = __webpack_require__("qaio");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0679283c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_va_nz_au_vue__ = __webpack_require__("AyGO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_va_nz_au_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0679283c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_va_nz_au_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7F0B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d108731_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("yC+e");
function injectStyle (ssrContext) {
  __webpack_require__("v4S7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d108731_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7d+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      print: 'Hellow Wolrd'
    };
  },

  mounted: function mounted() {
    this.fetchItem();
  },
  methods: {

    // printNow(value){
    // 	this.print = value;
    //     window.print();

    // },


    formatMoney: function formatMoney(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    printItem: function printItem() {
      var prtHtml = document.getElementById('printMe').innerHTML;
      var stylesHtml = '';

      var _arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('link[rel="stylesheet"], style')));

      for (var _i = 0; _i < _arr.length; _i++) {
        var node = _arr[_i];
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write('<!DOCTYPE html>\n                    <html>\n                    <head>\n                        ' + stylesHtml + '\n                    </head>\n                    <body>\n                        ' + prtHtml + '\n                    </body>\n                    </html>');

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    getCurentUser: function getCurentUser() {
      var _this = this;

      axios.get('api/user').then(function (response) {
        _this.users = response.data;
        if (_this.users.role_id != 5) {
          _this.$router.push({
            name: 'Login-Layout'
          });
        }
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    fetchItem: function fetchItem() {
      var _this2 = this;

      axios.get('api/jobinformation/get/' + this.$route.params.id).then(function (resp) {
        _this2.item = resp.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

});

/***/ }),

/***/ "7qGc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7w8K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "83OK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "84Cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_responsibility_vue__ = __webpack_require__("B4Ru");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0044c7fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_responsibility_vue__ = __webpack_require__("ubnY");
function injectStyle (ssrContext) {
  __webpack_require__("XQIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0044c7fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8DAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Daa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Job Information")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/jobinformation"}},[_vm._v(" Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Inactive Employees")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Position:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_position),expression:"filter_by_position"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"textContent":_vm._s(pos.pos_name)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"regular"}},[_vm._v("regular")]),_vm._v(" "),_c('option',{attrs:{"value":"probationary"}},[_vm._v("probationary")]),_vm._v(" "),_c('option',{attrs:{"value":"promoted"}},[_vm._v("promoted")]),_vm._v(" "),_c('option',{attrs:{"value":"trainee"}},[_vm._v("trainee")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Employee")]),_vm._v(" "),_c('th',[_vm._v("Designation")]),_vm._v(" "),_c('th',[_vm._v("Basic Salary")]),_vm._v(" "),_c('th',[_vm._v("Allowance")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Joined Date")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Date Signed")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedJobInformation),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.position_name))]),_vm._v(" "),_c('td',[_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(item.basic_salary)))]),_vm._v(" "),_c('td',[_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(item.monthly_allowance)))]),_vm._v(" "),_c('td',[(item.employment_date !== null)?_c('span',[_vm._v(" "+_vm._s(_vm.getDate(item.employment_date)))]):_c('span',[_vm._v("-------------------")])]),_vm._v(" "),_c('td',[(item.date_signed !== null)?_c('span',[_vm._v(" "+_vm._s(_vm.getDate(item.date_signed)))]):_c('span',[_vm._v("-------------------")])]),_vm._v(" "),_c('td',[(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'promoted')?_c('span',[_c('i',{staticClass:"fa fa-flag text-secondary"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'resigned')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'terminated')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):(item.status == 'awol')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"btn btn-xs btn-default",attrs:{"to":{name: 'view-job-information', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-job-information",modifiers:{"update-job-information":true}}],staticClass:"btn btn-xs btn-default",attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")])],1)]],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"hide-modal-job-information",attrs:{"id":"view-job-information","size":"xl","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.first_name))+", "+_vm._s(_vm._f("capitalize")(_vm.selected_user.last_name)))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Employment  Date:")]),_vm._v(" "),(_vm.selected_user.employment_date !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.employment_date))+"\n                        ")]):_c('p',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Date Signed:")]),_vm._v(" "),(_vm.selected_user.date_signed !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.date_signed))+"\n                        ")]):_c('p',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Resignation Date:")]),_vm._v(" "),(_vm.selected_user.regularization_date !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.regularization_date))+"\n                        ")]):_c('p',[_vm._v("N/A")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Promoted Date:")]),_vm._v(" "),(_vm.selected_user.promoted_date !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.promoted_date))+"\n                        ")]):_c('p',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Training Date:")]),_vm._v(" "),(_vm.selected_user.training_date !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.training_date))+"\n                        ")]):_c('p',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Regularization Date:")]),_vm._v(" "),(_vm.selected_user.regularization_date !== null)?_c('p',[_vm._v("\n                           "+_vm._s(_vm.getDate(_vm.selected_user.regularization_date))+"\n                        ")]):_c('p',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('b-modal',{ref:"hide-modal-job-information",attrs:{"id":"update-job-information","size":"l","title":"Update Status","hide-footer":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.full_name)))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employment Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.status),expression:"selected_user.status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_user, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"trainee"}},[_vm._v("Trainee")]),_vm._v(" "),_c('option',{attrs:{"value":"probationary"}},[_vm._v("Probationary")]),_vm._v(" "),_c('option',{attrs:{"value":"regular"}},[_vm._v("Regular")]),_vm._v(" "),_c('option',{attrs:{"value":"promoted"}},[_vm._v("Promoted")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("Terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("Resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])]),_vm._v(" "),_c('i',[_vm._v("You can update or change the employee status based on the selection.")]),_c('br'),_c('br')])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_job_information}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],1),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8MEg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Employee Payslip")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Employee Payslip")])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(item.full_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"btn-primary btn mr-xl-2 my-3",attrs:{"to":{name: 'uploadPayslip', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" Upload Payslip")])])],1)]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8NTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_group_access__ = __webpack_require__("NMAq");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        groupAccess: __WEBPACK_IMPORTED_MODULE_0__todo_group_access__["a" /* default */]
    }
});

/***/ }),

/***/ "8NvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_password_reset_vue__ = __webpack_require__("exW1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228e9472_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_password_reset_vue__ = __webpack_require__("KV7m");
function injectStyle (ssrContext) {
  __webpack_require__("+Huq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_password_reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228e9472_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_password_reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8PdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_reports_vue__ = __webpack_require__("rlnl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c3ecf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_reports_vue__ = __webpack_require__("HjtT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c3ecf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8TZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("NTE Tracker")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("NTE Tracker")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('span',{staticClass:"float-md-right"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/hr/nterequestform"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" NTE Tracker")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/hr/ntemanualinput"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Encode NTE Manually")])],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{attrs:{"width":"650"}},[_vm._v("Requested By")]),_vm._v(" "),_c('th',{attrs:{"width":"850"}},[_vm._v("Infraction")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"280"}},[_vm._v("ACTION")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Date Request")]),_vm._v(" "),_c('th',{attrs:{"width":"15"}},[_vm._v("Remove")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[(item.employee_status === 'unacknowledged')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-flag text-danger",attrs:{"title":"Waiting for agent to approve this request."}})]):_c('span',[_c('i',{staticClass:"fa fa-flag text-success"})])]),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('b',[(item.requested_by.length < 16)?[_vm._v(_vm._s(item.requested_by))]:_vm._e(),_vm._v(" "),(item.requested_by.length >= 16)?[_vm._v(_vm._s(item.requested_by.substring(0,16)+"..."))]:_vm._e()],2),_vm._v("\n                        - Requested NTE to \n                        "),_c('b',[(item.full_name.length < 20)?[_vm._v(_vm._s(item.full_name))]:_vm._e(),_vm._v(" "),(item.full_name.length >= 20)?[_vm._v(_vm._s(item.full_name.substring(0,20)+"..."))]:_vm._e()],2)]):_c('span',{staticClass:"text-fade"},[(item.requested_by.length < 16)?[_vm._v(_vm._s(item.requested_by))]:_vm._e(),_vm._v(" "),(item.requested_by.length >= 16)?[_vm._v(_vm._s(item.requested_by.substring(0,16)+"..."))]:_vm._e(),_vm._v("\n                        - Requested NTE to \n                        "),(item.full_name.length < 20)?[_vm._v(_vm._s(item.full_name))]:_vm._e(),_vm._v(" "),(item.full_name.length >= 20)?[_vm._v(_vm._s(item.full_name.substring(0,20)+"..."))]:_vm._e()],2)]),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('b',[(item.details_of_infraction.length < 79)?[_vm._v(_vm._s(item.details_of_infraction))]:_vm._e(),_vm._v(" "),(item.details_of_infraction.length >= 79)?[_vm._v(_vm._s(item.details_of_infraction.substring(0,79)+"..."))]:_vm._e()],2)]):_c('span',{staticClass:"text-fade"},[(item.details_of_infraction.length < 79)?[_vm._v(_vm._s(item.details_of_infraction))]:_vm._e(),_vm._v(" "),(item.details_of_infraction.length >= 79)?[_vm._v(_vm._s(item.details_of_infraction.substring(0,79)+"..."))]:_vm._e()],2)]),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('button',{staticClass:"pending"},[_vm._v("Pending")])]):(item.hr_status === 'approved')?_c('span',[_c('button',{staticClass:"approved "},[_vm._v("Approved")])]):(item.hr_status === 'rejected')?_c('span',[_c('button',{staticClass:"rejected"},[_vm._v("Rejected")])]):_vm._e()]),_vm._v(" "),_c('td',[((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'unacknowledged')?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'nte-edit-request', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update Request")])],1):_vm._e(),_vm._v(" "),((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'acknowledged' && item.hr_decision_status == 'undecided')?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'notice-for-decision', params: { id: item.id }}}},[_vm._v("Notice of Decision")])],1):_vm._e(),_vm._v(" "),((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'acknowledged' && item.hr_decision_status == 'decided')?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'nte-view-details', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" View Details")])],1):_vm._e(),_vm._v(" "),((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'pending'))?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'nte-approval-request', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-mail-forward"}),_vm._v("Review request")]),_vm._v("  "),_c('span',{staticClass:"badge badge-danger"},[_vm._v("New")])],1):_vm._e(),_vm._v(" "),((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'rejected'))?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'nte-approval-request', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-mail-forward"}),_vm._v("Update request")])],1):_vm._e()]),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.getDate(item.date_request)))])]):_c('span',{staticClass:"text-fade"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.getDate(item.date_request))+"\n                     ")])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger btn-xs btn-circle",attrs:{"title":"Remove NTE Request"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('i',{staticClass:"fa fa-times"})])])]],2)}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Tx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-edit-request')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8U+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },
   data: function data() {
      return {
         items: [],
         positions: [],
         selected_user: '',
         search: '',
         filter_by_position: '',
         filter_by_status: '',
         order_by: '',
         //pagination
         page_limit: '',
         start_page: 1,
         display_indicator: '',
         loading: true,
         //PAGINATION
         perPage: 20,
         curentPage: 1
      };
   },

   mounted: function mounted() {
      this.get_jobinformation();
      this.get_positions();
   },
   methods: {
      formatMoney: function formatMoney(value) {
         var val = (value / 1).toFixed(2).replace('.', ',');
         return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },


      current_change: function current_change(currentPage) {
         this.currentPage = currentPage;
      },
      get_jobinformation: function get_jobinformation() {
         var _this = this;

         axios.get('api/inactive').then(function (response) {
            _this.items = response.data;

            _this.loading = false;
            _this.display_indicator = 2;
         }).catch(function (e) {
            console.log(e.response);
            _this.display_indicator = 1;
         });
      },
      get_positions: function get_positions() {
         var _this2 = this;

         axios.get('api/positions').then(function (response) {
            _this2.positions = response.data;
         }).catch(function (e) {
            console.log(e.response);
         });
      },
      get_selected_id: function get_selected_id(item) {
         this.selected_user = item;
      },
      update_job_information: function update_job_information(e) {
         var _this3 = this;

         e.preventDefault();
         axios.post('api/jobinformation/update/inactive/' + this.selected_user.id, {
            'resignation_date': "NULL",
            'status': this.selected_user.status
         }).then(function (resp) {
            if (resp.data.response == 'success') {
               _this3.$swal({
                  type: 'success',
                  title: 'Updated',
                  text: resp.data.message,
                  showConfirmButton: false,
                  timer: 2000
               });
               _this3.$refs['hide-modal-job-information'].hide();
               _this3.get_jobinformation();
            } else if (resp.data.response == 'error') {
               _this3.$swal({
                  type: 'error',
                  title: 'Error',
                  text: resp.data.message,
                  showConfirmButton: true,
                  timer: 2000
               });
            }
         }).catch(function (error) {
            if (error.response.status == 422) {
               var d = error.response.data;
               console.log("response =>".d);
            }
         });
      }
   },

   computed: {

      // PAGINATION
      offset: function offset() {
         return (this.start_page - 1) * this.page_limit;
      },
      limit: function limit() {
         return this.offset + this.page_limit;
      },
      total_item: function total_item() {
         return this.items.length;
      },
      computedJobInformation: function computedJobInformation() {
         var _this4 = this;

         var filtered = this.items;
         // USE IN PAGINATION 
         var start = (this.curentPage - 1) * this.perPage;
         var end = this.curentPage * this.perPage;
         filtered = filtered.slice(start, end);

         if (filtered.length > 0) {
            // SEARCH BY EMPLOYEE FULLNAME
            if (this.search) {
               filtered = filtered.filter(function (item) {
                  return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
               });
               return filtered;
            }
            // FILTER BY POSITION
            if (this.filter_by_position) {
               filtered = filtered.filter(function (item) {
                  return item.position_name.toLowerCase() === _this4.filter_by_position.toLowerCase();
               });
               return filtered;
            }
            // ORDER BY ASC AND DESC COMBOBOX
            if (this.order_by) {
               filtered = filtered.slice(0).sort(function (a, b) {
                  return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
               });
               return filtered;
            }
            // SORTING NUMBER OF DISPLAY
            if (this.page_limit) {
               filtered = filtered.slice(this.offset, this.limit);
               return filtered;
            }
            // FILTER BY STATUS
            if (this.filter_by_status) {
               filtered = filtered.filter(function (item) {
                  return item.status.toLowerCase() === _this4.filter_by_status.toLowerCase();
               });
               return filtered;
            }
         }
         return filtered;
      }
   }

});

/***/ }),

/***/ "8Uc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__("nYKV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                viewRender: function viewRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['view-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                        args[_key7] = arguments[_key7];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),

/***/ "8i2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('notice-for-decision')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8w/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_calendar_vue__ = __webpack_require__("62bg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77053220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_calendar_vue__ = __webpack_require__("WRTj");
function injectStyle (ssrContext) {
  __webpack_require__("DUNh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77053220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8wdw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      sub_department_name: "",
      description: "",
      selected_item: "",
      loading: true,
      display_indicator: ""
    };
  },


  mounted: function mounted() {
    var _this = this;

    this.get_sub_departments();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    get_sub_departments: function get_sub_departments() {
      var _this2 = this;

      axios.get("api/subdepartments").then(function (response) {
        _this2.items = response.data;
        _this2.display_indicator = 2;
      }).catch(function (e) {
        console.log(e.response);
        _this2.display_indicator = 1;
      });
    },
    add_sub_departments: function add_sub_departments() {
      var _this3 = this;

      axios.post("api/subdepartments/add", {
        sub_department_name: this.sub_department_name,
        description: this.description
      }).then(function (resp) {
        if (resp.data.response == "success") {
          _this3.$swal({
            type: "success",
            title: "Save",
            text: resp.data.message,
            showConfirmButton: true,
            timer: 3000
          });
          _this3.get_sub_departments();
          _this3.$refs["add-new-sub-department"].hide();
        } else if (resp.data.response == "error") {
          _this3.$swal({
            type: "error",
            title: "Error",
            text: resp.data.message,
            showConfirmButton: true
          });
        }
      }).catch(function (error) {
        console.log(resp);
      });
    },
    update_sub_department: function update_sub_department() {
      var _this4 = this;

      axios.post("api/subdepartment/update/" + this.selected_item.id, {
        sub_department_name: this.selected_item.sub_department_name,
        description: this.selected_item.description
      }).then(function (resp) {
        if (resp.data.response == "success") {
          _this4.$swal({
            type: "success",
            title: "Save",
            text: resp.data.message,
            showConfirmButton: true,
            timer: 3000
          });
          _this4.get_sub_departments();
          _this4.$refs["update-sub-department"].hide();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_selected_item: function get_selected_item(item) {
      this.selected_item = item;
      console.log(this.selected_item);
    }
  },
  computed: {
    departmentItem: function departmentItem() {
      var filterd = this.items;
      if (filterd.length > 0) {
        filterd.slice().reverse();
      }
      return filterd;
    }
  }

});

/***/ }),

/***/ "8y+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        localStorage.removeItem('token');
        localStorage.removeItem('expiration');
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('logOutUser');
        this.$router.push({ name: 'Login-Layout' });
        console.log('response => ', 'This is logout');
    }
});

/***/ }),

/***/ "91bO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_position__ = __webpack_require__("dtpm");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Position: __WEBPACK_IMPORTED_MODULE_0__todo_position__["a" /* default */]
    }
});

/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "98KN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_cd_pq_vue__ = __webpack_require__("cXh+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25829f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_cd_pq_vue__ = __webpack_require__("2N99");
function injectStyle (ssrContext) {
  __webpack_require__("y0uv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_cd_pq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25829f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_cd_pq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9DIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_responsibility_form_vue__ = __webpack_require__("RYeG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44af445b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_responsibility_form_vue__ = __webpack_require__("ztwb");
function injectStyle (ssrContext) {
  __webpack_require__("Ah8g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_responsibility_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44af445b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_responsibility_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Oew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },
   data: function data() {
      return {
         item: {},
         reason: false,
         reason_to_declined: ''
      };
   },

   mounted: function mounted() {
      this.getItem();
   },
   methods: {
      reasonShow: function reasonShow() {
         if (this.item.status == 'rejected') {
            this.reason = true;
         } else {
            this.reason = false;
         }
      },
      getItem: function getItem() {
         var _this = this;

         axios.get('api/leaveabsences/get/' + this.$route.params.id).then(function (response) {
            _this.item = response.data;
         }).catch(function (error) {
            console.log(error);
         });
      },
      update_leave: function update_leave(e) {
         var _this2 = this;

         e.preventDefault();
         axios.post('api/leaveabsences/update/hr/' + this.item.id, {
            date_filled: this.item.date_filled,
            no_of_days: this.item.no_of_days,
            leave_type: this.item.leave_type,
            remarks: this.item.remarks,
            start_date: this.item.start_date,
            end_date: this.item.end_date,
            reason: this.item.reason,
            status: this.item.status,
            reason_to_declined: this.reason_to_declined
         }).then(function (resp) {
            if (resp.data.response == 'rejected') {
               _this2.$swal('Rejected', resp.data.message, 'success');
               _this2.$router.push({ name: 'absence-leave' });
            } else if (resp.data.response == 'approved') {
               _this2.$swal('Approved', resp.data.message, 'success');
               _this2.$router.push({ name: 'absence-leave' });
            } else if (resp.data.response == 'error') {
               _this2.$swal('error', resp.data.message, 'error');
            }
            console.log(resp);
         }).catch(function (e) {
            console.log(e.response);
         });
      }
   }

});

/***/ }),

/***/ "9X+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('employee-coached-details')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ZHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginbody"},[_c('div',{staticClass:"col-md-3",staticStyle:{"margin":"auto","padding-top":"5%"}},[_c('new-password')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9bjU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9eAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9nho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ppo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_requirements__ = __webpack_require__("ztaS");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TodoRequirements: __WEBPACK_IMPORTED_MODULE_0__todo_requirements__["a" /* default */]
    }
});

/***/ }),

/***/ "9zFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('coaching-record')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+Km":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_update_leave__ = __webpack_require__("qCjy");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        updateLeave: __WEBPACK_IMPORTED_MODULE_0__todo_update_leave__["a" /* default */]
    }
});

/***/ }),

/***/ "A2rL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Schedule Adjustment")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Schedule Adjustment")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":"/hr/adjustmentform"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Encode Adjustment Maually")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Current Shift")]),_vm._v(" "),_c('th',[_vm._v("Requested Shift")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Date Requested")]),_vm._v(" "),_c('th',[_vm._v("Reason")]),_vm._v(" "),_c('th',[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('br'),_c('i',[_vm._v(_vm._s(item.position_name))])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "+_vm._s(item.current_shift))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "+_vm._s(item.requested_shift))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.date_of_request)))]),_vm._v(" "),_c('td',[(item.reason_for_change.length < 50)?[_vm._v(_vm._s(item.reason_for_change))]:_vm._e(),_vm._v(" "),(item.reason_for_change.length >= 50)?[_vm._v(_vm._s(item.reason_for_change .substring(0,50)+"..."))]:_vm._e()],2),_vm._v(" "),_c('td',[(item.hr_status === 'pending')?_c('span',[_c('button',{staticClass:"pending"},[_vm._v("Pending")])]):(item.hr_status === 'approved')?_c('span',[_c('button',{staticClass:"approved "},[_vm._v("Approved")])]):(item.hr_status === 'rejected')?_c('span',[_c('button',{staticClass:"rejected"},[_vm._v("Rejected")])]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"width":"165"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"to":{name: 'schedule-edit-adjustment-form', params: { id: item.id }},"title":"click to view details and modify records"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"title":"Delete Entry"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('li',{staticClass:"fa fa-trash-o"}),_vm._v("\n                         Delete\n                     ")])],1)]],2)}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AAzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      employees: [],
      loading: true,
      //FILTER
      search: '',
      order_by: '',
      page_limit: '',
      start_page: 1,
      sortAsc: true,
      //PAGINATION
      perPage: 100,
      curentPage: 1,
      //Indicator
      display_indicator: ''
    };
  },


  mounted: function mounted() {
    this.get_undertime_request();
    this.get_employees();
  },

  methods: {
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/employeeworkshift').then(function (response) {
        _this.employees = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    get_undertime_request: function get_undertime_request() {
      var _this2 = this;

      axios.get('api/undertimerequest').then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
        _this2.display_indicator = 2;
      }).catch(function (e) {
        console.log(e.response);
        _this2.display_indicator = 1;
      });
    },
    deleteItem: function deleteItem(id, index) {
      var _this3 = this;

      /* USING SWEET ALERT */

      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/undertimerequest/delete/' + id).then(function (response) {
            _this3.get_undertime_request(); // reloader 
            _this3.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response);
            _this3.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    }
  },
  computed: {
    total_item: function total_item() {
      return this.items.length;
    },
    computedEmployee: function computedEmployee() {
      var _this4 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  },

  watch: {
    selectedSched: function selectedSched() {
      // Clear previously selected values
      this.sched_items = [];
      this.time_items = [];
      this.selectedTime = "";
      // Populate list of sched_items in the second dropdown
      if (this.selectedSched.length > 0) {
        this.sched_items = this.schedules[this.selectedSched];
      }
    },
    selectedTime: function selectedTime() {
      // Clear previously selected values
      this.time_items = [];
      // Now we have a continent and sched_index. Populate list of time_items in the third dropdown
      if (this.selectedTime.length > 0) {
        this.time_items = this.schedules[this.selectedSched][this.selectedTime];
      }
    }
  }
});

/***/ }),

/***/ "ASGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("User Roles")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Roles")])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped"},[_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-roles",modifiers:{"update-roles":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"link-default-user-roles",attrs:{"href":"#","title":"Update Roles"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v(_vm._s(item.roles_name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.description))]),_c('br')])])}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-roles-update",attrs:{"id":"update-roles","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v("Roles")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Roles Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.roles_name),expression:"selected_item.roles_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.roles_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "roles_name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Description:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.description),expression:"selected_item.description"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.selected_item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_roles}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AaH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3539ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_breadcrumb_menu_vue__ = __webpack_require__("225H");
function injectStyle (ssrContext) {
  __webpack_require__("9bjU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3539ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_breadcrumb_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AbsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      positions: [],
      //filter
      filter_by_position: '',
      filter_by_status: '',
      search: '',
      order_by: '',
      sortAsc: true,
      //pagination
      page_limit: '',
      start_page: 1,
      loading: true,
      //Indicator
      display_indicator: '',
      //PAGINATION
      perPage: 100,
      curentPage: 1
    };
  },


  mounted: function mounted() {
    this.get_employees();
    this.get_positions();
  },

  methods: {
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/resigned').then(function (response) {
        _this.items = response.data;
        _this.display_indicator = 2;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    get_positions: function get_positions() {
      var _this2 = this;

      axios.get('api/positions').then(function (response) {
        _this2.positions = response.data;
      }).catch(function (e) {
        console.log(e.response);
      });
    }
  },
  computed: {

    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedEmployee: function computedEmployee() {
      var _this3 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
          });
          return filtered;
        }
        // FILTER BY POSITION
        if (this.filter_by_position) {
          filtered = filtered.filter(function (item) {
            return item.position_name.toLowerCase() === _this3.filter_by_position.toLowerCase();
          });
          return filtered;
        }

        // FILTER BY STATUS
        if (this.filter_by_status) {
          filtered = filtered.filter(function (item) {
            return item.status.toLowerCase() === _this3.filter_by_status.toLowerCase();
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this3.order_by : -_this3.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }

});

/***/ }),

/***/ "Ah8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AixB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ak1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('group-access')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AkhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    var _ref;

    return _ref = {
      //items
      employees: [],
      // error
      error_handler: [],
      //input
      employee_id: '',
      details_of_occurence: [{
        date: '',
        detail: ''
      }],
      nteFiles: [],
      files: {},
      date_incident: '',
      date_request: ''
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'date_incident', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'action_to_be_taken', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'type_of_infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'details_of_infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'plan_for_improvement', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'employees_commitment', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hr_notice_for_decision', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'corrective', ''), _ref;
  },


  mounted: function mounted() {
    this.get_employees();
  },

  methods: {
    dismissal: function dismissal() {
      if (this.corrective == 'dismissal') {
        this.action_to_be_taken = 'Dismissal';
      }
    },

    add_form: function add_form() {
      this.details_of_occurence.push({
        date: '',
        detail: ''
      });
    },

    delete_form: function delete_form(index) {
      this.details_of_occurence.splice(index, 1);
      if (index === 0) this.add_form();
    },

    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/active/employee').then(function (response) {
        _this.employees = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },


    //FILE UPLOAD
    handleNteFilesUpload: function handleNteFilesUpload() {
      var uploadedNTEFiles = event.target.files;
      if (!uploadedNTEFiles.length) return;
      for (var i = 0; i < uploadedNTEFiles.length; i++) {
        this.nteFiles.push(uploadedNTEFiles[i]);
      }
      console.log('response => ', uploadedNTEFiles);
    },
    removenteFilesUpload: function removenteFilesUpload(key) {
      this.nteFiles.splice(key, 1);
    },
    resetData: function resetData() {
      this.data = new FormData();
      this.files = [];
      this.infraction_item = [];
      this.error_handler = [], this.employee_id = '';
      this.date_request = '';
      this.requested_by = '';
      this.date_incident = '';
      this.details_occurence = '';
      this.type_of_infraction = '';
      this.action_to_be_taken = '';
      this.details_of_infraction = '';
      this.plan_for_improvement = '';
      this.employees_commitment = '';
      this.hr_notice_for_decision = '';
      this.details_of_occurence = [{
        'date': '',
        'detail': ''
      }];
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to submit this request',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          for (var i = 0; i < _this2.nteFiles.length; i++) {
            var file = _this2.nteFiles[i];
            formData.append('files[' + i + ']', file);
          }
          //Additional POST Request
          formData.append('employee_id', _this2.employee_id);
          formData.append('requested_by', _this2.requested_by);
          formData.append('date_request', _this2.date_request);
          formData.append('date_incident', _this2.date_incident);
          formData.append('details_of_infraction', _this2.details_of_infraction);
          formData.append('details_occurence', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.details_of_occurence));
          formData.append('type_of_infraction', _this2.type_of_infraction);
          formData.append('action_to_be_taken', _this2.action_to_be_taken);
          formData.append('plan_for_improvement', _this2.plan_for_improvement);
          formData.append('employees_commitment', _this2.employees_commitment);
          formData.append('hr_notice_for_decision', _this2.hr_notice_for_decision);
          formData.append('details_of_infraction', _this2.details_of_infraction);
          axios.post('api/ntestoremanually/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this2.$swal('Success', 'You successfully submitted this request.', 'success');
            _this2.$router.push({
              name: 'nte-request'
            });
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this2.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {}

});

/***/ }),

/***/ "Aolk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contact_info_vue__ = __webpack_require__("fcTk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2478b26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contact_info_vue__ = __webpack_require__("3vwj");
function injectStyle (ssrContext) {
  __webpack_require__("0Qgv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contact_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2478b26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contact_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Apcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApvU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_manual_input__ = __webpack_require__("TBnq");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteManualInput: __WEBPACK_IMPORTED_MODULE_0__todo_nte_manual_input__["a" /* default */]
    }
});

/***/ }),

/***/ "Av0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Workshifts")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Workshifts")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.add-new-item",modifiers:{"add-new-item":true}}],staticClass:"btn  btn-primary float-right"},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("Add Workshifts")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Sched Type")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Sched Time")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Timezones")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('br'),_c('i',[_vm._v(_vm._s(item.position_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.schedule)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.time))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.timezone_name))]),_vm._v(" "),_c('td',{attrs:{"width":"170"}},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-schedule",modifiers:{"update-schedule":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"href":"#","title":"click to update designation item and position name"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"title":"Delete Entry"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('li',{staticClass:"fa fa-trash-o"}),_vm._v(" Delete")])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e(),_vm._v(" "),_c('b-modal',{ref:"add-new-item",attrs:{"id":"add-new-item","size":"l","title":"Register Workshifts","hide-footer":""}},[_c('h3',[_vm._v("Workshifts")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee Name:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("-- Select Employee --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(emp.full_name))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sched Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSched),expression:"selectedSched"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.schedule},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSched=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Schedule --")]),_vm._v(" "),_vm._l((_vm.schedules),function(sched_obj,sched_index){return _c('option',{domProps:{"value":sched_index}},[_vm._v(_vm._s(sched_index))])})],2),_vm._v(" "),(_vm.error_handler.schedule)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.schedule[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sched Time:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTime),expression:"selectedTime"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.time},attrs:{"disabled":_vm.sched_items.length == 0},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTime=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Time --")]),_vm._v(" "),_vm._l((_vm.sched_items),function(time_obj,time_index){return _c('option',{domProps:{"value":time_obj.time}},[_vm._v(_vm._s(time_obj.time))])})],2),_vm._v(" "),(_vm.error_handler.time)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.time[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timezone:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timezoneId),expression:"timezoneId"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.timezone_id},attrs:{"click":"hide_message_timezone_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timezoneId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.timezoneItem),function(time){return _c('option',{domProps:{"value":time.id,"textContent":_vm._s(time.timezone_name)}})})],2),_vm._v(" "),(_vm.error_handler.timezone_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.timezone_id[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.add_new_item}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit form")])])]),_vm._v(" "),_c('b-modal',{ref:"hide-update-sched",attrs:{"id":"update-schedule","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_employee.full_name)))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sched Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSched),expression:"selectedSched"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSched=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Schedule --")]),_vm._v(" "),_vm._l((_vm.schedules),function(sched_obj,sched_index){return _c('option',{domProps:{"value":sched_index}},[_vm._v(_vm._s(sched_index))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sched Time:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTime),expression:"selectedTime"}],staticClass:"form-control",attrs:{"disabled":_vm.sched_items.length == 0},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTime=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Time --")]),_vm._v(" "),_vm._l((_vm.sched_items),function(time_obj,time_index){return _c('option',{domProps:{"value":time_obj.time}},[_vm._v(_vm._s(time_obj.time))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timezone:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timezoneId),expression:"timezoneId"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.timezone_id},attrs:{"click":"hide_message_timezone_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timezoneId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.timezoneItem),function(time){return _c('option',{domProps:{"value":time.id,"textContent":_vm._s(time.timezone_name)}})})],2),_vm._v(" "),(_vm.error_handler.timezone_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.timezone_id[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_schedule}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AyGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to VA - NZ/AU")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To VA - NZ/AU")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to VA - NZ/AU")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"multiple","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                             "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                  "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B0do":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('system-settings')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B3Ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_form_vue__ = __webpack_require__("LiMT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312ab544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_form_vue__ = __webpack_require__("Pdbh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312ab544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B4Ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_view_responsibility__ = __webpack_require__("eHqH");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        viewResponsibility: __WEBPACK_IMPORTED_MODULE_0__todo_view_responsibility__["a" /* default */]
    }
});

/***/ }),

/***/ "B4jD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B5kz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B7wY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Update NTE Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Update NTE Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"float-lg-right"},[_c('h3',[_c('i',{staticClass:"fa fa-user"}),_vm._v("  "+_vm._s(_vm._f("capitalize")(_vm.item.full_name)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br')]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateForm($event)}}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 "},[_c('label',[_vm._v("Corrective Action To be Taken")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corrective),expression:"corrective"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.action_to_be_taken},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.corrective=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.dismissal]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One --")]),_vm._v(" "),_c('option',{attrs:{"value":"nte"}},[_vm._v("Notice To Explain")]),_vm._v(" "),_c('option',{attrs:{"value":"suspension"}},[_vm._v("Suspension")]),_vm._v(" "),_c('option',{attrs:{"value":"dismissal"}},[_vm._v("Dismissal")])]),_vm._v(" "),(_vm.error_handler.action_to_be_taken)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.action_to_be_taken[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Request")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_request),expression:"item.date_request"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_request},attrs:{"type":"date"},domProps:{"value":(_vm.item.date_request)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_request", $event.target.value)}}}),_vm._v(" "),(_vm.error_handler.date_request)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_request[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Incident")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_incident),expression:"item.date_incident"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_incident},attrs:{"type":"date"},domProps:{"value":(_vm.item.date_incident)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_incident", $event.target.value)}}}),_vm._v(" "),(_vm.error_handler.date_incident)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_incident[0]))]):_vm._e()])]),_vm._v(" "),(_vm.corrective == 'nte')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"VW - Verbal Warning"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"VW - Verbal Warning")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "VW - Verbal Warning")}}}),_vm._v(" VW - Verbal Warning\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 1"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"NTE 1")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "NTE 1")}}}),_vm._v(" NTE 1\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 2"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"NTE 2")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "NTE 2")}}}),_vm._v(" NTE 2\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 3"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"NTE 3")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "NTE 3")}}}),_vm._v(" NTE 3\n                    ")],1)]):_vm._e(),_vm._v(" "),(_vm.corrective == 'suspension')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"3 Days Suspension"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"3 Days Suspension")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "3 Days Suspension")}}}),_vm._v(" 3 Days Suspension\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.action_to_be_taken),expression:"item.action_to_be_taken"}],attrs:{"type":"radio","value":"10 Days Suspension"},domProps:{"checked":_vm._q(_vm.item.action_to_be_taken,"10 Days Suspension")},on:{"change":function($event){_vm.$set(_vm.item, "action_to_be_taken", "10 Days Suspension")}}}),_vm._v(" 10 Days Suspension\n                    ")],1)]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Infraction Details")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Type of Infraction :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.type_of_infraction),expression:"item.type_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.type_of_infraction},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "type_of_infraction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.get_previous_infraction]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select Infraction Type --")]),_vm._v(" "),_c('option',[_vm._v("i. Attendance and Punctuality")]),_vm._v(" "),_c('option',[_vm._v("ii. Time Keeping Infraction")]),_vm._v(" "),_c('option',[_vm._v("iii. Office Protocol and Decorum")]),_vm._v(" "),_c('option',[_vm._v("iv. Neglect of Duty")]),_vm._v(" "),_c('option',[_vm._v("v. Fraud and Similar Acts Prejudicial to Company Interest")]),_vm._v(" "),_c('option',[_vm._v("vi. Health and Sanitation")]),_vm._v(" "),_c('option',[_vm._v("vii. Company Facilities and Property")]),_vm._v(" "),_c('option',[_vm._v("viii. Insubordination")]),_vm._v(" "),_c('option',[_vm._v("ix. Confidentiality of Work and Information")]),_vm._v(" "),_c('option',[_vm._v("x. The Use of Workstations, Computer, Computer Programs, etc.")]),_vm._v(" "),_c('option',[_vm._v("xi. People Management")]),_vm._v(" "),_c('option',[_vm._v("xii. Policy on Call Handling")]),_vm._v(" "),_c('option',[_vm._v("xiii. Sexual Harrassment")]),_vm._v(" "),_c('option',[_vm._v("xiv. Prohibited Drugs and Paraphernalia")])]),_vm._v(" "),(_vm.error_handler.type_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.type_of_infraction[0]))]):_vm._e(),_vm._v(" "),(_vm.infraction_item != '')?_c('span',[_c('div',{staticClass:"infraction-border"},[_c('b',[_vm._v("Previous Infraction")]),_c('br'),_vm._v(" "),_vm._l((_vm.infraction_item),function(item){return _c('span',[_c('i',{staticClass:"fa fa-stop-circle-o"}),_vm._v(" "+_vm._s(item.type_of_infraction)+" \n                      "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.view-details",modifiers:{"view-details":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_vm._v(" "),_c('u',[_vm._v("View Details")])]),_vm._v(" "),_c('br')])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Details of Infraction")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.details_of_infraction),expression:"item.details_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.details_of_infraction},attrs:{"rows":"6"},domProps:{"value":(_vm.item.details_of_infraction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "details_of_infraction", $event.target.value)}}}),_vm._v(" "),(_vm.error_handler.details_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.details_of_infraction[0]))]):_vm._e()])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v("Details of Occurence")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},_vm._l((_vm.item.occurence),function(res,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of Occurence:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.date),expression:"res.date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(res.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Item Description:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.detail),expression:"res.detail"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(res.detail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "detail", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"floater-point"},[_c('div',{staticClass:"action-item-occurence"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_form($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.delete_form(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("ATTACHMENT FILE")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row col-md-12"},[_c('div',{staticClass:"upload-btn-wrapper "},_vm._l((_vm.item.data_files),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.file_type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.file_type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.file_type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.file_type=='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.file_type=='image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):_vm._e(),_vm._v("   \n                      "),_c('a',{attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + file.file_name,"target":"_blank"}},[_vm._v(_vm._s(file.file_name))]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.removeExistingFiles(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper "},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"nteFiles"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("Attach Files")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"nteFiles","multiple":"multiple","accept":".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif"},on:{"change":_vm.handleNteFilesUpload}}),_vm._v(" "),_vm._l((_vm.nteFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.type=='image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):_vm._e(),_vm._v("   \n                   "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n          "),_c('span',{on:{"click":function($event){_vm.removenteFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BCxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_holidays__ = __webpack_require__("aRO9");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        holidays: __WEBPACK_IMPORTED_MODULE_0__todo_holidays__["a" /* default */]
    }
});

/***/ }),

/***/ "BJka":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMSm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "BPsy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BcDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_edit_request__ = __webpack_require__("n2B/");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteEditRequest: __WEBPACK_IMPORTED_MODULE_0__todo_nte_edit_request__["a" /* default */]
    }
});

/***/ }),

/***/ "BfZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-cd-hw')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CCLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CH5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_notice_for_decision_vue__ = __webpack_require__("mCjc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73686340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_notice_for_decision_vue__ = __webpack_require__("8i2c");
function injectStyle (ssrContext) {
  __webpack_require__("KjbV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_notice_for_decision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73686340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_notice_for_decision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CNff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to Admin")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To Admin")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to Admin")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                          "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                     "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CPzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Employment Datasheet")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v("  Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("New Employee")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Work Shift")]),_vm._v(" "),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Schedule Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSched),expression:"selectedSched"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.schedule},on:{"click":_vm.hide_message_scheduleType,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSched=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Schedule --")]),_vm._v(" "),_vm._l((_vm.schedules),function(sched_obj,sched_index){return _c('option',{domProps:{"value":sched_index}},[_vm._v(_vm._s(sched_index))])})],2),_vm._v(" "),(_vm.error_handler.schedule)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.schedule[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTime),expression:"selectedTime"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.time},attrs:{"disabled":_vm.sched_items.length == 0},on:{"click":_vm.hide_message_scheduleTime,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTime=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Time --")]),_vm._v(" "),_vm._l((_vm.sched_items),function(time_obj,time_index){return _c('option',{domProps:{"value":time_obj.time}},[_vm._v(_vm._s(time_obj.time))])})],2),_vm._v(" "),(_vm.error_handler.time)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.time[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timezone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timezoneId),expression:"timezoneId"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.timezone_id},on:{"click":_vm.hide_message_timezone_id,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timezoneId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.timezoneItem),function(time){return _c('option',{domProps:{"value":time.id,"textContent":_vm._s(time.timezone_name)}})})],2),_vm._v(" "),(_vm.error_handler.timezone_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.timezone_id[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Job Information")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee No ")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-###']),expression:"['####-###']"},{name:"model",rawName:"v-model",value:(_vm.emp_id),expression:"emp_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.emp_id},attrs:{"placeholder":"Ex.100035"},domProps:{"value":(_vm.emp_id)},on:{"click":_vm.hide_message_employeeNo,"input":function($event){if($event.target.composing){ return; }_vm.emp_id=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.emp_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.emp_id[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sub Department Belong")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sub_department_id),expression:"sub_department_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.sub_department_id},on:{"click":_vm.hide_message_departmentBelong,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sub_department_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.subDepartmentItem),function(sub){return _c('option',{domProps:{"value":sub.id,"textContent":_vm._s(sub.sub_department_name)}})})],2),_vm._v(" "),(_vm.error_handler.sub_department_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.sub_department_id[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Job Title / Position")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position_id),expression:"position_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.position_id},on:{"click":_vm.hide_message_position,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.positionsItem),function(pos){return _c('option',{domProps:{"value":pos.id,"textContent":_vm._s(pos.position_name)}})})],2),_vm._v(" "),(_vm.error_handler.position_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.position_id[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-money"}),_vm._v("  Basic Salary ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basic_salary),expression:"basic_salary"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.basic_salary},attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.basic_salary)},on:{"click":_vm.hide_message_salary,"input":function($event){if($event.target.composing){ return; }_vm.basic_salary=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.basic_salary)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.basic_salary[0]))]):_vm._e()]),_vm._v(" "),(_vm.basic_salary == '0')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.others_salary),expression:"others_salary"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.others_salary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.others_salary=$event.target.value}}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-money"}),_vm._v("  Allowance ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.monthly_allowance),expression:"monthly_allowance"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.monthly_allowance},attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.monthly_allowance)},on:{"click":_vm.hide_message_allowance,"input":function($event){if($event.target.composing){ return; }_vm.monthly_allowance=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.monthly_allowance)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.monthly_allowance[0]))]):_vm._e()]),_vm._v(" "),(_vm.monthly_allowance == '0')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.others_allowance),expression:"others_allowance"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.others_allowance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.others_allowance=$event.target.value}}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  Date Hired ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employment_date),expression:"employment_date"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employment_date},attrs:{"type":"date"},domProps:{"value":(_vm.employment_date)},on:{"click":_vm.hide_message_dateHired,"input":function($event){if($event.target.composing){ return; }_vm.employment_date=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.employment_date)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employment_date[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  Date Signed ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_sign),expression:"date_sign"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.date_sign)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_sign=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  Training Startdate ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.training_date),expression:"training_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.training_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.training_date=$event.target.value}}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-user "}),_vm._v(" Personal Information")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Required")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.first_name},attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Ex.Juan"},domProps:{"value":(_vm.first_name)},on:{"click":_vm.hide_message_firstName,"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.first_name)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.first_name[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last name : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.last_name),expression:"last_name"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.last_name},attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Ex.Dela Cruz"},domProps:{"value":(_vm.last_name)},on:{"click":_vm.hide_message_lastName,"input":function($event){if($event.target.composing){ return; }_vm.last_name=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.last_name)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.last_name[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Middle name : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.middle_name),expression:"middle_name"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.middle_name},attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Ex.Dalisay"},domProps:{"value":(_vm.middle_name)},on:{"click":_vm.hide_message_middleName,"input":function($event){if($event.target.composing){ return; }_vm.middle_name=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.middle_name)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.middle_name[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Suffix : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.suffix),expression:"suffix"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.suffix=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose")]),_vm._v(" "),_c('option',{attrs:{"value":"Jr"}},[_vm._v("Jr")]),_vm._v(" "),_c('option',{attrs:{"value":"Sr"}},[_vm._v("Sr")]),_vm._v(" "),_c('option',{attrs:{"value":"I"}},[_vm._v("I")]),_vm._v(" "),_c('option',{attrs:{"value":"II"}},[_vm._v("II")]),_vm._v(" "),_c('option',{attrs:{"value":"III"}},[_vm._v("III")]),_vm._v(" "),_c('option',{attrs:{"value":"IV"}},[_vm._v("IV")]),_vm._v(" "),_c('option',{attrs:{"value":"IV"}},[_vm._v("V")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Civil Status : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.civil_status),expression:"civil_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.civil_status},on:{"click":_vm.hide_message_civilStatus,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.civil_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose")]),_vm._v(" "),_c('option',{attrs:{"value":"single"}},[_vm._v("Single")]),_vm._v(" "),_c('option',{attrs:{"value":"married"}},[_vm._v("Married")]),_vm._v(" "),_c('option',{attrs:{"value":"divorced"}},[_vm._v("Divorced")]),_vm._v(" "),_c('option',{attrs:{"value":"widowed"}},[_vm._v("Widowed")])]),_vm._v(" "),(_vm.error_handler.civil_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.civil_status[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  Birth date : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.birthdate),expression:"birthdate"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.birthdate},attrs:{"type":"date"},domProps:{"value":(_vm.birthdate)},on:{"click":_vm.hide_message_birthDate,"input":function($event){if($event.target.composing){ return; }_vm.birthdate=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.birthdate)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.birthdate[0]))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v("  Current Address : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current_address),expression:"current_address"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.current_address},attrs:{"type":"text"},domProps:{"value":(_vm.current_address)},on:{"click":_vm.hide_message_currentAddress,"input":function($event){if($event.target.composing){ return; }_vm.current_address=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.current_address)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.current_address[0]))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v("  Permanent address : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.permanent_address),expression:"permanent_address"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.permanent_address},attrs:{"type":"text"},domProps:{"value":(_vm.permanent_address)},on:{"click":_vm.hide_message_permanentAddress,"input":function($event){if($event.target.composing){ return; }_vm.permanent_address=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.permanent_address)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.permanent_address[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-address-book-o"}),_vm._v(" Contact Information")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Required")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-phone"}),_vm._v("  Contact no.  ")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-########']),expression:"['####-########']"},{name:"model",rawName:"v-model",value:(_vm.contact),expression:"contact"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.contact},attrs:{"type":"tel"},domProps:{"value":(_vm.contact)},on:{"click":_vm.hide_message_contactNo,"input":function($event){if($event.target.composing){ return; }_vm.contact=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.contact)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.contact[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Personal Email address : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_address),expression:"email_address"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.email_address},attrs:{"type":"email","placeholder":"Ex.juandelacrus@gmail.com"},domProps:{"value":(_vm.email_address)},on:{"click":_vm.hide_message_personalEmail,"input":function($event){if($event.target.composing){ return; }_vm.email_address=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.email_address)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.email_address[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" Emergency No")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-########']),expression:"['####-########']"},{name:"model",rawName:"v-model",value:(_vm.emergency_no),expression:"emergency_no"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.emergency_no},attrs:{"type":"tel"},domProps:{"value":(_vm.emergency_no)},on:{"click":_vm.hide_message_emergencyNo,"input":function($event){if($event.target.composing){ return; }_vm.emergency_no=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.emergency_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.emergency_no[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Contact Person")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact_person),expression:"contact_person"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.contact_person},attrs:{"type":"text","placeholder":"Ex.Juan Dela Cruz"},domProps:{"value":(_vm.contact_person)},on:{"click":_vm.hide_message_contactPerson,"input":function($event){if($event.target.composing){ return; }_vm.contact_person=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.contact_person)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.contact_person[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Relationship : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relationship),expression:"relationship"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.relationship},on:{"click":_vm.hide_message_relationship,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.relationship=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Mother"}},[_vm._v("Mother")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Father")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Daughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Son"}},[_vm._v("Son")]),_vm._v(" "),_c('option',{attrs:{"value":"Sister"}},[_vm._v("Sister")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Brother")]),_vm._v(" "),_c('option',{attrs:{"value":"Aunt"}},[_vm._v("Aunt")]),_vm._v(" "),_c('option',{attrs:{"value":"Uncle"}},[_vm._v("Uncle")]),_vm._v(" "),_c('option',{attrs:{"value":"Niece"}},[_vm._v("Niece")]),_vm._v(" "),_c('option',{attrs:{"value":"Nephew"}},[_vm._v("Nephew")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Sibling")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Guardian")]),_vm._v(" "),_c('option',{attrs:{"value":"Live in Partner"}},[_vm._v("Live in Partner")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Female)"}},[_vm._v("Cousin(Female)")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Male)"}},[_vm._v("Cousin(Male)")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandmother"}},[_vm._v("Grandmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Grandfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Granddaughter"}},[_vm._v("Granddaughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandson"}},[_vm._v("Grandson")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepsister"}},[_vm._v("Stepsister")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepbrother"}},[_vm._v("Stepbrother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepmother"}},[_vm._v("Stepmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepfather"}},[_vm._v("Stepfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Girlfreind"}},[_vm._v("Girlfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Boyfreind"}},[_vm._v("Boyfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Wife"}},[_vm._v("Wife")]),_vm._v(" "),_c('option',{attrs:{"value":"Husband"}},[_vm._v("Husband")])]),_vm._v(" "),(_vm.error_handler.relationship)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.relationship[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Employee Experience")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Optional")]),_vm._v(" "),_vm._l((_vm.experience),function(epx,index){return _c('div',[_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employeer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.employeer),expression:"epx.employeer"}],staticClass:"form-control",domProps:{"value":(epx.employeer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "employeer", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.company_address),expression:"epx.company_address"}],staticClass:"form-control",domProps:{"value":(epx.company_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "company_address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Job Title / Position")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.job_title),expression:"epx.job_title"}],staticClass:"form-control",domProps:{"value":(epx.job_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "job_title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.start_date),expression:"epx.start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(epx.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "start_date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.end_date),expression:"epx.end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(epx.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "end_date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Previous Salary")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(epx.previous_salary),expression:"epx.previous_salary"},{name:"mask",rawName:"v-mask",value:(['##,###.00']),expression:"['##,###.00']"}],staticClass:"form-control",domProps:{"value":(epx.previous_salary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "previous_salary", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reason for leaving")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(epx.reason_for_leaving),expression:"epx.reason_for_leaving"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(epx.reason_for_leaving)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(epx, "reason_for_leaving", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"floater-point-exp"},[_c('div',{staticClass:"action-item-exp-employee"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to add new employee experience section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_experience($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to remove employee experience section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.deleteUser(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-hospital-o"}),_vm._v(" Employee Benefits")]),_vm._v(" "),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) To be filled out later ")]),_vm._v(" "),_c('div',{staticClass:"border-box-new-employee"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("SSS No")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.sss_no},attrs:{"mask":['##-#######-#'],"placeholder":"00-0000000-0"},model:{value:(_vm.sss_no),callback:function ($$v) {_vm.sss_no=$$v},expression:"sss_no"}}),_vm._v(" "),(_vm.error_handler.sss_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.sss_no[0]))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("HDMF No")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hdmf_no},attrs:{"mask":['####-####-####'],"placeholder":"0000-0000-0000"},model:{value:(_vm.hdmf_no),callback:function ($$v) {_vm.hdmf_no=$$v},expression:"hdmf_no"}}),_vm._v(" "),(_vm.error_handler.hdmf_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hdmf_no[0]))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("MID No")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.mid_no},attrs:{"mask":['####-####-####'],"placeholder":"0000-0000-0000"},model:{value:(_vm.mid_no),callback:function ($$v) {_vm.mid_no=$$v},expression:"mid_no"}}),_vm._v(" "),(_vm.error_handler.mid_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.mid_no[0]))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TIN No")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tin_no},attrs:{"mask":['###-###-###'],"placeholder":"000-000-000"},model:{value:(_vm.tin_no),callback:function ($$v) {_vm.tin_no=$$v},expression:"tin_no"}}),_vm._v(" "),(_vm.error_handler.tin_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tin_no[0]))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("PHIC No")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.phic_no},attrs:{"mask":['##-#########-#'],"placeholder":"00-000000000-0"},model:{value:(_vm.phic_no),callback:function ($$v) {_vm.phic_no=$$v},expression:"phic_no"}}),_vm._v(" "),(_vm.error_handler.phic_no)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.phic_no[0]))]):_vm._e()],1)])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4 float-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},on:{"click":_vm.resForm}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Reset all fields")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"100%"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Datasheet")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CR8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('view-job')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/admin/overview'
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D+9+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Notice for Approval")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Notice for Approval")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.item.asm_status == 'approved')?_c('b-alert',{attrs:{"show":"","dismissible":""}},[_c('strong',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.requested_by)))]),_vm._v(" - Request NTE to "),_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.full_name)))]),_vm._v(", "+_vm._s(_vm.item.infraction)+"\n        ")]):_vm._e()],1)]),_vm._v(" "),_c('img',{attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header-nte"},[_vm._v("NOTICE TO EXPLAIN")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 b-right"},[_c('b',[_vm._v("Employee Name:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.full_name))+"\n          "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Supervisor Name: ")]),_vm._v(_vm._s(_vm.item.superior_name)+"\n          "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-4 b-right"},[_c('b',[_vm._v("Date Notice: ")]),_vm._v(_vm._s(_vm.getDate(_vm.item.date_incident))+"\n          "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Position:")]),_vm._v(" "+_vm._s(_vm.item.position_name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("ID No. : ")]),_vm._v(_vm._s(_vm.item.emp_no)+"\n          "),_c('br')])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update_form($event)}}},[_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Type of Infraction:")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.item.type_of_infraction)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Details of Occurence:")]),_vm._v(" "),_vm._l((_vm.item.occurence),function(res,i){return _c('span',[_c('br'),_c('b',[_vm._v(_vm._s(i+1))]),_vm._v(".  "+_vm._s(res.date)+"    "+_vm._s(res.details)+"\n        ")])}),_vm._v(" "),_c('br'),_c('br')],2),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Details of Infraction:")]),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.details_of_infraction))])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Corrective Action to be Taken")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corrective),expression:"corrective"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.corrective=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One --")]),_vm._v(" "),_c('option',{attrs:{"value":"nte"}},[_vm._v("Notice To Explain")]),_vm._v(" "),_c('option',{attrs:{"value":"suspension"}},[_vm._v("Suspension")]),_vm._v(" "),_c('option',{attrs:{"value":"others"}},[_vm._v("Others")])]),_vm._v(" "),_c('br')]),_vm._v(" "),(_vm.corrective == 'nte')?_c('div',[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"col-md-12 report-border-full"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"VW - Verbal Warning"},domProps:{"checked":_vm._q(_vm.corection_plan,"VW - Verbal Warning")},on:{"change":function($event){_vm.corection_plan="VW - Verbal Warning"}}}),_vm._v(" VW - Verbal Warning\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"NTE 1"},domProps:{"checked":_vm._q(_vm.corection_plan,"NTE 1")},on:{"change":function($event){_vm.corection_plan="NTE 1"}}}),_vm._v(" NTE 1\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"NTE 2"},domProps:{"checked":_vm._q(_vm.corection_plan,"NTE 2")},on:{"change":function($event){_vm.corection_plan="NTE 2"}}}),_vm._v(" NTE 2\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"NTE 3"},domProps:{"checked":_vm._q(_vm.corection_plan,"NTE 3")},on:{"change":function($event){_vm.corection_plan="NTE 3"}}}),_vm._v(" NTE 3\n          ")])])],1):_vm._e(),_vm._v(" "),(_vm.corrective == 'suspension')?_c('div',[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"col-md-12 report-border-full"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"3 Days Suspension"},domProps:{"checked":_vm._q(_vm.corection_plan,"3 Days Suspension")},on:{"change":function($event){_vm.corection_plan="3 Days Suspension"}}}),_vm._v(" 3 Days Suspension\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"10 Days Suspension"},domProps:{"checked":_vm._q(_vm.corection_plan,"10 Days Suspension")},on:{"change":function($event){_vm.corection_plan="10 Days Suspension"}}}),_vm._v(" 10 Days Suspension\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"15 Days Suspension"},domProps:{"checked":_vm._q(_vm.corection_plan,"15 Days Suspension")},on:{"change":function($event){_vm.corection_plan="15 Days Suspension"}}}),_vm._v(" 15 Days Supension\n          ")])])],1):_vm._e(),_vm._v(" "),(_vm.corrective == 'others')?_c('div',[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corection_plan),expression:"corection_plan"}],attrs:{"type":"radio","value":"Dismissal"},domProps:{"checked":_vm._q(_vm.corection_plan,"Dismissal")},on:{"change":function($event){_vm.corection_plan="Dismissal"}}}),_vm._v(" Dismissal\n        ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v("HR Approval: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.hr_status),expression:"item.hr_status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "hr_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("Approve Request")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("Decline Request")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("Pending Request")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("FILE ATTACHMENT")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row col-md-12"},[_c('div',{staticClass:"upload-btn-wrapper "},_vm._l((_vm.item.data_files),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.file_type == 'vnd.ms-excel')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.file_type =='jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.file_type == 'jpg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.file_type == 'png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.file_type == 'docx')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.file_type == 'csv')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.file_type == 'text/csv')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.file_type == 'pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x",staticStyle:{"color":"red"}})]):(file.file_type == 'ms-doc')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.file_type == 'msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.file_type == 'doc')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.file_type == 'vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):_vm._e(),_vm._v("\n                          "),_c('a',{attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + file.file_name,"target":"_blank"}},[_vm._v(_vm._s(file.file_name))]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.removeExistingFiles(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper "},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"nteFiles"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("Attach Files")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"nteFiles","multiple":"multiple","accept":".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif"},on:{"change":_vm.handleNteFilesUpload}}),_vm._v(" "),_vm._l((_vm.nteFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/vnd.ms-excel')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.type == 'text/csv')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.type == 'application/csv')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"green"}})]):(file.type =='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.type == 'image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.type == 'application/docx')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x",staticStyle:{"color":"red"}})]):(file.type == 'application/ms-doc')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.type == 'application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):(file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"blue"}})]):_vm._e(),_vm._v("  \n                       "+_vm._s(file.name)+"\n              "),_c('span',{on:{"click":function($event){_vm.removenteFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Approval")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0005")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D1iC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_undertime_form_vue__ = __webpack_require__("w7om");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d23444_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_undertime_form_vue__ = __webpack_require__("lgxh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_undertime_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d23444_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_undertime_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D3JF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('department')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DBhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DIyc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DSn1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Employee Name :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name",attrs:{"data-full_name":_vm.item.full_name}},[_vm._v(_vm._s(_vm.item.full_name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Employee No :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name",attrs:{"data-emp_id":_vm.item.emp_id}},[_vm._v(_vm._s(_vm.item.emp_id))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Position :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Department :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Date Hired :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  "+_vm._s(_vm.item.employment_date))])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Memos")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[(_vm.files.data_files != '')?_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Update Existing Memo\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.files.data_files == '')?_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo\n                                    ")]):_vm._e()]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                       "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                    "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),(_vm.files != '')?_c('hr',{staticStyle:{"margin-top":"50px"}}):_vm._e(),_vm._v(" "),(_vm.files != '')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Existing Memo/s")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]):_vm._e(),_vm._v(" "),(_vm.files != '')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},_vm._l((_vm.files),function(file_item,key){return _c('div',{key:key,staticClass:"mb-2"},[(file_item.data_files != '')?_c('div',_vm._l((file_item.data_files),function(item){return _c('div',{key:key,staticClass:"mb-2"},[(item.file_type == 'pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(item.file_type=='docx')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(item.file_type=='doc')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                                   "),_c('a',{attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + item.file_name,"target":"_blank"}},[_vm._v(_vm._s(item.file_name))]),_vm._v("    \n                                                "),(file_item.status === 'unacknowledged')?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-eye-slash text-secondary",staticStyle:{"font-size":"20px","cursor":"pointer"},attrs:{"aria-hidden":"true","title":"UNACKNOWLEDGED"}}):_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-eye text-success text-big",staticStyle:{"font-size":"20px"},attrs:{"aria-hidden":"true","title":"ACKNOWLEDGED"}}),_vm._v("     -      "),_c('span',{staticClass:"text-secondary"},[_vm._v("Sent on: "+_vm._s(new Date(file_item.date_sent).toDateString()))])],2)}),0):_vm._e()])}),0)])])]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DUNh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ds5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
     components: {
          Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
     },
     data: function data() {
          return {
               items: [],
               //input fields
               roles_name: '',
               description: '',
               //handler
               error_handler: [],
               error_exist: ''
          };
     },


     mounted: function mounted() {},

     methods: {
          formSubmit: function formSubmit(e) {
               var _this = this;

               e.preventDefault();
               this.$swal({
                    title: 'Are you sure?',
                    text: 'Do you want to save',
                    type: 'warning',
                    showCancelButton: true,
                    showCloseButton: false
               }).then(function (isConfirm) {
                    if (isConfirm === true) {
                         axios.post('api/userroles/add', {
                              roles_name: _this.roles_name,
                              description: _this.description
                         }).then(function (resp) {
                              if (resp.data.response == 'exist') {
                                   _this.error_exist = resp.data.message;
                                   console.log(resp.data.response);
                                   _this.$swal('Error', 'Already exist', 'error');
                              } else {
                                   console.log('response => save');
                                   _this.$swal('Save', 'You successfully save this file', 'success');
                                   _this.$router.push({ name: 'users-roles' });
                                   _this.roles_name = '';
                                   _this.description = '';
                              }
                         }).catch(function (error) {
                              if (error.response.status == 422) {
                                   _this.error_handler = error.response.data.errors;
                              }
                              console.log('response => ', error.response.data);
                         });
                    }
               });
          }
     }

});

/***/ }),

/***/ "E0bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_contributions_form__ = __webpack_require__("B3Ha");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        contributionsForm: __WEBPACK_IMPORTED_MODULE_0__todo_contributions_form__["a" /* default */]
    }
});

/***/ }),

/***/ "E7be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntegerPlusminus_vue__ = __webpack_require__("dCLU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8b1fbb96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntegerPlusminus_vue__ = __webpack_require__("u0IV");
function injectStyle (ssrContext) {
  __webpack_require__("S26g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b1fbb96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntegerPlusminus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8b1fbb96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntegerPlusminus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E8lQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_supervisor_account_vue__ = __webpack_require__("YYyO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed199d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_supervisor_account_vue__ = __webpack_require__("fyAm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_supervisor_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed199d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_supervisor_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EPvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('employee-list')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_list_vue__ = __webpack_require__("HMa9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5e7a65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_list_vue__ = __webpack_require__("VSKT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5e7a65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Eeo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_upload_payslip_vue__ = __webpack_require__("dsQ7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2127598a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_upload_payslip_vue__ = __webpack_require__("n13/");
function injectStyle (ssrContext) {
  __webpack_require__("h7Jy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_upload_payslip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2127598a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_upload_payslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Es3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Evtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_undertime_request__ = __webpack_require__("qS/h");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        undertimeRequest: __WEBPACK_IMPORTED_MODULE_0__todo_undertime_request__["a" /* default */]
    }
});

/***/ }),

/***/ "F3tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_mantra_vue__ = __webpack_require__("I3gI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42686bdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_mantra_vue__ = __webpack_require__("ouGH");
function injectStyle (ssrContext) {
  __webpack_require__("rM7B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_mantra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42686bdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_mantra_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FEU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('todo-new-employee')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FK/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_employee_coached_details__ = __webpack_require__("rZQL");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        employeeCoachedDetails: __WEBPACK_IMPORTED_MODULE_0__todo_employee_coached_details__["a" /* default */]
    }
});

/***/ }),

/***/ "FN/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fc+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_integer_plusminus__ = __webpack_require__("5G+X");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
      IntegerPlusminus: __WEBPACK_IMPORTED_MODULE_2_vue_integer_plusminus__["a" /* IntegerPlusminus */]
   },
   data: function data() {
      return {
         responsibility: [{
            name: '',
            description: '',
            received: ''
         }],
         quantity: '',
         items: [],
         emp: ''
      };
   },

   mounted: function mounted() {
      this.get_employees();
   },
   methods: {
      add_form: function add_form() {
         this.responsibility.push({
            name: '',
            description: '',
            received: ''
         });
      },

      delete_form: function delete_form(index) {
         console.log(index);
         console.log(this.finds);
         this.responsibility.splice(index, 1);
         if (index === 0) this.add_form();
      },

      formSubmit: function formSubmit(e) {
         var _this = this;

         e.preventDefault();
         this.$swal({
            title: 'Are you sure?',
            text: 'Do you want to save',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false
         }).then(function (isConfirm) {
            if (isConfirm === true) {
               axios.post('api/manualresponsibility/add', {
                  employee_id: _this.emp,
                  responsibility: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.responsibility)
               }).then(function (resp) {

                  _this.$swal('Save', resp.data.success, 'success');
                  _this.$router.push({
                     name: 'responsibility-form'
                  });
                  _this.clear_data();
                  console.log(resp);
               }).catch(function (error) {
                  console.log('response => ', error.response.data);
               });
            }
         });
      },
      get_employees: function get_employees() {
         var _this2 = this;

         axios.get('api/employeenoresponsibility').then(function (response) {
            _this2.items = response.data;
         }).catch(function (error) {
            console.log(error.response);
         });
      },
      clear_data: function clear_data() {
         this.responsibility = [{
            name: '',
            description: '',
            received: ''
         }];
      }
   }

});

/***/ }),

/***/ "Fe3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      employees: [],
      loading: true,
      //FILTER
      search: '',
      order_by: '',
      page_limit: '',
      start_page: 1,
      sortAsc: true,
      //PAGINATION
      perPage: 100,
      curentPage: 1,
      //Indicator
      display_indicator: ''
    };
  },


  mounted: function mounted() {
    this.get_schedule_adjustment_record();
  },

  methods: {
    get_schedule_adjustment_record: function get_schedule_adjustment_record() {
      var _this = this;

      axios.get('api/scheduleadjustment').then(function (response) {
        _this.items = response.data;
        _this.loading = false;
        _this.display_indicator = 2;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    deleteItem: function deleteItem(id, index) {
      var _this2 = this;

      /* USING SWEET ALERT */

      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/scheduleadjustment/delete/' + id).then(function (response) {
            _this2.get_schedule_adjustment_record(); //--> reloader 
            _this2.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response);
            _this2.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedEmployee: function computedEmployee() {
      var _this3 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this3.order_by : -_this3.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }

});

/***/ }),

/***/ "FfRg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FqER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_add_responsibility_form__ = __webpack_require__("wxom");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        addResponsibility: __WEBPACK_IMPORTED_MODULE_0__todo_add_responsibility_form__["a" /* default */]
    }
});

/***/ }),

/***/ "Ftyv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('todo-requirements')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fz/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },

   data: function data() {
      var _ref;

      return _ref = {
         //ITEMS
         item: {},
         nteFiles: [],
         files: []
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'files', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'occurence', [{
         dates: '',
         detail: ''
      }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'corrective', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'error_handler', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selected_item', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'type_of_infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'infraction_item', []), _ref;
   },


   mounted: function mounted() {
      this.getItem();
      this.get_previous_infraction();
   },

   methods: {
      add_form: function add_form() {
         this.item.occurence.push({
            date: '',
            detail: ''
         });
      },
      delete_form: function delete_form(index) {
         this.item.occurence.splice(index, 1);
         if (index === 0) this.add_form();
      },
      get_selected_id: function get_selected_id(item) {
         this.selected_item = item;
      },
      get_previous_infraction: function get_previous_infraction(id) {
         var _this = this;

         axios.post('api/infraction/find', {
            id: this.item.emp_id,
            type_of_infraction: this.type_of_infraction
         }).then(function (resp) {
            _this.infraction_item = resp.data;
         }).catch(function (error) {
            console.log(error.response);
         });
      },
      dismissal: function dismissal() {
         if (this.corrective == 'dismissal') {
            this.action_to_be_taken = 'Dismissal';
         }
      },
      getItem: function getItem() {
         var _this2 = this;

         axios.get('api/nterequestbyhr/get/' + this.$route.params.id).then(function (resp) {
            _this2.item = resp.data;
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
         }).catch(function (error) {
            if (error.response.status == 422) {
               _this2.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
         });
      },
      getDate: function getDate(date) {
         return moment(date).format('MMM DD YYYY');
      },


      //FILE UPLOAD
      handleNteFilesUpload: function handleNteFilesUpload() {
         var uploadedNTEFiles = event.target.files;
         if (!uploadedNTEFiles.length) return;
         for (var i = 0; i < uploadedNTEFiles.length; i++) {
            this.nteFiles.push(uploadedNTEFiles[i]);
         }
         console.log('response => ', uploadedNTEFiles);
      },
      removenteFilesUpload: function removenteFilesUpload(key) {
         this.nteFiles.splice(key, 1);
         console.log(this.nteFiles);
      },
      removeExistingFiles: function removeExistingFiles(key) {
         this.item.data_files.splice(key, 1);
         console.log(this.item.data_files);
      },
      updateForm: function updateForm(e) {
         var _this3 = this;

         e.preventDefault();

         //Form data a files to upload
         var formData = new FormData();
         for (var i = 0; i < this.nteFiles.length; i++) {
            var file = this.nteFiles[i];
            formData.append('files[' + i + ']', file);
         }

         //Additional POST Request
         formData.append('existing_files', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.item.data_files));
         formData.append('action_to_be_taken', this.item.action_to_be_taken);
         formData.append('date_request', this.item.date_request);
         formData.append('date_incident', this.item.date_incident);
         formData.append('details_of_infraction', this.item.details_of_infraction);
         formData.append('type_of_infraction', this.item.type_of_infraction);
         formData.append('occurence', this.item.occurence);

         this.$swal({
            title: 'Are you sure?',
            text: 'Do you want to save changes.',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false
         }).then(function (isConfirm) {
            if (isConfirm === true) {

               axios.post('api/nterequest/approval/update/' + _this3.item.id, {
                  existing_files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.item.data_files),
                  action_to_be_taken: _this3.item.action_to_be_taken,
                  date_request: _this3.item.date_request,
                  date_incident: _this3.item.date_incident,
                  details_of_infraction: _this3.item.details_of_infraction,
                  type_of_infraction: _this3.item.type_of_infraction,
                  occurence: _this3.item.occurence
               }).then(function (response) {
                  _this3.$swal({
                     type: 'success',
                     title: 'NTE Request Updated',
                     html: 'NTE Request was<br/> successfully updated.<br/><br/><br/><br/>',
                     showConfirmButton: false,
                     timer: 4000
                  });

                  _this3.$router.push({
                     name: 'nte-request'
                  });
                  console.log(response.data);
               }).catch(function (error) {
                  console.log(error);
               });
            }
         });
      }
   },

   computed: {
      imgpreview: function imgpreview() {
         var data = window.axios.defaults.baseURL + '/upload/';
         return data;
      }
   }
});

/***/ }),

/***/ "G7dM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('inActive')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G9pD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      selected_item: '',
      ub_departments: []
    };
  },

  created: function created() {
    this.get_calendar();
    this.getSubdepartments();
  },
  methods: {
    getSubdepartments: function getSubdepartments() {
      var _this = this;

      axios.get('api/subdepartments').then(function (response) {
        _this.sub_departments = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    get_selected_id: function get_selected_id(item) {
      this.selected_item = item;
    },
    deleteItem: function deleteItem(id, index) {
      var _this2 = this;

      /* USING SWEET ALERT */
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/calendar/delete/' + id).then(function (response) {
            _this2.get_calendar(); // reloader 
            _this2.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            console.log(response);
            _this2.$swal('Error Code', 'Please contact Web developer', 'error');
          });
        }
      });
    },
    update_calendar: function update_calendar(e) {
      var _this3 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save this changes',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //--> HTTP POST REQUEST
          axios.post('api/calendar/update/' + _this3.selected_item.id, {
            'name': _this3.selected_item.name,
            'event_type': _this3.selected_item.event_type,
            'date_event': _this3.selected_item.date_event,
            'sub_department_id': _this3.selected_item.sub_department_id
          }).then(function (response) {
            _this3.$swal({
              type: 'success',
              title: 'Updated',
              html: 'Data has been successfully change.',
              showConfirmButton: true,
              timer: 4000
            });
            _this3.$refs['hide-calendar-modal'].hide();
            _this3.get_calendar();
          }).catch(function (error) {
            console.log(response);
            _this3.$swal('Error Code', 'Please contact Web developer', 'error');
          });
          //--> END HTTP POST REQUEST  
        }
      });
    },
    get_calendar: function get_calendar() {
      var _this4 = this;

      axios.get("api/allcalendar").then(function (response) {
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getDate: function getDate(date) {
      return moment(date).format("MMM DD YYYY");
    }
  }
});

/***/ }),

/***/ "GJ0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_adjustment_form__ = __webpack_require__("HrHs");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        adjustmentForm: __WEBPACK_IMPORTED_MODULE_0__todo_adjustment_form__["a" /* default */]
    }
});

/***/ }),

/***/ "GJEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_cd_hw__ = __webpack_require__("qcVL");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosCdHw: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_cd_hw__["a" /* default */]
    }
});

/***/ }),

/***/ "GQa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Create Roles")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/usersroles"}},[_vm._v("Roles")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Create Roles")])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Roles Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roles_name),expression:"roles_name"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.roles_name},attrs:{"type":"text"},domProps:{"value":(_vm.roles_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.roles_name=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.roles_name)?_c('span',{staticClass:" invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.roles_name[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.description},attrs:{"type":"text"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.description)?_c('span',{staticClass:" invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.description[0]))]):_vm._e()])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary"},[_vm._v("Create Roles")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GTGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_details_vue__ = __webpack_require__("5n5A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039f352e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_details_vue__ = __webpack_require__("vHs7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039f352e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GfRJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_department__ = __webpack_require__("fB9U");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Department: __WEBPACK_IMPORTED_MODULE_0__todo_department__["a" /* default */]
    }
});

/***/ }),

/***/ "H3+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_credit_config__ = __webpack_require__("WCQp");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        creditConfig: __WEBPACK_IMPORTED_MODULE_0__todo_credit_config__["a" /* default */]
    }
});

/***/ }),

/***/ "H4OE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h3',{staticClass:"card-title"},[_vm._v("Sub Departments")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"department"}},[_vm._v(" Departments")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Sub Departments")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.add-new-item",modifiers:{"add-new-item":true}}],staticClass:"btn btn-primary float-right"},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Sub Departments")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"70"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"width":"300"}},[_vm._v("Sub Department Name")]),_vm._v(" "),_c('th',{attrs:{"width":"600"}},[_vm._v("Description")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.sub_department_name)))])]),_vm._v(" "),_c('td',[_c('i',[_vm._v(_vm._s(item.description))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.update-sub-department",modifiers:{"update-sub-department":true}}],staticClass:"btn btn-xs btn-default",on:{"click":function($event){_vm.get_selected_item(item)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Modify")])])])}),0)])]),_vm._v(" "),_c('b-modal',{ref:"add-new-sub-department",attrs:{"id":"add-new-item","size":"l","title":"New Sub Department","hide-footer":""}},[_c('h3',[_vm._v("Sub Department")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sub Deparment Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sub_department_name),expression:"sub_department_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sub_department_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sub_department_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.add_sub_departments}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit form")])])]),_vm._v(" "),_c('b-modal',{ref:"update-sub-department",attrs:{"id":"update-sub-department","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v("Sub Deparment")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sub Deparment Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.sub_department_name),expression:"selected_item.sub_department_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.sub_department_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "sub_department_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.description),expression:"selected_item.description"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.selected_item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_sub_department}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit form")])])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHgA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HHjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_users_vue__ = __webpack_require__("cUbI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a51cfe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_users_vue__ = __webpack_require__("uwWB");
function injectStyle (ssrContext) {
  __webpack_require__("7F0B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a51cfe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_contributions_list__ = __webpack_require__("yFbt");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        contributionsList: __WEBPACK_IMPORTED_MODULE_0__todo_contributions_list__["a" /* default */]
    }
});

/***/ }),

/***/ "HRIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_approval_vue__ = __webpack_require__("Xemw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e24d434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_approval_vue__ = __webpack_require__("D+9+");
function injectStyle (ssrContext) {
  __webpack_require__("DBhX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e24d434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hbh+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hg73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Responsibility Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"responsibilityform"}},[_vm._v("Responsibilities Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Responsibility Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee Name :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.emp),expression:"emp"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.emp=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.items),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('small',[_c('i',[_vm._v("I hereby acknowledge that I have received the following company property:")])]),_c('br'),_c('br'),_vm._v(" "),_vm._l((_vm.responsibility),function(res,index){return _c('div',[_c('div',{staticClass:"border-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name Of Item:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.name),expression:"res.name"}],staticClass:"form-control",domProps:{"value":(res.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description/Serial Number:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.description),expression:"res.description"}],staticClass:"form-control",domProps:{"value":(res.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Quantity:")]),_vm._v(" "),_c('integer-plusminus',{model:{value:(res.quantity),callback:function ($$v) {_vm.$set(res, "quantity", $$v)},expression:"res.quantity"}}),_vm._v("\n                  "+_vm._s(_vm.quantity)+"\n               ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Received:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.received),expression:"res.received"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(res.received)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "received", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"floater-point"},[_c('div',{staticClass:"action-item-responsibility"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_form($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.delete_form(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"10px"}}),_vm._v(" "),_c('small',[_c('i',[_vm._v("I agree to keep the property in working condition, and to notify management should the property malfunction in any way, or should the property be lost or stolen. "),_c('br'),_vm._v(" Further, \n        I agree to return this property at the end of my employment. When I no longer need one or more of the items, I will return it/them immediately to my immediate supervisor.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-info float-right"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit Responsibility")])])]),_vm._v(" "),_c('br')],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HjtT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Reports")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_c('input',{attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Question")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',[_c('tr')])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hjvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_edit_responsibility__ = __webpack_require__("n41B");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        editResponsibility: __WEBPACK_IMPORTED_MODULE_0__todo_edit_responsibility__["a" /* default */]
    }
});

/***/ }),

/***/ "HrHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_adjustment_form_vue__ = __webpack_require__("mcnh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa852220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_adjustment_form_vue__ = __webpack_require__("1/Wm");
function injectStyle (ssrContext) {
  __webpack_require__("x4uI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_adjustment_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa852220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_adjustment_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hu/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("New Calendar Event")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb  arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"holidays"}},[_vm._v("Calendar Event")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("New Calendar")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_vm._l((_vm.CalendarContent),function(res,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.name),expression:"res.name"}],staticClass:"form-control",attrs:{"required":""},domProps:{"value":(res.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.start),expression:"res.start"}],staticClass:"form-control",attrs:{"type":"date","required":""},domProps:{"value":(res.start)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "start", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sub Department")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(res.display),expression:"res.display"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(res, "display", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Display All")]),_vm._v(" "),_vm._l((_vm.sub_departments),function(sub_department){return _c('option',{key:sub_department.id,domProps:{"value":sub_department.id}},[_vm._v(_vm._s(sub_department.sub_department_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(res.type),expression:"res.type"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(res, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.selectedType(res,index)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Choose One --")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Critical Day")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Holidays")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Meeting")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Celebration")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Block off")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Company Party")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Rest Day")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Holiday Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(res.h_type),expression:"res.h_type"}],staticClass:"form-control",attrs:{"disabled":res.isDisabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(res, "h_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Choose One --")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Regular Holiday")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Special Holiday")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group float-right"},[_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_form($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.delete_form(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-info float-right"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Create calendar event")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HzzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-request')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I3gI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_mantra__ = __webpack_require__("i0gz");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosMantra: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_mantra__["a" /* default */]
    }
});

/***/ }),

/***/ "I4wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to Collections")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To Collections")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to Collections")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"multiple","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                             "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                  "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IDJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dashboard')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IHO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assistant-manager')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "II1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_settings_vue__ = __webpack_require__("0WW4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234f2e0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_settings_vue__ = __webpack_require__("B0do");
function injectStyle (ssrContext) {
  __webpack_require__("kJ8T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234f2e0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ILZ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_integer_plusminus__ = __webpack_require__("5G+X");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            responsibilityItem: {}
        };
    },

    created: function created() {
        this.fetchItem();
    },
    methods: {
        fetchItem: function fetchItem() {
            var _this = this;

            axios.get('api/wfh/responsibility/hr/get/' + this.$route.params.id).then(function (resp) {
                _this.responsibilityItem = resp.data;
                console.log('response =>', _this.responsibilityItem);
            }).catch(function (error) {
                console.log(error);
            });
        }
    }

});

/***/ }),

/***/ "IOch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IZjJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "If0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_va_nz_au_vue__ = __webpack_require__("0K9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10847150_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_va_nz_au_vue__ = __webpack_require__("0lgC");
function injectStyle (ssrContext) {
  __webpack_require__("VcKG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_va_nz_au_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10847150_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_va_nz_au_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iud5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J9i7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_wfh_responsibility_vue__ = __webpack_require__("iF6l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6fad5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_wfh_responsibility_vue__ = __webpack_require__("PaOG");
function injectStyle (ssrContext) {
  __webpack_require__("u80R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_wfh_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6fad5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_wfh_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JBS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_inactive_vue__ = __webpack_require__("8U+6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8c80d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_inactive_vue__ = __webpack_require__("8Daa");
function injectStyle (ssrContext) {
  __webpack_require__("Xd68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_inactive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8c80d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_inactive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      positions: [],
      subdepartment: [],
      experience: [{
        employeer: '',
        company_address: '',
        job_title: '',
        start_date: '',
        end_date: '',
        previous_salary: '',
        reason_for_leaving: ''
      }],

      result: {}
    };
  },

  mounted: function mounted() {
    this.getEmployeeInfo();
    this.getPositionName();
    this.getDepartmentName();
  },
  methods: {
    saveProfile: function saveProfile() {
      axios({
        method: 'get',
        url: '/user/1',
        data: {
          first_name: this.first_name,
          last_name: this.last_name
        }
      }).then(function (resp) {}).catch(function (error) {});
    },
    getEmployeeInfo: function getEmployeeInfo() {
      var _this = this;

      axios.get('api/updateemployeeinfo/get/' + this.$route.params.id).then(function (response) {
        _this.item = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPositionName: function getPositionName() {
      var _this2 = this;

      axios.get('api/positions').then(function (response) {
        _this2.positions = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDepartmentName: function getDepartmentName() {
      var _this3 = this;

      axios.get('api/subdepartments').then(function (response) {
        _this3.subdepartment = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    update_form: function update_form(e) {
      var _this4 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes.',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/updateemployeebyhr/update/' + _this4.item.employee_id, {
            //update employee table
            emp_id: _this4.item.emp_id,
            position_id: _this4.item.position_id,
            sub_department_id: _this4.item.sub_department_id,
            first_name: _this4.item.first_name,
            last_name: _this4.item.last_name,
            middle_name: _this4.item.middle_name,
            suffix: _this4.item.suffix,
            birthdate: _this4.item.birthdate,
            current_address: _this4.item.current_address,
            permanent_address: _this4.item.permanent_address,
            //update contact table
            contact: _this4.item.contact,
            contact_person: _this4.item.contact_person,
            emergency_no: _this4.item.emergency_no,
            email_address: _this4.item.email_address,
            relationship: _this4.item.relationship,
            //Update experience
            experience: _this4.item.experience
          }).then(function (response) {
            _this4.$swal({
              type: 'success',
              title: 'Save',
              text: 'You successfully save changes',
              showConfirmButton: false,
              timer: 2000
            });

            _this4.$router.push({
              name: 'employee-list'
            });
            console.log(response.data);
          }).catch(function (e) {
            console.log(e.response);
          });
        }
      });
    }
  }

});

/***/ }),

/***/ "JFSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Application Approval")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/absenceleave"}},[_vm._v("Leave & Absences Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Leave Application Approval")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container"},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"report-border-full"},[_c('div',{staticClass:"report-header"},[_vm._v("\n            LEAVE APPLICATION FORM\n         ")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Name:")]),_vm._v(" "+_vm._s(_vm.item.full_name))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Department:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Number:")]),_vm._v(" "+_vm._s(_vm.item.emp_id))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Position:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Filled :")]),_vm._v(" "+_vm._s(_vm.item.date_filled))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Type of Leave :")]),_vm._v(" "+_vm._s(_vm.item.leave_type))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Total Days:")]),_vm._v(" "+_vm._s(_vm.item.no_of_days))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Start Date :")]),_vm._v(" "+_vm._s(_vm.item.start_date))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("End Date :")]),_vm._v(" "+_vm._s(_vm.item.end_date))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Reason for Leave / Absent :")]),_c('br'),_vm._v(" "+_vm._s(_vm.item.reason))])])])]),_vm._v(" "),_c('form',{on:{"submit":_vm.update_leave}},[(_vm.item.roles === 1  && _vm.item.belongs_to != 0)?_c('div',[_c('b',[_vm._v("Departmental Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Supervisor Name:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.supervisor),expression:"item.supervisor"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.supervisor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "supervisor", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Supervisor Approval:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tl_status),expression:"item.tl_status"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.tl_status)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "tl_status", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tl_date_approved),expression:"item.tl_date_approved"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.tl_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "tl_date_approved", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head's Name:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.department_head),expression:"item.department_head"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.department_head)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "department_head", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head Approval:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_status),expression:"item.asm_status"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.asm_status)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "asm_status", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_date_approved),expression:"item.asm_date_approved"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "asm_date_approved", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.item.roles === 2)?_c('div',[_c('b',[_vm._v("Departmental Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head's Name:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.department_head),expression:"item.department_head"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.department_head)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "department_head", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head Approval:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_status),expression:"item.asm_status"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.asm_status)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "asm_status", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_date_approved),expression:"item.asm_date_approved"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.item.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "asm_date_approved", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),_c('b',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Remarks:")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.remarks),expression:"item.remarks"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "remarks", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"With Pay"}},[_vm._v("With Pay")]),_vm._v(" "),_c('option',{attrs:{"value":"Without Pay"}},[_vm._v("Without Pay")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("HR Approval:")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.status),expression:"item.status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.reasonShow]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("Approve Request")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("Decline Request")])])])])]),_vm._v(" "),(_vm.reason == true)?_c('div',[_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12  report-border-full"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Reason:")])]),_c('small',[_c('i',[_vm._v("Please write a reason why you decline his/her leave request.")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason_to_declined),expression:"reason_to_declined"}],staticClass:"form-control reason",attrs:{"cols":"100","rows":"10"},domProps:{"value":(_vm.reason_to_declined)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason_to_declined=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")])])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JPSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_contracts_vue__ = __webpack_require__("NhIQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9a32c96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_contracts_vue__ = __webpack_require__("u1eX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_contracts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9a32c96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_contracts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JSwQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JUXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_credits_vue__ = __webpack_require__("2neH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401445e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_credits_vue__ = __webpack_require__("q7Nd");
function injectStyle (ssrContext) {
  __webpack_require__("pZHm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401445e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_credits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JVSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jf0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_collections__ = __webpack_require__("fzkZ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosCollections: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_collections__["a" /* default */]
    }
});

/***/ }),

/***/ "JjK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_add_calendar_event_vue__ = __webpack_require__("lsma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac97a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_add_calendar_event_vue__ = __webpack_require__("JmxZ");
function injectStyle (ssrContext) {
  __webpack_require__("f5WK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_add_calendar_event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac97a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_add_calendar_event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jl1N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dashboard_vue__ = __webpack_require__("P73v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bae9c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dashboard_vue__ = __webpack_require__("IDJ/");
function injectStyle (ssrContext) {
  __webpack_require__("FN/G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bae9c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JmxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('add-calendar-event')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K0Yo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_time_attendance_vue__ = __webpack_require__("c8rk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdce0704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_time_attendance_vue__ = __webpack_require__("U5MD");
function injectStyle (ssrContext) {
  __webpack_require__("1cAu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_time_attendance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdce0704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_time_attendance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K2eJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_leave_approval__ = __webpack_require__("w42A");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        leaveApproval: __WEBPACK_IMPORTED_MODULE_0__todo_leave_approval__["a" /* default */]
    }
});

/***/ }),

/***/ "KLEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dependents')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KLFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KV7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginbody"},[_c('div',{staticClass:"col-md-3",staticStyle:{"margin":"auto","padding-top":"5%"}},[_c('reset-password')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KVSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('work-shift')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KcmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("XRWM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d46c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("hx8O");
function injectStyle (ssrContext) {
  __webpack_require__("qiBQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d46c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KjbV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assistant_manager_vue__ = __webpack_require__("dnff");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7e1ee02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assistant_manager_vue__ = __webpack_require__("2UL2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assistant_manager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7e1ee02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assistant_manager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L/Lh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Schedule Adjustment Approval")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Schedule Adjustment Approval")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update_form($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.item.hr_status == 'pending')?_c('b-alert',{attrs:{"show":"","dismissible":""}},[_c('strong',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.full_name)))]),_vm._v(" - Request for a schedule adjustment approval.\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_filled),expression:"item.date_filled"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.item.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_filled", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Of Request:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_of_request),expression:"item.date_of_request"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.item.date_of_request)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_of_request", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Current Shift:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.current_shift),expression:"item.current_shift"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.item.current_shift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "current_shift", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("HR Department Approval: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.hr_status),expression:"item.hr_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "hr_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.reasonRejected]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("Approve Request")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("Decline Request")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("Pending Request")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Requested Shift:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.requested_shift),expression:"item.requested_shift"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.item.requested_shift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "requested_shift", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reason for Change")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reason_for_change),expression:"item.reason_for_change"}],staticClass:"form-control",attrs:{"rows":"7","disabled":""},domProps:{"value":(_vm.item.reason_for_change)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "reason_for_change", $event.target.value)}}})])])]),_vm._v(" "),(_vm.reason==true)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('b',[_vm._v("Reason:")])]),_vm._v(" "),_c('small',[_c('i',[_vm._v("Please write a reason why you decline his/her leave request.")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason_to_declined),expression:"reason_to_declined"}],staticClass:"form-control reason",attrs:{"rows":"5"},domProps:{"value":(_vm.reason_to_declined)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason_to_declined=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L4wW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_vue__ = __webpack_require__("mIi/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7983c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_vue__ = __webpack_require__("DSn1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7983c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LAfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            item: {}
        };
    },

    created: function created() {
        //this.getCurentUser()
        this.getItem();
    },
    methods: {
        getCurentUser: function getCurentUser() {
            var _this = this;

            axios.get('api/user').then(function (response) {
                _this.users = response.data;
                if (_this.users.role_id != 5) {
                    _this.$router.push({ name: 'Login-Layout' });
                }
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        getItem: function getItem() {
            var _this2 = this;

            axios.get('api/evaluation/' + this.$route.params.id + '/' + this.$route.params.employee_id).then(function (resp) {
                _this2.item = resp.data;
            });
        }
    }
});

/***/ }),

/***/ "LGmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_user_roles__ = __webpack_require__("OggC");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        userRoles: __WEBPACK_IMPORTED_MODULE_0__todo_user_roles__["a" /* default */]
    }
});

/***/ }),

/***/ "LiMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },

    data: function data() {
        return {
            sss_cont: '',
            phic_cont: '',
            hdmf_cont: '',
            hmo: '',
            sss_loan: '',
            hdmf_loan: '',
            tax: '',
            others: '',

            employee_id: '',
            employees: [],
            //ERROR_HANDLER
            error_handler: []
        };
    },


    mounted: function mounted() {
        this.get_employees();
    },

    methods: {
        employeeIdHide: function employeeIdHide() {
            if (!!this.error_handler.employee_id) this.error_handler.employee_id = false;
        },
        sss_contHide: function sss_contHide() {
            if (!!this.error_handler.sss_cont) this.error_handler.sss_cont = false;
        },
        phic_contHide: function phic_contHide() {
            if (!!this.error_handler.phic_cont) this.error_handler.phic_cont = false;
        },
        hdmf_contHide: function hdmf_contHide() {
            if (!!this.error_handler.hdmf_pagibig_cont) this.error_handler.hdmf_pagibig_cont = false;
        },
        hmoHide: function hmoHide() {
            if (!!this.error_handler.hmo) this.error_handler.hmo = false;
        },
        sss_loanHide: function sss_loanHide() {
            if (!!this.error_handler.sss_loan) this.error_handler.sss_loan = false;
        },
        hdmf_loanHide: function hdmf_loanHide() {
            if (!!this.error_handler.hdmf_loan) this.error_handler.hdmf_loan = false;
        },
        taxHide: function taxHide() {
            if (!!this.error_handler.withholding_tax) this.error_handler.withholding_tax = false;
        },
        othersHide: function othersHide() {
            if (!!this.error_handler.others) this.error_handler.others = false;
        },
        get_employees: function get_employees() {
            var _this = this;

            axios.get('api/active/employee').then(function (response) {
                _this.employees = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        formSubmit: function formSubmit() {
            var _this2 = this;

            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to submit this request',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.post('api/contributions/create', {
                        employee_id: _this2.employee_id,
                        sss_cont: _this2.sss_cont,
                        phic_cont: _this2.phic_cont,
                        hdmf_pagibig_cont: _this2.hdmf_cont,
                        hmo: _this2.hmo,
                        sss_loan: _this2.sss_loan,
                        hdmf_loan: _this2.hdmf_loan,
                        withholding_tax: _this2.tax,
                        others: _this2.others
                    }).then(function (resp) {
                        if (resp.data.response == 'success') {
                            _this2.$swal('Save', resp.data.message, 'success');
                            _this2.$router.push({
                                name: 'contributions-list'
                            });
                        } else if (resp.data.response == 'error') {
                            _this2.$swal('Error', resp.data.message, 'error');
                        }
                    }).catch(function (error) {
                        if (error.response.status == 422) {
                            _this2.error_handler = error.response.data.errors;
                        }
                        console.log(error);
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ "Llef":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LmHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_account_vue__ = __webpack_require__("sJO1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce0c15d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_account_vue__ = __webpack_require__("wgC5");
function injectStyle (ssrContext) {
  __webpack_require__("Apcb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce0c15d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5692526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("8DAw");
function injectStyle (ssrContext) {
  __webpack_require__("dqry")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5692526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "MELa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('wfh-responsibility')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MJS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-request-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MQoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login_login_vue__ = __webpack_require__("KcmH");
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    authLayout: __WEBPACK_IMPORTED_MODULE_0__login_login_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31012849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("vAhM");
function injectStyle (ssrContext) {
  __webpack_require__("BPsy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31012849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Blueprint '
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: '/static/img/sidebar-8.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    sidebarStyle: function sidebarStyle() {
      return {
        backgroundImage: 'url(' + this.backgroundImage + ')'
      };
    }
  }
});

/***/ }),

/***/ "Mcpv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_contracts_all__ = __webpack_require__("3dd3");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignContractsAll: __WEBPACK_IMPORTED_MODULE_0__todo_assign_contracts_all__["a" /* default */]
    }
});

/***/ }),

/***/ "MlUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to VA - US")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To VA - US")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to VA - US")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                             "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                  "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MnrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_schedule_adjustment_vue__ = __webpack_require__("yA7+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218603c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_schedule_adjustment_vue__ = __webpack_require__("h5bQ");
function injectStyle (ssrContext) {
  __webpack_require__("KLFm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_schedule_adjustment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218603c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_schedule_adjustment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MsHV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1I/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N2ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__("8Uc3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__("CCLi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NB7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Calendar Event")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"calendar"}},[_vm._v("Calendar")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Calendar Event")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":"/hr/addcalendarevent"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Calendar Event")])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Type")]),_vm._v(" "),_c('th',{attrs:{"width":"600"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"width":"280"}},[_vm._v("Display")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(r,i){return _c('tr',[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v(" "+_vm._s(_vm.getDate(r.date_event)))]),_vm._v(" "),_c('td',[(r.event_type == 1)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-warning m-size"},[_vm._v("Critical Day")])]):(r.event_type == 2)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-primary m-size"},[_vm._v("Holiday")])]):(r.event_type == 3)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-info m-size"},[_vm._v("Meeting")])]):(r.event_type == 4)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Celebration")])]):(r.event_type == 5)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v("Block off")])]):(r.event_type == 6)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-info m-size"},[_vm._v("Company Party")])]):(r.event_type == 7)?_c('span',[_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v("Rest Day")])]):_vm._e()]),_vm._v(" "),_c('td',[_c('span',{staticClass:"fa fa-star-o",staticStyle:{"color":"darkorange"}}),_vm._v(" "+_vm._s(r.name)+"\n               ")]),_vm._v(" "),_c('td',[(r.sub_id == null)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                      "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-info m-size"},[_vm._v("All Sub Department")])]):(r.sub_id == 1)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                      "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-pill m-size",staticStyle:{"background":"rgb(158, 9, 245)","color":"aliceblue"}},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 2)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                      "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-secondary m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 3)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                        "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-dark m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 4)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                        "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-warning m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 5)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                       "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 6)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                        "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-primary m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):(r.sub_id == 7)?_c('span',[_c('b',[_vm._v("(ESS)")]),_vm._v(" Display to\n                        "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-info m-size"},[_vm._v(_vm._s(r.sub_department_name))])]):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.update-calendar",modifiers:{"update-calendar":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-primary btn-xs btn-circle",on:{"click":function($event){_vm.get_selected_id(r)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger btn-xs btn-circle",attrs:{"title":"Remove Calendar Event"},on:{"click":function($event){_vm.deleteItem(r.id, _vm.index)}}},[_c('i',{staticClass:"fa fa-times"})])])])}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-calendar-modal",attrs:{"id":"update-calendar","size":"l","hide-footer":""}},[_c('h3',[_vm._v("Update Calendar Event "),_c('i',{staticClass:"fa fa-calendar-o"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.name),expression:"selected_item.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.event_type),expression:"selected_item.event_type"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_item, "event_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Choose One --")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Critical Day")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Holidays")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Meeting")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Celebration")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Block off")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Company Party")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Rest Day")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.date_event),expression:"selected_item.date_event"}],staticClass:"form-control",attrs:{"type":"date","required":""},domProps:{"value":(_vm.selected_item.date_event)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "date_event", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ESS Display to :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.sub_department_id),expression:"selected_item.sub_department_id"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_item, "sub_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","selected":""}},[_vm._v("Display All")]),_vm._v(" "),_vm._l((_vm.sub_departments),function(sub_department){return _c('option',{key:sub_department.id,domProps:{"value":sub_department.id}},[_vm._v(_vm._s(sub_department.sub_department_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_calendar}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ND2J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NEa/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NFK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_signature_pad__ = __webpack_require__("TRHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_full_calendar__ = __webpack_require__("QaH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__("AixB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_easy_lightbox__ = __webpack_require__("xZWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("olkN");
/* eslint-disable */

// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;

window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





//Vue Resource

//Sweet Alert

//Vee Validate

//Vue Moment 

//Toggle Button

// LightBootstrap plugin

//Vue Mask

// Bootstrap Vue

// Bootstrap CSS and VUE CSS


// Signature Pad

// Element UI


// Vue Full-Calendar

// CSS Full-Calendar

// Router setup

// Light box

// VUEX STORE 


/*
|----------------------------------------------------------------------
|  INITIALIZE PLUGINS 
|----------------------------------------------------------------------
*/

// Light box
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_easy_lightbox__["a" /* default */]);
// Vuex
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */]);
// full calendar
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_full_calendar__["a" /* default */]);
// Element UI
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui___default.a);
// Signature pad
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_signature_pad__["a" /* default */]);
// Input Mask
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default.a);
// Plugin setup
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default.a);
// Use in http.post
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
// Use in routing
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
//Light Bootstrap
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__light_bootstrap_main__["a" /* default */]);
// Bootstrap vue 
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);
// Form Validation
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);
// Vue Moment
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
//toggle switch
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_js_toggle_button___default.a);

/*
|----------------------------------------------------------------------
|  CONFIGURE ROUTER
|----------------------------------------------------------------------
*/
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_19__routes_routes__["a" /* default */],
  linkActiveClass: 'nav-item active',
  mode: 'history'
});

/*
|----------------------------------------------------------------------
|  INITIALIZE GLOBAL
|----------------------------------------------------------------------
*/
window.axios = __webpack_require__("mtWM");
window.moment = __webpack_require__("w4Cw");
//window.axios.defaults.baseURL = "http://localhost:9090";
window.axios.defaults.baseURL = "https://endpoint.blueprintbusinesssolutionscorp.com";

/*
|----------------------------------------------------------------------
|  GLOBAL TEXT FORMATING
|----------------------------------------------------------------------
*/

moment.updateLocale('us', {
  workingWeekdays: [1, 2, 3, 4, 5]
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('uppercase', function (value) {
  if (!value) return '';
  return value.toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getBirth = function (date) {
  return moment(date).format('MMM DD');
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getDate = function (date) {
  return moment(date).format('MMM DD YYYY');
};
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.years = function (value) {
  var currentYear = new Date().getFullYear();
  var years = [];
  for (var year = value; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.yearCount = function (date) {
  return moment().diff(moment(date), "years", false);
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.formatMoney = function (value) {
  var val = (value / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
/*
|----------------------------------------------------------------------
| GLOBAL HEADER INTERCEPTORS FOR TOKEN & CORS
|----------------------------------------------------------------------
*/

axios.interceptors.request.use(function (config) {
  config.headers.common['Authorization'] = "Bearer " + localStorage.getItem("token");
  config.headers.get['Accepts'] = 'application/json';
  config.headers.get['Access-Control-Allow-Origin'] = '*';
  config.headers.get['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
  return config;
});

/*
|----------------------------------------------------------------------
|   ROUTE GUARD
|----------------------------------------------------------------------
*/

router.beforeEach(function (to, from, next) {

  if (to.matched.some(function (route) {
    return route.meta.requiresAuth;
  }) && !__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].state.isLoggedIn) {
    next({ name: 'Login-Layout' });
    return;
  }

  if (to.path === '/login' && __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].state.isLoggedIn) {
    next({ name: 'Dashboard' });
  }

  document.title = 'HRIS - ' + to.name;
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
  },
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  router: router
});

/***/ }),

/***/ "NKJQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        var _ref;

        return _ref = {
            items: [],
            //FILTER
            page_limit: '',
            order_by: '',
            search: '',
            loading: true,
            filter_by_year: ''
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'page_limit', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'start_page', 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'perPage', 100), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'curentPage', 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'display_indicator', ''), _ref;
    },

    created: function created() {
        this.employeeCoached();
    },
    methods: {
        getYear: function getYear() {
            var _this = this;

            if (this.filter_by_year == '') {
                this.employeeCoached();
            } else {
                axios.get('api/employee/coached/all/' + this.filter_by_year).then(function (response) {
                    _this.items = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                });
            }
        },
        employeeCoached: function employeeCoached() {
            var _this2 = this;

            axios.get('api/employee/coached/all').then(function (resp) {
                _this2.items = resp.data;_this2.loading = false;console.log(resp.data);_this2.display_indicator = 2;
            }).catch(function (error) {
                console.log(error.resp);_this2.display_indicator = 1;
            });
        }
    },
    computed: {
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_item: function total_item() {
            return this.items.length;
        },
        computedRequest: function computedRequest() {
            var _this3 = this;

            var filtered = this.items;
            // USE IN PAGINATION 
            var start = (this.curentPage - 1) * this.perPage;
            var end = this.curentPage * this.perPage;
            filtered = filtered.slice(start, end);

            // SORTING NUMBER OF DISPLAY
            if (this.page_limit) {
                filtered = filtered.slice(this.offset, this.limit);
                return filtered;
            }

            if (this.search) {
                filtered = filtered.filter(function (item) {
                    return item.first_name.toLowerCase().indexOf(_this3.search) > -1;
                });
                return filtered;
            }
            // ORDER BY ASC AND DESC COMBOBOX
            if (this.order_by) {
                filtered = filtered.slice(0).sort(function (a, b) {
                    return a.first_name < b.first_name ? _this3.order_by : -_this3.order_by;
                });
                return filtered;
            }

            return filtered;
        }
    }
});

/***/ }),

/***/ "NMAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_group_access_vue__ = __webpack_require__("TTnl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563fb0ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_group_access_vue__ = __webpack_require__("hBfl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_group_access_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563fb0ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_group_access_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NbDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dependents_form_vue__ = __webpack_require__("QTP/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea7aac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dependents_form_vue__ = __webpack_require__("0bmL");
function injectStyle (ssrContext) {
  __webpack_require__("PLQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dependents_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea7aac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dependents_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NhIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      contractFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: []
    };
  },
  mounted: function mounted() {
    this.getInfo();
    this.getItem();
  },

  methods: {
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },
    getCurentUser: function getCurentUser() {
      var _this = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      axios.get('api/contractsmemo/getinfo/' + this.$route.params.id).then(function (resp) {
        _this2.item = resp.data;
      });
    },
    getItem: function getItem() {
      var _this3 = this;

      axios.get('api/contractsmemo/getcontractinfo/' + this.$route.params.id).then(function (resp) {
        _this3.files = resp.data;
      });
    },

    //FILE UPLOAD
    //   handleFileContractsUpload() {
    //     let uploadedContractFiles = event.target.files;
    //     if(!uploadedContractFiles.length)
    //         return
    //     for (let i = 0; i < uploadedContractFiles.length; i++){
    //             this.contractFiles.push( uploadedContractFiles[i])
    //     }
    //     console.log('response => ', uploadedContractFiles)
    //   },


    handleFileContractsUpload: function handleFileContractsUpload(event) {
      var uploadedFiles = event.target.files;
      if (!uploadedFiles.length) return;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.contractFiles.push(uploadedFiles[i]);
      }
      console.log('Uploaded files:', uploadedFiles);
    },
    removeContractFilesUpload: function removeContractFilesUpload(key) {
      this.contractFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this4 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this4.contractFiles.length > 0) {
            for (var i = 0; i < _this4.contractFiles.length; i++) {
              var file = _this4.contractFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this4.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }
          //Additional POST Request
          formData.append('employee_id', _this4.item.id);
          formData.append('employee_name', _this4.item.full_name);
          formData.append('document_type', 'contract');

          //HTTP POST Request
          axios.post('api/uploadmemoscontracts/multiple', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this4.$swal('Success', 'Your request has been successfully submitted', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this4.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "NpBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemovaus', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/vaus', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "O+rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_new_employee_vue__ = __webpack_require__("jcqV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c504ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_new_employee_vue__ = __webpack_require__("FEU7");
function injectStyle (ssrContext) {
  __webpack_require__("a9QU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_new_employee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c504ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_new_employee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O5y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_calendar_vue__ = __webpack_require__("f7ff");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00900388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_calendar_vue__ = __webpack_require__("mKpc");
function injectStyle (ssrContext) {
  __webpack_require__("3yeV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00900388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O7LI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ODqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_notice_for_decision_vue__ = __webpack_require__("SXl5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4755584b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_notice_for_decision_vue__ = __webpack_require__("Q/Q1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_notice_for_decision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4755584b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_notice_for_decision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_coaching_record__ = __webpack_require__("dWkl");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        coachingRecord: __WEBPACK_IMPORTED_MODULE_0__todo_coaching_record__["a" /* default */]
    }
});

/***/ }),

/***/ "OaF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('undertime-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oeab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_manual_input_vue__ = __webpack_require__("ApvU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92212634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_manual_input_vue__ = __webpack_require__("zmQE");
function injectStyle (ssrContext) {
  __webpack_require__("an2P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_manual_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92212634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_manual_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OggC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_user_roles_vue__ = __webpack_require__("i9Ne");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856a51de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_user_roles_vue__ = __webpack_require__("ASGe");
function injectStyle (ssrContext) {
  __webpack_require__("tx5a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_user_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856a51de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_user_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ok0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('credit-config')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ol2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dependents_vue__ = __webpack_require__("zDRd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d9e844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dependents_vue__ = __webpack_require__("KLEr");
function injectStyle (ssrContext) {
  __webpack_require__("RSSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_dependents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d9e844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_dependents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1eb645c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("11xv");
function injectStyle (ssrContext) {
  __webpack_require__("HHgA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1eb645c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ope+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_schedule_adjustment_vue__ = __webpack_require__("3ije");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e91310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_schedule_adjustment_vue__ = __webpack_require__("R14B");
function injectStyle (ssrContext) {
  __webpack_require__("R/7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_schedule_adjustment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e91310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_schedule_adjustment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OtM5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P4xu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },
   data: function data() {
      return {
         item: {}
      };
   },

   mounted: function mounted() {
      this.fetchItem();
   },
   methods: {
      fetchItem: function fetchItem() {
         var _this = this;

         axios.get('api/responsibility/get/' + this.$route.params.id).then(function (resp) {
            _this.item = resp.data;
         }).catch(function (error) {
            console.log(error);
         });
      },
      print: function print() {
         window.print();
      },
      getDate: function getDate(date) {
         return moment(date).format('MMM DD YYYY');
      },
      undo: function undo() {
         this.$refs.signaturePadOne.undoSignature();
      },
      save: function save() {
         var _$refs$signaturePadOn = this.$refs.signaturePadOne.saveSignature(),
             isEmpty = _$refs$signaturePadOn.isEmpty,
             data = _$refs$signaturePadOn.data;
         //const { isEmptyTwo, b } = this.$refs.signaturePadTwo.saveSignature();

         // if(isEmptyOne){
         //    alert('empty');
         // }else{
         //     alert(a);
         // }

         console.log('response one =>', isEmpty);
         console.log('signature =>', a);
         //console.log('response two =>',a);
      }
   }

});

/***/ }),

/***/ "P73v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_dashboard__ = __webpack_require__("c45f");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        dashboard: __WEBPACK_IMPORTED_MODULE_0__todo_dashboard__["a" /* default */]
    }
});

/***/ }),

/***/ "P7sf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7tw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PCH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__new_password_new_password_vue__ = __webpack_require__("c4nz");
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    newPassword: __WEBPACK_IMPORTED_MODULE_0__new_password_new_password_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "PLQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PVKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_request_form_vue__ = __webpack_require__("mIL7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402d386b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_request_form_vue__ = __webpack_require__("yL8G");
function injectStyle (ssrContext) {
  __webpack_require__("olZf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_request_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402d386b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_request_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PWpI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PX2J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_va_us_vue__ = __webpack_require__("NpBr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4454ed15_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_va_us_vue__ = __webpack_require__("MlUs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_va_us_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4454ed15_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_va_us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PaOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('view-wfh-responsibility')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pdbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Loan & Contributions Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.$router.push('/')}}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contributions/list"}},[_vm._v("Loan & Contributions List")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Loan & Contribution Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("NOTE :")]),_vm._v(" "),_c('p',[_vm._v("Note: Input Zero(0) for blank if not inlucded in loan and contributions")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"col-md-12"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Employee")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id},on:{"click":_vm.employeeIdHide,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("SSS Contribution:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sss_cont),expression:"sss_cont"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.sss_cont},attrs:{"type":"number"},domProps:{"value":(_vm.sss_cont)},on:{"click":_vm.sss_contHide,"input":function($event){if($event.target.composing){ return; }_vm.sss_cont=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.sss_cont)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.sss_cont[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("PHIC Contribution:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phic_cont),expression:"phic_cont"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.phic_cont},attrs:{"type":"number"},domProps:{"value":(_vm.phic_cont)},on:{"click":_vm.phic_contHide,"input":function($event){if($event.target.composing){ return; }_vm.phic_cont=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.phic_cont)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.phic_cont[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("HDMF/Pagibig Contributions:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hdmf_cont),expression:"hdmf_cont"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hdmf_pagibig_cont},attrs:{"type":"number"},domProps:{"value":(_vm.hdmf_cont)},on:{"click":_vm.hdmf_contHide,"input":function($event){if($event.target.composing){ return; }_vm.hdmf_cont=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hdmf_pagibig_cont)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hdmf_pagibig_cont[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("HMO:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hmo),expression:"hmo"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hmo},attrs:{"type":"number"},domProps:{"value":(_vm.hmo)},on:{"click":_vm.hmoHide,"input":function($event){if($event.target.composing){ return; }_vm.hmo=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hmo)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hmo[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("SSS Loan:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sss_loan),expression:"sss_loan"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.sss_loan},attrs:{"type":"number"},domProps:{"value":(_vm.sss_loan)},on:{"click":_vm.sss_loanHide,"input":function($event){if($event.target.composing){ return; }_vm.sss_loan=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.sss_loan)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.sss_loan[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("HDMF/Pagibig Loan:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hdmf_loan),expression:"hdmf_loan"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hdmf_loan},attrs:{"type":"number"},domProps:{"value":(_vm.hdmf_loan)},on:{"click":_vm.hdmf_loanHide,"input":function($event){if($event.target.composing){ return; }_vm.hdmf_loan=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hdmf_loan)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hdmf_loan[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Withholding Tax:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tax),expression:"tax"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.withholding_tax},attrs:{"type":"number"},domProps:{"value":(_vm.tax)},on:{"click":_vm.taxHide,"input":function($event){if($event.target.composing){ return; }_vm.tax=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.withholding_tax)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.withholding_tax[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Others:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.others),expression:"others"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.others},attrs:{"type":"number"},domProps:{"value":(_vm.others)},on:{"click":_vm.othersHide,"input":function($event){if($event.target.composing){ return; }_vm.others=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.others)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.others[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"100%"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Submit Form")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pjvt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-view-details')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PwsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      dependents: [{
        name: '',
        relationship: '',
        age: '',
        phic_no: ''

      }],
      seniors: [{
        senior_citizen: '',
        middle_initial: ''
      }],
      employees: [],
      employee_id: ''
    };
  },


  mounted: function mounted() {
    this.get_employees();
  },

  methods: {
    add_dependent: function add_dependent() {
      this.dependents.push({
        name: '',
        relationship: '',
        age: '',
        phic_no: ''
      });
    },
    add_senior: function add_senior(index) {
      this.seniors.push({
        senior_citizen: '',
        middle_initial: ''
      });

      if (index === 1) this.seniors.splice(index, 1);
    },
    deleteSenior: function deleteSenior(index) {
      console.log(index);
      console.log(this.finds);
      this.seniors.splice(index, 1);
      if (index === 0) this.add_senior();
    },
    deleteDependent: function deleteDependent(index) {
      console.log(index);
      console.log(this.finds);
      this.dependents.splice(index, 1);
      if (index === 0) this.add_dependent();
    },
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/employeenodependent').then(function (response) {
        _this.employees = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/registerdependent/add', {
            // DEPENDENTS
            employee_id: _this2.employee_id,
            dependents: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.dependents),
            seniors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.seniors)
          }).then(function (resp) {
            _this2.$swal('Save', 'You successfully save this file', 'success');
            _this2.$router.push({
              name: 'dependents'
            });
          }).catch(function (error) {
            console.log('response => ', error);
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "PyRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q/Q1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Notice of Decision")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Notice of Decision")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container"},[_c('img',{attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header-nte"},[_vm._v("NOTICE TO EXPLAIN")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("Employee Name :")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.full_name))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Supervisor Name : ")]),_vm._v(_vm._s(_vm.item.superior_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("Date Notice : ")]),_vm._v(_vm._s(_vm.getDate(_vm.item.date_incident))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Position :")]),_vm._v(" "+_vm._s(_vm.item.position_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("ID No. : ")]),_vm._v(_vm._s(_vm.item.emp_no)+"\n               "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Type of Infraction :")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.item.type_of_infraction)),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Details of Occurence :")]),_vm._v(" "),_vm._l((_vm.item.occurence),function(res,i){return _c('span',[_c('br'),_c('b',[_vm._v(_vm._s(i+1))]),_vm._v(".  "+_vm._s(res.date)+"    "+_vm._s(res.details)+"\n         ")])}),_vm._v(" "),_c('br'),_c('br')],2),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_vm._v("\n         "+_vm._s(_vm.item.details_of_infraction)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Corrective Action To be Taken :")]),_c('br'),_vm._v(" "),(_vm.item.action_to_be_taken != 0 )?_c('div',[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v("  "+_vm._s(_vm.item.action_to_be_taken))]):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Explanation :")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.plan_for_improvement))])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Employee's Commitment :")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.employees_commitment))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("  I hereby acknowledge that I have been coached according to standard set by the company and commit to the objectives and targets stated above. ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_c('br'),_vm._v(" "),(_vm.item.signature == '')?_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("No signature found.")])])]):_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.item.signature,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"report-printed-control"},[_c('b',[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.item.full_name)))])]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v(" Employee Signature")])],1)])])]),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header-decision"},[_c('i',{staticClass:"fa fa-balance-scale"}),_vm._v("   NOTICE OF DECISION")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('b',[_vm._v("HR/Admin Department Decision:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notice_for_decision),expression:"notice_for_decision"}],staticClass:"form-control notice-decision",attrs:{"rows":"10"},domProps:{"value":(_vm.notice_for_decision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notice_for_decision=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0005")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q1YY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Contracts & Memos")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Contracts & Memos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"50"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-success btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-contracts', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Contract")])]),_vm._v(" "),_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "QGNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QTP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_dependents_form__ = __webpack_require__("sA5L");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        dependentsForm: __WEBPACK_IMPORTED_MODULE_0__todo_dependents_form__["a" /* default */]
    }
});

/***/ }),

/***/ "QlOi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R14B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-schedule-adjustment')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4fbf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("SKIF");
function injectStyle (ssrContext) {
  __webpack_require__("zA7R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4fbf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RFHt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RLZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_upload_payslip__ = __webpack_require__("Eeo2");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        uploadPayslip: __WEBPACK_IMPORTED_MODULE_0__todo_upload_payslip__["a" /* default */]
    }
});

/***/ }),

/***/ "RSSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RYAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-info')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RYeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_responsibility_form__ = __webpack_require__("a8vJ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ResponsibilityForm: __WEBPACK_IMPORTED_MODULE_0__todo_responsibility_form__["a" /* default */]
    }
});

/***/ }),

/***/ "Rb2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_wfh_responsibility_vue__ = __webpack_require__("ILZ3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32860420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_wfh_responsibility_vue__ = __webpack_require__("YyDY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_wfh_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32860420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_wfh_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RhR4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RqH2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S+7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_payslip_vue__ = __webpack_require__("r9kV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff4112d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_payslip_vue__ = __webpack_require__("ckdQ");
function injectStyle (ssrContext) {
  __webpack_require__("65qH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_payslip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff4112d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_payslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S26g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SBPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_user_roles_vue__ = __webpack_require__("LGmC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33263df7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_user_roles_vue__ = __webpack_require__("dCUw");
function injectStyle (ssrContext) {
  __webpack_require__("2oLe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_user_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33263df7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_user_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SKIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_vm._m(0),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name))])])}))],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"/static/img/bp_logo.png","alt":"","width":"165","height":"82"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SUDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Management")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Leave & Absences Record")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"leavecredits"}},[_vm._v("Employee Leave Credits")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn  btn-primary float-right",attrs:{"to":'requestleave',"title":"You can encode here manually based on request"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Encode Leave Manually")])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Leave Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_type),expression:"filter_by_type"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"Vacation"}},[_vm._v("Vacation Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Medical/Sick"}},[_vm._v("Medical/Sick Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Emergency"}},[_vm._v("Emergency Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Maternity"}},[_vm._v("Maternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Paternity"}},[_vm._v("Paternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Bereavement"}},[_vm._v("Bereavement Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Offset"}},[_vm._v("Offset")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover ",attrs:{"id":"my-table"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{attrs:{"width":"450"}},[_vm._v("Employee Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Date Filled")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Days")]),_vm._v(" "),_c('th',{attrs:{"width":"650"}},[_vm._v("Period")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Leave Type")]),_vm._v(" "),_c('th',{attrs:{"width":"220"}},[_vm._v("Remarks")]),_vm._v(" "),_c('th',{attrs:{"width":"170"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"350"}}),_vm._v(" "),_c('th',{attrs:{"width":"30"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedLeave),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[(item.full_name.length < 25)?[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]:_vm._e(),_vm._v(" "),(item.full_name.length >= 25)?[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name.substring(0,25)+"...")))]:_vm._e()],2),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(item.date_filled))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-pill badge-info"},[_vm._v(_vm._s(item.no_of_days)+" ")])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(item.start_date)+"   "),_c('b',[_vm._v("To")]),_vm._v("   "),_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v(" "+_vm._s(item.end_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.leave_type))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" "+_vm._s(item.remarks))]),_vm._v(" "),_c('td',[(item.status === 'pending')?_c('span',[_c('button',{staticClass:"pending"},[_vm._v("Pending")])]):(item.status === 'approved')?_c('span',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.leave-update",modifiers:{"leave-update":true}}],staticClass:"approved-leave",on:{"click":function($event){_vm.selected_employee(item)}}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v("Approved")])]):(item.status === 'rejected')?_c('span',[_c('button',{staticClass:"rejected"},[_vm._v("Rejected")])]):_vm._e()]),_vm._v(" "),_c('td',[((item.user_id != 0) &&  (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'approved'))?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'view-leave', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View Details")])],1):((item.user_id == 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'approved'))?_c('span',[_c('font',{attrs:{"color":"red"}},[_vm._v("No ESS Account")])],1):_vm._e(),_vm._v(" "),((item.user_id != 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'pending'))?_c('span',[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'leave-approval', params: { id: item.id }}}},[_c('i',{staticClass:"fa fa-mail-forward"}),_vm._v("Review Request")]),_vm._v("  "),_c('span',{staticClass:"badge badge-danger"},[_vm._v("New")])],1):((item.user_id == 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'pending'))?_c('span',[_c('font',{attrs:{"color":"red"}},[_vm._v("No ESS Account")])],1):_vm._e()]),_vm._v(" "),_c('td',[((item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.ceo_status === 'approved') && (item.status === 'pending'))?_c('span',[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger btn-xs btn-circle",attrs:{"title":"Remove Leave Request"},on:{"click":function($event){_vm.deleteItem(item.id, index)}}},[_c('i',{staticClass:"fa fa-times"})])]):_vm._e()])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-leave",attrs:{"id":"leave-update","size":"l","hide-footer":""}},[_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info",on:{"click":_vm.cancel_leave},model:{value:(_vm.selected_item.id),callback:function ($$v) {_vm.$set(_vm.selected_item, "id", $$v)},expression:"selected_item.id"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" Cancel Leave Request")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{name: 'update-leave', params: { id: _vm.selected_item.id }}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Update Leave Request")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px"}}),_vm._v(" "),_c('p',[_c('i',[_vm._v("This action you can cancel a employee leave request or update leave application form.")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SXl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      //ITEMS
      item: [],
      notice_for_decision: ''
    };
  },


  mounted: function mounted() {
    this.getItem();
  },

  methods: {
    getItem: function getItem() {
      var _this = this;

      axios.get('api/nterequestbyhr/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
      });
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      // alert(this.item.id);
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to submit this request',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/notice/for/decision/' + _this2.item.id, {
            id: _this2.item.id,
            notice_for_decision: _this2.notice_for_decision
          }).then(function (resp) {
            _this2.$swal('Success', 'You successfully submitted this request.', 'success');
            _this2.$router.push({
              name: 'nte-request'
            });
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this2.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  }

});

/***/ }),

/***/ "SY0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Se8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SncP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_settings_vue__ = __webpack_require__("s6Po");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05097068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_settings_vue__ = __webpack_require__("TLyk");
function injectStyle (ssrContext) {
  __webpack_require__("/dp2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05097068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SqAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-undertime-request')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "StJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_sub_department__ = __webpack_require__("jbuw");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        subDepartment: __WEBPACK_IMPORTED_MODULE_0__todo_sub_department__["a" /* default */]
    }
});

/***/ }),

/***/ "SuRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1GU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_department_vue__ = __webpack_require__("GjfT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6277b041_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_department_vue__ = __webpack_require__("D3JF");
function injectStyle (ssrContext) {
  __webpack_require__("83OK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_department_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6277b041_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_department_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_bp_dashboard_base_dashboard_vue__ = __webpack_require__("Jl1N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_bp_new_employee_base_new_employee_vue__ = __webpack_require__("O+rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_bp_calendar_base_calendar_vue__ = __webpack_require__("8w/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_bp_calendar_base_holidays_vue__ = __webpack_require__("fXsQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_bp_calendar_base_add_calendar_event_vue__ = __webpack_require__("JjK8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_bp_employee_management_base_employee_list_vue__ = __webpack_require__("qcaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_bp_employee_management_base_edit_info_vue__ = __webpack_require__("ycpX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_bp_employee_management_base_nte_request_vue__ = __webpack_require__("fVEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_bp_employee_management_base_nte_request_form_vue__ = __webpack_require__("e9mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_bp_employee_management_base_nte_approval_vue__ = __webpack_require__("tNzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_bp_employee_management_base_notice_for_decision_vue__ = __webpack_require__("CH5C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_bp_employee_management_base_nte_view_details_vue__ = __webpack_require__("VAJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_bp_employee_management_base_nte_edit_request_vue__ = __webpack_require__("4DDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_bp_employee_management_base_nte_manual_input_vue__ = __webpack_require__("Oeab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_bp_employee_management_base_coaching_record_vue__ = __webpack_require__("Yi1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_bp_employee_management_base_employee_coached_details_vue__ = __webpack_require__("td7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_bp_employee_management_base_work_shifts_vue__ = __webpack_require__("gMzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_bp_employee_management_base_schedule_adjustment_vue__ = __webpack_require__("MnrU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_bp_employee_management_base_adjustment_form_vue__ = __webpack_require__("prDZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_bp_employee_management_base_edit_schedule_adjustment_vue__ = __webpack_require__("Ope+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_bp_employee_management_base_undertime_request_vue__ = __webpack_require__("WEYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_bp_employee_management_base_undertime_form__ = __webpack_require__("Z8LU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_bp_employee_management_base_edit_undertime_request__ = __webpack_require__("+qne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_bp_employee_management_base_dependents_vue__ = __webpack_require__("Ol2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_bp_employee_management_base_dependents_form_vue__ = __webpack_require__("NbDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_bp_employee_management_base_edit_dependents_vue__ = __webpack_require__("mzyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_bp_employee_management_base_resigned_vue__ = __webpack_require__("Y9ri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_bp_contact_info_base_contact_info_vue__ = __webpack_require__("zlaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_bp_requirements_base_requirements_vue__ = __webpack_require__("57A+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_bp_job_information_base_job_information_vue__ = __webpack_require__("ozRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_bp_job_information_base_inactive_vue__ = __webpack_require__("x+wE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_bp_job_information_base_view_job_information_vue__ = __webpack_require__("7/ju");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_bp_departments_base_department_vue__ = __webpack_require__("T1GU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_bp_departments_base_sub_department_vue__ = __webpack_require__("nFlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_bp_positions_base_position_vue__ = __webpack_require__("3ldW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_bp_leave_management_base_leave_management_vue__ = __webpack_require__("ro9v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_bp_leave_management_base_request_leave_vue__ = __webpack_require__("gOoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_bp_leave_management_base_leave_approval_vue__ = __webpack_require__("4qbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_bp_leave_management_base_leave_credits__ = __webpack_require__("JUXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_bp_leave_management_base_view_leave_vue__ = __webpack_require__("m8T4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_bp_leave_management_base_update_leave__ = __webpack_require__("k1t8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_bp_time_attendance_base_time_attendance_vue__ = __webpack_require__("K0Yo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_bp_payroll_base_payslip_vue__ = __webpack_require__("S+7d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_bp_payroll_base_upload_payslip_vue__ = __webpack_require__("eBQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_bp_responsibility_form_base_responsibility_form_vue__ = __webpack_require__("9DIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_bp_responsibility_form_base_view_responsibility_vue__ = __webpack_require__("84Cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_bp_responsibility_form_base_add_responsibility_form_vue__ = __webpack_require__("2zXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_bp_responsibility_form_base_edit_responsibility_vue__ = __webpack_require__("jOZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_bp_responsibility_form_base_wfh_responsibility_vue__ = __webpack_require__("TG2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_bp_responsibility_form_base_view_wfh_responsibility_vue__ = __webpack_require__("J9i7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_bp_performance_base_performance_vue__ = __webpack_require__("vzty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_bp_performance_base_performance_details_vue__ = __webpack_require__("lTzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_bp_employee_accounts_base_employee_account_vue__ = __webpack_require__("LmHE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_bp_reports_base_reports_vue__ = __webpack_require__("tCvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_bp_contracts_memo_base_contracts_memo_vue__ = __webpack_require__("xiCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_bp_contracts_memo_base_assign_contracts_vue__ = __webpack_require__("/rJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_vue__ = __webpack_require__("4QKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_bp_contracts_memo_base_assign_contracts_all_vue__ = __webpack_require__("iSBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_all_vue__ = __webpack_require__("/bX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_cd_hw_vue__ = __webpack_require__("WBqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_cd_pq_vue__ = __webpack_require__("98KN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_mantra_vue__ = __webpack_require__("F3tJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_va_nz_au_vue__ = __webpack_require__("If0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_va_us_vue__ = __webpack_require__("cUg0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_collections_vue__ = __webpack_require__("2NP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_admin_vue__ = __webpack_require__("Zbh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_bp_users_base_users_vue__ = __webpack_require__("gaDY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_bp_users_base_account_user_vue__ = __webpack_require__("eejq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_bp_users_base_group_access_vue__ = __webpack_require__("c7fB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_bp_users_base_supervisor_account_vue__ = __webpack_require__("rjjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_bp_users_base_assistant_manager_vue__ = __webpack_require__("zS8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_bp_user_roles_base_user_roles_vue__ = __webpack_require__("SBPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_bp_user_roles_base_create_roles_vue__ = __webpack_require__("wwXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_bp_settings_base_settings_vue__ = __webpack_require__("II1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_bp_settings_base_notification_config_vue__ = __webpack_require__("/PbD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_bp_settings_base_credit_config_vue__ = __webpack_require__("dr5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_src_components_auth_layout_login_vue__ = __webpack_require__("b2Lf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_src_components_auth_layout_new_password_vue__ = __webpack_require__("sQwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_src_components_auth_layout_password_reset_vue__ = __webpack_require__("8NvA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_src_components_auth_logout_vue__ = __webpack_require__("3KYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_bp_contributions_base_contributions_details_vue__ = __webpack_require__("o/VV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_bp_contributions_base_contributions_form_vue__ = __webpack_require__("Z8MW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_bp_contributions_base_contributions_list_vue__ = __webpack_require__("EQKs");
/* eslint-disable */


// GeneralViews


// Dashboard


// New Employee


// Calendar Event




// Employee List



//NTE Request








//Coaching Record



// Work Shifts


// Schedule Adjustment 




// UnderTime Request 




// Dependents




// Resigned


// Contact Info


// Employee Requirements


// Job Information




// Department

// Sub Department


// Position


// Absence Leave







// Time and Attendance


// Payroll



// Responsibility Form 





//WFH Responsibility



// Perfomance


// Perfomance Details


// Employee Account


// Reports


//Contracts and Memos













// Users






// User Roles



// Settings




// Login and Register Pages





//Employee Contributions 





var routes = [

// LOGIN FORM 
{
  path: '/',
  name: 'Login-Layout',
  component: __WEBPACK_IMPORTED_MODULE_78_src_components_auth_layout_login_vue__["a" /* default */]
},

// PASSWORD RESET FORM 
{
  path: '/reset/password',
  name: 'password-resert-layout',
  component: __WEBPACK_IMPORTED_MODULE_80_src_components_auth_layout_password_reset_vue__["a" /* default */]
}, {
  path: '/new/password/:token',
  name: 'layout-password-new',
  component: __WEBPACK_IMPORTED_MODULE_79_src_components_auth_layout_new_password_vue__["a" /* default */]
},
// LOGOUT ROUTE
{
  path: '/logout',
  name: 'Logout-Layout',
  component: __WEBPACK_IMPORTED_MODULE_81_src_components_auth_logout_vue__["a" /* default */]
},

// Page route
{
  path: '/hr',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/hr/dashboard',
  children: [
  //Dashboard
  {
    path: 'dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_bp_dashboard_base_dashboard_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }

  },
  //Employee Contributions
  {
    path: 'contributions/list',
    name: 'contributions-list',
    component: __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_bp_contributions_base_contributions_list_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'contributions/form',
    name: 'contributions-form',
    component: __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_bp_contributions_base_contributions_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'contributions/details/:id/:employee_id',
    name: 'contributions-details',
    component: __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_bp_contributions_base_contributions_details_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //New Employee
  {
    path: 'newemployee',
    name: 'new-employee',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_bp_new_employee_base_new_employee_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Employee List
  {
    path: 'employeelist',
    name: 'employee-list',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_bp_employee_management_base_employee_list_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Calendar Event
  {
    path: 'calendar',
    name: 'calendar',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_bp_calendar_base_calendar_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'holidays',
    name: 'holidays',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_bp_calendar_base_holidays_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'addcalendarevent',
    name: 'add-calendar-event',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_bp_calendar_base_add_calendar_event_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Work Shifts
  {
    path: 'workshifts',
    name: 'work-shifts',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_bp_employee_management_base_work_shifts_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },

  //NTE Request
  {
    path: 'nterequest',
    name: 'nte-request',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_bp_employee_management_base_nte_request_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'nterequestform',
    name: 'nte-request-form',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_bp_employee_management_base_nte_request_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'nteapprovalrequest/:id',
    name: 'nte-approval-request',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_bp_employee_management_base_nte_approval_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'notice/for/decision/:id',
    name: 'notice-for-decision',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_bp_employee_management_base_notice_for_decision_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'nte/view/details/:id',
    name: 'nte-view-details',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_bp_employee_management_base_nte_view_details_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'nteeditrequest/:id',
    name: 'nte-edit-request',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_bp_employee_management_base_nte_edit_request_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'ntemanualinput',
    name: ' nte-manual-input',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_bp_employee_management_base_nte_manual_input_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Coaching Records
  {
    path: 'coaching/records',
    name: ' coaching-records',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_bp_employee_management_base_coaching_record_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'coaching/records/details/:id',
    name: 'coaching-records-details',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_bp_employee_management_base_employee_coached_details_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Schedule Adjustment
  {
    path: 'scheduleadjustment',
    name: 'schedule-adjustment',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_bp_employee_management_base_schedule_adjustment_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'adjustmentform',
    name: 'adjustment-form',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_bp_employee_management_base_adjustment_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'schedule/edit/adjustment/form/:id',
    name: 'schedule-edit-adjustment-form',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_bp_employee_management_base_edit_schedule_adjustment_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Undertime Request
  {
    path: 'undertimerequest',
    name: 'undertime-request',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_bp_employee_management_base_undertime_request_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'undertimeform',
    name: 'undertime-form',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_bp_employee_management_base_undertime_form__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'editundertimerequestform/:id',
    name: 'edit-undertime-request-form',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_bp_employee_management_base_edit_undertime_request__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },

  //Dependents
  {
    path: 'dependents',
    name: 'dependents',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_bp_employee_management_base_dependents_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Dependent form
  {
    path: 'dependentform',
    name: 'dependents-form',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_bp_employee_management_base_dependents_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Dependent Edit form
  {
    path: 'editdependent/:id',
    name: 'edit-dependent',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_bp_employee_management_base_edit_dependents_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },

  //Resigned
  {
    path: 'resigned',
    name: 'resigned',
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_bp_employee_management_base_resigned_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'editinfo/:id',
    name: 'edit-info',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_bp_employee_management_base_edit_info_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Contact info
  {
    path: 'contactinfo',
    name: 'contact-info',
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_bp_contact_info_base_contact_info_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Requirements
  {
    path: 'requirements',
    name: 'requirements',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_bp_requirements_base_requirements_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Departments
  {
    path: 'department',
    name: 'department',
    component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_bp_departments_base_department_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Sub Departments
  {
    path: 'subdepartment',
    name: 'sub-department',
    component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_bp_departments_base_sub_department_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Position
  {
    path: 'position',
    name: 'position',
    component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_bp_positions_base_position_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Absenceleave
  {
    path: 'absenceleave',
    name: 'absence-leave',
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_bp_leave_management_base_leave_management_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'requestleave',
    name: 'request-leave',
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_bp_leave_management_base_request_leave_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'viewleave',
    name: 'view-leave',
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_bp_leave_management_base_view_leave_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'leave/approval/:id',
    name: 'leave-approval',
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_bp_leave_management_base_leave_approval_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'update/leave/:id',
    name: 'update-leave',
    component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_bp_leave_management_base_update_leave__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'leavecredits',
    name: 'leave-credits',
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_bp_leave_management_base_leave_credits__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //Time Attendance
  {
    path: 'timeattendance',
    name: 'time-attendance',
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_bp_time_attendance_base_time_attendance_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Payroll
  {
    path: 'payslip',
    name: 'payslip',
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_bp_payroll_base_payslip_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'payslip/upload/:id',
    name: 'uploadPayslip',
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_bp_payroll_base_upload_payslip_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Responsibility form
  {
    path: 'responsibilityform',
    name: 'responsibility-form',
    component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_bp_responsibility_form_base_responsibility_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'viewresponsibility/:id',
    name: 'view-responsibility',
    component: __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_bp_responsibility_form_base_view_responsibility_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'addresponsibilityform',
    name: 'add-responsibility-form',
    component: __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_bp_responsibility_form_base_add_responsibility_form_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'editresponsibilityform',
    name: 'edit-responsibility-form',
    component: __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_bp_responsibility_form_base_edit_responsibility_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //WFH Responsibility
  {
    path: 'wfh/responsibility',
    name: 'wfh-responsibility',
    component: __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_bp_responsibility_form_base_wfh_responsibility_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'view/wfh/responsibility/:id',
    name: 'view-wfh-responsibility',
    component: __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_bp_responsibility_form_base_view_wfh_responsibility_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Job Information
  {
    path: 'jobinformation',
    name: 'job-information',
    component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_bp_job_information_base_job_information_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'viewjobinformation/:id',
    name: 'view-job-information',
    component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_bp_job_information_base_view_job_information_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'inactive',
    name: 'in-active',
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_bp_job_information_base_inactive_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Performance
  {
    path: 'performance',
    name: 'performance',
    component: __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_bp_performance_base_performance_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Performance
  {
    path: 'performancedetails/:id',
    name: 'performance-details',
    component: __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_bp_performance_base_performance_details_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Employee Account
  {
    path: 'employeeaccount',
    name: 'employee-account',
    component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_bp_employee_accounts_base_employee_account_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Reports
  {
    path: 'reports',
    name: 'reports',
    component: __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_bp_reports_base_reports_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for contracts memo
  {
    path: 'contractsmemo',
    name: 'contracts-memo',
    component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_bp_contracts_memo_base_contracts_memo_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning contracts
  {
    path: 'contracts/assign/:id',
    name: 'assign-contracts',
    component: __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_bp_contracts_memo_base_assign_contracts_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos
  {
    path: 'memos/assign/:id',
    name: 'assign-memos',
    component: __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning contracts to all
  {
    path: 'contracts/assign-all',
    name: 'assign-contracts-all',
    component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_bp_contracts_memo_base_assign_contracts_all_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to all
  {
    path: 'memos/assign-all',
    name: 'assign-memos-all',
    component: __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_all_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to CD-HW
  {
    path: 'memos/assign-cd-hw',
    name: 'assign-memos-cd-hw',
    component: __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_cd_hw_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to CD-PQ
  {
    path: 'memos/assign-cd-pq',
    name: 'assign-memos-cd-pq',
    component: __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_cd_pq_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to Mantra
  {
    path: 'memos/assign-mantra',
    name: 'assign-memos-mantra',
    component: __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_mantra_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to Va - NZAU
  {
    path: 'memos/assign-va-nz-au',
    name: 'assign-memos-va-nz-au',
    component: __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_va_nz_au_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to Va - US
  {
    path: 'memos/assign-va-us',
    name: 'assign-memos-va-us',
    component: __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_va_us_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to Collections
  {
    path: 'memos/assign-collections',
    name: 'assign-memos-collections',
    component: __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_collections_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  //route for assigning memos to Admin
  {
    path: 'memos/assign-admin',
    name: 'assign-memos-admin',
    component: __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_bp_contracts_memo_base_assign_memos_admin_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Users
  {
    path: 'users',
    name: 'users',
    component: __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_bp_users_base_users_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'accountuser',
    name: 'account-user',
    component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_bp_users_base_account_user_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'groupaccess',
    name: 'group-access',
    component: __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_bp_users_base_group_access_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'supervisoraccess',
    name: 'supervisor-access',
    component: __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_bp_users_base_supervisor_account_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'assistantmanager',
    name: 'assistant-manager',
    component: __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_bp_users_base_assistant_manager_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // User Roles
  {
    path: 'usersroles',
    name: 'users-roles',
    component: __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_bp_user_roles_base_user_roles_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'createroles',
    name: 'create-roles',
    component: __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_bp_user_roles_base_create_roles_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  },
  // Settings
  {
    path: 'settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_bp_settings_base_settings_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'notificationconfig',
    name: 'notification-config',
    component: __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_bp_settings_base_notification_config_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }, {
    path: 'creditconfig',
    name: 'credit-config',
    component: __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_bp_settings_base_credit_config_vue__["a" /* default */],
    meta: { requiresAuth: true, roles: ['hr'] }
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TBnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_manual_input_vue__ = __webpack_require__("AkhB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3058236c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_manual_input_vue__ = __webpack_require__("yRtw");
function injectStyle (ssrContext) {
  __webpack_require__("Y0OJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_manual_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3058236c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_manual_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TCjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Application Form")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/absenceleave"}},[_vm._v("Leave & Absences Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Leave Application Form")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"margin-top":"-45px"}},[_c('span',{staticClass:"float-right"},[_c('h2',[(_vm.emp != '')?_vm._t("default",[_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v("\n                        "+_vm._s(_vm.credits_indicator.leave_credit_balance)+"\n                     ")]),_vm._v("\n                     Leave Credits \n                ")]):_vm._e()],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Employee Leave Form")]),_vm._v(" "),_c('div',{staticClass:"border-box-leave"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_filled),expression:"date_filled"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_filled},attrs:{"type":"date"},domProps:{"value":(_vm.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_filled=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_filled)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_filled[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee Name / Employee ID:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.emp),expression:"emp"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.emp=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.indicator_leave]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_vm._l((_vm.items),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Number of Days Leave :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.countBusiness),expression:"countBusiness"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.no_of_days},attrs:{"readonly":""},domProps:{"value":(_vm.countBusiness)},on:{"input":function($event){if($event.target.composing){ return; }_vm.countBusiness=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.no_of_days)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.no_of_days[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type Of Leave : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.leave_type),expression:"leave_type"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.leave_type},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.leave_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Vacation"}},[_vm._v("Vacation Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Medical/Sick"}},[_vm._v("Medical/Sick Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Emergency"}},[_vm._v("Emergency Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Maternity"}},[_vm._v("Maternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Paternity"}},[_vm._v("Paternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Bereavement Leave"}},[_vm._v("Bereavement Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Offset"}},[_vm._v("Offset")])]),_vm._v(" "),(_vm.error_handler.leave_type)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.leave_type[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Remarks : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.remarks),expression:"remarks"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.remarks},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.remarks=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"With Pay"}},[_vm._v("With Pay")]),_vm._v(" "),_c('option',{attrs:{"value":"Without Pay"}},[_vm._v("Without Pay")])]),_vm._v(" "),(_vm.error_handler.remarks)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.remarks[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start_date),expression:"start_date"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.start_date},attrs:{"type":"date"},domProps:{"value":(_vm.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.start_date=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.start_date)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.start_date[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end_date),expression:"end_date"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.end_date},attrs:{"type":"date"},domProps:{"value":(_vm.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.end_date=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.end_date)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.end_date[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reason for Leave / Absent : ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.reason},attrs:{"rows":"8"},domProps:{"value":(_vm.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.reason)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.reason[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Approval Status")]),_vm._v(" "),_c('div',{staticClass:"border-box-leave"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_status),expression:"tl_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_status},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tl_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_status),expression:"asm_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_status},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.asm_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.asm_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.status},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.status[0]))]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_date_approved),expression:"tl_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_date_approved},attrs:{"type":"date"},domProps:{"value":(_vm.tl_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tl_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.tl_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_date_approved),expression:"asm_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_date_approved},attrs:{"type":"date"},domProps:{"value":(_vm.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.asm_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.asm_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_date_approved),expression:"hr_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_date_approved},attrs:{"type":"date"},domProps:{"value":(_vm.hr_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hr_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hr_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_date_approved[0]))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TG2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_wfh_responsibility_vue__ = __webpack_require__("ZKJf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e2babb7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_wfh_responsibility_vue__ = __webpack_require__("MELa");
function injectStyle (ssrContext) {
  __webpack_require__("y8R6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_wfh_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e2babb7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_wfh_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Change Password")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Change Password")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"creditconfig"}},[_vm._v(" Leave Credit Config ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"notificationconfig"}},[_vm._v(" Notification Config ")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v(" Current Password :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current_password),expression:"current_password"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.current_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.current_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v(" New Password :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_password),expression:"new_password"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.new_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v(" Confirm Password :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Change Password")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_leave_management__ = __webpack_require__("sZuo");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        absenceLeaveManagement: __WEBPACK_IMPORTED_MODULE_0__todo_leave_management__["a" /* default */]
    }
});

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
  },
  mounted: function mounted() {},
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {
    activeMenu: function activeMenu() {
      alert(this.$route.name);
    }
  }
});

/***/ }),

/***/ "TTnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_breadcrumb_menu__ = __webpack_require__("AaH/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        breadcrumbMenu: __WEBPACK_IMPORTED_MODULE_2__base_breadcrumb_menu__["a" /* default */]
    },
    data: function data() {
        var _ref;

        return _ref = {
            items: [],
            loading: true,
            belongs_to: '',
            selected_item: '',
            //options
            options: '',
            superior_name: '',
            supervisor: [],
            manager: [],
            //filter
            search: '',
            order_by: '',
            sortAsc: true,
            filter_by_supervisor: '',
            //pagination
            page_limit: '',
            start_page: 1
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account_type', ''), _ref;
    },


    mounted: function mounted() {
        this.get_users();
        this.get_supervisor();
        this.get_belongs();
        this.get_superiorname();
        this.get_manager();
    },

    methods: {
        doSometing: function doSometing() {
            this.options = '';
        },
        supervisorMember: function supervisorMember() {
            var _this = this;

            if (this.filter_by_supervisor != '') {
                axios.get('api/supervisor/members/' + this.filter_by_supervisor).then(function (response) {
                    _this.items = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                });
            } else {
                this.get_users();
            }
        },
        get_belongs: function get_belongs() {
            if (this.options == 'admin') {
                this.superior_name = { 'full_name': 'ADMIN' };
                this.belongs_to = 0;
                this.account_type = 'ADMIN';
            } else if (this.options == 'supervisor') {
                this.superior_name = { 'full_name': '' };
                this.belongs_to = 0;
                this.account_type = 'SUPERVISOR';
            } else if (this.options == 'asm') {
                this.superior_name = { 'full_name': '' };
                this.belongs_to = 0;
                this.account_type = 'ASM';
            } else if (this.options == 'staff') {

                this.account_type = 'STAFF';
            }
        },
        get_superiorname: function get_superiorname() {
            var _this2 = this;

            if (this.options == 'supervisor') {
                this.account_type = 'STAFF';
                axios.get('api/superiorname/get/' + this.belongs_to).then(function (response) {
                    _this2.superior_name = response.data;
                    console.log('superior_name:', superior_name);
                }).catch(function (error) {
                    console.log(error.response);
                });
            }
        },
        get_manager_name: function get_manager_name() {
            var _this3 = this;

            if (this.options == 'supervisor') {
                this.account_type = 'SUPERVISOR';
                axios.get('api/superiorname/get/' + this.belongs_to).then(function (response) {
                    _this3.superior_name = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                });
            }
        },
        get_supervisor: function get_supervisor() {
            var _this4 = this;

            axios.get('api/supervisor').then(function (resp) {
                _this4.supervisor = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_manager: function get_manager() {
            var _this5 = this;

            axios.get('api/operation').then(function (resp) {
                _this5.manager = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_users: function get_users() {
            var _this6 = this;

            axios.get('api/groupaccess').then(function (response) {
                _this6.items = response.data;_this6.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_selected_id: function get_selected_id(item) {
            this.selected_item = item;
        },

        //UPDATE USER BELONGS
        update_user: function update_user() {
            var _this7 = this;

            console.log('response => superior :', this.superior_name.full_name);
            console.log('response => belongs_to :', this.belongs_to);
            console.log('response => account_type :', this.account_type);
            axios.post('api/belongsto/update/' + this.selected_item.id, {
                'account_type': this.account_type,
                'belongs_to': this.belongs_to
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this7.get_users();
                    _this7.$swal('Save', resp.data.message, 'success');
                    _this7.$refs['hide-user-modal'].hide();
                } else {
                    _this7.$swal('Error', resp.data.message, 'error');
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    computed: {
        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_record: function total_record() {
            return this.items.length;
        },
        numOfPages: function numOfPages() {
            return Math.ceil(this.items.length / this.page_limit);
        },
        computedEmployee: function computedEmployee() {
            var _this8 = this;

            var filtered = this.items;
            if (filtered.length > 0) {
                // SEARCH BY EMPLOYEE FULLNAME  
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this8.search) > -1;
                    });
                    return filtered;
                }

                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }

                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this8.order_by : -_this8.order_by;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }

});

/***/ }),

/***/ "TUzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },

    data: function data() {
        return {
            items: [],
            employee_item: [],

            employee_id: '',
            leave_credit_used: '',
            leave_credit_balance: '',

            leave_status: '',
            search: '',
            order_by: '',
            //pagination
            page_limit: '',
            start_page: 1,
            loading: true,
            //Indicator
            display_indicator: '',
            //error handler
            error_handler: [],
            // selected id
            selected_user: ''

        };
    },


    mounted: function mounted() {
        this.get_employees();
        this.no_leave_credits();
    },

    methods: {
        update_leave_credits: function update_leave_credits() {
            var _this = this;

            console.log('reponse => emp_id :', this.selected_user.emp_id);
            axios.post('api/leave/credits/update/' + this.selected_user.id, {
                'employee_id': this.selected_user.emp_id,
                'leave_credit_balance': this.selected_user.leave_credit_balance,
                'leave_credit_used': this.selected_user.leave_credit_used,

                'leave_credit_bereavement': this.selected_user.leave_credit_bereavement,
                'leave_credit_solo_parents': this.selected_user.leave_credit_solo_parents,
                'leave_credit_maternity': this.selected_user.leave_credit_maternity,
                'leave_credit_paternity': this.selected_user.leave_credit_paternity
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this.$swal('Success', resp.data.message, 'success');
                    _this.$refs['leave-credits-update'].hide();
                    _this.get_employees();
                } else if (resp.data.response == 'error') {
                    _this.$swal('Opps', resp.data.message, 'error');
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        register_leave_credits: function register_leave_credits(e) {
            var _this2 = this;

            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to register leave credits.',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.post('api/register/credits', {
                        'employee_id': _this2.employee_id,
                        'leave_credit_balance': _this2.leave_credit_balance,
                        'leave_credit_used': _this2.leave_credit_used
                    }).then(function (resp) {

                        if (resp.data.response == 'error') {
                            _this2.$swal('Opps', resp.data.message, 'error');
                        } else if (resp.data.response == 'success') {
                            _this2.$refs['add-new-credits'].hide();
                            _this2.$swal({
                                type: 'success',
                                title: 'Success',
                                text: 'Employee leave credits, Has been Successfully Register.',
                                showConfirmButton: false,
                                timer: 2000
                            });
                            _this2.get_employees();
                            _this2.no_leave_credits();
                            _this2.leave_credit_used = '';
                            _this2.leave_credit_balance = '';
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        get_update_item: function get_update_item(item) {
            this.selected_user = item;
        },
        getCurentUser: function getCurentUser() {
            var _this3 = this;

            axios.get('api/user').then(function (response) {
                var users = response.data;
                if (users.role_id != 5) {
                    _this3.$router.push({
                        name: 'Login-Layout'
                    });
                }
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_employees: function get_employees() {
            var _this4 = this;

            axios.get('api/leavecredits').then(function (response) {
                _this4.items = response.data;
                _this4.display_indicator = 2;
                _this4.loading = false;
            }).catch(function (error) {
                console.log(error.response);
                _this4.display_indicator = 1;
            });
        },
        no_leave_credits: function no_leave_credits() {
            var _this5 = this;

            axios.get('api/employee/nocredits').then(function (response) {
                _this5.employee_item = response.data;
                _this5.display_indicator = 2;
            }).catch(function (error) {
                console.log(error.response);
                _this5.display_indicator = 1;
            });
        }
    },
    computed: {
        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_record: function total_record() {
            return this.items.length;
        },
        numOfPages: function numOfPages() {
            return Math.ceil(this.items.length / this.page_limit);
        },
        computedLeave: function computedLeave() {
            var _this6 = this;

            var filtered = this.items;
            if (filtered.length > 0) {
                // SEARCH BY EMPLOYEE FULLNAME
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
                    });
                    return filtered;
                }
                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }
                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this6.order_by : -_this6.order_by;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }
});

/***/ }),

/***/ "TYFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemo', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/all', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "U5MD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('time-attendance')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U6e3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_contracts_memo__ = __webpack_require__("uiTz");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        contractsMemo: __WEBPACK_IMPORTED_MODULE_0__todo_contracts_memo__["a" /* default */]
    }
});

/***/ }),

/***/ "U8dF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"new-password"},[_vm._v("NEW PASSWORD")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.requestNewPassword($event)}}},[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-field",attrs:{"type":"input","placeholder":"Email","autocomplete":"off"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_password),expression:"new_password"}],staticClass:"form-control form-field",attrs:{"type":"password","placeholder":"New Password","autocomplete":"off"},domProps:{"value":(_vm.new_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_password=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"form-control form-field",attrs:{"type":"password","placeholder":"Confirm Password","autocomplete":"off"},domProps:{"value":(_vm.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v("\n                   "),_c('router-link',{attrs:{"to":{ name: 'Login-Layout' }}},[_c('i',{staticClass:"fa fa-arrow-right"}),_c('u',[_vm._v("Back to Login")])])],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Create New Password")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-style"},[_vm._v("Copyright © 2019 Blueprint Business Solution Corp"),_c('br'),_vm._v(" version 2.1.3 beta")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UGQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {}
    };
  },

  mounted: function mounted() {
    this.getItem();
    this.getCurentUser();
  },
  methods: {
    getItem: function getItem() {
      var _this = this;

      axios.get("api/leaveabsences/get/" + this.$route.params.id).then(function (response) {
        _this.item = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    update_leave: function update_leave(e) {
      var _this2 = this;

      e.preventDefault();
      axios.post("api/leaveabsences/update/hr/" + this.item.id, {
        date_filled: this.item.date_filled,
        no_of_days: this.item.no_of_days,
        leave_type: this.item.leave_type,
        remarks: this.item.remarks,
        start_date: this.item.start_date,
        end_date: this.item.end_date,
        reason: this.item.reason,
        status: this.item.status,
        hr_date_recived: this.item.hr_date_recived
      }).then(function (response) {
        _this2.$swal({
          type: "success",
          title: "Approved",
          html: "Employee leave has been  <br/>successfully approved <br/><br/>",
          showConfirmButton: false,
          timer: 4000
        });
        _this2.$router.push({
          name: "absence-leave"
        });
        console.log(response.data);
      }).catch(function (e) {
        console.log(e.response);
      });
    }
  }

});

/***/ }),

/***/ "USqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_job_information_vue__ = __webpack_require__("7d+H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a64cc04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_job_information_vue__ = __webpack_require__("lbNw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_job_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a64cc04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_job_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_resigned_vue__ = __webpack_require__("AbsB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52351cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_resigned_vue__ = __webpack_require__("jziG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_resigned_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52351cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_resigned_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ui1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_schedule_adjustment_vue__ = __webpack_require__("gbBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc1ebd46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_schedule_adjustment_vue__ = __webpack_require__("L/Lh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_schedule_adjustment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc1ebd46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_schedule_adjustment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Un+v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V39C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('users')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VAJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_view_details_vue__ = __webpack_require__("jRBo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a480950_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_view_details_vue__ = __webpack_require__("Pjvt");
function injectStyle (ssrContext) {
  __webpack_require__("2NdQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_view_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a480950_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_view_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VQmJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_integer_plusminus__ = __webpack_require__("5G+X");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    IntegerPlusminus: __WEBPACK_IMPORTED_MODULE_2_vue_integer_plusminus__["a" /* IntegerPlusminus */]
  },
  data: function data() {
    return {
      CalendarContent: [{
        name: "",
        start: "",
        type: "",
        h_type: "",
        display: {},
        isDisabled: true
      }],
      sub_departments: []

    };
  },
  mounted: function mounted() {
    this.getSubdepartments();
  },

  methods: {
    selectedType: function selectedType(type, index) {
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(index));

      if (type[index] !== 2) {
        this.CalendarContent.map(function (e) {
          e.h_type = "";
          return e.isDisabled = false;
        });
      }
      // if(type != 2){
      //   this.CalendarContent.map(e => { 
      //         e.h_type = ""
      //         return e.isDisabled = true    
      //      }
      //   )
      // }
    },
    getSubdepartments: function getSubdepartments() {
      var _this = this;

      axios.get('api/subdepartments').then(function (response) {
        _this.sub_departments = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },


    add_form: function add_form() {

      // this.CalendarContent[index].isDisabled = !this.CalendarContent[index].isDisabled

      // console.log(this.CalendarContent[index].isDisabled)

      this.CalendarContent.push({
        name: "",
        start: "",
        type: "",
        h_type: "",
        display: {}
      });
    },
    delete_form: function delete_form(index) {
      this.CalendarContent.splice(index, 1);
      if (index === 0) this.add_form();
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {

          console.log('response => calendar', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.CalendarContent));
          axios.post("api/calendar/add", {
            calendar_content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.CalendarContent)
          }).then(function (resp) {
            _this2.$swal("Save", resp.data.success, "success");
            _this2.$router.push({
              name: "holidays"
            });
            _this2.clear_data();
          }).catch(function (error) {
            console.log("response => ", error.response.data);
          });
        }
      });

      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.CalendarContent));
    }
  }
});

/***/ }),

/***/ "VSKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contributions-list')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VXGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Job Information")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Active Employees")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/inactive"}},[_vm._v(" Inactive Employees")])],1)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Position:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_position),expression:"filter_by_position"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"textContent":_vm._s(pos.pos_name)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"regular"}},[_vm._v("regular")]),_vm._v(" "),_c('option',{attrs:{"value":"probationary"}},[_vm._v("probationary")]),_vm._v(" "),_c('option',{attrs:{"value":"trainee"}},[_vm._v("trainee")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Employee")]),_vm._v(" "),_c('th',[_vm._v("Basic Salary")]),_vm._v(" "),_c('th',[_vm._v("Allowance")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Joined Date")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Date Signed")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Regularization Date")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedJobInformation),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.position_name))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(item.basic_salary)))]),_vm._v(" "),_c('td',[_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(item.monthly_allowance)))]),_vm._v(" "),_c('td',[(item.employment_date !== null)?_c('span',[_vm._v(" "+_vm._s(_vm.getDate(item.employment_date)))]):_c('span',[_vm._v("-------------------")])]),_vm._v(" "),_c('td',[(item.date_signed !== null)?_c('span',[_vm._v(" "+_vm._s(_vm.getDate(item.date_signed)))]):_c('span',[_vm._v("-------------------")])]),_vm._v(" "),_c('td',[(item.regularization_date !== null)?_c('span',[_vm._v(" "+_vm._s(_vm.getDate(item.regularization_date)))]):_c('span',[_vm._v("-------------------")])]),_vm._v(" "),_c('td',[(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'promoted')?_c('span',[_c('i',{staticClass:"fa fa-flag text-secondary"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'resigned')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'terminated')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'awol')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"to":{name: 'view-job-information', params: { id: item.id }},"title":"click to view full details of job information"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-job-information",modifiers:{"update-job-information":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"href":"#","title":"click to update employee job information"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")])],1)]],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"hide-modal-job-information",attrs:{"id":"update-job-information","size":"xl","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.full_name)))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Employment Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.employment_date),expression:"selected_user.employment_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.employment_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "employment_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Date Signed:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.date_signed),expression:"selected_user.date_signed"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.date_signed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "date_signed", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Resignation Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.resignation_date),expression:"selected_user.resignation_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.resignation_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "resignation_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Promoted Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.promoted_date),expression:"selected_user.promoted_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.promoted_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "promoted_date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Training Start:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.training_start),expression:"selected_user.training_start"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.training_start)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "training_start", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Training End:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.training_end),expression:"selected_user.training_end"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.training_end)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "training_end", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Regularization Date:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.regularization_date),expression:"selected_user.regularization_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.selected_user.regularization_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "regularization_date", $event.target.value)}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Basic Salary:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.basic_salary),expression:"selected_user.basic_salary"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.selected_user.basic_salary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "basic_salary", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Monthly Allowance:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.monthly_allowance),expression:"selected_user.monthly_allowance"},{name:"mask",rawName:"v-mask",value:(['#########']),expression:"['#########']"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0.00"},domProps:{"value":(_vm.selected_user.monthly_allowance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "monthly_allowance", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employment Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.status),expression:"selected_user.status"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_user, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.supervisor_subtitute]}},[_c('option',{attrs:{"value":"trainee"}},[_vm._v("Trainee")]),_vm._v(" "),_c('option',{attrs:{"value":"probationary"}},[_vm._v("Probationary")]),_vm._v(" "),_c('option',{attrs:{"value":"regular"}},[_vm._v("Regular")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("Terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("Resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Note:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.note),expression:"selected_user.note"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.selected_user.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_job_information}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],1),_vm._v(" "),_c('b-modal',{ref:"get_supervisor",attrs:{"id":"select_supervisor","size":"l","hide-footer":""}},[_c('h3',{staticClass:"c-padding"},[_vm._v("Supervisor Subtitute")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Supervisor:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.subtitute_id),expression:"subtitute_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.subtitute_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_superiorname]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(sup.position_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "),_c('i',[_vm._v("Please select a subtitute for "),_c('b',[_vm._v(_vm._s(_vm.selected_user.full_name))]),_vm._v(" to his/her job position.")])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_supervisor}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Update Changes")])]),_vm._v(" "),_c('br'),_c('br'),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Va+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('create-roles')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VcKG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VioB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-all')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VoEh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_request__ = __webpack_require__("fpN8");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteRequest: __WEBPACK_IMPORTED_MODULE_0__todo_nte_request__["a" /* default */]
    }
});

/***/ }),

/***/ "WAPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_performance_details__ = __webpack_require__("66G3");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      PerformanceDetails: __WEBPACK_IMPORTED_MODULE_0__todo_performance_details__["a" /* default */]
   }
});

/***/ }),

/***/ "WBqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_cd_hw_vue__ = __webpack_require__("GJEL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260988c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_cd_hw_vue__ = __webpack_require__("BfZO");
function injectStyle (ssrContext) {
  __webpack_require__("5Baz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_cd_hw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260988c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_cd_hw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WCQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_credit_config_vue__ = __webpack_require__("WPBP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3283be8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_credit_config_vue__ = __webpack_require__("tLiW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_credit_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3283be8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_credit_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WEYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_undertime_request_vue__ = __webpack_require__("Evtz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcde1ac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_undertime_request_vue__ = __webpack_require__("ridT");
function injectStyle (ssrContext) {
  __webpack_require__("iMpz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_undertime_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcde1ac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_undertime_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WErw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schedules: {
        "Day-Shift": [{
          "time": "5AM - 2PM"
        }, {
          "time": "6AM - 3PM"
        }, {
          "time": "7AM - 4PM"
        }, {
          "time": "8AM - 5PM"
        }, {
          "time": "9AM - 6PM"
        }, {
          "time": "10AM - 7PM"
        }, {
          "time": "11AM - 8PM"
        }, {
          "time": "12NN - 9PM"
        }, {
          "time": "1PM - 10PM"
        }, {
          "time": "2PM - 11PM"
        }, {
          "time": "3PM - 12NN"
        }],
        "Mid-Shift": [{
          "time": "11PM - 8AM"
        }, {
          "time": "12NN - 9AM"
        }, {
          "time": "1AM - 10AM"
        }, {
          "time": "2AM - 11AM"
        }, {
          "time": "3AM - 12NN"
        }, {
          "time": "4AM - 1PM"
        }],
        "Night-Shift": [{
          "time": "9PM - 6AM"
        }, {
          "time": "10PM - 7AM"
        }, {
          "time": "8PM - 5AM"
        }, {
          "time": "7PM - 4AM"
        }, {
          "time": "4PM - 1AM"
        }, {
          "time": "5PM - 2AM"
        }, {
          "time": "6PM - 3AM"
        }]
      },
      timezoneId: "",
      sched_items: [],
      selectedSched: "",
      selectedTime: "",

      // Items
      departments: [],
      subdepartments: [],
      positions: [],
      sub_department_id: "",
      // Job Information
      position_id: "",
      employment_date: "",
      basic_salary: "",
      others_salary: "",
      monthly_allowance: "",
      others_allowance: "",
      date_sign: "",
      training_date: "",
      // Personal Information
      emp_id: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      suffix: "",
      civil_status: "",
      birthdate: "",
      current_address: "",
      permanent_address: "",
      // Contact Information
      contact: "",
      contact_person: "",
      emergency_no: "",
      email_address: "",
      relationship: "",
      // Requirements
      sss_no: "",
      hdmf_no: "",
      mid_no: "",
      tin_no: "",
      phic_no: "",
      //Experience
      experience: [{
        employeer: "",
        company_address: "",
        job_title: "",
        start_date: "",
        end_date: "",
        previous_salary: "",
        reason_for_leaving: ""
      }],
      dependents: [{
        name: "",
        relationship: "",
        age: "",
        phic_no: ""
      }],
      seniors: [{
        senior_citizen: "",
        middle_initial: ""
      }],

      // Errors handler
      error_handler: []
    };
  },
  mounted: function mounted() {
    this.$store.dispatch("GET_DEPARTMENT");
    this.$store.dispatch("GET_POSITIONS");
    this.$store.dispatch("GET_SUBDEPARTMENT");
    this.$store.dispatch("GET_TIMEZONES");
  },

  methods: {
    add_experience: function add_experience() {
      this.experience.push({
        employeer: "",
        company_address: "",
        job_title: "",
        start_date: "",
        end_date: "",
        previous_salary: "",
        reason_for_leaving: ""
      });
    },
    deleteUser: function deleteUser(index) {
      console.log(index);
      console.log(this.finds);
      this.experience.splice(index, 1);
      if (index === 0) this.add_experience();
    },
    add_dependent: function add_dependent() {
      this.dependents.push({
        name: "",
        relationship: "",
        age: "",
        phic_no: ""
      });
    },
    add_senior: function add_senior(index) {
      this.seniors.push({
        senior_citizen: "",
        middle_initial: ""
      });

      if (index === 1) this.seniors.splice(index, 1);
    },
    deleteSenior: function deleteSenior(index) {
      console.log(index);
      console.log(this.finds);
      this.seniors.splice(index, 1);
      if (index === 0) this.add_senior();
    },
    deleteDependent: function deleteDependent(index) {
      console.log(index);
      console.log(this.finds);
      this.dependents.splice(index, 1);
      if (index === 0) this.add_dependent();
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post("api/employees/add", {
            // PERSONAL INFORMATION
            emp_id: _this.emp_id,
            position_id: _this.position_id,
            sub_department_id: _this.sub_department_id,
            first_name: _this.first_name,
            middle_name: _this.middle_name,
            last_name: _this.last_name,
            suffix: _this.suffix,
            civil_status: _this.civil_status,
            birthdate: _this.frontEndDateFormat(_this.birthdate),
            current_address: _this.current_address,
            permanent_address: _this.permanent_address,

            //WORK SHIFT
            schedule: _this.selectedSched,
            time: _this.selectedTime,
            timezone_id: _this.timezoneId,

            // JOB INFORMATION
            employment_date: _this.frontEndDateFormat(_this.employment_date),
            basic_salary: _this.basic_salary != '0' ? _this.basic_salary : _this.others_salary,
            monthly_allowance: _this.monthly_allowance != '0' ? _this.monthly_allowance : _this.others_allowance,
            date_signed: _this.date_sign,
            training_date: _this.training_date,

            // CONTACT
            contact: _this.contact,
            contact_person: _this.contact_person,
            emergency_no: _this.emergency_no,
            email_address: _this.email_address,
            relationship: _this.relationship,

            // EXPERIENCE
            experience: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.experience),

            // REQUIREMENTS
            sss_no: _this.sss_no,
            hdmf_no: _this.hdmf_no,
            mid_no: _this.mid_no,
            tin_no: _this.tin_no,
            phic_no: _this.phic_no,

            // DEPENDENTS
            dependents: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.dependents),
            seniors: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.seniors)
          }).then(function (resp) {
            console.log(resp.data);
            if (resp.data.response == "error") {
              _this.$swal("Error", resp.data.message, "error");
            } else {
              _this.$swal("Save", resp.data.message, "success");
              _this.$router.push({ name: "new-employee" });
              _this.clear_data();
              _this.error_handler = "";
            }
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this.error_handler = error.response.data.errors;
            }
            console.log("response => ", error.response.message);
          });
        }
      });
    },
    resForm: function resForm(e) {
      e.preventDefault();
      this.clear_data();
      this.$swal("All feild are successfuly cleared");
    },
    clear_data: function clear_data() {
      // JOB INFORMATION
      this.employment_date = "";
      this.basic_salary = "";
      this.monthly_allowance = "";
      this.date_sign = "";
      this.training_date = "";
      this.date_sign = "";

      // PERSONAL INFORMATION  CLEAR
      this.emp_id = "";
      this.position_id = "";
      this.first_name = "";
      this.middle_name = "";
      this.last_name = "";
      this.civil_status = "";
      this.birthdate = "";
      this.current_address = "";
      this.permanent_address = "";

      //  CONTACT
      this.contact = "";
      this.contact_person = "";
      this.emergency_no = "";
      this.email_address = "";
      this.relationship = "";

      // EXPERIENCE
      this.experience = [{
        employeer: "",
        company_address: "",
        job_title: "",
        start_date: "",
        end_date: "",
        previous_salary: "",
        reason_for_leaving: ""
      }];

      // REQUIREMENTS
      this.sss_no = "";
      this.hdmf_no = "";
      this.tin_no = "";
      this.phic_no = "";

      // EXPERIENCE
      this.dependents = [{
        name: "",
        relationship: "",
        age: "",
        phic_no: ""
      }];

      // EXPERIENCE
      this.seniors = [{
        senior_citizen: "",
        middle_initial: ""
      }];
    },


    frontEndDateFormat: function frontEndDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    },

    hide_message_timezone_id: function hide_message_timezone_id() {
      if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false;
    },
    hide_message_scheduleType: function hide_message_scheduleType() {
      if (!!this.error_handler.schedule) this.error_handler.schedule = false;
    },
    hide_message_scheduleTime: function hide_message_scheduleTime() {
      if (!!this.error_handler.time) this.error_handler.time = false;
    },
    hide_message_employeeNo: function hide_message_employeeNo() {
      if (!!this.error_handler.emp_id) this.error_handler.emp_id = false;
    },
    hide_message_departmentBelong: function hide_message_departmentBelong() {
      if (!!this.error_handler.sub_department_id) this.error_handler.sub_department_id = false;
    },
    hide_message_position: function hide_message_position() {
      if (!!this.error_handler.position_id) this.error_handler.position_id = false;
    },
    hide_message_salary: function hide_message_salary() {
      if (!!this.error_handler.basic_salary) this.error_handler.basic_salary = false;
    },
    hide_message_allowance: function hide_message_allowance() {
      if (!!this.error_handler.monthly_allowance) this.error_handler.monthly_allowance = false;
    },
    hide_message_dateHired: function hide_message_dateHired() {
      if (!!this.error_handler.employment_date) this.error_handler.employment_date = false;
    },
    hide_message_firstName: function hide_message_firstName() {
      if (!!this.error_handler.first_name) this.error_handler.first_name = false;
    },
    hide_message_lastName: function hide_message_lastName() {
      if (!!this.error_handler.last_name) this.error_handler.last_name = false;
    },
    hide_message_middleName: function hide_message_middleName() {
      if (!!this.error_handler.middle_name) this.error_handler.middle_name = false;
    },
    hide_message_civilStatus: function hide_message_civilStatus() {
      if (!!this.error_handler.civil_status) this.error_handler.civil_status = false;
    },
    hide_message_birthDate: function hide_message_birthDate() {
      if (!!this.error_handler.birthdate) this.error_handler.birthdate = false;
    },
    hide_message_currentAddress: function hide_message_currentAddress() {
      if (!!this.error_handler.current_address) this.error_handler.current_address = false;
    },
    hide_message_permanentAddress: function hide_message_permanentAddress() {
      if (!!this.error_handler.permanent_address) this.error_handler.permanent_address = false;
    },
    hide_message_contactNo: function hide_message_contactNo() {
      if (!!this.error_handler.contact) this.error_handler.contact = false;
    },
    hide_message_personalEmail: function hide_message_personalEmail() {
      if (!!this.error_handler.email_address) this.error_handler.email_address = false;
    },
    hide_message_emergencyNo: function hide_message_emergencyNo() {
      if (!!this.error_handler.emergency_no) this.error_handler.emergency_no = false;
    },
    hide_message_contactPerson: function hide_message_contactPerson() {
      if (!!this.error_handler.contact_person) this.error_handler.contact_person = false;
    },
    hide_message_relationship: function hide_message_relationship() {
      if (!!this.error_handler.relationship) this.error_handler.relationship = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['departmentItem', 'positionsItem', 'subDepartmentItem', 'timezoneItem'])),
  watch: {
    selectedSched: function selectedSched() {
      // Clear previously selected values
      this.sched_items = [];
      this.time_items = [];
      this.selectedTime = "";
      // Populate list of sched_items in the second dropdown
      if (this.selectedSched.length > 0) {
        this.sched_items = this.schedules[this.selectedSched];
      }
    },
    selectedTime: function selectedTime() {
      // Clear previously selected values
      this.time_items = [];
      // Now we have a continent and sched_index. Populate list of time_items in the third dropdown
      if (this.selectedTime.length > 0) {
        this.time_items = this.schedules[this.selectedSched][this.selectedTime];
      }
    }
  }
});

/***/ }),

/***/ "WPBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            items: [],
            selected_user: ''
        };
    },

    created: function created() {
        this.getLeaveCredit();
    },
    methods: {
        update_credit_config: function update_credit_config() {
            var _this = this;

            axios.post('api/credits/config/update/' + this.selected_user.id, {
                monthly_earn: this.selected_user.monthly_earn,
                leave_refresh: this.selected_user.leave_refresh,
                description: this.selected_user.description
            }).then(function (response) {
                _this.$swal({
                    type: 'success',
                    title: 'Save',
                    text: 'You successfully save',
                    showConfirmButton: false,
                    timer: 2000
                });
                _this.getLeaveCredit();
                _this.$refs['hide-credit-config'].hide();
                console.log(response);
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_selected_id: function get_selected_id(item) {
            this.selected_user = item;
        },
        getLeaveCredit: function getLeaveCredit() {
            var _this2 = this;

            axios.get('api/leave/credits/config').then(function (resp) {
                _this2.items = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        formSubmit: function formSubmit(e) {
            e.preventDefault();
        }
    }

});

/***/ }),

/***/ "WRTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('calendar')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WTDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 500,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemo', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this5 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this5.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this5.order_by : _this5.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    }
  }
});

/***/ }),

/***/ "Wdxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: '',
      dependents: [{
        name: '',
        relationship: '',
        age: '',
        phic_no: ''
      }],
      seniors: [{
        senior_citizen: '',
        middle_initial: ''
      }]

    };
  },

  mounted: function mounted() {
    this.getEmployeeInfo();
  },
  methods: {
    getEmployeeInfo: function getEmployeeInfo() {
      var _this = this;

      axios.get('api/dependents/get/' + this.$route.params.id).then(function (response) {
        _this.item = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    update_form: function update_form(e) {
      var _this2 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes.',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/dependents/update/' + _this2.item.id, {
            //Update experience
            dependents: _this2.item.dependents,
            seniors: _this2.item.seniors

          }).then(function (response) {
            _this2.$swal({
              type: 'success',
              title: 'Save',
              text: 'You successfully save changes',
              showConfirmButton: false,
              timer: 2000
            });

            _this2.$router.push({
              name: 'dependents'
            });
            console.log(response.data);
          }).catch(function (e) {
            console.log(e.response);
          });
        }
      });
    }
  }

});

/***/ }),

/***/ "WhSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_payslip_vue__ = __webpack_require__("ngpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01418ba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_payslip_vue__ = __webpack_require__("8MEg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_payslip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01418ba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_payslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WugJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_contributions_details__ = __webpack_require__("GTGN");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        contributionsDetails: __WEBPACK_IMPORTED_MODULE_0__todo_contributions_details__["a" /* default */]
    }
});

/***/ }),

/***/ "WxFy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XA5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Employee Details")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Employees List")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Details")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update_form($event)}}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Employee ID:")]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.emp_id),expression:"item.emp_id"},{name:"mask",rawName:"v-mask",value:(['####-###']),expression:"['####-###']"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.item.emp_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "emp_id", $event.target.value)}}})]),_vm._v(" "),_c('p',{staticClass:"col-md-1 text-right p-text"},[_vm._v("Positions:")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.position_id),expression:"item.position_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "position_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"value":pos.pos_id}},[_vm._v(_vm._s(pos.pos_name))])}),0)]),_vm._v(" "),_c('p',{staticClass:"col-md-1 text-right p-text"},[_vm._v("Sub Dept:")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.sub_department_id),expression:"item.sub_department_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "sub_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subdepartment),function(sub){return _c('option',{domProps:{"value":sub.id}},[_vm._v(_vm._s(sub.sub_department_name))])}),0)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"10px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',{staticClass:"text-right"},[_c('u',[_vm._v("Basic Info")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Fullname :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.first_name),expression:"item.first_name"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Firstname","required":""},domProps:{"value":(_vm.item.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "first_name", $event.target.value)}}}),_vm._v(" "),_c('small',{staticStyle:{"color":"cornflowerblue"}},[_c('i',[_vm._v("Firstname")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.last_name),expression:"item.last_name"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Lastname","required":""},domProps:{"value":(_vm.item.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "last_name", $event.target.value)}}}),_vm._v(" "),_c('small',{staticStyle:{"color":"cornflowerblue"}},[_c('i',[_vm._v("Lastname")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.middle_name),expression:"item.middle_name"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","placeholder":"Middlename","required":""},domProps:{"value":(_vm.item.middle_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "middle_name", $event.target.value)}}}),_vm._v(" "),_c('small',{staticStyle:{"color":"cornflowerblue"}},[_c('i',[_vm._v("Middlename")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.suffix),expression:"item.suffix"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("None")]),_vm._v(" "),_c('option',{attrs:{"value":"Jr"}},[_vm._v("Jr")]),_vm._v(" "),_c('option',{attrs:{"value":"Sr"}},[_vm._v("Sr")]),_vm._v(" "),_c('option',{attrs:{"value":"I"}},[_vm._v("I")]),_vm._v(" "),_c('option',{attrs:{"value":"II"}},[_vm._v("II")]),_vm._v(" "),_c('option',{attrs:{"value":"III"}},[_vm._v("III")]),_vm._v(" "),_c('option',{attrs:{"value":"IV"}},[_vm._v("IV")]),_vm._v(" "),_c('option',{attrs:{"value":"IV"}},[_vm._v("V")])]),_vm._v(" "),_c('small',{staticStyle:{"color":"cornflowerblue"}},[_c('i',[_vm._v("Suffix")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Current Address :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.current_address),expression:"item.current_address"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.item.current_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "current_address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v(" Permanent address :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.permanent_address),expression:"item.permanent_address"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.item.permanent_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "permanent_address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v(" Birth Date :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.birthdate),expression:"item.birthdate"}],staticClass:"form-control",attrs:{"type":"date","required":""},domProps:{"value":(_vm.item.birthdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "birthdate", $event.target.value)}}})])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',{staticClass:"text-right"},[_c('u',[_vm._v("Contacts Info")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Contact No :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-#######']),expression:"['####-#######']"},{name:"model",rawName:"v-model",value:(_vm.item.contact),expression:"item.contact"}],staticClass:"form-control",attrs:{"type":"tel","required":""},domProps:{"value":(_vm.item.contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "contact", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Emergency Contact :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['####-#######']),expression:"['####-#######']"},{name:"model",rawName:"v-model",value:(_vm.item.emergency_no),expression:"item.emergency_no"}],staticClass:"form-control",attrs:{"type":"tel","required":""},domProps:{"value":(_vm.item.emergency_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "emergency_no", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Contact Person :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.contact_person),expression:"item.contact_person"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}","required":""},domProps:{"value":(_vm.item.contact_person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "contact_person", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Personal Email :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.email_address),expression:"item.email_address"}],staticClass:"form-control",attrs:{"type":"email","required":""},domProps:{"value":(_vm.item.email_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "email_address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Relationship :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.relationship),expression:"item.relationship"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "relationship", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Mother"}},[_vm._v("Mother")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Father")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Daughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Son"}},[_vm._v("Son")]),_vm._v(" "),_c('option',{attrs:{"value":"Sister"}},[_vm._v("Sister")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Brother")]),_vm._v(" "),_c('option',{attrs:{"value":"Aunt"}},[_vm._v("Aunt")]),_vm._v(" "),_c('option',{attrs:{"value":"Uncle"}},[_vm._v("Uncle")]),_vm._v(" "),_c('option',{attrs:{"value":"Niece"}},[_vm._v("Niece")]),_vm._v(" "),_c('option',{attrs:{"value":"Nephew"}},[_vm._v("Nephew")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Sibling")]),_vm._v(" "),_c('option',{attrs:{"value":"Sibling"}},[_vm._v("Guardian")]),_vm._v(" "),_c('option',{attrs:{"value":"Live in Partner"}},[_vm._v("Live in Partner")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Female)"}},[_vm._v("Cousin(Female)")]),_vm._v(" "),_c('option',{attrs:{"value":"Cousin(Male)"}},[_vm._v("Cousin(Male)")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandmother"}},[_vm._v("Grandmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Brother"}},[_vm._v("Grandfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Granddaughter"}},[_vm._v("Granddaughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Grandson"}},[_vm._v("Grandson")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepsister"}},[_vm._v("Stepsister")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepbrother"}},[_vm._v("Stepbrother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepmother"}},[_vm._v("Stepmother")]),_vm._v(" "),_c('option',{attrs:{"value":"Stepfather"}},[_vm._v("Stepfather")]),_vm._v(" "),_c('option',{attrs:{"value":"Girlfreind"}},[_vm._v("Girlfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Boyfreind"}},[_vm._v("Boyfreind")]),_vm._v(" "),_c('option',{attrs:{"value":"Wife"}},[_vm._v("Wife")]),_vm._v(" "),_c('option',{attrs:{"value":"Husband"}},[_vm._v("Husband")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',{staticClass:"text-right"},[_c('u',[_vm._v("Employee Experience")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_vm._l((_vm.item.experience),function(exp){return _c('div',[_c('hr',{staticStyle:{"margin-top":"10px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Employeer :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.employeer),expression:"exp.employeer"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(exp.employeer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "employeer", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Company Address :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.company_address),expression:"exp.company_address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(exp.company_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "company_address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Job Title/Position :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.job_title),expression:"exp.job_title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(exp.job_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "job_title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Start Date :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.start_date),expression:"exp.start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(exp.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "start_date", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("End Date :")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.end_date),expression:"exp.end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(exp.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "end_date", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Previous Salary :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.previous_salary),expression:"exp.previous_salary"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(exp.previous_salary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "previous_salary", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Reason for leaving :")]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(exp.reason_for_leaving),expression:"exp.reason_for_leaving"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(exp.reason_for_leaving)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(exp, "reason_for_leaving", $event.target.value)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-6 text-right p-text"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('router-link',{staticClass:"btn btn-info",attrs:{"to":"/hr/employeelist"}},[_c('i',{staticClass:"fa fa-list"}),_vm._v(" Employees List")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])])])])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XQIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
	},

	data: function data() {
		return {
			uname: '',
			upass: '',
			output: '',
			items: [],
			error_handler: '',
			seen: false,
			access_address: ''
		};
	},

	mounted: function mounted() {
		var _this = this;

		fetch('https://api.ipify.org?format=json').then(function (x) {
			return x.json();
		}).then(function (_ref) {
			var ip = _ref.ip;

			console.log(_this.term = ip);
		});
	},
	methods: {
		hide_message: function hide_message() {
			this.error_handler = false;
		},
		login: function login() {
			var _this2 = this;

			var auth = { name: this.uname, password: this.upass };
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/login', auth).then(function (resp) {
				_this2.seen = true;
				if (resp.data.user_type == 5) {
					setTimeout(function () {
						_this2.seen = false;
						_this2.$router.push({ name: 'Dashboard' });
					}, 2000);
					/**	
     * STORE TOKEN ON LOCAL STORAGE 
     */
					__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('loginUser');
					localStorage.setItem('token', resp.data.access_token);
					localStorage.setItem('expiration', resp.data.expires_at + Date.now());
				} else {
					_this2.uname = '';
					_this2.upass = '';
					_this2.seen = false;
					_this2.error_handler = 'Access Denied !';
					_this2.$router.push({ name: 'Login-Layout' });
				}
			}).catch(function (error) {
				_this2.error_handler = error.response.data.error;
				console.log(error.response.data.error);
				_this2.uname = '';
				_this2.upass = '';
			});
		}
	},

	watch: {
		error_handler: function error_handler() {
			console.log('response =>', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.error_handler));
		}
	}

});

/***/ }),

/***/ "Xd68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xemw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    var _ref;

    return _ref = {
      //ITEMS
      item: {},
      nteFiles: [],
      files: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'files', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'corrective', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'corection_plan', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'error_handler', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imgs', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'visible', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'uploadReady', true), _ref;
  },


  mounted: function mounted() {
    this.getItem();
  },

  methods: {
    //LIGHT BOX
    showSingle: function showSingle(img) {
      this.imgs = window.axios.defaults.baseURL + 'upload/' + img.file_name;
      this.show();
    },
    show: function show() {
      this.visible = true;
    },
    handleHide: function handleHide() {
      this.visible = false;
    },

    //END LIGHT BOX

    getItem: function getItem() {
      var _this = this;

      axios.get('api/nterequestbyhr/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
        console.log(_this.item.data_files);
      });
    },


    //FILE UPLOAD
    handleNteFilesUpload: function handleNteFilesUpload() {
      var uploadedNTEFiles = event.target.files;
      if (!uploadedNTEFiles.length) return;
      for (var i = 0; i < uploadedNTEFiles.length; i++) {
        this.nteFiles.push(uploadedNTEFiles[i]);
      }
      console.log('response => ', uploadedNTEFiles);
    },
    removenteFilesUpload: function removenteFilesUpload(key) {
      this.nteFiles.splice(key, 1);
      console.log(this.nteFiles);
    },
    removeExistingFiles: function removeExistingFiles(key) {
      this.item.data_files.splice(key, 1);
      console.log(this.item.data_files);
    },
    update_form: function update_form(e) {
      var _this2 = this;

      e.preventDefault();
      //Form data a files to upload
      var formData = new FormData();

      for (var i = 0; i < this.nteFiles.length; i++) {
        var file = this.nteFiles[i];
        formData.append('files[' + i + ']', file);
      }

      //Additional POST Request
      formData.append('existing_files', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.item.data_files));
      formData.append('action_to_be_taken', this.corection_plan);
      formData.append('hr_status', this.item.hr_status);

      axios.post('api/nterequest/approval/update/' + this.item.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      }).then(function (response) {
        _this2.$swal({
          type: 'success',
          title: 'NTE Request Send..',
          html: 'NTE Request was<br/> successfully send.<br/><br/><br/><br/>',
          showConfirmButton: false,
          timer: 4000
        });

        _this2.$router.push({
          name: 'nte-request'
        });
        console.log(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    imgpreview: function imgpreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }

});

/***/ }),

/***/ "XoiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_time_attendance_vue__ = __webpack_require__("lUJj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c529311_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_time_attendance_vue__ = __webpack_require__("aaEi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_time_attendance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c529311_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_time_attendance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y0OJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y2LM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-warning"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_c('i',{staticClass:"fa fa-pie-chart text-warning"})])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("EMPLOYEES")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.statusItem.activeEmployees))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v(" Employees")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("REGULAR")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.regular))])])])])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("POBATIONARY")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.probationary))])])])])])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("TRAINEE")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.trainee))])])])])])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("SUPERVISOR")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.supervisor))])])])])])]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("RESIGNED")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.resigned))])])])])])]),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("AWOL")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.awol))])])])])])]),_vm._v(" "),_vm._m(11)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_c('div',[_c('p',{staticClass:"card-category"},[_vm._v("TERMINATED")]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.statusItem.terminated))])])])])])]),_vm._v(" "),_vm._m(13)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  Celebrant of "),_c('b',[_vm._v(_vm._s(_vm.get_month))])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"4px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 overflow-auto"},_vm._l((_vm.birthdayAll),function(birth,i){return _c('span',[(birth == 'no data found')?_c('span',[_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-database text-warning"}),_vm._v("  NO RECORD FOUND ... "),_c('br'),_vm._v(" "),_c('br')]):_c('span',[_c('p',[_vm._v("\n                              "+_vm._s(i+1)+". \n                              "),(birth.full_name.length < 18)?[_vm._v(_vm._s(_vm._f("capitalize")(birth.full_name)))]:_vm._e(),_vm._v(" "),(birth.full_name.length >= 18)?[_vm._v(_vm._s(_vm._f("capitalize")(birth.full_name.substring(0,18)+"...")))]:_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-birthday-cake text-warning"}),_vm._v("  "+_vm._s(_vm.getBirth(birth.birthdate))+" "+_vm._s(new Date().getFullYear())+"\n                           ")],2)])])}),0)])]),_vm._v(" "),_vm._m(14)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_vm._m(15),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12  overflow-auto"},_vm._l((_vm.employeeLeave),function(leave,i){return _c('span',[(leave == 'no data found')?_c('span',[_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-database text-warning"}),_vm._v("  NO RECORD FOUND ... "),_c('br'),_vm._v(" "),_c('br')]):_c('span',[_c('p',[(leave.full_name.length < 22)?[_vm._v(_vm._s(_vm._f("capitalize")(leave.full_name)))]:_vm._e(),_vm._v(" "),(leave.full_name.length >= 22)?[_vm._v(_vm._s(_vm._f("capitalize")(leave.full_name.substring(0,22)+"...")))]:_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-plane text-warning"}),_vm._v(" "+_vm._s(_vm.getDate(leave.start_date))+"\n                           ")],2)])])}),0)])]),_vm._v(" "),_vm._m(16)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_vm._m(17),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12  overflow-auto"},_vm._l((_vm.incommingLeave),function(leave,i){return _c('span',[(leave == 'no data found')?_c('span',[_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-database text-warning"}),_vm._v("  NO RECORD FOUND ... "),_c('br'),_vm._v(" "),_c('br')]):_c('span',[_c('p',[(leave.full_name.length < 35)?[_vm._v(_vm._s(_vm._f("capitalize")(leave.full_name)))]:_vm._e(),_vm._v(" "),(leave.full_name.length >= 35)?[_vm._v(_vm._s(_vm._f("capitalize")(leave.full_name.substring(0,35)+"...")))]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"incoming-date-text"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.getDate(leave.start_date))+"  - "),_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.getDate(leave.end_date)))])],2),_vm._v(" "),_c('hr',{staticClass:"notification-divider"})])])}),0)])]),_vm._v(" "),_vm._m(18)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_vm._m(19),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12  overflow-auto"},_vm._l((_vm.aniversaryAll),function(anniv,i){return _c('span',[(anniv == 'no data found')?_c('span',[_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-database text-warning"}),_vm._v("  NO RECORD FOUND ... "),_c('br'),_vm._v(" "),_c('br')]):_c('span',[_c('p',[_vm._v(_vm._s(_vm._f("capitalize")(anniv.full_name))+" - Anniversary\n                      "),_c('br'),_c('small',[_vm._v(" Happy "),_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.yearCount(anniv.employment_date)))]),_vm._v(" Year's in Service")])])])])}),0)])]),_vm._v(" "),_vm._m(20)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-success"},[_c('i',{staticClass:"fa fa-line-chart text-success"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Regular Employees\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-danger"},[_c('i',{staticClass:"fa fa-line-chart text-info"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Probationary Employees\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-info"},[_c('i',{staticClass:"fa fa-line-chart text-warning"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Trainee Employees \n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-warning"},[_c('i',{staticClass:"fa fa-user-secret text-primary"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Company Supervisory \n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-warning"},[_c('i',{staticClass:"fa fa-line-chart text-danger"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Resigned Employees\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-warning"},[_c('i',{staticClass:"fa fa-line-chart text-danger"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Awol Employees\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_c('div',{staticClass:"icon-warning"},[_c('i',{staticClass:"fa fa-line-chart text-danger"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Terminated Employee's\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Birthdays of the month\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v("  Today Leave")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Employees Leave Monitoring\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-mail-forward"}),_vm._v("  In-Coming Leave")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Employees Leave Monitoring\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-user-circle-o"}),_vm._v("  Employee's Anniversary")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Employee Anniversary\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y9ri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_resigned_vue__ = __webpack_require__("qxhY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45f530c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_resigned_vue__ = __webpack_require__("i5Ax");
function injectStyle (ssrContext) {
  __webpack_require__("4XAN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_resigned_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45f530c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_resigned_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YM5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('job-information')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YYyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_breadcrumb_menu__ = __webpack_require__("AaH/");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        breadcrumbMenu: __WEBPACK_IMPORTED_MODULE_3__base_breadcrumb_menu__["a" /* default */]
    },
    data: function data() {
        var _ref;

        return _ref = {
            items: [],
            loading: true,
            belongs_to: '',
            selected_item: '',
            //options
            supervisor: [],
            manager: [],
            //filter
            search: '',
            order_by: '',
            sortAsc: true,
            //pagination
            page_limit: '',
            start_page: 1
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'options', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sup_subtitute_id', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sup_choosen_id', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'member_item', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'subtitute_item', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'supervisor_choosen', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'subordinate_item', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'checkedPerm_Id', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sub_department', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'status_control', ''), _ref;
    },


    mounted: function mounted() {
        this.get_users();
        this.get_supervisor();
        this.get_manager();
        this.get_subtitute();
        this.get_sub_department();
    },

    methods: {
        subordinateStatus: function subordinateStatus(id, status) {
            var _this = this;

            if (status == '1') {
                this.status_control = '0';
            } else if (status == '0') {
                this.status_control = '1';
            }

            axios.post('api/updateStatus', {
                id: id,
                status: this.status_control
            }).then(function (resp) {
                _this.get_users();
            });
        },

        //GET SUB DEPARTMENT
        get_sub_department: function get_sub_department() {
            var _this2 = this;

            axios.get('api/subdepartment/all').then(function (response) {
                _this2.sub_department = response.data;_this2.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },

        //GET MANAGER FOR SUBORDINATES DISPLAY
        get_selected_empId: function get_selected_empId(item) {
            var _this3 = this;

            this.selected_emp = item;
            //SUBORDINATES
            axios.get('api/employee/' + this.selected_emp.id).then(function (resp) {
                _this3.subordinate_item = resp.data;
                _this3.checkedPerm_Id = _this3.subordinate_item.subordinates.map(function (o) {
                    return o.id;
                });
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        update_subordinate: function update_subordinate() {
            var _this4 = this;

            console.log('response =>', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.checkedPerm_Id));
            console.log('response =>', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selected_emp.id));

            axios.post('api/subordinates/update', {
                id: this.selected_emp.id,
                subordinates: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.checkedPerm_Id)
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this4.get_sub_department();
                    _this4.$swal('Save', resp.data.message, 'success');
                    _this4.$refs['hide-subordinate-modal'].hide();
                } else {
                    _this4.$swal('Error', resp.data.message, 'error');
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_manager: function get_manager() {
            var _this5 = this;

            axios.get('api/operation').then(function (resp) {
                _this5.manager = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        modalClose: function modalClose() {
            this.subtitute_item = false, this.supervisor_choosen = false;
        },
        get_subtitute: function get_subtitute() {
            if (this.options == 'admin' && this.member_item.length != 0) {
                this.subtitute_item = true;
                this.supervisor_choosen = false;
            } else if (this.options == 'staff' && this.member_item.length != 0) {
                this.subtitute_item = true;
                this.supervisor_choosen = true;
            } else if (this.options == 'asm' && this.member_item.length != 0) {
                this.subtitute_item = true;
                this.supervisor_choosen = false;
            } else if (this.options == 'staff') {
                this.supervisor_choosen = true;
            } else {
                this.subtitute_item = false;
                this.supervisor_choosen = false;
            }
        },
        get_supervisor: function get_supervisor() {
            var _this6 = this;

            axios.get('api/supervisor').then(function (resp) {
                _this6.supervisor = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //SUPERVISOR ACCESS
        get_users: function get_users() {
            var _this7 = this;

            axios.get('api/supervisoraccess').then(function (response) {
                _this7.items = response.data;_this7.loading = false;console.log('response =>', response.data);
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_selected_id: function get_selected_id(item) {
            var _this8 = this;

            this.selected_item = item;
            axios.get('api/checkmember/' + this.selected_item.id).then(function (resp) {
                _this8.member_item = resp.data;console.log(_this8.member_item.length);
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //UPDATE USER BELONGS
        update_user: function update_user() {
            var _this9 = this;

            axios.post('api/supervisoraccess/update/' + this.selected_item.id, {
                'supervisor_member': this.member_item.length,
                'account_type': this.options,
                'sup_subtitute_id': this.sup_subtitute_id,
                'supervisor_choosen_id': this.sup_choosen_id
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this9.get_users();
                    _this9.$swal('Save', resp.data.message, 'success');
                    _this9.$refs['hide-user-modal'].hide();
                } else {
                    _this9.$swal('Error', resp.data.message, 'error');
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    computed: {
        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_record: function total_record() {
            return this.items.length;
        },
        numOfPages: function numOfPages() {
            return Math.ceil(this.items.length / this.page_limit);
        },
        computedEmployee: function computedEmployee() {
            var _this10 = this;

            var filtered = this.items;
            if (filtered.length > 0) {
                // SEARCH BY EMPLOYEE FULLNAME  
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this10.search) > -1;
                    });
                    return filtered;
                }

                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }

                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this10.order_by : -_this10.order_by;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }

});

/***/ }),

/***/ "Yi1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_coaching_record_vue__ = __webpack_require__("OHHg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b49abc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_coaching_record_vue__ = __webpack_require__("9zFS");
function injectStyle (ssrContext) {
  __webpack_require__("d3u9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_coaching_record_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b49abc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_coaching_record_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YjZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YuSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemocdhw', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/cdhw', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "YyDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("WFH Responsibility Details")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/wfh/responsibility"}},[_vm._v("Office Responsibility")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("WFH Responsibility Details")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"report-container-wfh"},[_c('div',{staticClass:"report-border-wfh"},[_c('center',[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_vm._v(" "),_c('h4',[_c('b',[_vm._v("BLUEPRINT   BUSINESS   SOLUTION   BPO   CORP")])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"-8px"}},[_c('b',[_vm._v("ADDENDUM   OF   AFFIDAVIT   OF   UNDERTAKING ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Due to the extension of the Enhanced Community Quarantine mandated by the local government of\n           Lapulapu City, that I, upon my request to Temporarily Work from Home until April 28, 2020, I agree to\n           be compliant to all the terms indicated in this affidavit as well as my employment contract with the\n           company.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Extension of the Work from Home (fulltime) is dependent upon the mandate of the local government\n            of Lapulapu City. Once lifted I agree to go back fulltime, officebased. Failure to do so will result in\n            Breach of Contract thus endorsement for a legal case.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n           All the other rules and regulations as well as guidelines stated in my Employment Contract and the\n           Affidavit of Undertaking will still apply and is considered valid.\n        ")]),_vm._v(" "),_c('p'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b',[_vm._v(" 1.")]),_vm._v(" That I must be compliant to all terms and conditions stated in the signed and completed\n                        Blueprint Business Solution BPO Corp Employment Agreement upon hire date. With the\n                        Temporary Work from Home Program of the company upon my request in full reiteration\n                        and emphasis of the Confidentiality Clause in the contract.\n                 ")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b',[_vm._v("  2.")]),_vm._v(" Two instances of unresponsiveness during work hours will result in revocation of the\n                            Work from Home scheme where in the Blueprint PC unit will be pulled out and the agent is\n                            expected to be back to IN OFFICE status.\n                        ")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("CONFORME:")]),_c('br'),_vm._v("\n            I accept the terms of this letter. I understand that the benefits, policies, and procedures of the\n            Company are subject to future updates and/or changes, and that my employment is contingent upon\n            the conditions set forth in this letter.\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.responsibilityItem.wfh_signature,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"report-printed-control"},[_c('b',[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.responsibilityItem.full_name)))])])]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v("Signature over Printed Name")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('center',[_vm._v(" "+_vm._s(_vm.responsibilityItem.date_sign)+" ")]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v("Date Signed ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z8LU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_undertime_form_vue__ = __webpack_require__("b/fK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e87e864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_undertime_form_vue__ = __webpack_require__("OaF5");
function injectStyle (ssrContext) {
  __webpack_require__("cfLU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_undertime_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e87e864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_undertime_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z8MW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_form_vue__ = __webpack_require__("E0bl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfed625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_form_vue__ = __webpack_require__("5iK4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfed625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZEwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Employee Accounts")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_c('input',{attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Question")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',[_c('tr')])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZJA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_reports__ = __webpack_require__("8PdU");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Reports: __WEBPACK_IMPORTED_MODULE_0__todo_reports__["a" /* default */]
    }
});

/***/ }),

/***/ "ZKJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_wfh_responsibility__ = __webpack_require__("ys/A");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        wfhResponsibility: __WEBPACK_IMPORTED_MODULE_0__todo_wfh_responsibility__["a" /* default */]
    }
});

/***/ }),

/***/ "ZPbt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a605500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("crUN");
function injectStyle (ssrContext) {
  __webpack_require__("RqH2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a605500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a605500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZXZ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zbh3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_admin_vue__ = __webpack_require__("xflq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1880870c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_admin_vue__ = __webpack_require__("5PUt");
function injectStyle (ssrContext) {
  __webpack_require__("tjL9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1880870c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZmR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_all__ = __webpack_require__("hV1p");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosAll: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_all__["a" /* default */]
    }
});

/***/ }),

/***/ "Zw8X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_request_leave__ = __webpack_require__("4mU7");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        requestLeave: __WEBPACK_IMPORTED_MODULE_0__todo_request_leave__["a" /* default */]
    }
});

/***/ }),

/***/ "a1av":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            items: {},
            search: '',
            loading: true,
            //Indicator
            display_indicator: ''
        };
    },

    mounted: function mounted() {
        this.get_responsibility();
    },
    methods: {
        get_responsibility: function get_responsibility() {
            var _this = this;

            axios.get('api/wfh/responsibility/hr/get').then(function (response) {
                _this.items = response.data;
                _this.display_indicator = 2;
                _this.loading = false;
            }).catch(function (error) {
                console.log(error.response);
                _this.display_indicator = 1;
            });
        },
        getDate: function getDate(date) {
            return moment(date).format('MMM DD YYYY');
        }
    },
    computed: {
        computedResponsibility: function computedResponsibility() {
            var _this2 = this;

            // SEARCH BY EMPLOYEE FULLNAME
            var filtered = this.items;
            if (filtered.length > 0) {
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this2.search) > -1;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }

});

/***/ }),

/***/ "a8vJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_responsibility_form_vue__ = __webpack_require__("n+rp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42062b38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_responsibility_form_vue__ = __webpack_require__("7/bk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_responsibility_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42062b38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_responsibility_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a9QU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aHtN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aLlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Coaching Records")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Employee Coached")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"150"}},[_vm._v("Date Coached")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Employee Name")]),_vm._v(" "),_c('th',{attrs:{"width":"380"}},[_vm._v("Performance")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Coached By")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item){return _c('tr',[_c('td',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(item.date_coaching))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.first_name))+", "+_vm._s(_vm._f("capitalize")(item.last_name)))]),_vm._v(" "),_c('td',[(item.performance.length < 50)?[_vm._v(_vm._s(_vm._f("capitalize")(item.performance)))]:_vm._e(),_vm._v(" "),(item.performance.length >= 50)?[_vm._v(_vm._s(_vm._f("capitalize")(item.performance.substring(0,50)+"...")))]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.superior_name))]),_vm._v(" "),_c('td',[(item.employee_status == 'acknowledged')?_c('span',[_c('router-link',{staticClass:"leave-link",attrs:{"to":{name: 'coaching-records-details', params: { id: item.coach_id }}}},[_c('u',[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View Details")])])],1):_vm._e(),_vm._v(" "),(item.employee_status == 'unacknowledged')?_c('span',[_c('router-link',{staticClass:"leave-link",attrs:{"to":{name: 'coaching-records-details', params: { id: item.coach_id }}}},[_c('u',[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View Details")])])],1):_vm._e()])])}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_new_employee_vue__ = __webpack_require__("WErw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d70d97a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_new_employee_vue__ = __webpack_require__("CPzd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_new_employee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d70d97a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_new_employee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aRO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_holidays_vue__ = __webpack_require__("G9pD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5075a5c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_holidays_vue__ = __webpack_require__("NB7N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_holidays_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5075a5c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_holidays_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aW1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_undertime_request_vue__ = __webpack_require__("0Usk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02da75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_undertime_request_vue__ = __webpack_require__("6CPr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_undertime_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02da75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_undertime_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aYbs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_notification_config_vue__ = __webpack_require__("66Af");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7c3d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_notification_config_vue__ = __webpack_require__("w0N8");
function injectStyle (ssrContext) {
  __webpack_require__("BJka")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_notification_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7c3d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_notification_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aaEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('b-modal',{attrs:{"id":"modal-1","centered":"","content-class":"modaal","size":"xl","scrollable":"","title":"Detailed Attendance List","hide-footer":""}},[(_vm.employeeModal !== null)?_c('p',{staticClass:"my-4"},[_vm._v("\n      Name: "+_vm._s(_vm.employeeModal.full_name)),_c('br'),_vm._v("\n      Department: "+_vm._s(_vm._f("capitalize")(_vm.employeeModal.department_name))),_c('br'),_vm._v("\n      Position: "+_vm._s(_vm._f("capitalize")(_vm.employeeModal.position_name))+"\n    ")]):_vm._e(),_vm._v(" "),_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Daily","active":""}},[_c('table',{staticClass:"table table-striped table-hover table-border table-bordered overflow-auto",attrs:{"id":"my-table"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Time In")]),_vm._v(" "),_c('th',[_vm._v("First Break Start")]),_vm._v(" "),_c('th',[_vm._v("First Break End")]),_vm._v(" "),_c('th',[_vm._v("Lunch Start")]),_vm._v(" "),_c('th',[_vm._v("Lunch End")]),_vm._v(" "),_c('th',[_vm._v("Second Break Start")]),_vm._v(" "),_c('th',[_vm._v("Second Break End")]),_vm._v(" "),_c('th',[_vm._v("Time Out")]),_vm._v(" "),_c('th',[_vm._v("Overbreak Time")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Edit Reason")]),_vm._v(" "),_c('th',[_vm._v("Edit")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.noOfDays),function(n){return _c('tr',{key:n,attrs:{"id":("entry" + n)}},[_c('td',[_vm._v("\n                  "+_vm._s(((_vm.date.getMonth()+1) + "/" + n + "/" + _vm.year))+"\n                ")]),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("timeInLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("timeIn" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("firstBreakOutLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("firstBreakOut" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; })
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("firstBreakInLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("firstBreakIn" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).first_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("lunchBreakOutLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("lunchBreakOut" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; })
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("lunchBreakInLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("lunchBreakIn" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).lunch_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("secondBreakOutLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("secondBreakOut" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("secondBreakInLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("secondBreakIn" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).second_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("timeOutLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"time","id":("timeOut" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',{staticClass:"text-danger font-weight-bold"},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).idle_time !== 0 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'; }) 
                  ?  parseInt(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).idle_time / 60, 10) + " min " + parseInt(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).idle_time % 60, 10) + " sec" : ''))]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday'; }))?_c('td',{staticClass:"bg-success"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Present\n                  ")])]):(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in === '00:00:00' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'holiday'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday'; }))?_c('td',{staticClass:"bg-tertiary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Absent\n                  ")])]):(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'holiday'; }))?_c('td',{staticClass:"bg-primary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-calendar-check-o",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Holiday\n                  ")])]):(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status === 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).remarks === 'With Pay'; }))?_c('td',{staticClass:"bg-info"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Leave With Pay\n                  ")])]):(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status === 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).remarks === 'Without Pay'; }))?_c('td',{staticClass:"bg-warning"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Leave Without Pay\n                  ")])]):((_vm.employeeModal !== null && _vm.employeeModal.sub_department_id !== 4
                  && (_vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n).getDay()] == 'SA' 
                  || _vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n).getDay()] == 'SU'))
                  || (_vm.employeeModal !== null && _vm.employeeModal.sub_department_id === 4 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday'; }))
                  || (_vm.employeeModal !== null && _vm.employeeModal.sub_department_id === 4 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday'; }))
                  || (_vm.employeeModal !== null && _vm.employeeModal.sub_department_id === 7 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday'; })))?_c('td',{staticClass:"bg-secondary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-calendar-times-o",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Day-Off\n                  ")])]):(_vm.date.getMonth() === new Date().addHours(12).getMonth() && n > _vm.date.getDate() )?_c('td',{staticClass:"bg-white"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}})]):_c('td',{staticClass:"bg-danger"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Absent\n                  ")])]),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + n),attrs:{"id":("updateReasonLog" + n)}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).update_reason !== _vm.NULL && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'; }) ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).update_reason : ''))]),_vm._v(" "),_c('input',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"type":"text","id":("updateReason" + n)},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).update_reason !== _vm.NULL && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave'; }) ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).update_reason : ''}})]):_vm._e(),_vm._v(" "),_c('td',[_c('a',{class:("logEntry" + n),attrs:{"href":"#","id":("edit" + n)},on:{"click":function($event){_vm.showEditLogs(n)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),(_vm.employeeModal !== null && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2) && _vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00'; }))?_c('a',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"href":"#","id":("save" + n)},on:{"click":function($event){_vm.saveEditLogs(_vm.employeeModal.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).id, _vm.employeeModal.sub_department_id, n)}}},[_c('i',{staticClass:"fa fa-save"})]):_c('a',{class:("logEntryInput" + n),staticStyle:{"display":"none"},attrs:{"href":"#","id":("save" + n)},on:{"click":function($event){_vm.saveNewLogs(_vm.employeeModal.emp_id, (_vm.year + "-" + (_vm.date.getMonth()+1) + "-" + n), _vm.employeeModal.sub_department_id, n)}}},[_c('i',{staticClass:"fa fa-save"})])])])}),0)])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Weekly"}},[_c('table',{staticClass:"table table-striped table-hover table-border table-bordered overflow-auto",attrs:{"id":"my-table"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Time In")]),_vm._v(" "),_c('th',[_vm._v("First Break Start")]),_vm._v(" "),_c('th',[_vm._v("First Break End")]),_vm._v(" "),_c('th',[_vm._v("Lunch Start")]),_vm._v(" "),_c('th',[_vm._v("Lunch End")]),_vm._v(" "),_c('th',[_vm._v("Second Break Start")]),_vm._v(" "),_c('th',[_vm._v("Second Break End")]),_vm._v(" "),_c('th',[_vm._v("Time Out")]),_vm._v(" "),_c('th',[_vm._v("Overbreak Time")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Edit Reason")]),_vm._v(" "),_c('th',[_vm._v("Edit")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.weeks),function(n){return _c('tr',{key:n},[_c('td',[_vm._v("\n                  "+_vm._s(((_vm.date.getMonth()+1) + "/" + (n+_vm.addedDays) + "/" + _vm.year))+"\n                ")]),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("timeInLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("timeIn" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("firstBreakOutLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("firstBreakOut" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("firstBreakInLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("firstBreakIn" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).first_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("lunchBreakOutLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("lunchBreakOut" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("lunchBreakInLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("lunchBreakIn" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).lunch_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("secondBreakOutLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("secondBreakOut" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("secondBreakInLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_in !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_in) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("secondBreakIn" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_in !== '00:00:00'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).second_break_in : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("timeOutLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.formatAMPM(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_out) : '--:--'))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"time","id":("timeOut" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_out !== '00:00:00' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                    && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                    ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_out : '--:--'}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',{staticClass:"text-danger font-weight-bold"},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).idle_time !== 0 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) 
                  ?  parseInt(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).idle_time / 60, 10) + " min " + parseInt(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).idle_time % 60, 10) + " sec" : ''))]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in !== '00:00:00' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }))?_c('td',{staticClass:"bg-success"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Present\n                  ")])]):(_vm.employeeModal !== null 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in === '00:00:00' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }))?_c('td',{staticClass:"bg-tertiary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Absent\n                  ")])]):(_vm.employeeModal !== null 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type === 'holiday'; }))?_c('td',{staticClass:"bg-primary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-calendar-check-o",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Holiday\n                  ")])]):(_vm.employeeModal !== null 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status === 'leave'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).remarks === 'With Pay'; }))?_c('td',{staticClass:"bg-info"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Leave With Pay\n                  ")])]):(_vm.employeeModal !== null 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'restday' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status === 'leave' 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).remarks === 'Without Pay'; }))?_c('td',{staticClass:"bg-warning"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Leave Without Pay\n                  ")])]):((_vm.employeeModal !== null 
                  && _vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n + _vm.addedDays).getDay()] == 'SA' 
                  || _vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n + _vm.addedDays).getDay()] == 'SU')
                  || (_vm.employeeModal !== null && _vm.employeeModal.sub_department_id === 4 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays 
                  && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type === 'restday'; })))?_c('td',{staticClass:"bg-secondary"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-calendar-times-o",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Day-Off\n                  ")])]):(_vm.date.getMonth() === new Date().addHours(12).getMonth() && n + _vm.addedDays > _vm.date.getDate() )?_c('td',{staticClass:"bg-white"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}})]):_c('td',{staticClass:"bg-danger"},[_c('span',{staticStyle:{"width":"20px","height":"24px","color":"#fff"}},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}}),_vm._v("\n                    Absent\n                  ")])]),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[_c('span',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"id":("updateReasonLog" + (n+_vm.addedDays))}},[_vm._v(_vm._s(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).update_reason !== _vm.NULL && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).update_reason : ''))]),_vm._v(" "),_c('input',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"type":"text","id":("updateReason" + (n+_vm.addedDays))},domProps:{"value":_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).update_reason !== _vm.NULL && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).status !== 'leave' && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).event_type !== 'holiday'; }) ?  _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).update_reason : ''}})]):_vm._e(),_vm._v(" "),(_vm.employeeModal !== null)?_c('td',[(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in !== '00:00:00'; }))?_c('a',{class:("logEntry" + (n+_vm.addedDays)),attrs:{"href":"#","id":("edit" + (n+_vm.addedDays))},on:{"click":function($event){_vm.showEditLogs(n+_vm.addedDays)}}},[_c('i',{staticClass:"fa fa-pencil"})]):_vm._e(),_vm._v(" "),(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays && _vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).time_in !== '00:00:00'; }))?_c('a',{class:("logEntryInput" + (n+_vm.addedDays)),staticStyle:{"display":"none"},attrs:{"href":"#","id":("save" + (n+_vm.addedDays))},on:{"click":function($event){_vm.saveEditLogs(_vm.employeeModal.attendance_logs.find(function (attendance) { return new Date(attendance['att_date']).getDate() === n + _vm.addedDays; }).id, _vm.employeeModal.sub_department_id, n+_vm.addedDays)}}},[_c('i',{staticClass:"fa fa-save"})]):_vm._e()]):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('button',{staticClass:"bg-white px-2",on:{"click":function($event){_vm.paginatePrevWeek()}}},[_vm._v(_vm._s("<"))]),_vm._v(" "),_c('span',[_vm._v("Week "+_vm._s(_vm.weekNumber))]),_vm._v(" "),_c('button',{staticClass:"bg-white px-2",on:{"click":function($event){_vm.paginateNextWeek()}}},[_vm._v(_vm._s(">"))])])])],1)],1),_vm._v(" "),_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Time and Attendance")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-3"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Time & Attendance")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"large-12 medium-12 small-12 cell"},[_c('div',{staticClass:"d-flex"},[_c('p',{staticClass:"mr-2 w-100 text-right"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Cut Off Start:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cut_off_start),expression:"cut_off_start"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cut_off_start=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":11}},[_vm._v("11")]),_vm._v(" "),_c('option',{domProps:{"value":26}},[_vm._v("26")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"large-12 medium-12 small-12 cell"},[_c('div',{staticClass:"d-flex"},[_c('p',{staticClass:"mr-2 w-100 text-right"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Cut Off End:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cut_off_end),expression:"cut_off_end"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cut_off_end=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[[_c('div',{staticClass:"container"},[_c('div',{staticClass:"large-12 medium-12 small-12 cell"},[_c('div',{staticClass:"float-right"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.exportExcel()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Export Excel")]),_vm._v(" "),_c('button',{staticClass:"p3 btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.downloadPdf()}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v(" Download PDF")])])])])]],2)]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h2',[_vm._v(_vm._s(("Month of " + _vm.month + " " + _vm.year)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"mb-2 mt-4"},[_vm._v("Filter by Department:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.department),expression:"department"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.department=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onChange(_vm.getAttendanceOfUsers())}]}},_vm._l((_vm.sub_departments),function(sub_department){return _c('option',{key:sub_department.id,domProps:{"value":sub_department.id}},[_vm._v(_vm._s(sub_department.sub_department_name))])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('button',{staticClass:"bg-white px-2",on:{"click":function (){
                _vm.getDaysInPrevMonth()
                _vm.getAttendanceOfUsers()
              }}},[_vm._v(_vm._s("<"))]),_vm._v(" "),_c('button',{staticClass:"bg-white px-2",on:{"click":function (){
                _vm.getDaysInNextMonth()
                _vm.getAttendanceOfUsers()
              }}},[_vm._v(_vm._s(">"))])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover table-border table-bordered",attrs:{"id":"my-table"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Employee")]),_vm._v(" "),_vm._l((_vm.noOfDays),function(n){return _c('th',{key:n},[_vm._v(_vm._s(n))])})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_vm._l((_vm.noOfDays),function(n){return _c('td',{key:n,attrs:{"width":"35"}},[_vm._v(_vm._s(_vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n).getDay()]))])})],2),_vm._v(" "),_vm._l((_vm.employees_by_members),function(employee,index){return _c('tr',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ index).slice(-2)},[_c('td',{key:employee.name,staticClass:"emp_name"},[_c('span',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-1",modifiers:{"modal-1":true}}],on:{"mouseover":function($event){_vm.toggleTooltip(index)},"mouseleave":function($event){_vm.toggleTooltip(index)},"click":function($event){_vm.assignEmployee(employee)}}},[_vm._v(_vm._s(employee.full_name))]),_vm._v(" "),_c('div',{staticClass:"px-4 bg-white border border-dark position-absolute",staticStyle:{"display":"none"},attrs:{"id":("tooltip" + index)}},[_vm._v("\n                            Name: "+_vm._s(employee.full_name)),_c('br'),_vm._v("\n                            Department: "+_vm._s(_vm._f("capitalize")(employee.department_name))),_c('br'),_vm._v("\n                            Position: "+_vm._s(_vm._f("capitalize")(employee.position_name))+"\n                          ")])]),_vm._v(" "),_vm._l((_vm.noOfDays),function(n){return [(employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'holiday' )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-primary"},[_c('i',{staticClass:"fa fa-calendar-check-o",staticStyle:{"color":"#fff"}})]):(employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status === 'leave' 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).remarks === 'With Pay' )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-info"},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}})]):((employee.sub_department_id === 1 && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday') 
                              || (employee.sub_department_id === 4 && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday')
                              || (employee.sub_department_id === 6 && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type === 'restday'))?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-secondary"},[_vm._v(" OFF ")]):(employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status === 'leave' 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).remarks === 'Without Pay' )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-warning"},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}})]):(employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in !== '00:00:00' 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).event_type !== 'restday'
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave' )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-success"},[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff"}})]):(employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }) 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).time_in === '00:00:00' 
                              && employee.attendance_logs.find(function (attendance) { return attendance['att_date'] === _vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1) ).slice(-2) + '-' + ('0'+ n).slice(-2); }).status !== 'leave' )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-tertiary"},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}})]):((_vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n).addHours(12).getDay()] == 'SA' 
                              || _vm.days[new Date(_vm.year, _vm.months.findIndex(function (elem) { return elem === _vm.month; }), n).addHours(12).getDay()] == 'SU') 
                              && employee.sub_department_id !== 4)?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-secondary"},[_vm._v(" OFF ")]):(_vm.date.getMonth() === new Date().addHours(12).getMonth() && n > _vm.date.getDate() )?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-white"},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}})]):((_vm.date <= new Date().addHours(12) && employee.attendance_logs.length !== 0) 
                              || employee.attendance_logs.length === 0)?_c('td',{key:_vm.year + '-' + ('0'+ (_vm.date.getMonth() + 1)).slice(-2) + '-' + ('0'+ n).slice(-2),staticClass:"bg-danger"},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}})]):_vm._e()]})],2)})],2)]),_vm._v(" "),_c('b-container',{staticClass:"mt-4",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"col-4"},[_c('button',{staticClass:"bg-white px-2",on:{"click":function($event){_vm.paginatePrev()}}},[_vm._v(_vm._s("<"))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentPage))]),_vm._v(" "),_c('button',{staticClass:"bg-white px-2",on:{"click":function($event){_vm.paginateNext()}}},[_vm._v(_vm._s(">"))])]),_vm._v(" "),_c('b-col',{staticClass:"row row-flex"},[_c('span',{staticClass:"px-2"},[_vm._v("Present: ")]),_vm._v(" "),_c('div',{staticClass:"bg-success",staticStyle:{"width":"20px","height":"24px"}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"px-2"}),_vm._v(" "),_c('div',{staticStyle:{"width":"20px","height":"24px"}}),_vm._v(" "),_c('span',{staticClass:"px-2"},[_vm._v("Absent: ")]),_vm._v(" "),_c('div',{staticClass:"bg-danger",staticStyle:{"width":"20px","height":"24px"}},[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"px-2"}),_vm._v(" "),_c('div',{staticStyle:{"width":"20px","height":"24px"}}),_vm._v(" "),_c('span',{staticClass:"px-2"},[_vm._v("Holiday: ")]),_vm._v(" "),_c('div',{staticClass:"bg-primary text-center",staticStyle:{"width":"25px","height":"25px"}},[_c('i',{staticClass:"fa fa-calendar-check-o",staticStyle:{"color":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"px-2"}),_vm._v(" "),_c('div',{staticStyle:{"width":"20px","height":"24px"}}),_vm._v(" "),_c('span',{staticClass:"px-2"},[_vm._v("Leave (With Pay): ")]),_vm._v(" "),_c('div',{staticClass:"bg-info",staticStyle:{"width":"20px","height":"24px"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"px-2"}),_vm._v(" "),_c('div',{staticStyle:{"width":"20px","height":"24px"}}),_vm._v(" "),_c('span',{staticClass:"px-2"},[_vm._v("Leave (Without Pay): ")]),_vm._v(" "),_c('div',{staticClass:"bg-warning",staticStyle:{"width":"20px","height":"24px"}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"color":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"px-2"}),_vm._v(" "),_c('div',{staticStyle:{"width":"20px","height":"24px"}}),_vm._v(" "),_c('span',{staticClass:"px-2"},[_vm._v("Day-off: ")]),_vm._v(" "),_c('div',{staticClass:"bg-secondary",staticStyle:{"width":"35px","height":"30px","padding":"2px"}},[_vm._v("\n                    OFF\n                  ")])])],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "an2P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "arTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Update Responsibility Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/responsibilityform"}},[_vm._v("Responsibilities Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Update Responsibilities Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('h2',[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.fullname))+" ")]),_vm._v(" "),_c('form',{on:{"submit":_vm.update_responsibility_info}},[_vm._l((_vm.item.responsibility),function(resp){return _c('span',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v("Item Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(resp.name),expression:"resp.name"}],staticClass:"form-control",domProps:{"value":(resp.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(resp, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b',[_vm._v("Description / Serial Number:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(resp.description),expression:"resp.description"}],staticClass:"form-control",domProps:{"value":(resp.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(resp, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b',[_vm._v("Received:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(resp.received),expression:"resp.received"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(resp.received)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(resp, "received", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b',[_vm._v("Quantity:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(resp.quantity),expression:"resp.quantity"}],staticClass:"form-control",domProps:{"value":(resp.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(resp, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('hr')])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('absence-leave-management')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b/fK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_undertime_form__ = __webpack_require__("D1iC");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        undertimeForm: __WEBPACK_IMPORTED_MODULE_0__todo_undertime_form__["a" /* default */]
    }
});

/***/ }),

/***/ "b2Lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__ = __webpack_require__("MQoa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f61cee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__ = __webpack_require__("v/Rc");
function injectStyle (ssrContext) {
  __webpack_require__("vk5y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f61cee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bASF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_work_shifts_vue__ = __webpack_require__("uQLL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d41fda02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_work_shifts_vue__ = __webpack_require__("Av0r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_work_shifts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d41fda02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_work_shifts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bDRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            items: [],
            selectedUser: '',
            positions: [],
            //filter
            filter_by_position: '',
            filter_by_status: '',
            search: '',
            order_by: '',
            sortAsc: true,
            //pagination
            page_limit: 100,
            start_page: 1,
            loading: true,

            paginate: ['computedRequirements'],
            //Indicator
            display_indicator: '',
            // Errors handler
            error_handler: []
        };
    },

    mounted: function mounted() {
        this.get_requirements();
        this.get_positions();
    },
    methods: {
        get_requirements: function get_requirements() {
            var _this = this;

            axios.get('api/requirements').then(function (response) {
                _this.items = response.data;
                _this.display_indicator = 2;
                _this.loading = false;
            }).catch(function (error) {
                console.log(error.response);
                _this.display_indicator = 1;
            });
        },
        get_selected_id: function get_selected_id(item) {
            this.selectedUser = item;
        },
        get_positions: function get_positions() {
            var _this2 = this;

            axios.get('api/positions').then(function (response) {
                _this2.positions = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        update_requirements: function update_requirements(e) {
            var _this3 = this;

            e.preventDefault();
            var req = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedUser);
            axios.post('api/requirements/update/' + this.selectedUser.id, {
                'sss_no': this.selectedUser.sss_no,
                'hdmf_no': this.selectedUser.hdmf_no,
                'mid_no': this.selectedUser.mid_no,
                'tin_no': this.selectedUser.tin_no,
                'phic_no': this.selectedUser.phic_no,
                'TOR': this.selectedUser.TOR,
                'ITW': this.selectedUser.ITW,
                'COE': this.selectedUser.COE,
                'NBI': this.selectedUser.NBI,
                'NSO_BC': this.selectedUser.NSO_BC,
                'barangay_clearance': this.selectedUser.barangay_clearance,
                'police_clearance': this.selectedUser.police_clearance,
                'id_picture': this.selectedUser.id_picture,
                'MC': this.selectedUser.MC,
                "sss_static": this.selectedUser.sss_static,
                "photocopy_sss": this.selectedUser.photocopy_sss,
                "photocopy_phic": this.selectedUser.photocopy_phic,
                "photocopy_hdmf": this.selectedUser.photocopy_hdmf,
                "photocopy_tin": this.selectedUser.photocopy_tin,
                "nso_dependents": this.selectedUser.nso_dependents,
                "note": this.selectedUser.note
            }).then(function (resp) {
                _this3.$router.push({ name: 'requirements' });
                _this3.$swal({
                    type: 'success',
                    title: 'Save',
                    text: 'You successfully save',
                    showConfirmButton: false,
                    timer: 300
                });
                _this3.$refs['update-modal-hide'].hide();
                _this3.$refs['update-notes'].hide();
                _this3.get_requirements();
            }).catch(function (error) {
                if (error.response.status == 422) {
                    _this3.error_handler = error.response.data.errors;
                }
            });
        },

        // PAGINATION NEXT & PREV
        next_page: function next_page() {
            this.start_page++;
        },
        prev_page: function prev_page() {
            this.start_page--;
        }
    },
    computed: {
        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_record: function total_record() {
            return this.items.length;
        },
        numOfPages: function numOfPages() {
            return Math.ceil(this.items.length / this.page_limit);
        },
        computedRequirements: function computedRequirements() {
            var _this4 = this;

            var filtered = this.items;
            // if greater than zero display record 
            if (filtered.length > 0) {
                // SEARCH BY EMPLOYEE FULLNAME  
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
                    });
                    return filtered;
                }
                // FILTER BY POSITION
                if (this.filter_by_position) {
                    filtered = filtered.filter(function (item) {
                        return item.position_name.toLowerCase() === _this4.filter_by_position.toLowerCase();
                    });
                    return filtered;
                }
                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }
                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
                    });
                    return filtered;
                }
                // FILTER BY STATUS COMPLETED OR LACKING
                if (this.filter_by_status === 'submitted') {
                    filtered = filtered.slice(0).filter(function (item) {
                        return item.TOR === _this4.filter_by_status && item.ITW === _this4.filter_by_status && item.COE === _this4.filter_by_status && item.NBI === _this4.filter_by_status && item.NSO_BC === _this4.filter_by_status && item.barangay_clearance === _this4.filter_by_status && item.police_clearance === _this4.filter_by_status && item.id_picture === _this4.filter_by_status && item.MC === _this4.filter_by_status && item.sss_static === _this4.filter_by_status && item.photocopy_sss === _this4.filter_by_status && item.photocopy_phic === _this4.filter_by_status && item.photocopy_hdmf === _this4.filter_by_status && item.photocopy_tin === _this4.filter_by_status && item.sss_no > 1 && item.hdmf_no > 1 && item.mid_no > 1 && item.tin_no > 1 && item.phic_no;
                    });
                    return filtered;
                }
                if (this.filter_by_status === 'notsubmitted') {
                    filtered = filtered.slice(0).filter(function (item) {
                        return item.TOR < 1 || item.ITW < 1 || item.COE < 1 || item.NBI < 1 || item.NSO_BC < 1 || item.barangay_clearance < 1 || item.police_clearance < 1 || item.id_picture < 1 || item.MC < 1 || item.sss_static < 1 || item.photocopy_sss < 1 || item.photocopy_phic < 1 || item.photocopy_hdmf < 1 || item.photocopy_tin < 1 || (item.sss_no < 1 || item.hdmf_no < 1) && (item.phic_no < 1 || item.tin_no < 1) || item.mid_no < 1;
                    });
                    return filtered;
                }
            }

            return filtered;
        }
    }
});

/***/ }),

/***/ "bE53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bKcs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_admin_vue__ = __webpack_require__("jTeO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010c4b4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_admin_vue__ = __webpack_require__("CNff");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010c4b4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bSUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Edit Dependent")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependent List")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Edit Dependent")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update_form($event)}}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h2',{staticClass:"text-right"},[_c('i',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.fullname)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',{staticClass:"text-right"},[_c('u',[_vm._v("Dependent")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_vm._l((_vm.item.dependents),function(dep){return _c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Name :")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dep.name),expression:"dep.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(dep.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dep, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Relationship :")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dep.relationship),expression:"dep.relationship"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(dep.relationship)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dep, "relationship", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Age :")]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dep.age),expression:"dep.age"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(dep.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dep, "age", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("phic :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dep.phic_no),expression:"dep.phic_no"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(dep.phic_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dep, "phic_no", $event.target.value)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',{staticClass:"text-right"},[_c('u',[_vm._v("Senior Dependent")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_vm._l((_vm.item.seniors),function(sen){return _c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Senior citizen :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(sen.senior_citizen),expression:"sen.senior_citizen"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(sen.senior_citizen)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(sen, "senior_citizen", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-2 text-right p-text"},[_vm._v("Middle initial :")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(sen.middle_initial),expression:"sen.middle_initial"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(sen.middle_initial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(sen, "middle_initial", $event.target.value)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])])])])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bbR4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Update Leave Application")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/absenceleave"}},[_vm._v("Leave & Absences Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Update Leave Application")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"margin-top":"-45px"}},[_c('span',{staticClass:"float-right"},[_c('h2',[_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v("\n                    "+_vm._s(_vm.credits_indicator.leave_credit_balance)+"\n                 ")]),_vm._v("\n                 Leave Credits \n            ")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Employee Leave Form")]),_vm._v(" "),_c('div',{staticClass:"border-box-leave"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.full_name),expression:"item.full_name"}],staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":(_vm.item.full_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "full_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.date_filled),expression:"item.date_filled"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "date_filled", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Number of Days Leave :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.countDate),expression:"countDate"}],staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":(_vm.countDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.countDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type Of Leave : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.leave_type),expression:"item.leave_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "leave_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Vacation"}},[_vm._v("Vacation Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Medical/Sick"}},[_vm._v("Medical/Sick Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Emergency"}},[_vm._v("Emergency Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Maternity"}},[_vm._v("Maternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Paternity"}},[_vm._v("Paternity Leave")]),_vm._v(" "),_c('option',{attrs:{"value":"Offset"}},[_vm._v("Offset")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Remarks : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.remarks),expression:"item.remarks"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "remarks", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"With Pay"}},[_vm._v("With Pay")]),_vm._v(" "),_c('option',{attrs:{"value":"Without Pay"}},[_vm._v("Without Pay")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.start_date),expression:"item.start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date  :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.end_date),expression:"item.end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reason for Leave / Absent : ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reason),expression:"item.reason"}],staticClass:"form-control",attrs:{"rows":"8"},domProps:{"value":(_vm.item.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "reason", $event.target.value)}}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Approval Status")]),_vm._v(" "),_c('div',{staticClass:"border-box-leave"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tl_status),expression:"item.tl_status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "tl_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_status),expression:"item.asm_status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "asm_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.status),expression:"item.status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approve")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tl_date_approved),expression:"item.tl_date_approved"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.tl_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "tl_date_approved", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.asm_date_approved),expression:"item.asm_date_approved"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "asm_date_approved", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.hr_date_recived),expression:"item.hr_date_recived"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.item.hr_date_recived)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "hr_date_recived", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Update Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bcBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch("GET_ANNIVERSARRY_ALL");
    this.$store.dispatch("GET_EMPLOYEE_LEAVE");
    this.$store.dispatch("GET_EMPLOYEE_BIRTHDAY");
    this.$store.dispatch("GET_INCOMING_LEAVE");
    this.$store.dispatch("GET_DASHBOARD_COUNTER");

    setTimeout(function () {
      _this.loading = false;
    }, 3000);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['aniversaryAll', 'employeeLeave', 'birthdayAll', 'incommingLeave', 'statusItem']), {
    get_month: function get_month() {
      var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

      var d = new Date();
      var n = month[d.getMonth()];
      return n;
    }
  })
});

/***/ }),

/***/ "bpfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("NTE Details")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("NTE Details")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container",attrs:{"id":"printme"}},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('img',{attrs:{"width":"30","height":"30","id":"printIcon","onclick":"window.print()","src":"/static/img/print.png","alt":"..."}})]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header-decision"},[_c('i',{staticClass:"fa fa-balance-scale"}),_vm._v("   NOTICE FOR DECISION")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('b',[_vm._v("HR/Admin Department Decision:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.hr_notice_for_decision),expression:"item.hr_notice_for_decision"}],staticClass:"form-control notice-decision",attrs:{"rows":"10","disabled":""},domProps:{"value":(_vm.item.hr_notice_for_decision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "hr_notice_for_decision", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header-nte"},[_vm._v("NOTICE TO EXPLAIN")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("Employee Name :")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.full_name))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Supervisor Name : ")]),_vm._v(_vm._s(_vm.item.superior_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("Date Notice : ")]),_vm._v(_vm._s(_vm.getDate(_vm.item.date_incident))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Position :")]),_vm._v(" "+_vm._s(_vm.item.position_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b',[_vm._v("ID No. : ")]),_vm._v(_vm._s(_vm.item.emp_no)+"\n               "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Type of Infraction :")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.item.type_of_infraction)),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Details of Occurence :")]),_vm._v(" "),_vm._l((_vm.item.occurence),function(res,i){return _c('span',[_c('br'),_c('b',[_vm._v(_vm._s(i+1))]),_vm._v(".  "+_vm._s(res.date)+"    "+_vm._s(res.details)+"\n         ")])}),_vm._v(" "),_c('br'),_c('br')],2),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_vm._v("\n         "+_vm._s(_vm.item.details_of_infraction)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('b',[_vm._v("ATTACHMENT FILE")]),_vm._v(" "),_vm._l((_vm.item.data_files),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.file_type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.file_type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.file_type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.file_type=='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.file_type=='image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):_vm._e(),_vm._v("   \n                    "),_c('a',{attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + file.file_name,"target":"_blank"}},[_vm._v(_vm._s(file.file_name))])],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Corrective Action To be Taken :")]),_c('br'),_vm._v(" "),(_vm.item.action_to_be_taken != 0 )?_c('div',[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v("  "+_vm._s(_vm.item.action_to_be_taken))]):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Explanation :")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.plan_for_improvement))])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Employee's Commitment :")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.employees_commitment))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("  I hereby acknowledge that I have been coached according to standard set by the company and commit to the objectives and targets stated above. ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_c('br'),_vm._v(" "),(_vm.item.signature == '')?_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("No signature found.")])])]):_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.item.signature,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"report-printed-control"},[_c('b',[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.item.full_name)))])]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v(" Employee Signature")])],1)])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0005")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb0881f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("Es3f");
function injectStyle (ssrContext) {
  __webpack_require__("sPCV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb0881f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c45f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dashboard_vue__ = __webpack_require__("bcBE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89b38c8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dashboard_vue__ = __webpack_require__("Y2LM");
function injectStyle (ssrContext) {
  __webpack_require__("inNS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89b38c8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c4nz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_password_vue__ = __webpack_require__("3Gch");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c9827e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_password_vue__ = __webpack_require__("U8dF");
function injectStyle (ssrContext) {
  __webpack_require__("/e6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c9827e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c78x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemocollections', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/collections', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "c7fB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_group_access_vue__ = __webpack_require__("8NTA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765882dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_group_access_vue__ = __webpack_require__("Ak1R");
function injectStyle (ssrContext) {
  __webpack_require__("FfRg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_group_access_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765882dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_group_access_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c8rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_time_attendance__ = __webpack_require__("XoiQ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        timeAttendance: __WEBPACK_IMPORTED_MODULE_0__todo_time_attendance__["a" /* default */]
    }
});

/***/ }),

/***/ "cFZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Active Employee")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Active Employees")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Position:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_position),expression:"filter_by_position"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"textContent":_vm._s(pos.pos_name)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Designation")]),_vm._v(" "),_c('th',[_vm._v("Address")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Joined date")]),_vm._v(" "),_c('th',[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("capitalize")(item.full_name))+" "+_vm._s(item.suffix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.position_name))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v(" \n                    "),(item.current_address.length < 30)?[_vm._v(_vm._s(_vm._f("capitalize")(item.current_address)))]:_vm._e(),_vm._v(" "),(item.current_address.length >= 30)?[_vm._v(_vm._s(_vm._f("capitalize")(item.current_address.substring(0,30)+"...")))]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"width":"115"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"to":{name: 'edit-info', params: { id: item.id }},"title":"click to view details and modify records"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("modify")])],1)]],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cJf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('h3',{staticClass:"card-title"},[_vm._v("Evaluation List")])])])]),_vm._v(" "),[_c('nav',{staticClass:"row breadcrumb-tweak"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Employee Evaluation")])])])],_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])]),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('tr',[_c('th',{attrs:{"width":"10"}}),_vm._v(" "),_c('th',{attrs:{"width":"600"}}),_vm._v(" "),_c('th',{attrs:{"width":"350"}}),_vm._v(" "),_c('th',{attrs:{"width":"350"}}),_vm._v(" "),_c('th',{attrs:{"width":"150"}}),_vm._v(" "),_c('th',{attrs:{"width":"240"}})]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[_c('td',[(item.employee_status == 'pending')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-flag danger status-pending",attrs:{"title":"Waiting for employee to approve"}})]):(item.employee_status == 'approved')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-flag  status-approved",attrs:{"title":"Request has been approved"}})]):_vm._e()]),_vm._v(" "),_c('td',[(item.requester_role_id == '3')?[(item.employee_status == 'pending')?_c('span',[_c('b',[_vm._v(_vm._s(item.department_head))]),_vm._v(" - Evaluated\n                                    "),_c('b',[_vm._v(" "+_vm._s(item.full_name)+" ")]),_vm._v(" for\n                                ")]):(item.employee_status == 'approved')?_c('span',[_vm._v("\n                                     "+_vm._s(item.department_head)+" - Evaluated "+_vm._s(item.full_name)+" for\n                                ")]):_vm._e()]:_vm._e(),_vm._v(" "),(item.requester_role_id == '2')?[(item.asm_status == 'pending')?_c('span',[_c('b',[_vm._v(_vm._s(item.supervisor_head))]),_vm._v(" - Evaluated\n                                    "),_c('b',[_vm._v(" "+_vm._s(item.full_name)+" ")]),_vm._v(" for\n                                ")]):_vm._e(),_vm._v(" "),(item.asm_status == 'approved' || item.asm_status == 'rejected' )?_c('span',[_vm._v("\n                                     "+_vm._s(item.supervisor_head)+" - Evaluated "+_vm._s(item.full_name)+" for\n                                ")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('span',[(item.description != 'Others' )?[_vm._v("("+_vm._s(item.description)+")")]:[_vm._v("("+_vm._s(item.others)+")")]],2)],2),_vm._v(" "),_c('td',[(item.performance_comments.length < 40)?[_vm._v(_vm._s(item.performance_comments))]:_vm._e(),_vm._v(" "),(item.performance_comments.length >= 40)?[_vm._v(_vm._s(item.performance_comments.substring(0,40)+"..."))]:_vm._e()],2),_vm._v(" "),_c('td',[(item.communication_comments.length < 40)?[_vm._v(_vm._s(item.communication_comments))]:_vm._e(),_vm._v(" "),(item.communication_comments.length >= 40)?[_vm._v(_vm._s(item.communication_comments.substring(0,40)+"..."))]:_vm._e()],2),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v(" "+_vm._s(_vm.getDate(item.created_at)))]),_vm._v(" "),_c('td',[(item.asm_status == 'approved' && item.employee_status == 'approved' && item.tl_status == 'approved')?[_c('router-link',{staticClass:"r-link",attrs:{"to":{name: 'performance-details' , params: { id: item.id, employee_id: item.employee_id} }}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" View Details")])]:(item.asm_status == 'rejected' && item.employee_status == 'pending' && item.tl_status == 'approved')?[_c('font',{attrs:{"color":"red"}},[_c('i',{staticClass:"fa fa-thumbs-down"}),_vm._v(" "),_c('b',[_vm._v("REJECTED")])])]:(item.asm_status == 'approved' && item.employee_status == 'pending' && item.tl_status == 'approved')?[_c('i',{staticClass:"fa fa-spinner fa-pulse"}),_vm._v(" "),_c('b',[_vm._v("Waiting ...")])]:_vm._e()],2)])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cSUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('performance-details')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cUXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_cd_pq_vue__ = __webpack_require__("zrsU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167afec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_cd_pq_vue__ = __webpack_require__("gYMG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_cd_pq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167afec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_cd_pq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cUbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_breadcrumb_menu__ = __webpack_require__("AaH/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        breadcrumbMenu: __WEBPACK_IMPORTED_MODULE_1__base_breadcrumb_menu__["a" /* default */]
    },
    data: function data() {
        return {
            items: [],
            loading: true,
            selected_item: '',
            new_password: 'Blueprint@111',
            search: ''
        };
    },


    mounted: function mounted() {
        this.get_users();
    },

    methods: {
        get_users: function get_users() {
            var _this = this;

            axios.get('api/users').then(function (response) {
                _this.items = response.data;_this.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_selected_id: function get_selected_id(item) {
            this.selected_item = item;
        },
        update_user: function update_user() {
            var _this2 = this;

            axios.post('api/users/update/' + this.selected_item.id, {
                'role_id': this.selected_item.role_id,
                'name': this.selected_item.name,
                'email': this.selected_item.email
            }).then(function (resp) {
                _this2.$refs['hide-user-modal'].hide();
                _this2.get_users();
                alert('success');
            }).catch(function (error) {
                console.log(error);
            });
        },
        reset_password: function reset_password(e) {
            var _this3 = this;

            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to reset password.',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.post('api/resetpassword/update/' + _this3.selected_item.id, {
                        'new_password': _this3.new_password
                    }).then(function (resp) {
                        if (resp.data.response == 'success') {
                            _this3.$refs['hide-reset-form-modal'].hide();
                            _this3.get_users();
                            _this3.$swal({
                                type: 'success',
                                title: 'Success',
                                text: resp.data.message,
                                showConfirmButton: false,
                                timer: 2000
                            });
                        } else if (resp.data.response == 'error') {
                            _this3.get_users();
                            _this3.$swal({
                                type: 'error',
                                title: 'Oops',
                                text: resp.data.message,
                                timer: 2000
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        }
    },
    computed: {
        computedLeave: function computedLeave() {
            var _this4 = this;

            // SEARCH BY EMPLOYEE FULLNAME
            var filtered = this.items;
            if (filtered.length > 0) {
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    },
    filters: {
        capitalize: function capitalize(value) {
            if (!value) return '';
            value = value.toString();
            //return value.charAt(0).toUpperCase() + value.slice(1); -> capitalize first 
            return value.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }); // -> capitalize each first words
        }
    }
});

/***/ }),

/***/ "cUg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_va_us_vue__ = __webpack_require__("mwS7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe3f704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_va_us_vue__ = __webpack_require__("iFtn");
function injectStyle (ssrContext) {
  __webpack_require__("5GF2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_memos_va_us_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe3f704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_memos_va_us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cXh+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_cd_pq__ = __webpack_require__("cUXR");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosCdPq: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_cd_pq__["a" /* default */]
    }
});

/***/ }),

/***/ "cfLU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ckdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('payroll')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "crUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d/y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_job_information_vue__ = __webpack_require__("nVyA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084df2e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_job_information_vue__ = __webpack_require__("VXGI");
function injectStyle (ssrContext) {
  __webpack_require__("RFHt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_job_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084df2e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_job_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d3u9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d5jJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Coaching Details")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Coaching Details")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container",attrs:{"id":"printme"}},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('img',{attrs:{"width":"30","height":"30","id":"printIcon","onclick":"window.print()","src":"/static/img/print.png","alt":"..."}})]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('span',{staticClass:"report-header"},[_vm._v("EMPLOYEE COACHING FORM")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 report-border-right"},[_c('b',[_vm._v("Employee Name :")]),_vm._v(" "+_vm._s(_vm.item.full_name)+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Position : ")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.position_name))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Department : ")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.department_name))+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Employment Status : "+_vm._s(_vm._f("capitalize")(_vm.item.status)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b',[_vm._v("Employee Number : ")]),_vm._v(" "+_vm._s(_vm.item.emp_id)+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Immediate Supervisor :")]),_vm._v("  "+_vm._s(_vm.item.superior_name)+"\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Department Manager : ")]),_vm._v(" Nile Dano\n               "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Hired Date: "+_vm._s(_vm.getDate(_vm.item.employment_date))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Agreement")])]),_vm._v("\n               (Employee agreed that these items should be duscussed during the coaching session)\n               "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.agreement))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Strengths")])]),_vm._v("\n               (Employee agreed that these items should be discussed during the coaching session)\n               "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.strength))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Performance")])]),_vm._v("\n               (Employee agreed that these items should be duscussed during the coaching session)\n               "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(" "+_vm._s(_vm.item.performance))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Impact of the Performance")])]),_vm._v("\n               (Impact of the performance towards the clients, employee, team and company)\n               "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8 pb-4 pt-3"},[_c('b',[_vm._v("Clients:")]),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.client))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Employee:")]),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.employee))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Team:")]),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.team))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Company:")]),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.company))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Action Plans")])]),_vm._v("\n               (Employee agreed that these items should be duscussed during the coaching session)\n               "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8 pb-4 pt-3"},[_c('label',[_vm._v("What is your action plan :")]),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.employee_commitment))])])])]),_vm._v(" "),_c('div',{staticClass:"gatterBreak"}),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 report-border-right"},[_c('h4',[_c('b',[_vm._v("Expected Results")])]),_vm._v("\n                  (What are the expected results after the actions plan are implemented ? Include timeline)\n                  "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-8 pb-4 pt-3"},[_c('label',[_vm._v("What is your expected result :")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.expected_result))])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("  I hereby acknowledge that I have been coached according to standard set by the company and commit to the objectives and targets stated above. ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 pb-4 pt-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_c('br'),_vm._v(" "),(_vm.item.employee_status == 'acknowledged')?_c('span',[_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.item.employee_signature,"alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"report-printed-control-coaching"},[_c('b',[_c('center',[_vm._v(_vm._s(_vm._f("uppercase")(_vm.item.first_name))+" "+_vm._s(_vm._f("uppercase")(_vm.item.last_name)))])],1)]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v("Signature over Printed Name")])],1):_c('span',[_c('center',[_c('p',{staticStyle:{"color":"red"}},[_vm._v("Unacknowledged.")])])],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0004")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dCLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegerPlusminus',
  props: {
    value: {
      default: 0,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    },
    vertical: {
      default: false,
      type: Boolean
    },
    incrementAriaLabel: {
      default: null,
      type: String
    },
    decrementAriaLabel: {
      default: null,
      type: String
    },
    spinButtonAriaLabel: {
      default: null,
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      intValue: 0
    };
  },

  computed: {
    canIncrement: function canIncrement() {
      if (this.disabled) return false;
      return this.max === undefined || this.intValue + this.step <= this.max;
    },
    canDecrement: function canDecrement() {
      if (this.disabled) return false;
      return this.intValue - this.step >= this.min;
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.keyUp);
  },

  methods: {
    keyUp: function keyUp(event) {
      if (this.isSpinButtonFocused()) {
        if (event.keyCode === 33 || event.keyCode === 38) {
          // page up || up arrow
          this.increment();
          event.preventDefault();
        }

        if (event.keyCode === 34 || event.keyCode === 40) {
          // page down || down arrow
          this.decrement();
          event.preventDefault();
        }

        if (event.keyCode === 36) {
          // home button
          this.setToMin();
          event.preventDefault();
        }

        // if max, set to max
        if (this.max !== undefined && event.keyCode === 35) {
          // end button
          this.setToMax();
          event.preventDefault();
        }
      }
    },
    isSpinButtonFocused: function isSpinButtonFocused() {
      return document.activeElement === this.$refs.spinbutton;
    },
    getBtnClass: function getBtnClass(firstBtn) {
      var btnClass = 'int-pm-';
      if (firstBtn && !this.vertical || !firstBtn && this.vertical) {
        btnClass += 'decrement';
        if (!this.canDecrement) btnClass += ' disabled';
      } else {
        btnClass += 'increment';
        if (!this.canIncrement) btnClass += ' disabled';
      }
      return btnClass;
    },
    setToMin: function setToMin() {
      if (this.disabled) return;
      this.intValue = this.min;
      this.$emit('input', this.intValue);
    },
    setToMax: function setToMax() {
      if (this.disabled) return;
      this.intValue = this.max;
      this.$emit('input', this.intValue);
    },
    increment: function increment() {
      if (this.canIncrement) {
        this.intValue = this.intValue + this.step;
        this.$emit('ipm-increment', this.intValue);
        this.$emit('input', this.intValue);
      }
    },
    decrement: function decrement() {
      if (this.canDecrement) {
        this.intValue = this.intValue - this.step;
        this.$emit('ipm-decrement', this.intValue);
        this.$emit('input', this.intValue);
      }
    }
  },
  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.intValue = newVal;
      }
    }
  },
  created: function created() {
    this.intValue = this.value;
    if (this.step < 1) this.step = 1;
    if (this.max < this.min) this.max = undefined;
  }
});

/***/ }),

/***/ "dCUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('user-roles')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dJmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("WFH Responsibilities Record")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-md-6"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/responsibilityform"}},[_vm._v("Office Responsibilities")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("WFH Responsibility")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}})]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10"}}),_vm._v(" "),_c('th',{attrs:{"width":"700"}},[_vm._v("Employee Name")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Date Submitted")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedResponsibility),function(emp,i){return _c('tr',[(emp === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(emp.created)))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-default",attrs:{"to":{name: 'view-wfh-responsibility', params: { id: emp.id }},"title":"click to view full details of responsibility form"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View")])],1)]],2)}),0)])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dWkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_coaching_record_vue__ = __webpack_require__("NKJQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8238cde2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_coaching_record_vue__ = __webpack_require__("aLlQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_coaching_record_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8238cde2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_coaching_record_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXoH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reports')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dYI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('upload-payslip')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dfke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dlC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_contracts__ = __webpack_require__("JPSC");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignContracts: __WEBPACK_IMPORTED_MODULE_0__todo_assign_contracts__["a" /* default */]
    }
});

/***/ }),

/***/ "dnff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_breadcrumb_menu__ = __webpack_require__("AaH/");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        breadcrumbMenu: __WEBPACK_IMPORTED_MODULE_3__base_breadcrumb_menu__["a" /* default */]
    },
    data: function data() {
        var _ref;

        return _ref = {
            items: [],
            loading: true,
            belongs_to: '',
            selected_item: '',
            selected_emp: '',
            subordinate_item: [],
            //options
            supervisor: [],
            managers: [],
            //filter
            search: '',
            order_by: '',
            sortAsc: true,
            //pagination
            page_limit: '',
            start_page: 1
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'options', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sup_subtitute_id', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sup_choosen_id', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'member_item', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'subtitute_item', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'supervisor_choosen', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'checkedPerm_Id', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sub_department', []), _ref;
    },


    mounted: function mounted() {
        this.get_users();
        this.get_supervisor();
        this.get_subtitute();
        this.get_manager();
        this.get_sub_department();
    },

    methods: {
        get_sub_department: function get_sub_department() {
            var _this = this;

            axios.get('api/subdepartment/all').then(function (response) {
                _this.sub_department = response.data;_this.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        update_subordinate: function update_subordinate() {
            var _this2 = this;

            console.log('response =>', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.checkedPerm_Id));
            console.log('response =>', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selected_emp.id));

            axios.post('api/subordinates/update', {
                id: this.selected_emp.id,
                subordinates: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.checkedPerm_Id)
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this2.get_sub_department();
                    _this2.$swal('Save', resp.data.message, 'success');
                    _this2.$refs['hide-subordinate-modal'].hide();
                } else {
                    _this2.$swal('Error', resp.data.message, 'error');
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        modalClose: function modalClose() {
            this.subtitute_item = false, this.supervisor_choosen = false;
        },
        get_subtitute: function get_subtitute() {

            if (this.options == 'admin') {
                this.subtitute_item = false, this.supervisor_choosen = false;
            }

            if (this.options == 'staff') {
                this.subtitute_item = false, this.supervisor_choosen = true;
            }

            if (this.options == 'staff' && this.member_item.length != 0) {
                this.subtitute_item = true;
                this.supervisor_choosen = true;
            }

            if (this.options == 'admin' && this.member_item.length != 0) {
                this.subtitute_item = true;
            }
        },
        get_supervisor: function get_supervisor() {
            var _this3 = this;

            axios.get('api/supervisor').then(function (resp) {
                _this3.supervisor = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //GET MANAGER SUBTITUTE
        get_manager: function get_manager() {
            var _this4 = this;

            axios.get('api/managersubtitute').then(function (resp) {
                _this4.managers = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //MANAGER ACCESS
        get_users: function get_users() {
            var _this5 = this;

            axios.get('api/manageraccess').then(function (response) {
                _this5.items = response.data;_this5.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },

        //CHECK MEMBER 
        get_selected_id: function get_selected_id(item) {
            var _this6 = this;

            this.selected_item = item;
            axios.get('api/checkmember/' + this.selected_item.id).then(function (resp) {
                _this6.member_item = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //GET MANAGER FOR SUBORDINATES DISPLAY
        get_selected_empId: function get_selected_empId(item) {
            var _this7 = this;

            this.selected_emp = item;
            //SUBORDINATES
            axios.get('api/employee/' + this.selected_emp.id).then(function (resp) {
                _this7.subordinate_item = resp.data;
                _this7.checkedPerm_Id = _this7.subordinate_item.subordinates.map(function (o) {
                    return o.id;
                });
            }).catch(function (error) {
                console.log(error.response);
            });
        },


        //UPDATE USER BELONGS
        update_user: function update_user() {
            var _this8 = this;

            //   console.log('supervisor subtitute id =>',this.sup_subtitute_id)
            //   console.log('supervisor choosen id =>',this.sup_choosen_id)
            //   console.log('acount choose =>',this.options)
            //   console.log('member =>',this.member_item.length);

            axios.post('api/supervisoraccess/update/' + this.selected_item.id, {
                'supervisor_member': this.member_item.length,
                'account_type': this.options,
                'sup_subtitute_id': this.sup_subtitute_id,
                'supervisor_choosen_id': this.sup_choosen_id
            }).then(function (resp) {
                if (resp.data.response == 'success') {
                    _this8.get_users();
                    _this8.$swal('Save', resp.data.message, 'success');
                    _this8.$refs['hide-user-modal'].hide();
                } else {
                    _this8.$swal('Error', resp.data.message, 'error');
                }
                console.log(resp.data.message);
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    computed: {

        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_record: function total_record() {
            return this.items.length;
        },
        numOfPages: function numOfPages() {
            return Math.ceil(this.items.length / this.page_limit);
        },
        computedEmployee: function computedEmployee() {
            var _this9 = this;

            var filtered = this.items;
            if (filtered.length > 0) {
                // SEARCH BY EMPLOYEE FULLNAME  
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this9.search) > -1;
                    });
                    return filtered;
                }

                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }

                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this9.order_by : -_this9.order_by;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }

});

/***/ }),

/***/ "dqry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dr5x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_credit_config_vue__ = __webpack_require__("H3+4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e7dac5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_credit_config_vue__ = __webpack_require__("Ok0N");
function injectStyle (ssrContext) {
  __webpack_require__("vkw7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_credit_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e7dac5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_credit_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dsQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      error_handler: [],
      pay_date: "",

      docFileName: '',
      docFileSize: 0,
      files: '',

      //PAGINATION
      page_limit: '',
      filter_by_year: '',
      order_by: '',
      start_page: 1,
      loading: true,
      perPage: 50,
      curentPage: 1,
      search: '',

      items: []
    };
  },
  created: function created() {
    this.getInfo();
    this.get_payslip();
  },

  methods: {

    frontEndDateFormat: function frontEndDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    },

    /*
     |----------------------------------------------------------------------
     |  TO SUBMIT FORM 
     |----------------------------------------------------------------------
     */
    uploadPayslip: function uploadPayslip() {
      var _this = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to submit this payslip',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          var formData = new FormData();
          formData.append('employee_id', _this.item.id);
          formData.append('pay_date', _this.frontEndDateFormat(_this.pay_date));
          formData.append('files', _this.files);
          axios.post('api/upload/payslip', formData).then(function (resp) {
            if (resp.data.response == "success") {
              _this.$swal({
                type: 'success',
                title: 'Submitted',
                html: 'Payslip has been successfully uploaded. <br/><br/><br/><br/>',
                showConfirmButton: false,
                timer: 5000
              });
              setTimeout(function () {
                // this.$router.push({ name: 'payslip'})
                _this.get_payslip();
              }, 3000);
            } else if (resp.data.response == "error") {
              _this.$swal('Opps', resp.data.message, 'error');
            }
          }).catch(function (error) {
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error.response.data.errors));
            if (error.response.status == 422) {
              _this.error_handler = error.response.data.errors;
            }
          });
        }
      });
    },
    removePayslip: function removePayslip(id) {
      var _this2 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/payslip/' + id + '/delete').then(function () {
            _this2.get_payslip();
            _this2.$swal('Deleted!', 'The payslip has been deleted.', 'success');
          }).catch(function (error) {
            console.error(error);
            _this2.$swal('Error', 'Failed to delete record.', 'error');
          });
        }
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;

      axios.get('api/contractsmemo/getinfo/' + this.$route.params.id).then(function (resp) {
        _this3.item = resp.data;
      });
    },
    getYear: function getYear() {
      var _this4 = this;

      if (this.filter_by_year == '') {
        this.get_payslip();
      } else {
        axios.get('api/employee/' + this.$route.params.id + '/payslip/' + this.filter_by_year).then(function (response) {
          _this4.items = response.data;
          console.log('response => ', _this4.items);
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    get_payslip: function get_payslip() {
      var _this5 = this;

      axios.get('api/employee/' + this.$route.params.id + '/payslip').then(function (response) {
        _this5.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    payslipFiles: function payslipFiles(event) {
      var file = event.target.files[0];
      if (file) {
        this.files = file;
        this.docFileName = file.name;
        this.docFileSize = (file.size / 1024).toFixed(2);
      }
    },
    removePayslipFiles: function removePayslipFiles() {
      this.files = '';
      this.error_handler.files = [];
    }
  },
  computed: {
    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.id < b.id ? _this6.order_by : -_this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    }
  }

});

/***/ }),

/***/ "dtpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_position_vue__ = __webpack_require__("24TF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b847356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_position_vue__ = __webpack_require__("+f2B");
function injectStyle (ssrContext) {
  __webpack_require__("snK2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_position_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b847356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_position_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/3l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e9mh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_request_form_vue__ = __webpack_require__("w6nZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17cdf739_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_request_form_vue__ = __webpack_require__("MJS8");
function injectStyle (ssrContext) {
  __webpack_require__("PyRq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_request_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17cdf739_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_request_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eBQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_upload_payslip_vue__ = __webpack_require__("RLZp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3db0be41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_upload_payslip_vue__ = __webpack_require__("dYI/");
function injectStyle (ssrContext) {
  __webpack_require__("ZXZ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_upload_payslip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3db0be41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_upload_payslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207956d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("4wqI");
function injectStyle (ssrContext) {
  __webpack_require__("ZPbt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207956d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eHqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_responsibility_vue__ = __webpack_require__("P4xu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a9956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_responsibility_vue__ = __webpack_require__("6dvs");
function injectStyle (ssrContext) {
  __webpack_require__("2lrU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_view_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a9956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_view_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eK6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Management")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"absenceleave"}},[_vm._v("Leave & Absences Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Employee Leave Credits")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.add-new-item",modifiers:{"add-new-item":true}}],staticClass:"btn btn-primary float-right"},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Register Leave Credits")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"50"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"380"}},[_vm._v("Employee Name")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}}),_vm._v(" "),_c('th',{attrs:{"width":"180"}}),_vm._v(" "),_c('th',{attrs:{"width":"180"}}),_vm._v(" "),_c('th',{attrs:{"width":"180"}}),_vm._v(" "),_c('th',{attrs:{"width":"180"}}),_vm._v(" "),_c('th',{attrs:{"width":"170"}}),_vm._v(" "),_c('th',{attrs:{"width":"160"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedLeave),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))])]),_vm._v(" "),_c('td',[_vm._v("Credit Balance "),_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v(_vm._s(item.leave_credit_balance))])]),_vm._v(" "),_c('td',[_c('b'),_vm._v("Leave Used "),_c('span',{staticClass:"badge badge-pill badge-warning m-size"},[_vm._v(_vm._s(item.leave_credit_used))])]),_vm._v(" "),_c('td',[_c('b'),_vm._v("Bereavement "),_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v(_vm._s(item.leave_credit_bereavement))])]),_vm._v(" "),_c('td',[_c('b'),_vm._v("Solo Parent "),_c('span',{staticClass:"badge badge-pill badge-primary m-size"},[_vm._v(_vm._s(item.leave_credit_solo_parents))])]),_vm._v(" "),_c('td',[_c('b'),_vm._v("Maternity "),_c('span',{staticClass:"badge badge-pill badge-secondary m-size"},[_vm._v(_vm._s(item.leave_credit_maternity))])]),_vm._v(" "),_c('td',[_c('b'),_vm._v("Paternity "),_c('span',{staticClass:"badge badge-pill badge-info m-size"},[_vm._v(_vm._s(item.leave_credit_paternity))])]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-leave-credit",modifiers:{"update-leave-credit":true}}],staticClass:"link-credits-update",attrs:{"href":"#"},on:{"click":function($event){_vm.get_update_item(item)}}},[_c('u',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")])])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"add-new-credits",attrs:{"id":"add-new-item","size":"l","hide-footer":""}},[_c('h4',{staticClass:"c-padding"},[_vm._v("Register Employee Leave Credits")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Employee:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Employee --")]),_vm._v(" "),_vm._l((_vm.employee_item),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(emp.full_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave Credits Balance:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['#']),expression:"['#']"},{name:"model",rawName:"v-model",value:(_vm.leave_credit_balance),expression:"leave_credit_balance"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.leave_credit_balance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.leave_credit_balance=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave Credits Used:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['#']),expression:"['#']"},{name:"model",rawName:"v-model",value:(_vm.leave_credit_used),expression:"leave_credit_used"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.leave_credit_used)},on:{"input":function($event){if($event.target.composing){ return; }_vm.leave_credit_used=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.register_leave_credits}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Register Leave Credits")])]),_vm._v(" "),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('b-modal',{ref:"leave-credits-update",attrs:{"id":"update-leave-credit","size":"xl","hide-footer":""}},[_c('h4',{staticClass:"c-padding"},[_vm._v("Update Leave Credits")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h4',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_user.full_name)))])]),_vm._v("\n            "+_vm._s(_vm.selected_user.employee_id)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave Credits Balance:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_balance),expression:"selected_user.leave_credit_balance"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.selected_user.leave_credit_balance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_balance", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave Credits Used:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_used),expression:"selected_user.leave_credit_used"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.leave_credit_used)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_used", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bereavement:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_bereavement),expression:"selected_user.leave_credit_bereavement"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.leave_credit_bereavement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_bereavement", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Solo Parent:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_solo_parents),expression:"selected_user.leave_credit_solo_parents"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.leave_credit_solo_parents)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_solo_parents", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Maternity:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_maternity),expression:"selected_user.leave_credit_maternity"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.leave_credit_maternity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_maternity", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Paternity:")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(['##']),expression:"['##']"},{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_credit_paternity),expression:"selected_user.leave_credit_paternity"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.leave_credit_paternity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "leave_credit_paternity", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_leave_credits}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Update Leave Credits")])]),_vm._v(" "),_c('br'),_c('br'),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  }
});

/***/ }),

/***/ "eejq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_account_user_vue__ = __webpack_require__("1X3Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f57c7a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_account_user_vue__ = __webpack_require__("qBCz");
function injectStyle (ssrContext) {
  __webpack_require__("dfke")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_account_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f57c7a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_account_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "exPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_job_information__ = __webpack_require__("d/y+");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        JobInformation: __WEBPACK_IMPORTED_MODULE_0__todo_job_information__["a" /* default */]
    }
});

/***/ }),

/***/ "exW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reset_password_reset_password_vue__ = __webpack_require__("+me+");
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    resetPassword: __WEBPACK_IMPORTED_MODULE_0__reset_password_reset_password_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "f3UM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f5WK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f7ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        var _config;

        return {
            eventSources: [{
                events: function events(start, end, timezone, callback) {
                    axios.get("api/calendar").then(function (response) {
                        callback(response.data);
                    });
                }
            }],
            config: (_config = {
                locale: "en",
                defaultView: "month",
                editable: false,
                eventLimit: 4
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, "eventLimit", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, "eventRender", function eventRender(event, element) {
                if (event.type == 1) {
                    element.css({
                        "background-color": "#d19a02",
                        border: "none",
                        color: "#eee"
                    });
                } else if (event.type == 2) {
                    element.css({
                        "background-color": "#007bff",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 3) {
                    element.css({
                        "background-color": "#17a2b8",
                        border: "none",
                        color: "#000"
                    });
                } else if (event.type == 4) {
                    element.css({
                        "background-color": "#f9ff4a",
                        border: "none",
                        color: "#000"
                    });
                } else if (event.type == 5) {
                    element.css({
                        "background-color": "#dc3545",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 6) {
                    element.css({
                        "background-color": "#70c2c2",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 7) {
                    element.css({
                        "background-color": "#f9ff4a",
                        border: "none",
                        color: "#000"
                    });
                } else if (event.type == 8) {
                    element.css({
                        "background-color": "#ed0758",
                        border: "1px solid #f75c95",
                        color: "#fff"
                    });
                } else if (event.type == 9) {
                    element.css({
                        "background-color": "#3629c2",
                        border: "1px solid #685de3",
                        color: "#fff"
                    });
                } else if (event.type == 10) {
                    element.css({
                        "background-color": "#34eb46",
                        border: "1px solid #05a314",
                        color: "#fff"
                    });
                } else if (event.type == 12) {
                    element.css({
                        "background-color": "#facf32",
                        border: "1px solid #e6b810",
                        color: "#fff"
                    });
                }
            }), _config)
        };
    }
});

/***/ }),

/***/ "fB9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_department_vue__ = __webpack_require__("1Tu3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6bad956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_department_vue__ = __webpack_require__("24Ms");
function injectStyle (ssrContext) {
  __webpack_require__("IZjJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_department_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6bad956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_department_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fVEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_request_vue__ = __webpack_require__("VoEh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e65383c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_request_vue__ = __webpack_require__("HzzE");
function injectStyle (ssrContext) {
  __webpack_require__("5KKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e65383c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fXN8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fXsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_holidays_vue__ = __webpack_require__("BCxN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0e077e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_holidays_vue__ = __webpack_require__("52xl");
function injectStyle (ssrContext) {
  __webpack_require__("Hbh+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_holidays_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0e077e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_holidays_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      contact_items: [],
      personale_no: "",
      emergency_no: "",
      relationship: "",
      search: "",
      selected_user: "",
      loading: true,
      //Indicator
      display_indicator: "",
      //PAGINATION
      perPage: 200,
      curentPage: 1
    };
  },

  created: function created() {
    this.get_contact();
  },
  methods: {
    get_contact: function get_contact() {
      var _this = this;

      axios.get("api/contacts").then(function (response) {
        _this.contact_items = response.data;
        _this.display_indicator = 2;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    get_selected_id: function get_selected_id(item) {
      this.selected_user = item;
    },
    update_contact: function update_contact() {
      var _this2 = this;

      axios.post("api/contacts/update/" + this.selected_user.id, {
        contact: this.selected_user.contact,
        contact_person: this.selected_user.contact_person,
        emergency_no: this.selected_user.emergency_no,
        email_address: this.selected_user.email_address,
        blueprint_address: this.selected_user.blueprint_address,
        relationship: this.selected_user.relationship
      }).then(function (response) {
        _this2.$swal({
          type: "success",
          title: "Save",
          text: "You successfully save",
          showConfirmButton: false,
          timer: 2000
        });
        _this2.get_contact();
        _this2.$refs["hide-contact-modal"].hide();
        console.log(response.data);
      }).catch(function (e) {
        console.log(e.response);
      });
    }
  },
  computed: {
    total_item: function total_item() {
      return this.contact_items.length;
    },
    computedContacts: function computedContacts() {
      var _this3 = this;

      var filtered = this.contact_items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }

});

/***/ }),

/***/ "fhr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {}
    };
  },

  created: function created() {
    this.getItem();
  },
  methods: {
    printPreview: function printPreview() {

      var newstr = document.getElementById('printme').innerHTML;
      document.body.innerHTML = newstr;
      var oldstr = document.body.innerHTML;
      window.close();
      window.print();

      document.body.innerHTML = oldstr;
      window.location.reload();
    },
    getItem: function getItem() {
      var _this = this;

      axios.get('api/employee/coaching/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
      });
    }
  }
});

/***/ }),

/***/ "fpN8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_request_vue__ = __webpack_require__("xL5F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e98a80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_request_vue__ = __webpack_require__("8TZG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e98a80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fwtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_view_job_information__ = __webpack_require__("USqe");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        viewJob: __WEBPACK_IMPORTED_MODULE_0__todo_view_job_information__["a" /* default */]
    }
});

/***/ }),

/***/ "fxS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fyAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Supervisor Access")])]),_vm._v(" "),_c('breadcrumb-menu'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20"}},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"500"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('td',[_vm._v("Belongs to "),_c('b',[_c('i',{staticClass:"fa fa-long-arrow-right"}),_vm._v(" "+_vm._s(_vm._f("capitalize")(item.superior_name))+" ")])]),_vm._v(" "),_c('td',[(item.belong == null)?_vm._t("default",[_vm._v("No team member")]):_vm._t("default",[_vm._v("\n                          Has"),_c('i',{staticClass:"fa fa-long-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v("\n                                "+_vm._s(item.belong)+"  \n                            ")]),_vm._v(" "),_c('b',[_vm._v(" Member ")])])],2),_vm._v(" "),_c('td',[_vm._v("Module Access \n                       "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":item.module_access == '1'},on:{"click":function($event){_vm.subordinateStatus(item.id,item.module_access)}}})]),_vm._v(" "),_c('td',[(item.module_access == '1')?_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-subordinate",modifiers:{"update-subordinate":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_empId(item)}}},[_c('u',[_vm._v("Subordinates")])]):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-user-account",modifiers:{"update-user-account":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v("Change Access")])])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-user-modal",attrs:{"id":"update-user-account","size":"l","hide-footer":""},on:{"hide":_vm.modalClose}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_item.full_name)))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Account Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.options),expression:"options"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.options=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_subtitute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"staff"}},[_vm._v("OFFICE STAFF")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("ADMIN STAFF")]),_vm._v(" "),_c('option',{attrs:{"value":"supervisor"}},[_vm._v("SUPERVISOR")]),_vm._v(" "),_c('option',{attrs:{"value":"asm"}},[_vm._v("MANAGER")])])]),_vm._v(" "),(_vm.subtitute_item == true)?_vm._t("default",[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Supervisor to Subtitute")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sup_subtitute_id),expression:"sup_subtitute_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sup_subtitute_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(sup.position_name))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.supervisor_choosen == true)?_vm._t("default",[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Employee Supervisor")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sup_choosen_id),expression:"sup_choosen_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sup_choosen_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(sup.position_name))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.options == 'supervisor')?_c('div',[_c('label',[_vm._v("Belongs to:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sup_choosen_id),expression:"sup_choosen_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sup_choosen_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_manager]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Manager --")]),_vm._v(" "),_vm._l((_vm.manager),function(mag){return _c('option',{domProps:{"value":mag.id}},[_vm._v(_vm._s(_vm._f("capitalize")(mag.full_name))+" - "+_vm._s(_vm._f("capitalize")(mag.position_name)))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_user}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('b-modal',{ref:"hide-subordinate-modal",attrs:{"id":"update-subordinate","size":"l","hide-footer":""},on:{"hide":_vm.modalClose}},[_c('h1',[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.subordinate_item.full_name)))])]),_vm._v(" "),_c('p',[_vm._v("Select Subordinates for Managerial Belongs:")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("SUB DEPARTMENT / SUBORDINATES")]),_vm._v(" "),_c('div',{staticClass:"subordinatesSytle"},_vm._l((_vm.sub_department),function(item){return _c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPerm_Id),expression:"checkedPerm_Id"}],staticClass:"perm_id",attrs:{"type":"checkbox","name":"perm_id","id":"perm_name"},domProps:{"value":item.id,"checked":Array.isArray(_vm.checkedPerm_Id)?_vm._i(_vm.checkedPerm_Id,item.id)>-1:(_vm.checkedPerm_Id)},on:{"change":function($event){var $$a=_vm.checkedPerm_Id,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPerm_Id=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPerm_Id=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPerm_Id=$$c}}}}),_vm._v(" "+_vm._s(item.sub_department_name)),_c('br')])}),0),_vm._v(" "),_c('div',{staticClass:"form-group mt-3"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_subordinate}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fzkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_collections_vue__ = __webpack_require__("c78x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d901a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_collections_vue__ = __webpack_require__("I4wg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_collections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d901a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_collections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g90p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_edit_info__ = __webpack_require__("ynpy");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        editInfo: __WEBPACK_IMPORTED_MODULE_0__todo_edit_info__["a" /* default */]
    }
});

/***/ }),

/***/ "gMzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_work_shifts_vue__ = __webpack_require__("q0+I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b2316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_work_shifts_vue__ = __webpack_require__("KVSD");
function injectStyle (ssrContext) {
  __webpack_require__("N1I/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_work_shifts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b2316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_work_shifts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gOoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_request_leave_vue__ = __webpack_require__("Zw8X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90c1f322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_request_leave_vue__ = __webpack_require__("k1hG");
function injectStyle (ssrContext) {
  __webpack_require__("JSwQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_request_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90c1f322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_request_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gYMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to CD-PQ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To CD-PQ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to CD-PQ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                           "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                     "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gaDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_users_vue__ = __webpack_require__("i1u7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dca922a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_users_vue__ = __webpack_require__("V39C");
function injectStyle (ssrContext) {
  __webpack_require__("k5/w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dca922a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gbBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      reason: false,
      reason_to_declined: ''
    };
  },

  created: function created() {
    this.getItem();
  },
  methods: {
    reasonRejected: function reasonRejected() {
      if (this.item.hr_status == 'rejected') {
        this.reason = true;
      } else {
        this.reason = false;
      }
    },
    getItem: function getItem() {
      var _this = this;

      axios.get('api/scheduleadjustment/get/' + this.$route.params.id).then(function (resp) {
        _this.item = resp.data;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
      });
    },
    update_form: function update_form(e) {
      var _this2 = this;

      e.preventDefault();
      axios.post('api/adjustment/approval/' + this.item.id, {
        hr_status: this.item.hr_status,
        hr_reason_to_declined: this.reason_to_declined,
        hr_date_approved: new Date()
      }).then(function (resp) {
        if (resp.data.response == 'success') {
          _this2.$swal({
            type: 'success',
            title: resp.data.title,
            html: resp.data.message,
            showConfirmButton: true,
            timer: 4000
          });
          _this2.$router.push({ name: 'schedule-adjustment' });
        }
        console.log(resp.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

});

/***/ }),

/***/ "gos+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      emp: "",
      no_of_days: "",
      date_filled: "",
      leave_type: "",
      remarks: "",
      start_date: "",
      end_date: "",
      reason: "",
      status: "",
      tl_status: "",
      asm_status: "",
      //date approval
      tl_date_approved: "",
      asm_date_approved: "",
      hr_date_approved: "",
      // Errors handler
      error_handler: [],
      no_credits: '',
      //credits
      credits_indicator: '',
      //loading
      loading: true
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.get_employees();
    this.indicator_leave();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },
  methods: {
    indicator_leave: function indicator_leave() {
      var _this2 = this;

      axios.get('api/employee/credits/' + this.emp).then(function (resp) {
        _this2.credits_indicator = resp.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_employees: function get_employees() {
      var _this3 = this;

      axios.get("api/employees").then(function (response) {
        _this3.items = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    formSubmit: function formSubmit(e) {
      var _this4 = this;

      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post("api/manualleave/add", {
            employee_id: _this4.emp,
            date_filled: _this4.date_filled,
            no_of_days: _this4.no_of_days,
            leave_type: _this4.leave_type,
            remarks: _this4.remarks,
            start_date: _this4.start_date,
            end_date: _this4.end_date,
            reason: _this4.reason,
            status: _this4.status,
            tl_status: _this4.tl_status,
            asm_status: _this4.asm_status,
            tl_date_approved: _this4.tl_date_approved,
            asm_date_approved: _this4.asm_date_approved,
            hr_date_approved: _this4.hr_date_approved
          }).then(function (resp) {
            _this4.$swal("Save", "You successfully save this file", "success");
            _this4.$router.push({ name: "absence-leave" });
            _this4.resForm();
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this4.error_handler = error.response.data.errors;
              _this4.no_credits = error.response.data.message;
              _this4.$swal('Opps', _this4.no_credits, 'error');

              _this4.no_of_days = '';
            }
          });
        }
      });
    }
  },
  computed: {
    countBusiness: function countBusiness() {
      this.no_of_days = moment(this.start_date, 'MM-DD-YYYY').businessDiff(moment(this.end_date, 'MM-DD-YYYY'));
      return this.no_of_days;
    },


    countDate: {
      get: function get() {

        var start = moment(this.start_date);
        var end = moment(this.end_date);
        this.no_of_days = end.diff(start, "days") + 1;
        //if NaN result change to 0
        if (isNaN(this.no_of_days)) this.no_of_days = 0;
        return this.no_of_days;
      },
      set: function set(val) {
        this.no_of_days = val;
      }
    }

  }

});

/***/ }),

/***/ "h5bQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('schedule-adjustment')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h7Jy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hBfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Staff Access")])]),_vm._v(" "),_c('breadcrumb-menu'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Filter By Supervisor ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_supervisor),expression:"filter_by_supervisor"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_supervisor=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.supervisorMember]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Supervisor --")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(_vm._f("capitalize")(sup.position_name)))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20"}},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"500"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}}),_vm._v(" "),_c('th',{attrs:{"width":"200"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name)))]),_vm._v(" "),_c('td',[_vm._v("Belongs to "),_c('b',[_c('i',{staticClass:"fa fa-long-arrow-right"}),_vm._v(" "+_vm._s(_vm._f("capitalize")(item.superior_name))+" ")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-user-account",modifiers:{"update-user-account":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v("Change Access")])])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-user-modal",attrs:{"id":"update-user-account","size":"l","hide-footer":""},on:{"hide":_vm.doSometing}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_item.full_name)))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Account Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.options),expression:"options"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.options=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_belongs]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_c('option',{attrs:{"value":"staff"}},[_vm._v("OFFICE STAFF")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("ADMIN STAFF")]),_vm._v(" "),_c('option',{attrs:{"value":"supervisor"}},[_vm._v("SUPERVISOR")]),_vm._v(" "),_c('option',{attrs:{"value":"asm"}},[_vm._v("MANAGER")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.options == 'staff')?_c('div',[_c('label',[_vm._v("Belongs to:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.belongs_to),expression:"belongs_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.belongs_to=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_superiorname]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Supervisor --")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name))+" - "+_vm._s(_vm._f("capitalize")(sup.position_name)))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.options == 'supervisor')?_c('div',[_c('label',[_vm._v("Belongs to:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.belongs_to),expression:"belongs_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.belongs_to=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_manager_name]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Manager --")]),_vm._v(" "),_vm._l((_vm.manager),function(mag){return _c('option',{domProps:{"value":mag.id}},[_vm._v(_vm._s(_vm._f("capitalize")(mag.full_name))+" - "+_vm._s(_vm._f("capitalize")(mag.position_name)))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_user}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hGyo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hP+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hV1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_all_vue__ = __webpack_require__("TYFD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b62617e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_all_vue__ = __webpack_require__("jMRj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b62617e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hx8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img-fluid col-md-10",attrs:{"src":"/static/img/blueprintlogologin.png","alt":"..."}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('template',{slot:"header"},[_vm._v("\n\t\t Login\n\t  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uname),expression:"uname"}],staticClass:"form-control form-field",class:{ 'is-invalid': _vm.error_handler},attrs:{"type":"text","placeholder":"Username","autocomplete":"off","required":""},domProps:{"value":(_vm.uname)},on:{"click":_vm.hide_message,"input":function($event){if($event.target.composing){ return; }_vm.uname=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.upass),expression:"upass"}],staticClass:"form-control form-field",class:{ 'is-invalid': _vm.error_handler},attrs:{"type":"password","placeholder":"Password","autocomplete":"off","required":""},domProps:{"value":(_vm.upass)},on:{"click":_vm.hide_message,"input":function($event){if($event.target.composing){ return; }_vm.upass=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.error_handler)?_c('div',{staticClass:"alert alert-danger"},[_vm._m(1),_vm._v(" "),_c('b',[_vm._v("error:")]),_vm._v(" "+_vm._s(_vm.error_handler)+"\n\t\t\t   ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info "},[_c('i',{staticClass:"fa fa-user"}),_vm._v("  Login Account\n\t\t\t   "),(_vm.seen)?_c('span',[_c('img',{attrs:{"src":"static/img/loading.gif","alt":"","width":"25","height":"25"}})]):_vm._e()]),_vm._v("\n\t\t\t    \n\t\t\t\t "),_c('router-link',{attrs:{"to":"/reset/password"}},[_c('u',[_vm._v("Forgot Password ?")])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')])]),_vm._v(" "),_vm._m(2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-title"},[_c('b',[_vm._v("HRIS")]),_vm._v(" - Human Resource Information System")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" Warning ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-style"},[_vm._v("Copyright © 2019 Blueprint Business Solution Corp"),_c('br'),_vm._v(" version 7.2.0 LTS")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0gz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_mantra_vue__ = __webpack_require__("nuob");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07961dd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_mantra_vue__ = __webpack_require__("tdlJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_mantra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07961dd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_mantra_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i1u7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_users__ = __webpack_require__("HHjo");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        users: __WEBPACK_IMPORTED_MODULE_0__todo_users__["a" /* default */]
    }
});

/***/ }),

/***/ "i5Ax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('resigned')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i9Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            items: [],
            selected_item: '',
            //Indicator
            loading: true
        };
    },


    mounted: function mounted() {
        this.get_roles();
    },

    methods: {
        get_roles: function get_roles() {
            var _this = this;

            axios.get('api/userroles').then(function (response) {
                _this.items = response.data;_this.loading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        get_selected_id: function get_selected_id(item) {
            this.selected_item = item;
        },
        update_roles: function update_roles() {
            var _this2 = this;

            axios.post('api/userroles/update/' + this.selected_item.id, {
                roles_name: this.selected_item.roles_name,
                description: this.selected_item.description
            }).then(function (resp) {
                if (resp.data.response == 'noupdate') {
                    console.log(resp.data.message);
                    _this2.$swal('Error', resp.data.message, 'error');
                } else if (resp.data.response == 'success') {
                    console.log(resp.data.message);
                    _this2.$swal('Success', resp.data.message, 'success');
                    _this2.$router.push({ name: 'users-roles' });

                    _this2.roles_name = '';
                    _this2.get_roles();
                    _this2.$refs['hide-roles-update'].hide();
                    console.log(response.data);
                }
            }).catch(function (e) {
                console.log(e);
            });
        }
    }

});

/***/ }),

/***/ "iF6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_view_wfh_responsibility__ = __webpack_require__("Rb2W");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        viewWfhResponsibility: __WEBPACK_IMPORTED_MODULE_0__todo_view_wfh_responsibility__["a" /* default */]
    }
});

/***/ }),

/***/ "iFtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-va-us')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iHIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_create_roles_vue__ = __webpack_require__("Ds5r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a16955a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_create_roles_vue__ = __webpack_require__("GQa5");
function injectStyle (ssrContext) {
  __webpack_require__("YjZi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_create_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a16955a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_create_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iMpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iSBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_contracts_all_vue__ = __webpack_require__("Mcpv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358e9932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_contracts_all_vue__ = __webpack_require__("zbiO");
function injectStyle (ssrContext) {
  __webpack_require__("PWpI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assign_contracts_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358e9932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assign_contracts_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iiJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("ESS Account Creations")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/users"}},[_vm._v("Users")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Create account")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Employees List:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Employee --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(emp.full_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Username :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.username)},on:{"keyup":_vm.concat_email,"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Company Email :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Default Password :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Select Roles :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_roles),expression:"user_roles"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.user_roles=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Roles --")]),_vm._v(" "),_vm._l((_vm.roles),function(r){return _c('option',{domProps:{"value":r.id}},[_vm._v(_vm._s(r.roles_name))])})],2)]),_vm._v(" "),(_vm.user_roles === 1)?_c('div',[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Belongs to")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.assign_to),expression:"assign_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.assign_to=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_belongs]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("Belongs to ADMIN")]),_vm._v(" "),_c('option',{attrs:{"value":"supervisor"}},[_vm._v("Belongs to SUPERVISOR")])])])]):_vm._e(),_vm._v(" "),(_vm.user_roles === 2)?_c('div',[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Belongs To :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.belongs_to),expression:"belongs_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.belongs_to=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_operation]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Manager --")]),_vm._v(" "),_vm._l((_vm.operations),function(op){return _c('option',{domProps:{"value":op.id}},[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(op.full_name)))]),_vm._v(" - "+_vm._s(_vm._f("capitalize")(op.position_name)))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.assign_to === 'supervisor' && _vm.user_roles === 1)?_c('div',[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v("Supervisor:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.belongs_to),expression:"belongs_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.belongs_to=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_superiorname]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select Supervisor --")]),_vm._v(" "),_vm._l((_vm.supervisor),function(sup){return _c('option',{domProps:{"value":sup.id}},[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(sup.full_name)))]),_vm._v(" - "+_vm._s(_vm._f("capitalize")(sup.position_name)))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.user_roles === 3)?_c('div',[_c('p',{staticClass:"p-text"},[_vm._v("Select team to handle :")]),_vm._v(" "),_c('h6',[_vm._v("SUB DEPARTMENT / SUBORDINATES")]),_vm._v(" "),_c('div',{staticClass:"subordinatesSytle mt-3"},_vm._l((_vm.sub_department_item),function(item){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subordinates),expression:"subordinates"}],attrs:{"type":"checkbox"},domProps:{"value":item.id,"checked":Array.isArray(_vm.subordinates)?_vm._i(_vm.subordinates,item.id)>-1:(_vm.subordinates)},on:{"change":function($event){var $$a=_vm.subordinates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.subordinates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.subordinates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.subordinates=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"vehicle1"}},[_vm._v(_vm._s(item.sub_department_name))]),_c('br')])}),0)]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mt-4"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Create Account")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "inNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iyEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-approval')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j/FY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j7wH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10486de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("hP+7");
function injectStyle (ssrContext) {
  __webpack_require__("B5kz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10486de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jMRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to All")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To All")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Assign Memos to All")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                          "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                     "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jOZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_responsibility_vue__ = __webpack_require__("Hjvo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d040e1ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_responsibility_vue__ = __webpack_require__("ls7l");
function injectStyle (ssrContext) {
  __webpack_require__("vMHG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d040e1ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jRBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_view_details__ = __webpack_require__("q7EO");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteViewDetails: __WEBPACK_IMPORTED_MODULE_0__todo_nte_view_details__["a" /* default */]
    }
});

/***/ }),

/***/ "jTeO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemoadmin', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/admin', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "jZ97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_edit_undertime_request__ = __webpack_require__("aW1d");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        editUndertimeRequest: __WEBPACK_IMPORTED_MODULE_0__todo_edit_undertime_request__["a" /* default */]
    }
});

/***/ }),

/***/ "jbuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_sub_department_vue__ = __webpack_require__("8wdw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0ab806e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_sub_department_vue__ = __webpack_require__("H4OE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_sub_department_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0ab806e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_sub_department_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jcqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_new_employee__ = __webpack_require__("aLzU");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TodoNewEmployee: __WEBPACK_IMPORTED_MODULE_0__todo_new_employee__["a" /* default */]
  }
});

/***/ }),

/***/ "jziG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Inactive Employee")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Inactive Employees")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Position:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_position),expression:"filter_by_position"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"textContent":_vm._s(pos.pos_name)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"terminated"}},[_vm._v("terminated")]),_vm._v(" "),_c('option',{attrs:{"value":"resigned"}},[_vm._v("resigned")]),_vm._v(" "),_c('option',{attrs:{"value":"awol"}},[_vm._v("AWOL")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Designation")]),_vm._v(" "),_c('th',[_vm._v("Address")]),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Joined date")]),_vm._v(" "),_c('th',[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("capitalize")(item.full_name))+" "+_vm._s(item.suffix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.position_name))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v(" \n                    "),(item.current_address.length < 30)?[_vm._v(_vm._s(_vm._f("capitalize")(item.current_address)))]:_vm._e(),_vm._v(" "),(item.current_address.length >= 30)?[_vm._v(_vm._s(_vm._f("capitalize")(item.current_address.substring(0,30)+"...")))]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'resigned')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'terminated')?_c('span',[_c('i',{staticClass:"fa fa-flag text-danger"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):(item.status == 'awol')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                     ")]):_vm._e()])]],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k1hG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('request-leave')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k1t8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_update_leave_vue__ = __webpack_require__("A+Km");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c5b469_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_update_leave_vue__ = __webpack_require__("3RLs");
function injectStyle (ssrContext) {
  __webpack_require__("hGyo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_update_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c5b469_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_update_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k5/w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k9Io":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      positions: [],
      //filter
      filter_by_position: '',
      filter_by_status: '',
      search: '',
      order_by: '',
      sortAsc: true,
      //pagination
      page_limit: '',
      start_page: 1,
      loading: true,
      //Indicator
      display_indicator: '',
      //PAGINATION
      perPage: 200,
      curentPage: 1
    };
  },


  mounted: function mounted() {
    this.get_employees();
    this.get_positions();
  },

  methods: {
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/employees').then(function (response) {
        _this.items = response.data;
        _this.display_indicator = 2;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    get_positions: function get_positions() {
      var _this2 = this;

      axios.get('api/positions').then(function (response) {
        _this2.positions = response.data;
      }).catch(function (e) {
        console.log(e.response);
      });
    }
  },
  computed: {

    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedEmployee: function computedEmployee() {
      var _this3 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
          });
          return filtered;
        }
        // FILTER BY POSITION
        if (this.filter_by_position) {
          filtered = filtered.filter(function (item) {
            return item.position_name.toLowerCase() === _this3.filter_by_position.toLowerCase();
          });
          return filtered;
        }

        // FILTER BY STATUS
        if (this.filter_by_status) {
          filtered = filtered.filter(function (item) {
            return item.status.toLowerCase() === _this3.filter_by_status.toLowerCase();
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this3.order_by : -_this3.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }

});

/***/ }),

/***/ "kBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),

/***/ "kCpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('notification-config')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJ8T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kSyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      order_by: '',
      //PAGINATION
      page_limit: '',
      filter_by_year: '',
      start_page: 1,
      loading: true,
      perPage: 20,
      curentPage: 1,
      search: ''
    };
  },


  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  beforeMount: function beforeMount() {
    this.get_contributions();
  },

  methods: {
    deleteItem: function deleteItem(id, index) {
      var _this2 = this;

      /* USING SWEET ALERT */
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/contributions/remove/' + id).then(function (response) {
            _this2.get_contributions(); // reloader 
            _this2.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            console.log(response);
            _this2.$swal('Error Code', 'Please contact Web developer', 'error');
          });
        }
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_contributions();
      } else {
        axios.get('api/contributions/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
          console.log(_this3.items);
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    get_contributions: function get_contributions() {
      var _this4 = this;

      axios.get('api/contributions').then(function (response) {
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  computed: {
    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this5 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this5.search) > -1;
          });
          return filtered;
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this5.order_by : -_this5.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    }
  }

});

/***/ }),

/***/ "kUwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_schedule_adjustment_vue__ = __webpack_require__("Fe3C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e0d754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_schedule_adjustment_vue__ = __webpack_require__("A2rL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_schedule_adjustment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e0d754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_schedule_adjustment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ki6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_view_leave__ = __webpack_require__("5JwZ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        viewLeave: __WEBPACK_IMPORTED_MODULE_0__todo_view_leave__["a" /* default */]
    }
});

/***/ }),

/***/ "l1Qx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lTzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_performance_details_vue__ = __webpack_require__("WAPL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ad4278_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_performance_details_vue__ = __webpack_require__("cSUi");
function injectStyle (ssrContext) {
  __webpack_require__("fxS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_performance_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ad4278_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_performance_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lUJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
    function getDaysInCurrentMonth() {
      var date = new Date();

      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }
    return {
      file: '',
      items: [],
      employees_by_members: [],
      department: null,
      sub_departments: [],
      pageEmployees: [],
      loading: true,
      logs: [],
      cut_off_start: 11,
      cut_off_end: 25,
      date: new Date(),
      month: months[new Date().getMonth()],
      months: months,
      year: new Date().getFullYear(),
      noOfDays: getDaysInCurrentMonth(),
      days: days,
      employeeCount: 10,
      currentPage: 1,
      tooltip: false,
      employeeModal: null,
      weeks: 7 - new Date(new Date().getFullYear(), new Date().getMonth(), 1).getDay(),
      addedDays: 0,
      weekNumber: 1,
      currentUser: {}
    };
  },
  created: function created() {
    var _this = this;

    this.getAttendanceOfUsers();
    this.getSubdepartments();
    setTimeout(function () {
      _this.loading = false;
    }, 1700);
  },

  methods: {
    getAttendanceOfUsers: function getAttendanceOfUsers() {
      var _this2 = this;

      axios.get('api/getmemberlogsarchivebydepartment', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        params: {
          startDate: this.year + "-" + (this.date.getMonth() + 1) + "-" + new Date(this.year, this.date.getMonth(), 1).getDate().toString().padStart(2, '0'),
          lastDate: this.year + "-" + (this.date.getMonth() + 1) + "-" + new Date(this.year, this.date.getMonth() + 1, 0).getDate().toString().padStart(2, '0'),
          sub_department: this.department,
          offset: this.employeeCount - 10
        }
      }).then(function (response) {
        _this2.employees_by_members = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getSubdepartments: function getSubdepartments() {
      var _this3 = this;

      axios.get('api/subdepartment/all', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this3.sub_departments = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    formatAMPM: function formatAMPM(date) {
      var ftime = date.split(":");
      var hours = ftime[0];
      var minutes = ftime[1];
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      // minutes = minutes < 10 && minutes !=0 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    paginateNext: function paginateNext() {
      if (this.employees_by_members.length === 10) {
        this.employeeCount = this.employeeCount + 10;
        this.currentPage++;
        this.getAttendanceOfUsers();
      }
    },
    paginatePrev: function paginatePrev() {
      if (this.currentPage - 1 !== 0) {
        this.employeeCount = this.employeeCount - 10;
        this.currentPage--;
        this.getAttendanceOfUsers();
      }
    },

    //--> IMPORT EXCEL FILE TO DATABASE
    exportExcel: function exportExcel() {
      var _this4 = this;

      axios.get("api/exportdata", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        },
        params: {
          startDate: this.year + "-" + (this.date.getMonth() + 1) + "-" + this.cut_off_start,
          lastDate: (this.date.getMonth() + 1 === 12 && this.cut_off_end === 10 ? this.year + 1 : this.year) + "-" + (this.cut_off_end === 10 ? this.date.getMonth() + 1 === 12 ? 1 : this.date.getMonth() + 2 : this.date.getMonth() + 1) + "-" + this.cut_off_end,
          subDepartmentId: this.department
        },
        responseType: 'blob'
      }).then(function (resp) {
        var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', "time-attendance-log-" + (_this4.date.getMonth() + 1) + "-" + _this4.year + ".csv");
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch(function (error) {
        console.log(error);
      });
    },


    //--> Download file to PDF
    downloadPdf: function downloadPdf() {
      var _this5 = this;

      axios.get("api/downloadpdfadmin", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        },
        params: {
          startDate: this.year + "-" + (this.date.getMonth() + 1) + "-" + this.cut_off_start,
          lastDate: (this.date.getMonth() + 1 === 12 && this.cut_off_end === 10 ? this.year + 1 : this.year) + "-" + (this.cut_off_end === 10 ? this.date.getMonth() + 1 === 12 ? 1 : this.date.getMonth() + 2 : this.date.getMonth() + 1) + "-" + this.cut_off_end,
          subDepartmentId: this.department
        },
        responseType: 'arraybuffer'
      }).then(function (resp) {

        //VIEW PDF ONLY   
        //  let blob = new Blob([resp.data], { type: 'application/pdf' }),
        //  url = window.URL.createObjectURL(blob)
        //  window.open(url)

        //DOWNLOAD PDF
        var blob = new Blob([resp.data], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "time-attendance-log-" + (_this5.date.getMonth() + 1) + "-" + _this5.year + ".pdf";
        link.click();
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDaysInNextMonth: function getDaysInNextMonth() {
      this.noOfDays = new Date(this.date.getFullYear(), this.date.getMonth() + 2, 0).getDate();
      this.date.setMonth(this.date.getMonth() + 1);
      this.month = this.date.getMonth();
      this.year = this.date.getFullYear();
      this.month = this.months[this.date.getMonth()];
      this.employeeCount = 10;
      this.currentPage = 1;
      this.weeks = 7 - new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
      this.weekNumber = 1;
    },
    getDaysInPrevMonth: function getDaysInPrevMonth() {
      this.noOfDays = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();
      this.date.setMonth(this.date.getMonth() - 1);
      this.month = this.date.getMonth();
      this.year = this.date.getFullYear();
      this.month = this.months[this.date.getMonth()];
      this.employeeCount = 10;
      this.currentPage = 1;
      this.weeks = 7 - new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
      this.weekNumber = 1;
    },
    toggleTooltip: function toggleTooltip(id) {
      if (this.tooltip === false) {
        setTimeout(function () {
          return document.getElementById("tooltip" + id).style.display = "inline-block";
        }, 500);
        setTimeout(function () {
          return document.getElementById("tooltip" + id).style.zIndex = "999";
        }, 500);
      } else {
        setTimeout(function () {
          return document.getElementById("tooltip" + id).style.display = "none";
        }, 500);
      }
      this.tooltip = !this.tooltip;
    },
    showEditLogs: function showEditLogs(id) {
      var elements = document.getElementsByClassName("logEntry" + id);

      var _loop = function _loop(element) {
        setTimeout(function () {
          return element.style.display = "none";
        }, 500);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          _loop(element);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var elements2 = document.getElementsByClassName("logEntryInput" + id);

      var _loop2 = function _loop2(element2) {
        setTimeout(function () {
          return element2.style.display = "inline-block";
        }, 500);
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements2), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element2 = _step2.value;

          _loop2(element2);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    closeEditLogs: function closeEditLogs(id) {
      document.getElementById("timeInLog" + id).innerHTML = document.getElementById("timeIn" + id).value !== '' ? this.formatAMPM(document.getElementById("timeIn" + id).value) : '--:--', document.getElementById("timeOutLog" + id).innerHTML = document.getElementById("timeOut" + id).value !== '' ? this.formatAMPM(document.getElementById("timeOut" + id).value) : '--:--', document.getElementById("firstBreakOutLog" + id).innerHTML = document.getElementById("firstBreakOut" + id).value !== '' ? this.formatAMPM(document.getElementById("firstBreakOut" + id).value) : '--:--';
      document.getElementById("firstBreakInLog" + id).innerHTML = document.getElementById("firstBreakIn" + id).value !== '' ? this.formatAMPM(document.getElementById("firstBreakIn" + id).value) : '--:--', document.getElementById("lunchBreakOutLog" + id).innerHTML = document.getElementById("lunchBreakOut" + id).value !== '' ? this.formatAMPM(document.getElementById("lunchBreakOut" + id).value) : '--:--', document.getElementById("lunchBreakInLog" + id).innerHTML = document.getElementById("lunchBreakIn" + id).value !== '' ? this.formatAMPM(document.getElementById("lunchBreakIn" + id).value) : '--:--', document.getElementById("secondBreakOutLog" + id).innerHTML = document.getElementById("secondBreakOut" + id).value !== '' ? this.formatAMPM(document.getElementById("secondBreakOut" + id).value) : '--:--', document.getElementById("secondBreakInLog" + id).innerHTML = document.getElementById("secondBreakIn" + id).value !== '' ? this.formatAMPM(document.getElementById("secondBreakIn" + id).value) : '--:--', document.getElementById("updateReasonLog" + id).innerHTML = document.getElementById("updateReason" + id).value !== '' ? document.getElementById("updateReason" + id).value : '';

      var elements = document.getElementsByClassName("logEntry" + id);

      var _loop3 = function _loop3(element) {
        setTimeout(function () {
          return element.style.display = "inline-block";
        }, 500);
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var element = _step3.value;

          _loop3(element);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var elements2 = document.getElementsByClassName("logEntryInput" + id);

      var _loop4 = function _loop4(element2) {
        setTimeout(function () {
          return element2.style.display = "none";
        }, 500);
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements2), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var element2 = _step4.value;

          _loop4(element2);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    assignEmployee: function assignEmployee(employee) {
      this.employeeModal = employee;
    },
    paginateNextWeek: function paginateNextWeek() {
      var oldAddedDays = this.addedDays;
      var flag = 0;
      if (this.weeks !== 7 && this.addedDays / 7 < 4) {
        this.addedDays = this.addedDays + this.weeks;
        this.weeks = 7;
        flag = 1;
      }
      if (this.noOfDays - (this.addedDays + 7) < 7 && this.noOfDays - (this.addedDays + 7) > 0) {
        this.addedDays = this.addedDays + 7;
        this.weeks = this.noOfDays - this.addedDays;
      }
      if (this.addedDays + 7 < this.noOfDays && this.weeks === 7 && flag !== 1) {
        this.addedDays = this.addedDays + 7;
      }
      if (oldAddedDays !== this.addedDays) {
        this.weekNumber = this.weekNumber + 1;
      }
    },
    paginatePrevWeek: function paginatePrevWeek() {
      var oldAddedDays = this.addedDays;
      if (this.addedDays / 7 >= 4) {
        this.weeks = 7;
      }
      if (this.addedDays < 7 && this.addedDays !== 0) {
        this.addedDays = 0;
        this.weeks = 7 - new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
      }
      if (this.addedDays - 7 >= 0) {
        this.addedDays = this.addedDays - 7;
      }
      if (oldAddedDays !== this.addedDays) {
        this.weekNumber = this.weekNumber - 1;
      }
    },
    saveEditLogs: function saveEditLogs(logId, subDepartmentId, index) {
      var _this6 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes.',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/updateindividualattendanceinfo', {
            id: logId,
            sub_department_id: subDepartmentId,
            time_in: document.getElementById("timeIn" + index).value !== '' ? document.getElementById("timeIn" + index).value : '00:00',
            time_out: document.getElementById("timeOut" + index).value !== '' ? document.getElementById("timeOut" + index).value : '00:00',
            first_break_out: document.getElementById("firstBreakOut" + index).value !== '' ? document.getElementById("firstBreakOut" + index).value : '00:00',
            first_break_in: document.getElementById("firstBreakIn" + index).value !== '' ? document.getElementById("firstBreakIn" + index).value : '00:00',
            lunch_break_out: document.getElementById("lunchBreakOut" + index).value !== '' ? document.getElementById("lunchBreakOut" + index).value : '00:00',
            lunch_break_in: document.getElementById("lunchBreakIn" + index).value !== '' ? document.getElementById("lunchBreakIn" + index).value : '00:00',
            second_break_out: document.getElementById("secondBreakOut" + index).value !== '' ? document.getElementById("secondBreakOut" + index).value : '00:00',
            second_break_in: document.getElementById("secondBreakIn" + index).value !== '' ? document.getElementById("secondBreakIn" + index).value : '00:00',
            update_reason: document.getElementById("updateReason" + index).value !== '' ? document.getElementById("updateReason" + index).value : ''
          }).then(function (response) {
            _this6.$swal({
              type: 'success',
              title: 'Saved',
              text: 'You successfully saved your changes',
              showConfirmButton: false,
              timer: 5000
            });
            _this6.closeEditLogs(index);
          }).catch(function (e) {
            console.log(e.response);
          });
        }
      });
    },
    saveNewLogs: function saveNewLogs(empId, attDate, subDepartmentId, index) {
      var _this7 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes.',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/createindividualattendanceinfo', {
            emp_id: empId,
            att_date: attDate,
            sub_department_id: subDepartmentId,
            update_reason: document.getElementById("updateReason" + index).value !== '' ? document.getElementById("updateReason" + index).value : ''
          }).then(function (response) {
            _this7.$swal({
              type: 'success',
              title: 'Saved',
              text: 'You successfully saved your changes',
              showConfirmButton: false,
              timer: 5000
            });
            _this7.closeEditLogs(index);
          }).catch(function (e) {
            console.log(e.response);
          });
        }
      });
    }
  },
  computed: {}
});

/***/ }),

/***/ "lbNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Job Information")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/jobinformation"}},[_vm._v("Job Information")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Details")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"float-right",on:{"click":function($event){_vm.printItem()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v("Print Preview")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{attrs:{"id":"printMe"}},[_c('div',{staticClass:"report-container"},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"report-header"},[_c('center',[_vm._v("EMPLOYEE JOB INFORMATION")])],1)]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Name:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.first_name))+" , "+_vm._s(_vm._f("capitalize")(_vm.item.last_name)))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Department:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Number:")]),_vm._v(" "+_vm._s(_vm.item.emp_id))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Position:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employment Date:")]),_vm._v(" "),(_vm.item.employment_date === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.employment_date)))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Signed Date:")]),_vm._v(" "),(_vm.item.date_signed === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.date_signed)))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Training Date:")]),_vm._v(" \n                    From - "),(_vm.item.training_start === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.training_start)))]),_vm._v("\n                    To - "),(_vm.item.training_end === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.training_end)))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Basic Salary:")]),_vm._v(" "),_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(_vm.item.basic_salary)))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Monthly Allowance:")]),_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(_vm.item.monthly_allowance)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Resignation Date:")]),_vm._v(" "),(_vm.item.resignation_date === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.resignation_date)))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Termination Date:")]),_vm._v(" _______________________")]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Regularization Date")]),_vm._v(" "),(_vm.item.regularization_date === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.getDate(_vm.item.regularization_date)))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Promoted Date:")]),_vm._v(" "),(_vm.item.promoted_date === null)?_c('span',[_vm._v("_______________________")]):_c('span',[_vm._v(_vm._s(_vm.item.promoted_date))])]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Blueprint Status:")]),_vm._v(" "+_vm._s(_vm.item.status))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Note / Reason:")]),_c('br'),_vm._v("\n            "+_vm._s(_vm.item.note)),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),(_vm.item.experience !== null)?_c('div',[_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"report-header"},[_c('center',[_vm._v("WORK EXPERIENCE")])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_vm._l((_vm.item.experience),function(exp,i){return _c('span',[_c('p',[_c('b',[_vm._v("From :")]),_vm._v(" "+_vm._s(_vm.getDate(exp.start_date))+" "),_c('b',[_vm._v("To :")]),_vm._v(_vm._s(_vm.getDate(exp.end_date)))]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',[_c('b',[_vm._v("Employeer:")]),_vm._v(" "+_vm._s((exp.employeer)))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Company Address:")]),_vm._v(" "+_vm._s(exp.company_address))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',[_c('b',[_vm._v("Position:")]),_vm._v(" "+_vm._s(exp.job_title))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Salary:")]),_vm._v(" "),_c('span',[_vm._v("₱")]),_vm._v(_vm._s(_vm.formatMoney(exp.previous_salary)))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Reason to leave:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(exp.reason_for_leaving))])]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0003")])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lgxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Undertime Form")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Undertime Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Employee Name")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Employee Undertime Request")]),_vm._v(" "),_c('div',{staticClass:"border-box-undertime"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Filled:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_filled),expression:"date_filled"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_filled },attrs:{"type":"date"},domProps:{"value":(_vm.date_filled)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_filled=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_filled)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_filled[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of Undertime:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_of_undertime),expression:"date_of_undertime"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_of_undertime },attrs:{"type":"date"},domProps:{"value":(_vm.date_of_undertime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_of_undertime=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_of_undertime)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_of_undertime[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Total Hours:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.total_hours),expression:"total_hours"},{name:"mask",rawName:"v-mask",value:(['#']),expression:"['#']"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.total_hours },attrs:{"type":"text"},domProps:{"value":(_vm.total_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.total_hours=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.total_hours)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.total_hours[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Purpose")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.purpose),expression:"purpose"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.purpose },attrs:{"rows":"8"},domProps:{"value":(_vm.purpose)},on:{"input":function($event){if($event.target.composing){ return; }_vm.purpose=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.purpose)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.purpose[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Approval Status")]),_vm._v(" "),_c('div',{staticClass:"border-box-undertime"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_status),expression:"tl_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tl_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.tl_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_status),expression:"asm_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.asm_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.asm_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_status[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_status),expression:"hr_status"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_status },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.hr_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One--")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("pending")]),_vm._v(" "),_c('option',{attrs:{"value":"approved"}},[_vm._v("approved")]),_vm._v(" "),_c('option',{attrs:{"value":"rejected"}},[_vm._v("rejected")])]),_vm._v(" "),(_vm.error_handler.hr_status)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_status[0]))]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Supervisor Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tl_date_approved),expression:"tl_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.tl_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.tl_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tl_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.tl_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.tl_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Departamental Head Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.asm_date_approved),expression:"asm_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.asm_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.asm_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.asm_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.asm_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.asm_date_approved[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("HR Date Approval")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_date_approved),expression:"hr_date_approved"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_date_approved },attrs:{"type":"date"},domProps:{"value":(_vm.hr_date_approved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hr_date_approved=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hr_date_approved)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_date_approved[0]))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ls7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-responsibility')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lsma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_add_calendar_event__ = __webpack_require__("qpH5");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        addCalendarEvent: __WEBPACK_IMPORTED_MODULE_0__todo_add_calendar_event__["a" /* default */]
    }
});

/***/ }),

/***/ "m8T4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_leave_vue__ = __webpack_require__("ki6z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1509f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_leave_vue__ = __webpack_require__("rorq");
function injectStyle (ssrContext) {
  __webpack_require__("B4jD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_view_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1509f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_view_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mCjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_notice_for_decision__ = __webpack_require__("ODqr");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        noticeForDecision: __WEBPACK_IMPORTED_MODULE_0__todo_notice_for_decision__["a" /* default */]
    }
});

/***/ }),

/***/ "mDwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            item: '',
            responsibility: [{
                name: '',
                description: '',
                received: '',
                quantity: ''
            }]

        };
    },

    mounted: function mounted() {
        this.getEmployeeResponsibility();
    },
    methods: {
        new_field: function new_field() {
            this.responsibility.push({
                name: '',
                description: '',
                received: '',
                quantity: ''
            });
        },


        remove_field: function remove_field(index) {
            console.log(index);
            console.log(this.finds);
            this.responsibility.splice(index, 1);
            if (index === 0) this.add_form();
        },

        getEmployeeResponsibility: function getEmployeeResponsibility() {
            var _this = this;

            axios.get('api/responsibilitymodify/get/' + this.$route.params.id).then(function (response) {
                _this.item = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        update_responsibility_info: function update_responsibility_info(e) {
            var _this2 = this;

            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to save changes.',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.post('api/responsibility/update/' + _this2.item.id, {
                        //Update responsibilities
                        responsibility: _this2.item.responsibility
                    }).then(function (response) {
                        _this2.$swal({
                            type: 'success',
                            title: 'Save',
                            text: 'You successfully save changes',
                            showConfirmButton: false,
                            timer: 2000
                        });

                        _this2.$router.push({
                            name: 'responsibility-form'
                        });
                        console.log(response.data);
                    }).catch(function (e) {
                        console.log(e.response);
                    });
                }
            });
        }
    }

});

/***/ }),

/***/ "mIL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    var _ref;

    return _ref = {
      files: [],
      //items
      employees: [],
      infraction_item: [],
      // error
      error_handler: [],
      selected_item: [],
      //input
      employee_id: '',
      details_of_occurence: [{
        date: '',
        detail: ''
      }],
      nteFiles: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'files', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'date_incident', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'date_request', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'date_incident', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'action_to_be_taken', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'type_of_infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'details_of_infraction', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'corrective', ''), _ref;
  },


  mounted: function mounted() {
    this.get_employees();
  },

  methods: {
    get_selected_id: function get_selected_id(item) {
      this.selected_item = item;
    },
    get_previous_infraction: function get_previous_infraction() {
      var _this = this;

      axios.post('api/infraction/find', {
        id: this.employee_id,
        type_of_infraction: this.type_of_infraction
      }).then(function (resp) {
        _this.infraction_item = resp.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    dismissal: function dismissal() {
      if (this.corrective == 'dismissal') {
        this.action_to_be_taken = 'Dismissal';
      }
    },

    add_form: function add_form() {
      this.details_of_occurence.push({
        date: '',
        detail: ''
      });
    },

    delete_form: function delete_form(index) {
      this.details_of_occurence.splice(index, 1);
      if (index === 0) this.add_form();
    },

    get_employees: function get_employees() {
      var _this2 = this;

      axios.get('api/active/employee').then(function (response) {
        _this2.employees = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },


    //FILE UPLOAD
    handleNteFilesUpload: function handleNteFilesUpload() {
      var uploadedNTEFiles = event.target.files;
      if (!uploadedNTEFiles.length) return;
      for (var i = 0; i < uploadedNTEFiles.length; i++) {
        this.nteFiles.push(uploadedNTEFiles[i]);
      }
      console.log('response => ', uploadedNTEFiles);
    },
    removenteFilesUpload: function removenteFilesUpload(key) {
      this.nteFiles.splice(key, 1);
    },
    resetData: function resetData() {
      this.data = new FormData();
      this.files = [];
      this.infraction_item = [];
      this.error_handler = [], this.employee_id = '';
      this.date_request = '';
      this.requested_by = '';
      this.date_incident = '';
      this.details_occurence = '';
      this.type_of_infraction = '';
      this.action_to_be_taken = '';
      this.details_of_infraction = '';
      this.details_of_occurence = [{
        'date': '',
        'detail': ''
      }];
    },
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to submit this request',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {

          //Form data a files to upload
          var formData = new FormData();
          for (var i = 0; i < _this3.nteFiles.length; i++) {
            var file = _this3.nteFiles[i];
            formData.append('files[' + i + ']', file);
          }
          //Additional POST Request
          formData.append('employee_id', _this3.employee_id);
          formData.append('requested_by', _this3.requested_by);
          formData.append('date_request', _this3.date_request);
          formData.append('date_incident', _this3.date_incident);
          formData.append('details_occurence', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.details_of_occurence));
          formData.append('type_of_infraction', _this3.type_of_infraction);
          formData.append('action_to_be_taken', _this3.action_to_be_taken);
          formData.append('details_of_infraction', _this3.details_of_infraction);
          axios.post('api/nterequestbyhr/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this3.$swal('Success', 'You successfully submitted this request.', 'success');
            _this3.$router.push({
              name: 'nte-request'
            });
            _this3.resetData();
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this3.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {}

});

/***/ }),

/***/ "mIi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            item: {},
            emp_id: '',
            full_name: '',
            document_type: '',
            memoFiles: [],
            files: {},
            uploadReady: true,
            //INPUT
            file_added: '',
            error_handler: []
        };
    },
    mounted: function mounted() {
        this.getInfo();
        this.getItem();
    },

    methods: {
        getCurentUser: function getCurentUser() {
            var _this = this;

            axios.get('api/user', {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            }).then(function (response) {
                _this.currentUser = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        getInfo: function getInfo() {
            var _this2 = this;

            axios.get('api/contractsmemo/getinfo/' + this.$route.params.id).then(function (resp) {
                _this2.item = resp.data;
            });
        },
        getItem: function getItem() {
            var _this3 = this;

            axios.get('api/contractsmemo/getmemoinfo/' + this.$route.params.id).then(function (resp) {
                _this3.files = resp.data;
            });
        },
        openFileDialog: function openFileDialog() {
            this.$refs.files.click(); // Opens the hidden file input
        },


        //FILE UPLOAD
        handleFileMemosUpload: function handleFileMemosUpload() {
            var uploadedContractFiles = event.target.files;
            if (!uploadedContractFiles.length) return;
            for (var i = 0; i < uploadedContractFiles.length; i++) {
                this.memoFiles.push(uploadedContractFiles[i]);
            }
            console.log('response => ', uploadedContractFiles);
        },
        removeMemoFilesUpload: function removeMemoFilesUpload(key) {
            this.memoFiles.splice(key, 1);
        },


        /*
        |----------------------------------------------------------------------
        |  TO SUBMIT FORM 
        |----------------------------------------------------------------------
        */
        formSubmit: function formSubmit() {
            var _this4 = this;

            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to upload these documents',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    //Form data a files to upload
                    var formData = new FormData();
                    if (_this4.memoFiles.length > 0) {
                        for (var i = 0; i < _this4.memoFiles.length; i++) {
                            var file = _this4.memoFiles[i];
                            formData.append('files[' + i + ']', file);
                            //   console.log(formData);
                        }
                    } else {
                        _this4.$swal({
                            title: 'Empty document!',
                            text: 'Please upload at least one document',
                            type: 'error',
                            showCloseButton: false
                        });
                        return;
                    }
                    //Additional POST Request
                    formData.append('employee_id', _this4.item.id);
                    formData.append('employee_name', _this4.item.full_name);
                    formData.append('document_type', 'memo');

                    //HTTP POST Request
                    axios.post('api/uploadmemoscontracts/multiple', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: "Bearer " + localStorage.getItem("token")
                        }
                    }).then(function (resp) {
                        _this4.$swal('Success', 'Your request has been successfully submitted', 'success');
                        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
                    }).catch(function (error) {
                        if (error.response.status == 422) {
                            _this4.error_handler = error.response.data.errors;
                        }
                        console.log('response => ', error.response);
                    });
                }
            });
        }
    },
    computed: {
        filePreview: function filePreview() {
            var data = window.axios.defaults.baseURL + '/upload/';
            return data;
        }
    }
});

/***/ }),

/***/ "mKpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Calendar")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Calendar")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"holidays"}},[_vm._v("Calendar Event")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('full-calendar',{attrs:{"event-sources":_vm.eventSources,"config":_vm.config}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mcnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },

   data: function data() {
      return {
         //input
         employee_id: '',
         date_filled: '',
         date_of_request: '',
         current_shift: '',
         requested_shift: '',
         reason_for_change: '',
         tl_status: '',
         asm_status: '',
         hr_status: '',
         tl_date_approved: '',
         asm_date_approved: '',
         hr_date_approved: '',
         employees: [],
         // Errors handler
         error_handler: [],

         sched_item: ''
      };
   },


   mounted: function mounted() {
      this.get_employees();
      this.selected_employee();
   },

   methods: {
      get_employees: function get_employees() {
         var _this = this;

         axios.get('api/employeeworkshift').then(function (response) {
            _this.employees = response.data;
         }).catch(function (error) {
            console.log(error.response);
         });
      },
      selected_employee: function selected_employee() {
         var _this2 = this;

         var data = '';

         if (this.employee_id == 1) {
            data = 1;
         } else {
            axios.get('api/getcurrentshift/get/' + this.employee_id).then(function (response) {
               _this2.sched_item = response.data;console.log(_this2.sched_item);
            }).catch(function (error) {
               console.log(error);
            });
         }

         console.log(data);
      },
      formSubmit: function formSubmit(e) {
         var _this3 = this;

         e.preventDefault();
         this.$swal({
            title: 'Are you sure?',
            text: 'Do you want to save',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false
         }).then(function (isConfirm) {
            if (isConfirm === true) {
               axios.post('api/scheduleadjustment/add', {
                  // ADJUSTMENT 
                  employee_id: _this3.employee_id,
                  date_filled: _this3.date_filled,
                  date_of_request: _this3.date_of_request,
                  current_shift: _this3.sched_item.time,
                  requested_shift: _this3.requested_shift,
                  reason_for_change: _this3.reason_for_change,
                  tl_status: _this3.tl_status,
                  asm_status: _this3.asm_status,
                  hr_status: _this3.hr_status,
                  tl_date_approved: _this3.tl_date_approved,
                  asm_date_approved: _this3.asm_date_approved,
                  hr_date_approved: _this3.hr_date_approved

               }).then(function (resp) {
                  _this3.$swal('Save', 'You successfully save this file', 'success');
                  _this3.$router.push({
                     name: 'schedule-adjustment'
                  });
               }).catch(function (error) {
                  if (error.response.status == 422) {
                     _this3.error_handler = error.response.data.errors;
                  }
                  console.log('response => ', error.response);
               });
            }
         });
      }
   },
   computed: {},

   filters: {
      capitalize: function capitalize(value) {
         if (!value) return '';
         value = value.toString();
         //return value.charAt(0).toUpperCase() + value.slice(1); -> capitalize first 
         return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
         }); // -> capitalize each first words
      }
   }

});

/***/ }),

/***/ "mkiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_create_roles__ = __webpack_require__("iHIL");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        createRoles: __WEBPACK_IMPORTED_MODULE_0__todo_create_roles__["a" /* default */]
    }
});

/***/ }),

/***/ "mwS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_va_us__ = __webpack_require__("PX2J");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosVaUs: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_va_us__["a" /* default */]
    }
});

/***/ }),

/***/ "mzyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_dependents_vue__ = __webpack_require__("sIbg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75df56c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_dependents_vue__ = __webpack_require__("2VMc");
function injectStyle (ssrContext) {
  __webpack_require__("SuRq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_dependents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75df56c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_dependents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n+rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            items: {},
            search: '',
            loading: true,
            //Indicator
            display_indicator: ''
        };
    },

    mounted: function mounted() {
        this.get_responsibility();
    },
    methods: {
        get_responsibility: function get_responsibility() {
            var _this = this;

            axios.get('api/responsibility').then(function (response) {
                _this.items = response.data;
                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.items));
                _this.display_indicator = 2;
                _this.loading = false;
            }).catch(function (error) {
                console.log(error.response);
                _this.display_indicator = 1;
            });
        },
        deleteItem: function deleteItem(id, i) {
            var _this2 = this;

            /* USING SWEET ALERT */

            this.$swal({
                title: 'Are you sure?',
                text: 'You can\'t revert your action',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes Delete it!',
                cancelButtonText: 'No, Keep it!',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.delete('api/responsibility/delete/' + id).then(function (response) {
                        // this.items.splice(index, 1); //--> reloader 
                        _this2.get_responsibility();
                        _this2.$swal('Deleted', 'You successfully deleted this file', 'success');
                    }).catch(function (response) {
                        //alert("error");
                        console.log(response.response);
                        _this2.$swal('Error Code', 'Review your code', 'error');
                    });
                }
            });
        }
    },
    computed: {
        computedResponsibility: function computedResponsibility() {
            var _this3 = this;

            // SEARCH BY EMPLOYEE FULLNAME
            var filtered = this.items;
            if (filtered.length > 0) {
                if (this.search) {
                    filtered = filtered.filter(function (item) {
                        return item.full_name.toLowerCase().indexOf(_this3.search) > -1;
                    });
                    return filtered;
                }
            }
            return filtered;
        }
    }

});

/***/ }),

/***/ "n13/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Upload Payslip")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/payslip/"}},[_vm._v("Employee Payslip")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Upload Payslip")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Employee Information")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"payslip-border"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Employee Name")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.full_name}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Employee No ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.emp_id}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Position")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.position_name}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Department")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.department_name}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Date Hired")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.employment_date}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row alert alert-info",attrs:{"role":"alert"}},[_c('p',{staticClass:"pt-2"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("Notes: Upload generated payslip PDFs with the correct pay date to ESS system so employees can securely view and download their payslips online. ")])])]),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-table"}),_vm._v(" Upload Payslip")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("(*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"payslip-border"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.uploadPayslip($event)}}},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                        Upload Payslip for "),_c('b',[_vm._v(_vm._s(_vm.item.full_name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_c('b',[_vm._v("Pay Date")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pay_date),expression:"pay_date"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.pay_date },attrs:{"type":"date"},domProps:{"value":(_vm.pay_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pay_date=$event.target.value}}}),_vm._v(" "),(_vm.error_handler && _vm.error_handler.pay_date)?_c('span',{staticClass:"invalid-feedback d-block"},[_vm._v("\n                            "+_vm._s(_vm.error_handler.pay_date[0])+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"float-right mt-2"},[_c('b',[_vm._v("Attach Payslip")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"docFileUpload"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("Upload file")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"docFileUpload"},on:{"change":_vm.payslipFiles}}),_vm._v(" "),_vm._l((_vm.error_handler.files),function(item){return _c('span',[_c('li',{staticClass:"invalid-feedback d-block"},[_vm._v(_vm._s(item))])])})],2),_vm._v(" "),_c('div',{staticClass:"col-sm-2 mt-2"},[(_vm.files != '')?[_c('div',{staticClass:"gallery-item"},[_c('div',{staticClass:"gallery-caption"},[(_vm.docFileName)?_c('span',{staticClass:"text-black"},[_vm._v(_vm._s(_vm.docFileName))]):_vm._e(),_c('br'),_vm._v(" "),(_vm.docFileSize)?_c('span',{staticClass:"text-black-50"},[_vm._v(_vm._s(_vm.docFileSize)+" KB")]):_vm._e(),_vm._v("  \n                                  "),_c('button',{staticClass:"btn btn-xs btn-default",attrs:{"type":"button"},on:{"click":_vm.removePayslipFiles}},[_c('i',{staticClass:"fa fa-trash text-black"})])])])]:[_c('p',[_vm._v("No file selected.")])]],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary float-right"},[_c('i',{staticClass:"fa fa-paper-plane"}),_vm._v(" Submit Payslip")])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-list"}),_vm._v(" Payslip History")]),_vm._v(" "),_c('div',{staticClass:"payslip-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{staticClass:"table table-striped table-hover "},[_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[_c('td',[(item.status ==='1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b',[_c('i',{staticClass:"fa fa-star",staticStyle:{"color":"darkorange"}}),_vm._v("    Payslip sent to "+_vm._s(item.full_name)+",  Pay Date for "+_vm._s(_vm.getDate(item.pay_date)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('span',{staticClass:"float-right"},[_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/payslip/' + item.files,"target":"_blank"}},[_vm._v("\n                                        View Payslip\n                                      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('span',{staticClass:"float-right"},[_c('small',[_vm._v(_vm._s(_vm.getDate(item.created_at)))])])])])]:(item.status='2')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('i',{staticClass:"fa fa-star-o",staticStyle:{"color":"darkorange"}}),_vm._v("    Payslip sent to "+_vm._s(item.full_name)+",  Pay Date for "+_vm._s(_vm.getDate(item.pay_date))+" \n                                 ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('span',{staticClass:"float-right"},[_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/payslip/' + item.files,"target":"_blank"}},[_vm._v("\n                                         View Payslip\n                                      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('span',{staticClass:"float-right"},[_c('small',[_vm._v(_vm._s(_vm.getDate(item.created_at)))])])])])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-xs btn-danger float-right",on:{"click":function($event){_vm.removePayslip(item.id)}}},[_c('i',{staticClass:"fa fa-times"})])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])])],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n2B/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_edit_request_vue__ = __webpack_require__("Fz/z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c14a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_edit_request_vue__ = __webpack_require__("B7wY");
function injectStyle (ssrContext) {
  __webpack_require__("e/3l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_edit_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c14a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_edit_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n2kJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to CD-HW")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To CD-HW")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to CD-HW")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                         "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                      "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n41B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_responsibility_vue__ = __webpack_require__("mDwX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7640bdf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_responsibility_vue__ = __webpack_require__("arTC");
function injectStyle (ssrContext) {
  __webpack_require__("OtM5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7640bdf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nFlr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_sub_department_vue__ = __webpack_require__("StJH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37724c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_sub_department_vue__ = __webpack_require__("tIxm");
function injectStyle (ssrContext) {
  __webpack_require__("fXN8")
  __webpack_require__("P7tw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_sub_department_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37724c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_sub_department_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nVyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
   components: {
      Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
   },
   data: function data() {
      return {
         items: [],
         positions: [],
         selected_user: '',
         search: '',
         supervisor: [],
         filter_by_position: '',
         filter_by_status: '',
         order_by: '',
         subtitute_id: '',
         page_limit: '',
         start_page: 1,
         display_indicator: '',
         loading: true,
         superior_name: {},
         member_item: [],
         //PAGINATION
         perPage: 200,
         curentPage: 1,
         others_salary: "",
         others_allowance: ""
      };
   },

   mounted: function mounted() {
      this.get_jobinformation();
      this.get_positions();
   },
   methods: {
      /**
       * GET SUPERIOR NAME BASED ON DROWPDOWN SELECTION ON MODAL
       */
      get_superiorname: function get_superiorname() {
         var _this = this;

         axios.get('api/superiorname/get/' + this.subtitute_id).then(function (resp) {
            _this.superior_name = resp.data;
         }).catch(function (error) {
            console.log(error);
         });
      },

      /**
       * UPDATE SUPERIOR ROLES AND JOBINFORMATION 
       */
      update_supervisor: function update_supervisor() {
         var _this2 = this;

         if (this.subtitute_id != '') {
            axios.post('api/superiorroles/update/' + this.selected_user.emp_id, {
               'subtitute_id': this.subtitute_id,
               'superior_name': this.superior_name.full_name,
               'status': this.selected_user.status
            }).then(function (resp) {
               if (resp.data.response == 'success') {
                  _this2.$swal({ 'title': 'Save', text: resp.data.message, type: 'success', timer: 2000, showConfirmButton: true });
                  _this2.$refs['hide-modal-job-information'].hide();
                  _this2.$refs['get_supervisor'].hide();
                  _this2.get_jobinformation();
               } else if (resp.data.response == 'error') {
                  _this2.$swal({ 'title': 'Oops', text: resp.data.message, type: 'error', showConfirmButton: true });
               }
            }).catch(function (error) {
               console.log(error);
            });
         } else {
            this.$swal({ 'title': 'Oops', text: 'Please select supervisor to subtitute.', type: 'error', showConfirmButton: true });
         }
      },


      /**
       * IF RESIGNED AND ROLE IS 2 THE MODAL WILL POP UP 
       */
      supervisor_subtitute: function supervisor_subtitute() {
         var _this3 = this;

         if ((this.selected_user.status == 'resigned' || this.selected_user.status == 'awol' || this.selected_user.status == 'terminated') && this.member_item.length != 0) {
            if (this.selected_user.resignation_date != null) {
               this.$refs['get_supervisor'].show();
               axios.get('api/supervisor/get/' + this.selected_user.emp_id).then(function (resp) {
                  _this3.supervisor = resp.data;
               }).catch(function (error) {
                  console.log(error.response);
               });
               this.$refs['get_supervisor'].show();
            } else {
               this.$swal({ 'title': 'Opps', text: 'Please input or select Resignation date to proceed.', type: 'error', timer: 3000, showConfirmButton: true });
               this.selected_user.status = 'regular';
            }
         }
      },


      /**
      * GET JOBINFORMATION
      */
      get_jobinformation: function get_jobinformation() {
         var _this4 = this;

         axios.get('api/jobinformation').then(function (response) {
            _this4.items = response.data;
            _this4.display_indicator = 2;
            _this4.loading = false;
         }).catch(function (e) {
            console.log(e.response);
            _this4.display_indicator = 1;
         });
      },

      /**
       * GET POSITIONS
       */
      get_positions: function get_positions() {
         var _this5 = this;

         axios.get('api/positions').then(function (response) {
            _this5.positions = response.data;
         }).catch(function (e) {
            console.log(e.response);
         });
      },
      get_selected_id: function get_selected_id(item) {
         var _this6 = this;

         this.selected_user = item;
         axios.get('api/checkmember/' + this.selected_user.emp_id).then(function (resp) {
            _this6.member_item = resp.data;
         }).catch(function (error) {
            console.log(error.response);
         });
      },

      /**
       * UPDATE JOB INFORMATION RECORD
       */
      update_job_information: function update_job_information(e) {
         var _this7 = this;

         e.preventDefault();
         this.$swal({
            title: 'Are you sure?',
            text: 'Do you want to  update this record.',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false
         }).then(function (isConfirm) {
            if (isConfirm === true) {
               //--> HTTP POST REQUEST 
               axios.post('api/jobinformation/update/' + _this7.selected_user.id, {
                  'employee_id': _this7.selected_user.emp_id,
                  'employment_date': _this7.selected_user.employment_date,
                  'date_signed': _this7.selected_user.date_signed,
                  'regularization_date': _this7.selected_user.regularization_date,
                  'training_start': _this7.selected_user.training_start,
                  'training_end': _this7.selected_user.training_end,
                  'resignation_date': _this7.selected_user.resignation_date,
                  'promoted_date': _this7.selected_user.promoted_date,
                  'basic_salary': _this7.selected_user.basic_salary,
                  'status': _this7.selected_user.status,
                  'monthly_allowance': _this7.selected_user.monthly_allowance,
                  'note': _this7.selected_user.note
               }).then(function (resp) {
                  if (resp.data.response == 'success') {
                     _this7.$swal({ 'title': 'Updated', text: resp.data.message, type: 'success', timer: 2000, showConfirmButton: true });
                     _this7.$refs['hide-modal-job-information'].hide();
                     _this7.get_jobinformation();
                  } else if (resp.data.response == 'error') {
                     _this7.$swal({ 'title': 'Opps', text: resp.data.message, type: 'error', timer: 3000, showConfirmButton: true });
                  }
               }).catch(function (error) {
                  console.log(error);
               });
               //--> END HTTP POST REQUEST   
            }
         });
      }
   },

   computed: {
      offset: function offset() {
         return (this.start_page - 1) * this.page_limit;
      },
      limit: function limit() {
         return this.offset + this.page_limit;
      },
      total_item: function total_item() {
         return this.items.length;
      },
      computedJobInformation: function computedJobInformation() {
         var _this8 = this;

         var filtered = this.items;
         // USE IN PAGINATION 
         var start = (this.curentPage - 1) * this.perPage;
         var end = this.curentPage * this.perPage;
         filtered = filtered.slice(start, end);

         if (filtered.length > 0) {
            // SEARCH BY EMPLOYEE FULLNAME
            if (this.search) {
               filtered = filtered.filter(function (item) {
                  return item.full_name.toLowerCase().indexOf(_this8.search) > -1;
               });
               return filtered;
            }
            // FILTER BY POSITION
            if (this.filter_by_position) {
               filtered = filtered.filter(function (item) {
                  return item.position_name.toLowerCase() === _this8.filter_by_position.toLowerCase();
               });
               return filtered;
            }
            // ORDER BY ASC AND DESC COMBOBOX
            if (this.order_by) {
               filtered = filtered.slice(0).sort(function (a, b) {
                  return a.full_name < b.full_name ? _this8.order_by : -_this8.order_by;
               });
               return filtered;
            }
            // SORTING NUMBER OF DISPLAY
            if (this.page_limit) {
               filtered = filtered.slice(this.offset, this.limit);
               return filtered;
            }
            // FILTER BY STATUS
            if (this.filter_by_status) {
               filtered = filtered.filter(function (item) {
                  return item.status.toLowerCase() === _this8.filter_by_status.toLowerCase();
               });
               return filtered;
            }
         }
         return filtered;
      }
   },

   watch: {
      subtitute_id: function subtitute_id(val) {
         console.log(val);
      }
   }
});

/***/ }),

/***/ "ngpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      order_by: '',
      //PAGINATION
      page_limit: '',
      filter_by_year: '',
      start_page: 1,
      loading: true,
      perPage: 1000,
      curentPage: 1,
      search: ''
    };
  },


  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  beforeMount: function beforeMount() {
    this.getAllEmployees();
  },

  methods: {
    //LIST OF EMPLOYEE BASE SA CONTRACTS AND MEMOS LIST
    getYear: function getYear() {
      var _this2 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this2.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this3 = this;

      axios.get('api/contractsmemo').then(function (response) {
        _this3.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  computed: {
    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this4 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
          });
          return filtered;
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    }
  }

});

/***/ }),

/***/ "npX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contact-info')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nuob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemomantra', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/mantra', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "o+Rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_account_vue__ = __webpack_require__("BMSm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287a8d3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_account_vue__ = __webpack_require__("ZEwV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287a8d3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o/VV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_details_vue__ = __webpack_require__("WugJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62643ca6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_details_vue__ = __webpack_require__("s3gL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contributions_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62643ca6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contributions_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oPlk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_list_vue__ = __webpack_require__("k9Io");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6377fe1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_list_vue__ = __webpack_require__("cFZp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6377fe1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "obBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_supervisor_account__ = __webpack_require__("E8lQ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        supervisorAccount: __WEBPACK_IMPORTED_MODULE_0__todo_supervisor_account__["a" /* default */]
    }
});

/***/ }),

/***/ "olZf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



var _this = this;

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */].Store({
    state: {
        isLoggedIn: !!localStorage.getItem('token'),
        departmentItem: [],
        positionsItem: [],
        subDepartmentItem: [],

        aniversaryAll: [],
        employeeLeave: [],
        birthdayAll: [],
        incommingLeave: [],
        statusItem: [],
        timezoneItem: []
    },

    getters: {},

    actions: {
        //DROPDOWN
        GET_DEPARTMENT: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
                var commit = _ref2.commit;

                var _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/departments');

                            case 2:
                                _ref3 = _context.sent;
                                data = _ref3.data;

                                commit('SET_DEPARTMENT', data);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function GET_DEPARTMENT(_x) {
                return _ref.apply(this, arguments);
            };
        }(),

        GET_POSITIONS: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
                var commit = _ref5.commit;

                var _ref6, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/employeepositions');

                            case 2:
                                _ref6 = _context2.sent;
                                data = _ref6.data;

                                commit('SET_POSITIONS', data);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function GET_POSITIONS(_x2) {
                return _ref4.apply(this, arguments);
            };
        }(),

        GET_SUBDEPARTMENT: function () {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8) {
                var commit = _ref8.commit;

                var _ref9, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/subdepartments');

                            case 2:
                                _ref9 = _context3.sent;
                                data = _ref9.data;

                                commit('SET_SUBDEPARTMENT', data);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function GET_SUBDEPARTMENT(_x3) {
                return _ref7.apply(this, arguments);
            };
        }(),

        GET_TIMEZONES: function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11) {
                var commit = _ref11.commit;

                var _ref12, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/timezones');

                            case 2:
                                _ref12 = _context4.sent;
                                data = _ref12.data;

                                commit('SET_TIMEZONES', data);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));

            return function GET_TIMEZONES(_x4) {
                return _ref10.apply(this, arguments);
            };
        }(),

        //FOR DASHBOARD
        GET_ANNIVERSARRY_ALL: function () {
            var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref14) {
                var commit = _ref14.commit;

                var _ref15, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/anniversary/all');

                            case 2:
                                _ref15 = _context5.sent;
                                data = _ref15.data;

                                commit('SET_ANNIVERSARRY_ALL', data);

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this);
            }));

            return function GET_ANNIVERSARRY_ALL(_x5) {
                return _ref13.apply(this, arguments);
            };
        }(),

        GET_EMPLOYEE_LEAVE: function () {
            var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref17) {
                var commit = _ref17.commit;

                var _ref18, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/employee/leave');

                            case 2:
                                _ref18 = _context6.sent;
                                data = _ref18.data;

                                commit('SET_EMPLOYEE_LEAVE', data);

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this);
            }));

            return function GET_EMPLOYEE_LEAVE(_x6) {
                return _ref16.apply(this, arguments);
            };
        }(),

        GET_EMPLOYEE_BIRTHDAY: function () {
            var _ref19 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref20) {
                var commit = _ref20.commit;

                var _ref21, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/celebrant');

                            case 2:
                                _ref21 = _context7.sent;
                                data = _ref21.data;

                                commit('SET_EMPLOYEE_BIRTHDAY', data);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this);
            }));

            return function GET_EMPLOYEE_BIRTHDAY(_x7) {
                return _ref19.apply(this, arguments);
            };
        }(),

        GET_INCOMING_LEAVE: function () {
            var _ref22 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref23) {
                var commit = _ref23.commit;

                var _ref24, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/incomingLeave');

                            case 2:
                                _ref24 = _context8.sent;
                                data = _ref24.data;

                                commit('SET_INCOMING_LEAVE', data);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this);
            }));

            return function GET_INCOMING_LEAVE(_x8) {
                return _ref22.apply(this, arguments);
            };
        }(),

        GET_DASHBOARD_COUNTER: function () {
            var _ref25 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(_ref26) {
                var commit = _ref26.commit;

                var _ref27, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/dashboardCounter');

                            case 2:
                                _ref27 = _context9.sent;
                                data = _ref27.data;

                                commit('SET_DASHBOARD_COUNTER', data);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this);
            }));

            return function GET_DASHBOARD_COUNTER(_x9) {
                return _ref25.apply(this, arguments);
            };
        }()

    },

    mutations: {

        SET_TIMEZONES: function SET_TIMEZONES(state, payload) {
            state.timezoneItem = payload;
        },

        SET_DEPARTMENT: function SET_DEPARTMENT(state, payload) {
            state.departmentItem = payload;
        },

        SET_POSITIONS: function SET_POSITIONS(state, payload) {
            state.positionsItem = payload;
        },

        SET_SUBDEPARTMENT: function SET_SUBDEPARTMENT(state, payload) {
            state.subDepartmentItem = payload;
        },

        loginUser: function loginUser(state) {
            state.isLoggedIn = true;
        },
        logOutUser: function logOutUser(state) {
            state.isLoggedIn = false;
        },


        //FOR DASHBOARD
        SET_ANNIVERSARRY_ALL: function SET_ANNIVERSARRY_ALL(state, payload) {
            state.aniversaryAll = payload;
        },

        SET_EMPLOYEE_LEAVE: function SET_EMPLOYEE_LEAVE(state, payload) {
            state.employeeLeave = payload;
        },

        SET_EMPLOYEE_BIRTHDAY: function SET_EMPLOYEE_BIRTHDAY(state, payload) {
            state.birthdayAll = payload;
        },

        SET_INCOMING_LEAVE: function SET_INCOMING_LEAVE(state, payload) {
            state.incommingLeave = payload;
        },

        SET_DASHBOARD_COUNTER: function SET_DASHBOARD_COUNTER(state, payload) {
            state.statusItem = payload;
        }

    }
}));

/***/ }),

/***/ "ouGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-memos-mantra')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ozRG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_job_information_vue__ = __webpack_require__("exPe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7747e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_job_information_vue__ = __webpack_require__("YM5d");
function injectStyle (ssrContext) {
  __webpack_require__("IOch")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_job_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7747e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_job_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pSXi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Register Dependent")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dependents"}},[_vm._v("Dependents")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Dependent Registration")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('label',[_vm._v("Select Employee")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control col-md-12",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("---- Select Employee ----")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(emp.full_name))])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-male"}),_vm._v("Dependents")]),_vm._v(" "),_vm._l((_vm.dependents),function(dept,index){return _c('div',[_c('div',{staticClass:"border-box-dependents"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name Of Dependent:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dept.name),expression:"dept.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(dept.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dept, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Relationship:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(dept.relationship),expression:"dept.relationship"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(dept, "relationship", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Please select one --")]),_vm._v(" "),_c('option',{attrs:{"value":"Mother"}},[_vm._v("Mother")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Father")]),_vm._v(" "),_c('option',{attrs:{"value":"Father"}},[_vm._v("Daughter")]),_vm._v(" "),_c('option',{attrs:{"value":"Son"}},[_vm._v("Son")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Age of Dependent:")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['##']},model:{value:(dept.age),callback:function ($$v) {_vm.$set(dept, "age", $$v)},expression:"dept.age"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phic No. Of Dependent:")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['##-#######-#'],"placeholder":"00-0000000-0"},model:{value:(dept.phic_no),callback:function ($$v) {_vm.$set(dept, "phic_no", $$v)},expression:"dept.phic_no"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"floater-point-dept"},[_c('div',{staticClass:"action-item-dept"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to add new employee dependents section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_dependent($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to remove employee dependents section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.deleteDependent(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-blind"}),_vm._v("Senior Citizen Dependent")]),_vm._v(" "),_vm._l((_vm.seniors),function(senior,index){return _c('div',[_c('div',{staticClass:"border-box-dependents"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Senior Citizen ID No. of Dependent:")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['##-#######-#'],"placeholder":"00-0000000-0"},model:{value:(senior.senior_citizen),callback:function ($$v) {_vm.$set(senior, "senior_citizen", $$v)},expression:"senior.senior_citizen"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Middle Initial of Dependent:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(senior.middle_initial),expression:"senior.middle_initial"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[A-Za-z ]{1,32}"},domProps:{"value":(senior.middle_initial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(senior, "middle_initial", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"floater-point-sinior"},[_c('div',{staticClass:"action-item-sinior"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to add senior section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.add_senior(index)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-primary",attrs:{"title":"click to remove senior section"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.deleteSenior(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4 float-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"100%"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Dependent Data")])])])])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pZHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pePw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('leave-approval')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "prDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_adjustment_form_vue__ = __webpack_require__("GJ0j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a846a3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_adjustment_form_vue__ = __webpack_require__("6/qy");
function injectStyle (ssrContext) {
  __webpack_require__("bE53")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_adjustment_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a846a3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_adjustment_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_work_shifts__ = __webpack_require__("bASF");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        workShift: __WEBPACK_IMPORTED_MODULE_0__todo_work_shifts__["a" /* default */]
    }
});

/***/ }),

/***/ "q7EO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_view_details_vue__ = __webpack_require__("/S0l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4706cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_view_details_vue__ = __webpack_require__("bpfp");
function injectStyle (ssrContext) {
  __webpack_require__("w9Qo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_nte_view_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4706cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_nte_view_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q7Nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('leave-credits')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qBCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('account-user')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qCjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_update_leave_vue__ = __webpack_require__("uQAa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5e56b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_update_leave_vue__ = __webpack_require__("bbR4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_update_leave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5e56b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_update_leave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qGmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dependents_vue__ = __webpack_require__("0093");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa65fcb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dependents_vue__ = __webpack_require__("y/Hw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dependents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa65fcb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dependents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qL5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos__ = __webpack_require__("L4wW");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemos: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos__["a" /* default */]
    }
});

/***/ }),

/***/ "qMc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {},

	data: function data() {
		return {
			email: '',
			seen: false,
			error_handler: ''
		};
	},


	methods: {
		fetchData: function fetchData() {
			console.log();
		},
		requestPasswordReset: function requestPasswordReset() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/create', { email: this.email }).then(function (resp) {
				if (resp.data.response == 'success') {
					_this.$swal({
						type: 'success',
						title: 'Done',
						text: resp.data.message,
						showConfirmButton: true
						// timer: 3000
					});
					_this.email = '';
				} else if (resp.data.response == 'error') {
					_this.$swal({
						type: 'error',
						title: 'warning',
						text: resp.data.message,
						showConfirmButton: true
						//timer: 4000
					});
				}
			}).catch(function (error) {
				if (error.response.status == 422) {
					_this.error_handler = error.response.data.message;
					_this.$swal('Opps', _this.error_handler, 'error');
					console.log(_this.error_handler);
				}
			});
		}
	}

});

/***/ }),

/***/ "qS/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_undertime_request_vue__ = __webpack_require__("AAzL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9394e098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_undertime_request_vue__ = __webpack_require__("1dTM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_undertime_request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9394e098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_undertime_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qaio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemovanzau', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },


    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/vanzau', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "qcVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_cd_hw_vue__ = __webpack_require__("YuSY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c60686_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_cd_hw_vue__ = __webpack_require__("n2kJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_assign_memos_cd_hw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c60686_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_assign_memos_cd_hw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qcaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_list_vue__ = __webpack_require__("6OK4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2f26dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_list_vue__ = __webpack_require__("EPvo");
function injectStyle (ssrContext) {
  __webpack_require__("4Oz2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2f26dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qiBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_add_calendar_event_vue__ = __webpack_require__("VQmJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6baef9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_add_calendar_event_vue__ = __webpack_require__("Hu/P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_add_calendar_event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6baef9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_add_calendar_event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qxhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_resigned__ = __webpack_require__("UZAr");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        resigned: __WEBPACK_IMPORTED_MODULE_0__todo_resigned__["a" /* default */]
    }
});

/***/ }),

/***/ "r6O+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r9kV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_payslip__ = __webpack_require__("WhSt");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        payroll: __WEBPACK_IMPORTED_MODULE_0__todo_payslip__["a" /* default */]
    }
});

/***/ }),

/***/ "rBKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      leave_status: "",
      search: "",
      order_by: "",
      filter_by_status: "",
      filter_by_type: "",
      filter_by_year: "",
      //SORTING
      page_limit: "",
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 200,
      curentPage: 1,
      selected_item: '',
      //Indicator
      display_indicator: ''
    };
  },


  mounted: function mounted() {
    this.get_employees_leave();
  },

  methods: {
    deleteItem: function deleteItem(id, index) {
      var _this = this;

      /* USING SWEET ALERT */
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/leaveabsences/delete/' + id).then(function (response) {
            _this.get_employees_leave(); // reloader 
            _this.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response);
            _this.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    },
    getYear: function getYear() {
      var _this2 = this;

      if (this.filter_by_year == '') {
        this.get_employees_leave();
      } else {
        axios.get('api/leavemanagement/' + this.filter_by_year).then(function (response) {
          _this2.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    selected_employee: function selected_employee(item) {
      this.selected_item = item;
    },
    cancel_leave: function cancel_leave() {
      var _this3 = this;

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to cancel this leave request.",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/leave/approval/hr/' + _this3.selected_item.id, { status: "rejected" }).then(function (resp) {
            if (resp.data.response == 'success') {
              _this3.$swal({
                type: 'success',
                title: 'Cancelled',
                text: resp.data.message,
                showConfirmButton: true,
                timer: 2000
              });
              _this3.get_employees_leave();
              _this3.$refs['hide-leave'].hide();
            } else if (resp.data.response == 'error') {
              _this3.$swal({
                type: 'error',
                title: 'Oops',
                text: resp.data.message,
                showConfirmButton: true
              });
            }
            console.log(resp.data);
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },


    //GET EMPLOYEES LEAVE
    get_employees_leave: function get_employees_leave() {
      var _this4 = this;

      axios.get("api/leavemanagement").then(function (response) {
        _this4.items = response.data;
        _this4.loading = false;
        _this4.display_indicator = 2;
      }).catch(function (error) {
        console.log(error.response);
        _this4.display_indicator = 1;
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedLeave: function computedLeave() {
      var _this5 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this5.search) > -1;
          });
          return filtered;
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }
        // FILTER BY STATUS
        if (this.filter_by_status) {
          filtered = filtered.filter(function (item) {
            return item.status.toLowerCase() === _this5.filter_by_status.toLowerCase();
          });
          return filtered;
        }
        // FILTER BY TYPE
        if (this.filter_by_type) {
          filtered = filtered.filter(function (item) {
            return item.leave_type.toLowerCase() === _this5.filter_by_type.toLowerCase();
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this5.order_by : -_this5.order_by;
          });
          return filtered;
        }
      }

      return filtered;
    }
  }
});

/***/ }),

/***/ "rE+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },

    data: function data() {
        return {
            items: [],
            order_by: '',
            //PAGINATION
            page_limit: '',
            filter_by_year: '',
            start_page: 1,
            loading: true,
            perPage: 20,
            curentPage: 1

        };
    },


    created: function created() {
        var _this = this;

        setTimeout(function () {
            _this.loading = false;
        }, 300);
    },

    beforeMount: function beforeMount() {
        this.get_evaluation();
    },

    methods: {
        getYear: function getYear() {
            var _this2 = this;

            if (this.filter_by_year == '') {
                this.get_evaluation();
            } else {
                axios.get('api/evaluation/all/' + this.filter_by_year).then(function (response) {
                    _this2.items = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                });
            }
        },
        get_evaluation: function get_evaluation() {
            var _this3 = this;

            axios.get('api/evaluation/all').then(function (response) {
                _this3.items = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        }
    },
    computed: {
        // PAGINATION
        offset: function offset() {
            return (this.start_page - 1) * this.page_limit;
        },
        limit: function limit() {
            return this.offset + this.page_limit;
        },
        total_item: function total_item() {
            return this.items.length;
        },
        computedRequest: function computedRequest() {
            var _this4 = this;

            var filtered = this.items;
            // USE IN PAGINATION 
            var start = (this.curentPage - 1) * this.perPage;
            var end = this.curentPage * this.perPage;
            filtered = filtered.slice(start, end);

            if (filtered.length > 0) {
                // SORTING NUMBER OF DISPLAY
                if (this.page_limit) {
                    filtered = filtered.slice(this.offset, this.limit);
                    return filtered;
                }
                // ORDER BY ASC AND DESC COMBOBOX
                if (this.order_by) {
                    filtered = filtered.slice(0).sort(function (a, b) {
                        return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
                    });
                    return filtered;
                }
            } else {
                filtered = 0;
            }

            return filtered;
        }
    }
});

/***/ }),

/***/ "rJbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Details")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/absenceleave"}},[_vm._v("Leave & Absences Record")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Leave Details")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container",attrs:{"id":"printme"}},[_c('img',{staticClass:"logo-print",attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('img',{attrs:{"width":"30","height":"30","id":"printIcon","onclick":"window.print()","src":"/static/img/print.png","alt":"..."}})]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"report-border-full"},[_c('div',{staticClass:"report-header"},[_vm._v("\n            LEAVE APPLICATION FORM\n         ")])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 b-border"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Name:")]),_vm._v(" "+_vm._s(_vm.item.full_name))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Department:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Employee Number:")]),_vm._v(" "+_vm._s(_vm.item.emp_id))]),_vm._v(" "),_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Position:")]),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Filled :")]),_vm._v(" "+_vm._s(_vm.item.date_filled))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Type of Leave :")]),_vm._v(" "+_vm._s(_vm.item.leave_type))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Total Days:")]),_vm._v(" "+_vm._s(_vm.item.no_of_days))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Start Date :")]),_vm._v(" "+_vm._s(_vm.item.start_date))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("End Date :")]),_vm._v(" "+_vm._s(_vm.item.end_date))])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Reason for Leave / Absent :")]),_c('br'),_vm._v(" "+_vm._s(_vm.item.reason))])])])]),_vm._v(" "),_c('form',{on:{"submit":_vm.update_leave}},[(_vm.item.roles === 1 && _vm.item.belongs_to != 0)?_c('div',[_c('b',[_vm._v("Departmental Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Supervisor Name:")])]),_vm._v("\n                     "+_vm._s(_vm.item.supervisor)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Supervisor Approval:")])]),_vm._v("\n                     "+_vm._s(_vm.item.tl_status)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v("\n                     "+_vm._s(_vm.item.tl_date_approved)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head's Name:")])]),_vm._v("\n                     "+_vm._s(_vm.item.department_head)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head Approval:")])]),_vm._v("\n                     "+_vm._s(_vm._f("capitalize")(_vm.item.asm_status))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v("\n                     "+_vm._s(_vm.item.asm_date_approved)+"\n                  ")])])])]):_vm._e(),_vm._v(" "),(_vm.item.roles === 2)?_c('div',[_c('b',[_vm._v("Departmental Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head's Name:")])]),_vm._v("\n                     "+_vm._s(_vm.item.department_head)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Departmental Head Approval:")])]),_vm._v("\n                     "+_vm._s(_vm._f("capitalize")(_vm.item.asm_status))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Approved:")])]),_vm._v("\n                     "+_vm._s(_vm.item.asm_date_approved)+"\n                  ")])])])]):_vm._e(),_vm._v(" "),_c('b',[_vm._v("HR Department Approval")]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Remarks:")])]),_vm._v("\n                  "+_vm._s(_vm.item.remarks)+"\n               ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("HR Approval:")])]),_vm._v("\n                  "+_vm._s(_vm._f("capitalize")(_vm.item.status))+"\n               ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"margin-p"},[_c('b',[_vm._v("Date Recived:")])]),_vm._v("\n                  "+_vm._s(_vm.item.hr_date_recived)+"\n               ")])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rM7B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rXcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_contact_info__ = __webpack_require__("Aolk");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ContactInfo: __WEBPACK_IMPORTED_MODULE_0__todo_contact_info__["a" /* default */]
    }
});

/***/ }),

/***/ "rZQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_coached_details_vue__ = __webpack_require__("fhr/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c4e3a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_coached_details_vue__ = __webpack_require__("d5jJ");
function injectStyle (ssrContext) {
  __webpack_require__("tQvF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_employee_coached_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c4e3a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_employee_coached_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ridT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('undertime-request')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_supervisor_account_vue__ = __webpack_require__("obBz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0ec066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_supervisor_account_vue__ = __webpack_require__("snGX");
function injectStyle (ssrContext) {
  __webpack_require__("GfRJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_supervisor_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0ec066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_supervisor_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rlnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "ro9v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_management_vue__ = __webpack_require__("TNbI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48743ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_management_vue__ = __webpack_require__("axHM");
function injectStyle (ssrContext) {
  __webpack_require__("7qGc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_leave_management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48743ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_leave_management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rorq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('view-leave')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s/R8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s3gL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contributions-details')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6Po":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            current_password: '',
            new_password: '',
            confirm_password: '',
            error_handler: [],
            message: ''
        };
    },

    created: function created() {},
    methods: {
        formSubmit: function formSubmit(e) {
            var _this = this;

            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to change your password',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {

                    axios.post('api/login/pwdchange', {
                        current_password: _this.current_password,
                        new_password: _this.new_password,
                        confirm_password: _this.confirm_password

                    }).then(function (resp) {
                        //  this.$swal('Changed', 'Your password has been changed successfully. Please try to login to confirm.' , 'success')

                        _this.$swal({
                            type: 'success',
                            title: 'Changed',
                            text: 'Your password has been changed successfully. Please try to login to confirm.',
                            showConfirmButton: false,
                            timer: 4000
                        });

                        _this.$router.push({ name: 'Logout-Layout' });
                    }).catch(function (error) {
                        if (error.response.status == 422) {
                            _this.error_handler = error.response.data.message;
                            _this.$swal('Opps', _this.error_handler, 'error');
                            console.log(_this.error_handler);
                        }
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ "sA5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dependents_form_vue__ = __webpack_require__("PwsZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd5e306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dependents_form_vue__ = __webpack_require__("pSXi");
function injectStyle (ssrContext) {
  __webpack_require__("Un+v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_dependents_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd5e306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_dependents_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sEys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Requirements")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Requirements")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Position:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_position),expression:"filter_by_position"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_vm._l((_vm.positions),function(pos){return _c('option',{domProps:{"textContent":_vm._s(pos.pos_name)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter by Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_status),expression:"filter_by_status"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("Completed Requirements")]),_vm._v(" "),_c('option',{attrs:{"value":"notsubmitted"}},[_vm._v("Lacking Requirements")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover table-header-rotated"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("EMPLOYEE")]),_vm._v(" "),_c('th',[_vm._v("STATUS")]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("SSS ")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("HDMF")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("MID")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("TIN")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("Phic")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("TOR")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("2316")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("COE")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("NBI")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("NSO/BIRTH")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("Brgy Clearance")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("Police Clearance")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("ID Pictures")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("Mariage Contract")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("SSS STATIC")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("photocopy SSS")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("photocopy PHIC")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("photocopy HDMF")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("photocopy TIN")])])]),_vm._v(" "),_c('th',{staticClass:"rotate-45"},[_c('div',[_c('span',[_vm._v("NSO Dependents")])])]),_vm._v(" "),_c('th',{attrs:{"width":"100"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequirements),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-record",modifiers:{"update-record":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"link-default-requirements",attrs:{"href":"#","title":"click to update employee requirements record"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v(_vm._s(_vm._f("capitalize")(item.full_name))+" ")])]),_vm._v(" \n                    ")]),_vm._v(" "),_c('td',[(
                            (item.sss_no !== null) &&
                            (item.hdmf_no !== null) &&
                            (item.tin_no !== null) &&
                            (item.phic_no !== null) &&
                            (item.mid_no !== null) &&
                            (item.TOR == 'submitted') &&  
                            (item.ITW == 'submitted') && 
                            (item.COE == 'submitted') &&
                            (item.NBI == 'submitted') &&
                            (item.NSO_BC == 'submitted') &&
                            (item.barangay_clearance == 'submitted') &&
                            (item.police_clearance == 'submitted') &&  
                            (item.id_picture == 'submitted') &&
                            (item.sss_static == 'submitted') &&
                            (item.photocopy_sss == 'submitted') &&
                            (item.photocopy_phic == 'submitted') &&
                            (item.photocopy_hdmf == 'submitted') &&
                            (item.photocopy_tin == 'submitted')  && 
                            (item.nso_dependents == 'submitted') 
                            )?_c('span',{staticClass:"enable"},[_c('i',{staticClass:"fa fa-star-o"}),_vm._v(" Completed ")]):_c('span',{staticClass:"disable"},[_c('i',{staticClass:"fa fa-thumb-tack"}),_vm._v(" Lacking "),_c('span',{staticClass:"badge badge-pill badge-danger"})])]),_vm._v(" "),_c('td',[(item.sss_no !== null)?_c('span',[_c('i',{staticClass:"fa fa-check enable"})]):_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"SSS - (Social Security System) "}})])]),_vm._v(" "),_c('td',[(item.hdmf_no !== null)?_c('span',[_c('i',{staticClass:"fa fa-check enable"})]):_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"HDMF - (Home Development Mutual Fund) "}})])]),_vm._v(" "),_c('td',[(item.mid_no !== null)?_c('span',[_c('i',{staticClass:"fa fa-check enable"})]):_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"HDMF - (Home Development Mutual Fund) "}})])]),_vm._v(" "),_c('td',[(item.tin_no !== null)?_c('span',[_c('i',{staticClass:"fa fa-check enable"})]):_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"TIN - (Taxpayer Identification Number)"}})])]),_vm._v(" "),_c('td',[(item.phic_no !== null)?_c('span',[_c('i',{staticClass:"fa fa-check enable"})]):_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Philhealth No."}})])]),_vm._v(" "),_c('td',[(item.TOR == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"TOR - (Transcript Of Record)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.ITW == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"2316"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.COE == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"COE - (Certificate Of Employment)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.NBI == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NBI - (National Bureau of Investigation)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.NSO_BC == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NSO/Birth Certificate"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.barangay_clearance == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"BCLR - (Barangay Clearance)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.police_clearance == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"PCLR - (Police Clearance)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.id_picture == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Pics - (1x1 and 2x2 Picture)"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.MC == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"MC - (Married's Contract) if Married"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.sss_static == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"SSS Static"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.photocopy_sss == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy of SSS"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.photocopy_phic == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy PHIC"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.photocopy_hdmf == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy HDMF"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.photocopy_tin == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy TIN"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.nso_dependents == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NSO Dependents"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})])]),_vm._v(" "),_c('td',[(item.note !== null)?_c('span',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-notes",modifiers:{"update-notes":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs btn-success",attrs:{"href":"#","title":"click to view a notes"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("View\n                        ")])]):_c('span',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-notes",modifiers:{"update-notes":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-default btn-xs",attrs:{"href":"#","title":"click add notes to create a new notes or reminders"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                        Add \n                        ")])])])]],2)}),0)]),_vm._v(" "),_c('b-modal',{ref:"update-modal-hide",attrs:{"id":"update-record","size":"xl","title":"Update Record","hide-footer":"","no-stacking":""}},[_c('h2',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selectedUser.full_name)))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("SSS No.")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['##-#######-#'],"placeholder":"00-0000000-0"},model:{value:(_vm.selectedUser.sss_no),callback:function ($$v) {_vm.$set(_vm.selectedUser, "sss_no", $$v)},expression:"selectedUser.sss_no"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("HDMF NO.")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['####-####-####'],"placeholder":"0000-0000-0000"},model:{value:(_vm.selectedUser.hdmf_no),callback:function ($$v) {_vm.$set(_vm.selectedUser, "hdmf_no", $$v)},expression:"selectedUser.hdmf_no"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("MID NO.")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['####-####-####'],"placeholder":"000-000-000"},model:{value:(_vm.selectedUser.mid_no),callback:function ($$v) {_vm.$set(_vm.selectedUser, "mid_no", $$v)},expression:"selectedUser.mid_no"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TIN NO.")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['####-####-####'],"placeholder":"000-000-000"},model:{value:(_vm.selectedUser.tin_no),callback:function ($$v) {_vm.$set(_vm.selectedUser, "tin_no", $$v)},expression:"selectedUser.tin_no"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("PHILHEALTH NO.")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['##-#########-#'],"placeholder":"00-000000000-0"},model:{value:(_vm.selectedUser.phic_no),callback:function ($$v) {_vm.$set(_vm.selectedUser, "phic_no", $$v)},expression:"selectedUser.phic_no"}})],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TOR.")]),_vm._v(" "),(_vm.selectedUser.TOR == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"TOR Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.TOR),expression:"selectedUser.TOR"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "TOR", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.TOR}},[_vm._v(_vm._s(_vm.selectedUser.TOR))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("2316.")]),_vm._v(" "),(_vm.selectedUser.ITW == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"TOR Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.ITW),expression:"selectedUser.ITW"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "ITW", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.ITW}},[_vm._v(_vm._s(_vm.selectedUser.ITW))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("COE.")]),_vm._v(" "),(_vm.selectedUser.COE == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"COE Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.COE),expression:"selectedUser.COE"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "COE", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.COE}},[_vm._v(_vm._s(_vm.selectedUser.COE))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("NBI.")]),_vm._v(" "),(_vm.selectedUser.NBI == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NBI Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.NBI),expression:"selectedUser.NBI"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "NBI", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.NBI}},[_vm._v(_vm._s(_vm.selectedUser.NBI))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("NSO_BC.")]),_vm._v(" "),(_vm.selectedUser.NSO_BC == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NSO_BC Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.NSO_BC),expression:"selectedUser.NSO_BC"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "NSO_BC", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.NSO_BC}},[_vm._v(_vm._s(_vm.selectedUser.NSO_BC))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Brgy Clearance.")]),_vm._v(" "),(_vm.selectedUser.barangay_clearance == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"barangay_clearance Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.barangay_clearance),expression:"selectedUser.barangay_clearance"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "barangay_clearance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.barangay_clearance}},[_vm._v(_vm._s(_vm.selectedUser.barangay_clearance))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Police Clearance.")]),_vm._v(" "),(_vm.selectedUser.police_clearance == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"police_clearance Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.police_clearance),expression:"selectedUser.police_clearance"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "police_clearance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.police_clearance}},[_vm._v(_vm._s(_vm.selectedUser.police_clearance))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID Picture.")]),_vm._v(" "),(_vm.selectedUser.id_picture == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"id_picture Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.id_picture),expression:"selectedUser.id_picture"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "id_picture", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.id_picture}},[_vm._v(_vm._s(_vm.selectedUser.id_picture))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("MC.")]),_vm._v(" "),(_vm.selectedUser.MC == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"MC Not Yet Sumitted"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.MC),expression:"selectedUser.MC"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "MC", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.MC}},[_vm._v(_vm._s(_vm.selectedUser.MC))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("SSS Static")]),_vm._v(" "),(_vm.selectedUser.sss_static == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"SSS Static"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.sss_static),expression:"selectedUser.sss_static"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "sss_static", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(_vm.error_handler.sss_static)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.sss_static[0]))]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.sss_static}},[_vm._v(_vm._s(_vm.selectedUser.sss_static))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Photocopy SSS")]),_vm._v(" "),(_vm.selectedUser.photocopy_sss == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy SSS"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.photocopy_sss),expression:"selectedUser.photocopy_sss"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "photocopy_sss", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.photocopy_sss}},[_vm._v(_vm._s(_vm.selectedUser.photocopy_sss))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Photocopy Phic")]),_vm._v(" "),(_vm.selectedUser.photocopy_phic == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy Phic"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.photocopy_phic),expression:"selectedUser.photocopy_phic"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "photocopy_phic", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.photocopy_phic}},[_vm._v(_vm._s(_vm.selectedUser.photocopy_phic))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("photocopy_hdmf")]),_vm._v(" "),(_vm.selectedUser.photocopy_hdmf == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy HDMF"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.photocopy_hdmf),expression:"selectedUser.photocopy_hdmf"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "photocopy_hdmf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.photocopy_hdmf}},[_vm._v(_vm._s(_vm.selectedUser.photocopy_hdmf))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("photocopy_tin")]),_vm._v(" "),(_vm.selectedUser.photocopy_tin == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"Photocopy TIN"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.photocopy_tin),expression:"selectedUser.photocopy_tin"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "photocopy_tin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.photocopy_tin}},[_vm._v(_vm._s(_vm.selectedUser.photocopy_tin))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("NSO Dependents")]),_vm._v(" "),(_vm.selectedUser.nso_dependents == 'none')?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-times disable",attrs:{"title":"NSO Dependents"}})]):_c('span',[_c('i',{staticClass:"fa fa-check enable"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.nso_dependents),expression:"selectedUser.nso_dependents"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedUser, "nso_dependents", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.selectedUser.nso_dependents}},[_vm._v(_vm._s(_vm.selectedUser.photocopy_tin))]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("none")]),_vm._v(" "),_c('option',{attrs:{"value":"submitted"}},[_vm._v("submitted")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_requirements}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Update Record")]),_c('br')])])])]),_vm._v(" "),_c('b-modal',{ref:"update-notes",attrs:{"id":"update-notes","size":"lg","title":"Notes","hide-footer":"","no-stacking":""}},[_c('h3',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selectedUser.full_name)))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser.note),expression:"selectedUser.note"}],staticClass:"form-control",staticStyle:{"background":"#fcdf88","color":"#000","border-radius":"0px","border":"0px"},attrs:{"rows":"10","id":"comment"},domProps:{"value":(_vm.selectedUser.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedUser, "note", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_requirements}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Notes")])])])],1),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sIbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_edit_dependents__ = __webpack_require__("/+7w");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        editDependent: __WEBPACK_IMPORTED_MODULE_0__todo_edit_dependents__["a" /* default */]
    }
});

/***/ }),

/***/ "sJO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_employee_account__ = __webpack_require__("o+Rk");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        EmployeeAccount: __WEBPACK_IMPORTED_MODULE_0__todo_employee_account__["a" /* default */]
    }
});

/***/ }),

/***/ "sPCV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
});

/***/ }),

/***/ "sQwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_new_password_vue__ = __webpack_require__("PCH6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fecf5f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_new_password_vue__ = __webpack_require__("9ZHL");
function injectStyle (ssrContext) {
  __webpack_require__("w3Ya")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_new_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fecf5f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_new_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sRSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sZuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_management_vue__ = __webpack_require__("rBKf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0cad72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_management_vue__ = __webpack_require__("SUDz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0cad72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "snGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('supervisor-account')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "snK2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tCvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_reports_vue__ = __webpack_require__("ZJA9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30993db3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_reports_vue__ = __webpack_require__("dXoH");
function injectStyle (ssrContext) {
  __webpack_require__("O7LI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30993db3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tIxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('sub-department')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Leave Cretdit Config")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"settings"}},[_vm._v(" Change Password ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v(" Leave Credit Config")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"notificationconfig"}},[_vm._v(" Notification Config")])],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"150"}},[_vm._v("Sub Department ID")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Sub Department Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Monthly Earn")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Leave Refresh")]),_vm._v(" "),_c('th',{attrs:{"width":"650"}},[_vm._v("Decription")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,i){return _c('tr',[_c('td',[_vm._v(_vm._s(item.sub_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sub_department_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.monthly_earn))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.leave_refresh)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.update-credit-config",modifiers:{"update-credit-config":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Update Config")])])])])}),0)]),_vm._v(" "),_c('b-modal',{ref:"hide-credit-config",attrs:{"id":"update-credit-config","size":"l","title":"Update Item","hide-footer":""}},[_c('h3',[_vm._v("Credit Config")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Monthly Earn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.monthly_earn),expression:"selected_user.monthly_earn"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_user.monthly_earn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "monthly_earn", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave Refresh")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.leave_refresh),expression:"selected_user.leave_refresh"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected_user, "leave_refresh", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"monthly"}},[_vm._v("Monthly")]),_vm._v(" "),_c('option',{attrs:{"value":"yearly"}},[_vm._v("Yearly")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descrption")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.description),expression:"selected_user.description"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.selected_user.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "description", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_credit_config}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tNzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_approval_vue__ = __webpack_require__("4eA3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c60baba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_approval_vue__ = __webpack_require__("iyEu");
function injectStyle (ssrContext) {
  __webpack_require__("/uT+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_nte_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c60baba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_nte_approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "td7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_coached_details_vue__ = __webpack_require__("FK/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f5ecec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_coached_details_vue__ = __webpack_require__("9X+d");
function injectStyle (ssrContext) {
  __webpack_require__("l1Qx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_employee_coached_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f5ecec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_employee_coached_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tdlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Memos to Mantra")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Memos To Mantra")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-info"},[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v("   Mass Assign Contracts/Memos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoute),expression:"selectedRoute"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRoute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.goToRoute]}},[_c('option',{attrs:{"value":""}},[_vm._v("--------------------------------------------------------------------")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/contracts/assign-all/"}},[_vm._v("Assign Contracts to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-all/"}},[_vm._v("Assign Memos to All")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-pq/"}},[_vm._v("Assign Memos to CD-PQ")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-cd-hw/"}},[_vm._v("Assign Memos to CD-HW")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-mantra/"}},[_vm._v("Assign Memos to Mantra")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-nz-au/"}},[_vm._v("Assign Memos to VA-NZ/AU")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-va-us/"}},[_vm._v("Assign Memos to VA-US")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-collections/"}},[_vm._v("Assign Memos to Collections")]),_vm._v(" "),_c('option',{attrs:{"value":"/hr/memos/assign-admin/"}},[_vm._v("Assign Memos to Admin")])])])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Mass Assign Memos to Mantra")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},[_c('button',{staticClass:"btn-info btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"memoFiles","multiple":"","accept":".doc,.docx, .pdf"},on:{"change":_vm.handleFileMemosUpload}}),_vm._v(" "),_vm._l((_vm.memoFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                           "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                  "),_c('span',{on:{"click":function($event){_vm.removeMemoFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('p',[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Filter By Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter_by_year),expression:"filter_by_year"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter_by_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getYear]}},_vm._l((_vm.years(2019)),function(year){return _c('option',[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("DESC")])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Employee Id")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Full Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Position")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Hired Date")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedRequest),function(item,index){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(item.emp_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("capitalize")(item.position_name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDate(item.employment_date)))]),_vm._v(" "),_c('td',[(item.status == 'regular')?_c('span',[_c('i',{staticClass:"fa fa-flag text-success"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'probationary')?_c('span',[_c('i',{staticClass:"fa fa-flag text-info"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):(item.status == 'trainee')?_c('span',[_c('i',{staticClass:"fa fa-flag text-warning"}),_vm._v(" "+_vm._s(item.status)+"\n                       ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"upload-btn-wrapper "},[_c('router-link',{staticClass:"btn-info btn mr-xl-2 my-3",attrs:{"to":{name: 'assign-memos', params: { id: item.id }}}},[_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Memo")])])],1)])]],2)}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjL9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tx5a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0IV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"int-pm",class:{'int-pm-vertical': _vm.vertical}},[_c('button',{staticClass:"int-pm-btn",class:_vm.getBtnClass(true),attrs:{"aria-label":_vm.decrementAriaLabel,"disabled":_vm.disabled},on:{"click":function($event){_vm.vertical ? _vm.increment() : _vm.decrement()}}},[_vm._t(_vm.vertical ? 'increment' : 'decrement',[_vm._v(_vm._s(_vm.vertical ? '+' : '-'))])],2),_vm._v(" "),_c('div',{ref:"spinbutton",staticClass:"int-pm-value",attrs:{"role":"spinbutton","tabindex":"0","aria-valuenow":_vm.value,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-label":_vm.spinButtonAriaLabel}},[_vm._t("default",[_vm._v(_vm._s(_vm.intValue))])],2),_vm._v(" "),_c('button',{staticClass:"int-pm-btn",class:_vm.getBtnClass(false),attrs:{"aria-label":_vm.incrementAriaLabel,"disabled":_vm.disabled},on:{"click":function($event){_vm.vertical ? _vm.decrement() : _vm.increment()}}},[_vm._t(_vm.vertical ? 'decrement' : 'increment',[_vm._v(_vm._s(_vm.vertical ? '-' : '+'))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u1eX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Assign Contracts")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('nav',[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contractsmemo/"}},[_vm._v("Contracts & Memos")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Assign Contracts")])])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Employee Name :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name",attrs:{"data-full_name":_vm.item.full_name}},[_vm._v(_vm._s(_vm.item.full_name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Employee No :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name",attrs:{"data-emp_id":_vm.item.emp_id}},[_vm._v(_vm._s(_vm.item.emp_id))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Position :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.position_name)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Department :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.department_name)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-md-3 text-right p-text"},[_vm._v("Date Hired :")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"employee_name"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("  "+_vm._s(_vm.item.employment_date))])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Contracts")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper"},[_c('button',{staticClass:"btn-success btn mr-xl-2 mb-3",attrs:{"type":"button"},on:{"click":_vm.openFileDialog}},[(_vm.files.data_files && _vm.files.data_files.length > 0)?_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Update Existing Contract\n                                    ")]):_c('div',[_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" Assign Contract\n                                    ")])]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"contractFiles","multiple":"","accept":".doc,.docx,.pdf"},on:{"change":_vm.handleFileContractsUpload}}),_vm._v(" "),_vm._l((_vm.contractFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2"},[(file.type === 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type === 'application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("\n                                       "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                                    "),_c('span',{on:{"click":function($event){_vm.removeContractFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2)])])]),_vm._v(" "),(_vm.files.data_files != '')?_c('hr',{staticStyle:{"margin-top":"50px"}}):_vm._e(),_vm._v(" "),(_vm.files.data_files != '')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"title-header"},[_vm._v("Existing Contract/s")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]):_vm._e(),_vm._v(" "),(_vm.files.data_files != '')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"upload-btn-wrapper "},_vm._l((_vm.files),function(file_item,key){return _c('div',{key:key,staticClass:"mb-2"},[(file_item.data_files != '')?_c('div',_vm._l((file_item.data_files),function(item){return _c('div',{key:key,staticClass:"mb-2"},[(item.file_type == 'pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(item.file_type=='docx')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(item.file_type=='doc')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):_vm._e(),_vm._v("  \n                                                   "),_c('a',{attrs:{"href":'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + item.file_name,"target":"_blank"}},[_vm._v(_vm._s(item.file_name))]),_vm._v("    \n                                                "),(file_item.status === 'unacknowledged')?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-eye-slash text-secondary",staticStyle:{"font-size":"20px","cursor":"pointer"},attrs:{"aria-hidden":"true","title":"UNACKNOWLEDGED"}}):_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-eye text-success text-big",staticStyle:{"font-size":"20px"},attrs:{"aria-hidden":"true","title":"ACKNOWLEDGED"}}),_vm._v("     -      "),_c('span',{staticClass:"text-secondary"},[_vm._v("Sent on: "+_vm._s(new Date(file_item.date_sent).toDateString()))])],2)}),0):_vm._e()])}),0)])])]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Documents")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u6IG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_inactive__ = __webpack_require__("JBS3");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        inActive: __WEBPACK_IMPORTED_MODULE_0__todo_inactive__["a" /* default */]
    }
});

/***/ }),

/***/ "u80R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uAM/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"reset-header"},[_vm._v("PASSWORD RESET")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('template',{slot:"header"},[_vm._v("\n\t\t Login\n\t  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.requestPasswordReset($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-field",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info "},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Send Password Reset Link\n\t\t\t\t\t"),(_vm.seen)?_c('span',[_c('img',{attrs:{"src":"static/img/loading.gif","alt":"","width":"25","height":"25"}})]):_vm._e()]),_vm._v("\n\t\t\t\t    "),_c('router-link',{attrs:{"to":{ name: 'Login-Layout' }}},[_c('i',{staticClass:"fa fa-arrow-right"}),_c('u',[_vm._v("Back to Login")])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')])]),_vm._v(" "),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-style"},[_vm._v("Copyright © 2019 Blueprint Business Solution Corp"),_c('br'),_vm._v(" version 2.1.3 beta")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uD4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Evaluation Details")])]),_vm._v(" "),[_c('nav',{staticClass:"row breadcrumb-tweak"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/performance"}},[_vm._v("Evaluation List")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Evaluation Details")])])])],_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container"},[_c('img',{attrs:{"width":"190","height":"110","src":"/static/img/blueprintlogo.png","alt":"..."}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12  text-center text-dark"},[_c('h4',[_c('b',[_vm._v("EMPLOYEE PERFORMANCE EVALUATION FORM")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 border-right"},[_vm._v("\n                Employee Name : "),_c('b',[_vm._v(_vm._s(_vm.item.fullname))]),_vm._v(" "),_c('br'),_vm._v("\n                Position : "),_c('b',[_vm._v(_vm._s(_vm.item.position))]),_vm._v(" "),_c('br'),_vm._v("\n                Department : "),_c('b',[_vm._v(_vm._s(_vm.item.department))]),_vm._v(" "),_c('br'),_vm._v("\n                Review Period : "),_c('b',[_vm._v(_vm._s(_vm.getDate(_vm.item.supervisor_date_sign)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                Employee Number : "),_c('b',[_vm._v(_vm._s(_vm.item.employee_no))]),_vm._v(" "),_c('br'),_vm._v("\n                Immediate Supervisor : "),_c('b',[_vm._v(_vm._s(_vm.item.supervisor_name))]),_vm._v(" "),_c('br'),_vm._v("\n                Department Manager : "),_c('b',[_vm._v(_vm._s(_vm.item.department_head))]),_vm._v(" "),_c('br'),_vm._v("\n                Hired Date : "),_c('b',[_vm._v(_vm._s(_vm.item.hire_date))])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 text-center"},[_c('b',[_vm._v("Type of Review")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 p-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 border-left text-center"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),(_vm.item.description != 'Others' )?[_vm._v("("+_vm._s(_vm.item.description)+")")]:[_vm._v("(Others) - "+_vm._s(_vm.item.others))]],2)])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("GENERAL RATING - Mark the appropriate category based on the overall rating for this employee. \n            Any rating above or below \"Meets expectations\" should include a comment.")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 border-right text-center"},[_c('h4',[_c('b',[_vm._v("CRITERIA")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right"},[_c('br'),_c('p',[_vm._v("Consistently Exceeds Expectations")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right"},[_c('br'),_c('p',[_vm._v("Exceeds Expectations in Some Areas or Sometimes")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right"},[_c('br'),_c('p',[_vm._v("Meets Expectations")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right"},[_c('br'),_c('p',[_vm._v("Does Not Meet Some Expectations")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_c('p',[_vm._v("Consistently Falls Below Expectations")])])])]),_vm._v(" "),_c('div',{staticClass:"report-gatter"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 border-right text-center"},[_c('b',[_vm._v("PERFORMANCE")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("5  "),(_vm.item.performance_rating == '5')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("4  "),(_vm.item.performance_rating == '4')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("3  "),(_vm.item.performance_rating == '3')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("2  "),(_vm.item.performance_rating == '2')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-center"},[_vm._v("1 "),(_vm.item.performance_rating == '1')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 border-right"},[_c('p',{staticClass:"mt-5"},[_vm._v(" - Prioritizing assigned task/s, time management, initiative, creativity, adaptability, flexibility, etc. ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"mt-3"},[_c('b',[_vm._v("Comments:")])]),_vm._v(" "),_c('p',{staticClass:"justify-content-center",staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.performance_comments))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 border-right text-center"},[_c('b',[_vm._v("COMMUNICATION")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("5  "),(_vm.item.communication_rating == '5')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("4  "),(_vm.item.communication_rating == '4')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("3  "),(_vm.item.communication_rating == '3')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("2  "),(_vm.item.communication_rating == '2')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-center"},[_vm._v("1 "),(_vm.item.communication_rating == '1')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 border-right"},[_c('p',{staticClass:"mt-5"},[_vm._v(" - Team skills, relationship, responsiveness to customers, etc ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"mt-3"},[_c('b',[_vm._v("Comments:")])]),_vm._v(" "),_c('p',{staticClass:"justify-content-center",staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.communication_comments))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 border-right text-center"},[_c('b',[_vm._v("ADHERANCE")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("5  "),(_vm.item.adherence_rating == '5')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("4  "),(_vm.item.adherence_rating == '4')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("3  "),(_vm.item.adherence_rating == '3')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("2  "),(_vm.item.adherence_rating == '2')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-center"},[_vm._v("1 "),(_vm.item.adherence_rating == '1')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 border-right"},[_c('p',{staticClass:"mt-5"},[_vm._v(" - Confidentiality, attendance, punctuality, reliability, honesty, etc. ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"mt-3"},[_c('b',[_vm._v("Comments:")])]),_vm._v(" "),_c('p',{staticClass:"justify-content-center",staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.adherence_comments))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 border-right text-center"},[_c('b',[_vm._v("A-PLUS VALUES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("5  "),(_vm.item.aplus_value_rating == '5')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("4  "),(_vm.item.aplus_value_rating == '4')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("3  "),(_vm.item.aplus_value_rating == '3')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 border-right text-center"},[_vm._v("2  "),(_vm.item.aplus_value_rating == '2')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-center"},[_vm._v("1 "),(_vm.item.aplus_value_rating == '1')?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 border-right"},[_c('p',{staticClass:"mt-5"},[_vm._v(" - Purpose and commitment, problem solving and environment, accountability, transformative, assessment. ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"mt-3"},[_c('b',[_vm._v("Comments:")])]),_vm._v(" "),_c('p',{staticClass:"justify-content-center",staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.aplus_value_comments))])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full text-center"},[_c('p',{staticClass:"mt-2"},[_c('b',[_vm._v("ACTION PLANS- Individual goals set may which can either be in a general performance area or a more direct related job task. \n                Goals need to be specific , measurable, realistic and time framed.If more than three are appropriate, please attach and additional page.\n            ")])])]),_vm._v(" "),_vm._l((_vm.item.action_plans),function(res,i){return [_c('div',{staticClass:"col-md-12 report-border-full"},[_c('p',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_c('b',[_vm._v("Action Item")]),_vm._v(" # "+_vm._s(i+1)+" "+_vm._s(res.action_item))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('p',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_c('b',[_vm._v("Messure of success :")]),_vm._v(" "+_vm._s(res.messure_of_success))])])]}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-5"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("OVERALL RATING : "),_c('span',{staticClass:"badge-danger rounded p-1"},[_vm._v(" "+_vm._s(_vm.item.overall_rating))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Immediate Supervisor's Comments:")]),_vm._v(" "),_c('p',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.supervisor_comments))])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-5"},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_c('br'),_vm._v(" "),(_vm.item.supervisor_signature === '')?_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v("No signature found .")])])]):_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.item.supervisor_signature,"alt":"..."}})]),_vm._v(" "),(_vm.item.requester_role_id == '2')?_c('div',{staticClass:"report-printed-control"},[_c('b',[_c('center',[_vm._v(_vm._s(_vm._f("uppercase")(_vm.item.supervisor_name)))])],1)]):(_vm.item.requester_role_id == '3')?_c('div',{staticClass:"report-printed-control"},[_c('b',[_c('center',[_vm._v(_vm._s(_vm._f("uppercase")(_vm.item.department_head)))])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),(_vm.item.requester_role_id == '2')?_c('div',[_c('center',[_vm._v("Supervisor Signature")])],1):(_vm.item.requester_role_id == '3')?_c('div',[_c('center',[_vm._v("Department Head Signature")])],1):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 report-border-full"},[_c('b',[_vm._v("Employee's Comments:")]),_vm._v(" "),_c('p',{staticStyle:{"font-family":"Arial, Helvetica, sans-serif","font-size":"initial","padding":"15px","white-space":"pre-line"}},[_vm._v(_vm._s(_vm.item.employee_comments))])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-5"},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_c('br'),_vm._v(" "),(_vm.item.employee_signature === '')?_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v("No signature found .")])])]):_c('div',[_c('div',{staticClass:"report-signature-container"},[_c('img',{staticClass:"report-signature-control",attrs:{"src":_vm.item.employee_signature,"alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"report-printed-control"},[_c('b',[_c('center',[_vm._v(_vm._s(_vm._f("uppercase")(_vm.item.fullname)))])],1)]),_vm._v(" "),_c('div',{staticClass:"report-line-divider"}),_vm._v(" "),_c('center',[_vm._v("Employee Signature")])],1)])])])],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      item: {},
      emp: "",
      no_of_days: "",
      // Errors handler
      error_handler: [],
      no_credits: '',
      //credits
      credits_indicator: '',
      //loading
      loading: true
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.get_employees();
    this.leave_credits();
    this.getItem();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },
  methods: {
    getItem: function getItem() {
      var _this2 = this;

      axios.get("api/leaveabsences/get/" + this.$route.params.id).then(function (response) {
        _this2.item = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    leave_credits: function leave_credits() {
      var _this3 = this;

      axios.get('api/employee/credits/' + this.item.employee_id).then(function (resp) {
        _this3.credits_indicator = resp.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_employees: function get_employees() {
      var _this4 = this;

      axios.get("api/employees").then(function (response) {
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    formSubmit: function formSubmit(e) {
      var _this5 = this;

      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post("api/manualleave/add", {
            // employee_id: this.emp,
            // date_filled: this.date_filled,
            // no_of_days: this.no_of_days,
            // leave_type: this.leave_type,
            // remarks: this.remarks,
            // start_date: this.start_date,
            // end_date: this.end_date,
            // reason: this.reason,
            // status: this.status,
            // tl_status: this.tl_status,
            // asm_status: this.asm_status,
            // tl_date_approved: this.tl_date_approved,
            // asm_date_approved: this.asm_date_approved,
            // hr_date_approved: this.hr_date_approved

          }).then(function (resp) {
            _this5.$swal("Save", "You successfully save this file", "success");
            _this5.$router.push({ name: "absence-leave" });
            _this5.resForm();
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
              _this5.no_credits = error.response.data.message;
              _this5.$swal('Opps', _this5.no_credits, 'error');

              _this5.no_of_days = '';
            }
          });
        }
      });
    }
  },
  computed: {
    countDate: {
      get: function get() {

        var start = moment(this.start_date);
        var end = moment(this.end_date);
        this.no_of_days = end.diff(start, "days") + 1;
        //if NaN result change to 0
        if (isNaN(this.no_of_days)) this.no_of_days = 0;
        return this.no_of_days;
      },
      set: function set(val) {
        this.no_of_days = val;
      }
    }
  }
});

/***/ }),

/***/ "uQLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],

      //FILTER
      search: "",
      order_by: "",
      page_limit: "",
      start_page: 1,
      sortAsc: true,
      //Indicator
      display_indicator: "",
      employees: [],
      loading: true,
      timezoneId: "",
      //------------------------
      schedules: {

        "Day-Shift": [{
          "time": "5AM - 2PM"
        }, {
          "time": "6AM - 3PM"
        }, {
          "time": "7AM - 4PM"
        }, {
          "time": "8AM - 5PM"
        }, {
          "time": "9AM - 6PM"
        }, {
          "time": "10AM - 7PM"
        }, {
          "time": "11AM - 8PM"
        }, {
          "time": "12NN - 9PM"
        }, {
          "time": "1PM - 10PM"
        }, {
          "time": "2PM - 11PM"
        }, {
          "time": "3PM - 12NN"
        }],
        "Mid-Shift": [{
          "time": "11PM - 8AM"
        }, {
          "time": "12NN - 9AM"
        }, {
          "time": "1AM - 10AM"
        }, {
          "time": "2AM - 11AM"
        }, {
          "time": "3AM - 12NN"
        }, {
          "time": "4AM - 1PM"
        }],
        "Night-Shift": [{
          "time": "9PM - 6AM"
        }, {
          "time": "10PM - 7AM"
        }, {
          "time": "8PM - 5AM"
        }, {
          "time": "7PM - 4AM"
        }, {
          "time": "4PM - 1AM"
        }, {
          "time": "5PM - 2AM"
        }, {
          "time": "6PM - 3AM"
        }]
      },
      sched_items: [],
      time_items: [],
      //input data
      employee_id: "",
      selectedSched: "",
      selectedTime: "",

      selected_employee: {},
      error_handler: [],
      //PAGINATION
      perPage: 100,
      curentPage: 1
    };
  },


  mounted: function mounted() {
    this.get_work_shifts();
    this.get_list_of_employee_no_sched();
    this.$store.dispatch("GET_TIMEZONES");
  },

  methods: {
    get_selected_id: function get_selected_id(item) {
      this.selected_employee = item;
    },
    get_work_shifts: function get_work_shifts() {
      var _this = this;

      axios.get('api/workshifts').then(function (response) {
        _this.items = response.data;
        _this.loading = false;
        _this.display_indicator = 2;
      }).catch(function (e) {
        console.log(e.response);
        _this.display_indicator = 1;
      });
    },
    get_list_of_employee_no_sched: function get_list_of_employee_no_sched() {
      var _this2 = this;

      axios.get('api/employeenosched').then(function (response) {
        _this2.employees = response.data;
      }).catch(function (e) {
        console.log(e.response);
      });
    },
    hide_errorHanler: function hide_errorHanler() {
      if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false;
      if (!!this.error_handler.employee_id) this.error_handler.employee_id = false;
      if (!!this.error_handler.schedule) this.error_handler.schedule = false;
      if (!!this.error_handler.time) this.error_handler.time = false;
    },
    add_new_item: function add_new_item(e) {
      var _this3 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/workshifts/add', {
            employee_id: _this3.employee_id,
            schedule: _this3.selectedSched,
            time: _this3.selectedTime,
            timezone_id: _this3.timezoneId
          }).then(function (resp) {
            _this3.$swal('Save', 'You successfully save this file', 'success');
            _this3.get_work_shifts();
            _this3.get_list_of_employee_no_sched();
            _this3.$refs['add-new-item'].hide();
            _this3.employee_id = "";
            _this3.selectedSched = "";
            _this3.selectedTime = "";
            _this3.timezoneId = "";
            _this3.hide_errorHanler();
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this3.error_handler = error.response.data.errors;
            }
            console.log('response => ', error);
          });
        }
      });
    },
    update_schedule: function update_schedule() {
      var _this4 = this;

      axios.post('api/workshifts/update/' + this.selected_employee.id, {
        schedule: this.selectedSched,
        time: this.selectedTime,
        timezone_id: this.timezoneId
      }).then(function (response) {
        _this4.$swal({
          type: 'success',
          title: 'Save',
          text: 'You successfully save',
          showConfirmButton: false,
          timer: 2000
        });
        _this4.get_work_shifts();
        _this4.get_list_of_employee_no_sched();
        _this4.$refs['hide-update-sched'].hide();
        _this4.employee_id = "";
        _this4.selectedSched = "";
        _this4.selectedTime = "";
        _this4.timezoneId = "";
        _this4.hide_errorHanler();
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteItem: function deleteItem(id, index) {
      var _this5 = this;

      /* USING SWEET ALERT */

      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/workshifts/delete/' + id).then(function (response) {
            // this.items.splice(index, 1); //--> reloader 
            _this5.get_work_shifts();
            _this5.get_list_of_employee_no_sched();
            _this5.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response.response);
            _this5.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['timezoneItem']), {
    hide_message_timezone_id: function hide_message_timezone_id() {
      if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false;
    },


    // PAGINATION
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedEmployee: function computedEmployee() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : -_this6.order_by;
          });
          return filtered;
        }
      }
      return filtered;
    }
  }),

  watch: {
    selectedSched: function selectedSched() {
      // Clear previously selected values
      this.sched_items = [];
      this.time_items = [];
      this.selectedTime = "";
      // Populate list of sched_items in the second dropdown
      if (this.selectedSched.length > 0) {
        this.sched_items = this.schedules[this.selectedSched];
      }

      console.log(this.sched_items);
    },
    selectedTime: function selectedTime() {
      // Clear previously selected values
      this.time_items = [];
      // Now we have a continent and sched_index. Populate list of time_items in the third dropdown
      if (this.selectedTime.length > 0) {
        this.time_items = this.schedules[this.selectedSched][this.selectedTime];
      }
    }
  }
});

/***/ }),

/***/ "ubnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('view-responsibility')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uiTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contracts_memo_vue__ = __webpack_require__("WTDM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50167343_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contracts_memo_vue__ = __webpack_require__("Q1YY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contracts_memo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50167343_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contracts_memo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_performance_vue__ = __webpack_require__("rE+x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e88bf4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_performance_vue__ = __webpack_require__("cJf3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_performance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e88bf4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_performance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uwWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("System Users")])]),_vm._v(" "),_c('breadcrumb-menu'),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"90"}},[_vm._v("User Name")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Account Type")]),_vm._v(" "),_c('th',{attrs:{"width":"400"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Password Reset")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Create At")]),_vm._v(" "),_c('th',{attrs:{"width":"30"}},[_vm._v("Update")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedLeave),function(item,i){return _c('tr',[(item === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-user-o"}),_vm._v(" "+_vm._s(item.name))]),_vm._v(" "),_c('td',[(item.role_id == '1')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-primary m-size"},[_vm._v("Office Staff")])]):(item.role_id == '2')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-warning m-size"},[_vm._v("Supervisor")])]):(item.role_id == '3')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v("Assistant Manager")])]):(item.role_id == '4')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-secondary m-size"},[_vm._v("Business Developement Manager")])]):(item.role_id == '5')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v("HR Department")])]):(item.role_id == '6')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Chief Operating Officer")])]):(item.role_id == '7')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Chief Executive Officer")])]):(item.role_id == '8')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Chief Financial Officer")])]):(item.role_id == '9')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Chief Operation Director")])]):(item.role_id == '10')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-success m-size"},[_vm._v("Chief Administrative Officer")])]):(item.role_id == '11')?_c('span',[_c('span',{staticClass:"badge badge-pill badge-danger m-size"},[_vm._v("Operation Manager")])]):_vm._e()]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(item.email)}}),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-key"}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.reset-password-user",modifiers:{"reset-password-user":true}}],attrs:{"href":"#"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('u',[_vm._v("Reset Password")])])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v(" "+_vm._s(_vm.getDate(item.created_at)))]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.update-user-account",modifiers:{"update-user-account":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-primary btn-xs btn-circle",attrs:{"title":"Update User"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_c('i',{staticClass:"fa fa-pencil"})])])]],2)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"hide-user-modal",attrs:{"id":"update-user-account","size":"l","hide-footer":""}},[_c('h3',[_vm._v("Username & Email")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Username:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.name),expression:"selected_item.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Email:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.email),expression:"selected_item.email"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selected_item.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.update_user}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('b-modal',{ref:"hide-reset-form-modal",attrs:{"id":"reset-password-user","size":"l","hide-footer":""}},[_c('h3',[_vm._v("Reset Password")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_password),expression:"new_password"}],staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":(_vm.new_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "),_c('i',[_vm._v("Resseting password for: "),_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selected_item.full_name))+" ?")])])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info float-right",on:{"click":_vm.reset_password}},[_c('i',{staticClass:"fa fa-repeat"}),_vm._v(" Reset password")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v/Rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginbody"},[_c('div',{staticClass:"col-md-3",staticStyle:{"margin":"auto","padding-top":"5%"}},[_c('auth-layout')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v4S7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vAhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/admin'}}},[_vm._v("Human Resource Information System")])],1)])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © Coded"),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Jayvee Ayao at\n      "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Blueprint Business Solutions Corp")]),_vm._v(".\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vHs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Loan & Contributions Info")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.$router.push('/')}}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/contributions/list"}},[_vm._v("Loan & Contributions List")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Loan & Contributions Info")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('div',{staticClass:"report-container"},[_c('table',{staticClass:"p-table",attrs:{"border":"1","width":"100%"}},[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_c('h4',[_c('center',[_vm._v("Blueprint Business Solutions BPO Corporation")])],1)])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_c('p',[_c('center',[_vm._v("4F Norkis Cyberpark, A.S. Fortuna St. Bakilid, Mandaue City, Cebu")])],1)])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("  Employee Name:")])]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_c('b',[_vm._v(_vm._s(_vm.item.full_name))])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("  ID Number:")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm.item.emp_id))]),_vm._v(" "),_c('td',[_c('b',[_vm._v("  Date Covered:")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm.getDate(_vm.item.created_at)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("  TIN:")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(" "+_vm._s(_vm.item.tin_no))]),_vm._v(" "),_c('td',[_c('b',[_vm._v("  Department:")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.item.department_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("  PHIC Number:")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm.item.phic_no))]),_vm._v(" "),_c('td',[_c('b',[_vm._v("  Position:")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.item.position_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("  HDMF Number:")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm.item.hdmf_no))])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('b',[_vm._v("  LOAN AND CONTRIBUTIONS")])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  SSS Contributions")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.sss_cont))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  PHIC Contributions")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.phic_cont))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  HDMF/PAG-IBIG Contributions")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.hdmf_pagibig_cont))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  HMO")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.hmo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  SSS Loan")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.sss_loan))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  HDMF/PAG-IBIG Loan")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.hdmf_loan))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  Wihtholding Tax")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.withholding_tax))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  Others")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4","align":"right"}},[_vm._v("  "+_vm._s(_vm.item.others))])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vMHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vk5y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vkw7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vzty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_performance_vue__ = __webpack_require__("4J9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5741ac28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_performance_vue__ = __webpack_require__("4fJ3");
function injectStyle (ssrContext) {
  __webpack_require__("Se8i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_performance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5741ac28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_performance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Notification Config")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"settings"}},[_vm._v(" Change Password ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"creditconfig"}},[_vm._v(" Leave Credit Config ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Notification Config")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v(" Email Address :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","autocomplete":"off"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"p-text"},[_vm._v(" Password :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save Changes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w3Ya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w42A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_approval_vue__ = __webpack_require__("9Oew");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258fa720_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_approval_vue__ = __webpack_require__("JFSQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258fa720_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w6nZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_nte_request_form__ = __webpack_require__("PVKz");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        nteRequestForm: __WEBPACK_IMPORTED_MODULE_0__todo_nte_request_form__["a" /* default */]
    }
});

/***/ }),

/***/ "w7om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {

      employees: [],
      //input
      employee_id: '',
      date_filled: '',
      date_of_undertime: '',
      total_hours: '',
      purpose: '',
      tl_status: '',
      asm_status: '',
      hr_status: '',
      tl_date_approved: '',
      asm_date_approved: '',
      hr_date_approved: '',
      error_handler: []

    };
  },


  mounted: function mounted() {
    this.get_employees();
  },

  methods: {
    get_employees: function get_employees() {
      var _this = this;

      axios.get('api/employeenodependent').then(function (response) {
        _this.employees = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.post('api/undertimerequest/add', {
            // Undertime request
            employee_id: _this2.employee_id,
            date_filled: _this2.date_filled,
            date_of_undertime: _this2.date_of_undertime,
            total_hours: _this2.total_hours,
            purpose: _this2.purpose,
            tl_status: _this2.tl_status,
            asm_status: _this2.asm_status,
            hr_status: _this2.hr_status,
            tl_date_approved: _this2.tl_date_approved,
            asm_date_approved: _this2.asm_date_approved,
            hr_date_approved: _this2.hr_date_approved
          }).then(function (resp) {
            _this2.$swal('Save', 'You successfully save this file', 'success');
            _this2.$router.push({
              name: 'undertime-request'
            });
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this2.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {}

});

/***/ }),

/***/ "w9Qo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wW7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-contracts')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wgC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('employee-account')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wwXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_create_roles_vue__ = __webpack_require__("mkiZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a82dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_create_roles_vue__ = __webpack_require__("Va+l");
function injectStyle (ssrContext) {
  __webpack_require__("QlOi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_create_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a82dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_create_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wxom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_add_responsibility_form_vue__ = __webpack_require__("Fc+X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f1f7c65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_add_responsibility_form_vue__ = __webpack_require__("Hg73");
function injectStyle (ssrContext) {
  __webpack_require__("9eAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_add_responsibility_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f1f7c65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_add_responsibility_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+wE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_inactive_vue__ = __webpack_require__("u6IG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8221d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_inactive_vue__ = __webpack_require__("G7dM");
function injectStyle (ssrContext) {
  __webpack_require__("DIyc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_inactive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8221d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_inactive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x4uI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x92b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_credits_vue__ = __webpack_require__("TUzY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d670e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_credits_vue__ = __webpack_require__("eK6d");
function injectStyle (ssrContext) {
  __webpack_require__("RhR4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_leave_credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d670e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_leave_credits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('expiration');
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('logOutUser');
        _this.$router.push({ name: 'Login-Layout' });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),

/***/ "xL5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  data: function data() {
    return {
      items: [],
      selected_user: '',
      selected: {},
      leave_status: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //FILTER
      page_limit: '',
      start_page: 1,
      loading: true,
      search: '',
      //Indicator
      display_indicator: '',
      //PAGINATION
      perPage: 200,
      curentPage: 1
    };
  },


  created: function created() {
    this.get_employees();
  },

  methods: {
    deleteItem: function deleteItem(id, index) {
      var _this = this;

      /* USING SWEET ALERT */
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          axios.delete('api/nterequest/delete/' + id).then(function (response) {
            _this.get_employees(); // reloader 
            _this.$swal('Deleted', 'You successfully deleted this file', 'success');
          }).catch(function (response) {
            //alert("error");
            console.log(response);
            _this.$swal('Error Code', 'Review your code', 'error');
          });
        }
      });
    },
    getYear: function getYear() {
      var _this2 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/nterequestbyhr/' + this.filter_by_year).then(function (response) {
          _this2.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    get_employees: function get_employees() {
      var _this3 = this;

      axios.get('api/nterequestbyhr').then(function (response) {
        _this3.items = response.data;
        _this3.loading = false;
        _this3.display_indicator = 2;
      }).catch(function (error) {
        console.log(error.response);
        _this3.display_indicator = 1;
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this4 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this4.search) > -1;
          });
          return filtered;
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }
        // FILTER BY STATUS
        if (this.filter_by_status) {
          filtered = filtered.filter(function (item) {
            return item.hr_status.toLowerCase() === _this4.filter_by_status.toLowerCase();
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this4.order_by : -_this4.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    }
  }

});

/***/ }),

/***/ "xflq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_admin__ = __webpack_require__("bKcs");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AssignMemosAdmin: __WEBPACK_IMPORTED_MODULE_0__todo_assign_memos_admin__["a" /* default */]
    }
});

/***/ }),

/***/ "xiCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contracts_memo_vue__ = __webpack_require__("U6e3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7bb76c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contracts_memo_vue__ = __webpack_require__("z0Ha");
function injectStyle (ssrContext) {
  __webpack_require__("P7sf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contracts_memo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7bb76c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contracts_memo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/Hw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Dependents")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/employeelist"}},[_vm._v("Active Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/resigned"}},[_vm._v("Inactive Employees")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Dependents")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/workshifts"}},[_vm._v("Workshifts")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/scheduleadjustment"}},[_vm._v("Schedule Adjustment")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/undertimerequest"}},[_vm._v("Undertime Request")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/coaching/records"}},[_vm._v("Employee Coached")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('hr',{staticStyle:{"margin-top":"-10px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 float-right"},[_c('router-link',{staticClass:"btn btn-primary float-right",attrs:{"to":"/hr/dependentform"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Register Dependent")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Employee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"test","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-amount-asc"}),_vm._v(" Order by ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_by),expression:"order_by"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.order_by=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("ASC")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("DESC")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('p',[_c('i',{staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_limit),expression:"page_limit"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page_limit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"500"}},[_vm._v("500")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.dependent_item.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive "},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table table-striped table-hover "},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Employee Name")]),_vm._v(" "),_c('th',[_vm._v("Dependents")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_c('i',{staticClass:"fa fa-blind"}),_vm._v("Seniors")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.computedEmployee),function(resp,index){return _c('tr',[(resp === 'no data found')?[_c('td',{attrs:{"colspan":"100%"}},[_c('h4',[_c('i',{staticClass:"fa fa-database"}),_vm._v(" Empty Records ...")])])]:[_c('td',[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm._f("capitalize")(resp.full_name)))]),_vm._v(" "),_c('td',_vm._l((resp.dependents),function(d){return _c('div',[_c('b',[_vm._v("Name of Dependent")]),_vm._v(" :     "+_vm._s(d.name)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Relationship")]),_vm._v(" :    "+_vm._s(d.relationship)),_c('br'),_c('br')])}),0),_vm._v(" "),_c('td',_vm._l((resp.dependents),function(d){return _c('div',[_c('b',[_vm._v("Age")]),_vm._v(" :   "+_vm._s(d.age)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Phic NO")]),_vm._v(":   "+_vm._s(d.phic_no)+" "),_c('br'),_c('br')])}),0),_vm._v(" "),_c('td',_vm._l((resp.seniors),function(s){return _c('div',[_c('b',[_vm._v("senior_citizen")]),_vm._v("   : "+_vm._s(s.senior_citizen)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("middle_initial")]),_vm._v(" : "+_vm._s(s.middle_initial)+" "),_c('br'),_c('br')])}),0),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-xs",attrs:{"to":{name: 'edit-dependent', params: { id: resp.id }},"title":"click to view details and modify records"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Update")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs",on:{"click":function($event){_vm.deleteItem(resp.id, index)}}},[_c('li',{staticClass:"fa fa-trash-o"}),_vm._v("\n                 Delete\n              ")])],1)]],2)}),0)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticStyle:{"color":"#9a9a9a"}},[_vm._v("Page "+_vm._s(_vm.curentPage)+" out of "+_vm._s(_vm.total_item)+" records")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-pagination',{attrs:{"total-rows":_vm.dependent_item.length,"per-page":_vm.perPage,"aria-controls":"my-table","align":"right","first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.curentPage),callback:function ($$v) {_vm.curentPage=$$v},expression:"curentPage"}})],1)]),_vm._v(" "),(_vm.display_indicator === 1)?[_c('center',[_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/warning.png","width":"225","height":"190"}}),_vm._v(" "),_c('h1',[_vm._v("You've lost your network connection")]),_vm._v(" "),_c('h3',[_vm._v("Check your wireless settings, or your network cable, and reload the page.")]),_vm._v(" "),_c('br'),_c('br')])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y0uv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y8R6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yA7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_schedule_adjustment__ = __webpack_require__("kUwZ");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        scheduleAdjustment: __WEBPACK_IMPORTED_MODULE_0__todo_schedule_adjustment__["a" /* default */]
    }
});

/***/ }),

/***/ "yC+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar($event)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",[(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yFbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_list_vue__ = __webpack_require__("kSyJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5ccd58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_list_vue__ = __webpack_require__("4vc8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_contributions_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5ccd58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_contributions_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yL8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("NOTICE TO EXPLAIN")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("NTE Form")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Select Employee")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_previous_infraction]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "),_c('b',[_vm._v("Note")]),_vm._v(": This module will apply a (NTE) Request for employee's. Otherwise employee will notify and receive a NTE form request throught Employee Self Service or "),_c('b',[_vm._v("ESS System")]),_vm._v("."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Corrective Action")]),_vm._v(" "),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 "},[_c('label',[_vm._v("Corrective Action To be Taken")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corrective),expression:"corrective"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.action_to_be_taken},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.corrective=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.dismissal]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One --")]),_vm._v(" "),_c('option',{attrs:{"value":"nte"}},[_vm._v("Notice To Explain")]),_vm._v(" "),_c('option',{attrs:{"value":"suspension"}},[_vm._v("Suspension")]),_vm._v(" "),_c('option',{attrs:{"value":"dismissal"}},[_vm._v("Dismissal")])]),_vm._v(" "),(_vm.error_handler.action_to_be_taken)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.action_to_be_taken[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Request")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_request),expression:"date_request"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_request},attrs:{"type":"date"},domProps:{"value":(_vm.date_request)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_request=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_request)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_request[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Incident")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_incident),expression:"date_incident"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_incident},attrs:{"type":"date"},domProps:{"value":(_vm.date_incident)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_incident=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_incident)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_incident[0]))]):_vm._e()])]),_vm._v(" "),(_vm.corrective == 'nte')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"VW - Verbal Warning"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"VW - Verbal Warning")},on:{"change":function($event){_vm.action_to_be_taken="VW - Verbal Warning"}}}),_vm._v(" VW - Verbal Warning\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 1"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 1")},on:{"change":function($event){_vm.action_to_be_taken="NTE 1"}}}),_vm._v(" NTE 1\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 2"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 2")},on:{"change":function($event){_vm.action_to_be_taken="NTE 2"}}}),_vm._v(" NTE 2\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 3"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 3")},on:{"change":function($event){_vm.action_to_be_taken="NTE 3"}}}),_vm._v(" NTE 3\n               ")],1)]):_vm._e(),_vm._v(" "),(_vm.corrective == 'suspension')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"3 Days Suspension"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"3 Days Suspension")},on:{"change":function($event){_vm.action_to_be_taken="3 Days Suspension"}}}),_vm._v(" 3 Days Suspension\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"10 Days Suspension"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"10 Days Suspension")},on:{"change":function($event){_vm.action_to_be_taken="10 Days Suspension"}}}),_vm._v(" 10 Days Suspension\n               ")],1)]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Infraction Details")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Type of Infraction :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type_of_infraction),expression:"type_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.type_of_infraction},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type_of_infraction=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.get_previous_infraction]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select Infraction Type --")]),_vm._v(" "),_c('option',[_vm._v("i. Attendance and Punctuality")]),_vm._v(" "),_c('option',[_vm._v("ii. Time Keeping Infraction")]),_vm._v(" "),_c('option',[_vm._v("iii. Office Protocol and Decorum")]),_vm._v(" "),_c('option',[_vm._v("iv. Neglect of Duty")]),_vm._v(" "),_c('option',[_vm._v("v. Fraud and Similar Acts Prejudicial to Company Interest")]),_vm._v(" "),_c('option',[_vm._v("vi. Health and Sanitation")]),_vm._v(" "),_c('option',[_vm._v("vii. Company Facilities and Property")]),_vm._v(" "),_c('option',[_vm._v("viii. Insubordination")]),_vm._v(" "),_c('option',[_vm._v("ix. Confidentiality of Work and Information")]),_vm._v(" "),_c('option',[_vm._v("x. The Use of Workstations, Computer, Computer Programs, etc.")]),_vm._v(" "),_c('option',[_vm._v("xi. People Management")]),_vm._v(" "),_c('option',[_vm._v("xii. Policy on Call Handling")]),_vm._v(" "),_c('option',[_vm._v("xiii. Sexual Harrassment")]),_vm._v(" "),_c('option',[_vm._v("xiv. Prohibited Drugs and Paraphernalia")])]),_vm._v(" "),(_vm.error_handler.type_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.type_of_infraction[0]))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.infraction_item != '')?_c('span',[_c('div',{staticClass:"infraction-border"},[_c('b',[_vm._v("Previous Infraction")]),_c('br'),_vm._v(" "),_vm._l((_vm.infraction_item),function(item){return _c('span',[_c('i',{staticClass:"fa fa-stop-circle-o"}),_vm._v(" "+_vm._s(item.type_of_infraction)+" \n                   "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.view-details",modifiers:{"view-details":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.get_selected_id(item)}}},[_vm._v(" "),_c('u',[_vm._v("View Details")])]),_vm._v(" "),_c('br')])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Details of Infraction")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details_of_infraction),expression:"details_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.details_of_infraction},attrs:{"rows":"6"},domProps:{"value":(_vm.details_of_infraction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.details_of_infraction=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.details_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.details_of_infraction[0]))]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"hide-details",attrs:{"id":"view-details","size":"md","hide-footer":""}},[_c('h3',[_vm._v("Infraction Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Date Incident:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.date_incident),expression:"selected_item.date_incident"}],staticClass:"form-control",domProps:{"value":(_vm.selected_item.date_incident)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "date_incident", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Infraction Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.details_of_infraction),expression:"selected_item.details_of_infraction"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.selected_item.details_of_infraction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "details_of_infraction", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Employees Commitment")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.employees_commitment),expression:"selected_item.employees_commitment"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.selected_item.employees_commitment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "employees_commitment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Explanation")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_item.plan_for_improvement),expression:"selected_item.plan_for_improvement"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.selected_item.plan_for_improvement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_item, "plan_for_improvement", $event.target.value)}}})])])])])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_c('u',[_vm._v("ATTACHMENT FILE")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper "},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"nteFiles"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("Attach Files")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"nteFiles","multiple":"multiple","accept":".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif"},on:{"change":_vm.handleNteFilesUpload}}),_vm._v(" "),_vm._l((_vm.error_handler.files),function(item){return _c('span',[_c('li',{staticClass:"invalid-feedback d-block"},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_vm._l((_vm.nteFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2 mt-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.type=='image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):_vm._e(),_vm._v("   \n                            "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                   "),_c('span',{on:{"click":function($event){_vm.removenteFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Details of Occurence")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) This Fields Are Optional")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},_vm._l((_vm.details_of_occurence),function(res,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of Occurence:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.date),expression:"res.date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(res.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Item Description:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.detail),expression:"res.detail"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(res.detail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "detail", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 mt-4"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_form($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.delete_form(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])}),0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0005")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yRtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h3',{staticClass:"card-title"},[_vm._v("ENCODE NOTICE TO EXPLAIN")])]),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right bg-breadcrum"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/hr/nterequest"}},[_vm._v("NTE Tracker")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Encode NTE Manually")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-10px"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Select Employee")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee_id),expression:"employee_id"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employee_id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.employee_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select One --")]),_vm._v(" "),_vm._l((_vm.employees),function(emp){return _c('option',{domProps:{"value":emp.id}},[_vm._v(_vm._s(_vm._f("capitalize")(emp.full_name)))])})],2),_vm._v(" "),(_vm.error_handler.employee_id)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employee_id[0]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "),_c('b',[_vm._v("Note")]),_vm._v(": This module you can encode your previous record manually without the use of Employee Self Service or "),_c('b',[_vm._v("ESS System")]),_vm._v("."),_c('br'),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Corrective Action")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 "},[_c('label',[_vm._v("Corrective Action To be Taken")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corrective),expression:"corrective"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.action_to_be_taken},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.corrective=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.dismissal]}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select One --")]),_vm._v(" "),_c('option',{attrs:{"value":"nte"}},[_vm._v("Notice To Explain")]),_vm._v(" "),_c('option',{attrs:{"value":"suspension"}},[_vm._v("Suspension")]),_vm._v(" "),_c('option',{attrs:{"value":"dismissal"}},[_vm._v("Dismissal")])]),_vm._v(" "),(_vm.error_handler.action_to_be_taken)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.action_to_be_taken[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Request")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_request),expression:"date_request"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_request},attrs:{"type":"date"},domProps:{"value":(_vm.date_request)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_request=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_request)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_request[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Incident")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_incident),expression:"date_incident"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.date_incident},attrs:{"type":"date"},domProps:{"value":(_vm.date_incident)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_incident=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.date_incident)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.date_incident[0]))]):_vm._e()])]),_vm._v(" "),(_vm.corrective == 'nte')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"VW - Verbal Warning"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"VW - Verbal Warning")},on:{"change":function($event){_vm.action_to_be_taken="VW - Verbal Warning"}}}),_vm._v(" VW - Verbal Warning\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 1"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 1")},on:{"change":function($event){_vm.action_to_be_taken="NTE 1"}}}),_vm._v(" NTE 1\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 2"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 2")},on:{"change":function($event){_vm.action_to_be_taken="NTE 2"}}}),_vm._v(" NTE 2\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"NTE 3"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"NTE 3")},on:{"change":function($event){_vm.action_to_be_taken="NTE 3"}}}),_vm._v(" NTE 3\n               ")],1)]):_vm._e(),_vm._v(" "),(_vm.corrective == 'suspension')?_c('div',[_c('div',{staticClass:"col-md-12 "},[_c('font',{attrs:{"color":"red"}},[_vm._v("Select one for your employee action")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"3 Days Suspension"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"3 Days Suspension")},on:{"change":function($event){_vm.action_to_be_taken="3 Days Suspension"}}}),_vm._v(" 3 Days Suspension\n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action_to_be_taken),expression:"action_to_be_taken"}],attrs:{"type":"radio","value":"10 Days Suspension"},domProps:{"checked":_vm._q(_vm.action_to_be_taken,"10 Days Suspension")},on:{"change":function($event){_vm.action_to_be_taken="10 Days Suspension"}}}),_vm._v(" 10 Days Suspension\n               ")],1)]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Infraction Details")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Type of Infraction :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type_of_infraction),expression:"type_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.type_of_infraction},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type_of_infraction=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--Select Infraction Type --")]),_vm._v(" "),_c('option',[_vm._v("i. Attendance and Punctuality")]),_vm._v(" "),_c('option',[_vm._v("ii. Time Keeping Infraction")]),_vm._v(" "),_c('option',[_vm._v("iii. Office Protocol and Decorum")]),_vm._v(" "),_c('option',[_vm._v("iv. Neglect of Duty")]),_vm._v(" "),_c('option',[_vm._v("v. Fraud and Similar Acts Prejudicial to Company Interest")]),_vm._v(" "),_c('option',[_vm._v("vi. Health and Sanitation")]),_vm._v(" "),_c('option',[_vm._v("vii. Company Facilities and Property")]),_vm._v(" "),_c('option',[_vm._v("viii. Insubordination")]),_vm._v(" "),_c('option',[_vm._v("ix. Confidentiality of Work and Information")]),_vm._v(" "),_c('option',[_vm._v("x. The Use of Workstations, Computer, Computer Programs, etc.")]),_vm._v(" "),_c('option',[_vm._v("xi. People Management")]),_vm._v(" "),_c('option',[_vm._v("xii. Policy on Call Handling")]),_vm._v(" "),_c('option',[_vm._v("xiii. Sexual Harrassment")]),_vm._v(" "),_c('option',[_vm._v("xiv. Prohibited Drugs and Paraphernalia")])]),_vm._v(" "),(_vm.error_handler.type_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.type_of_infraction[0]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Details of Infraction")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details_of_infraction),expression:"details_of_infraction"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.details_of_infraction},attrs:{"rows":"6"},domProps:{"value":(_vm.details_of_infraction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.details_of_infraction=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.details_of_infraction)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.details_of_infraction[0]))]):_vm._e()])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_c('u',[_vm._v("ATTACHMENT FILE")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper "},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"nteFiles"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("Attach Files")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"nteFiles","multiple":"multiple","accept":".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif"},on:{"change":_vm.handleNteFilesUpload}}),_vm._v(" "),_vm._l((_vm.error_handler.files),function(item){return _c('span',[_c('li',{staticClass:"invalid-feedback d-block"},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_vm._l((_vm.nteFiles),function(file,key){return _c('div',{key:key,staticClass:"mb-2 mt-2"},[(file.type == 'application/pdf')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x"})]):(file.type=='application/msword')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-word-o fa-2x"})]):(file.type=='image/jpeg')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):(file.type=='image/png')?_vm._t("default",[_c('i',{staticClass:"fa fa-file-image-o fa-2x"})]):_vm._e(),_vm._v("   \n                         "+_vm._s(file.name)+" - "+_vm._s(file.size)+"\n                "),_c('span',{on:{"click":function($event){_vm.removenteFilesUpload(key)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red","cursor":"pointer"}})])],2)})],2),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-wpforms"}),_vm._v(" Details of Occurence")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) This Fields Are Optional")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},_vm._l((_vm.details_of_occurence),function(res,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of Occurence:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.date),expression:"res.date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(res.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Item Description:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(res.details),expression:"res.details"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(res.details)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(res, "details", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 mt-4"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.add_form($event)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.delete_form(index)}}},[_c('i',{staticClass:"fa fa-minus"})])])])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Employees Commitment")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Plan for Improvement:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan_for_improvement),expression:"plan_for_improvement"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.plan_for_improvement},attrs:{"rows":"8"},domProps:{"value":(_vm.plan_for_improvement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.plan_for_improvement=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.plan_for_improvement)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.plan_for_improvement[0]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Employee's Commitment :")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.employees_commitment),expression:"employees_commitment"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.employees_commitment},attrs:{"rows":"8"},domProps:{"value":(_vm.employees_commitment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.employees_commitment=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.employees_commitment)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.employees_commitment[0]))]):_vm._e()])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('font',{staticClass:"title-section",attrs:{"color":"#4285f4"}},[_c('i',{staticClass:"fa fa-balance-scale"}),_vm._v("  Notice for Decision")]),_c('font',{staticClass:"float-right",attrs:{"size":"2","color":"red"}},[_vm._v("Note: (*) All Fields Are Required")]),_vm._v(" "),_c('div',{staticClass:"border-box-nte"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("HR/Admin Decision for Employee NTE:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.hr_notice_for_decision),expression:"hr_notice_for_decision"}],staticClass:"form-control",class:{ 'is-invalid': _vm.error_handler && _vm.error_handler.hr_notice_for_decision},attrs:{"rows":"8"},domProps:{"value":(_vm.hr_notice_for_decision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hr_notice_for_decision=$event.target.value}}}),_vm._v(" "),(_vm.error_handler.hr_notice_for_decision)?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.error_handler.hr_notice_for_decision[0]))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"float-right"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info"},[_c('i',{staticClass:"fa fa-location-arrow"}),_vm._v(" Submit Request")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('p',[_vm._v("HR FORM NO. 0005")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ycpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_info_vue__ = __webpack_require__("g90p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efec4dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_info_vue__ = __webpack_require__("RYAK");
function injectStyle (ssrContext) {
  __webpack_require__("zykv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_edit_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efec4dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_edit_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ynpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_info_vue__ = __webpack_require__("JDpA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68226969_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_info_vue__ = __webpack_require__("XA5U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_edit_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68226969_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_edit_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ys/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_wfh_responsibility_vue__ = __webpack_require__("a1av");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_711c1c5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_wfh_responsibility_vue__ = __webpack_require__("dJmD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_wfh_responsibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_711c1c5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_wfh_responsibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z0Ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contracts-memo')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zA7R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zDRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todo_dependents__ = __webpack_require__("qGmu");
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Dependents: __WEBPACK_IMPORTED_MODULE_0__todo_dependents__["a" /* default */]
    }
});

/***/ }),

/***/ "zS8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assistant_manager_vue__ = __webpack_require__("6KaH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abcb994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assistant_manager_vue__ = __webpack_require__("IHO/");
function injectStyle (ssrContext) {
  __webpack_require__("JVSk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_assistant_manager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abcb994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_assistant_manager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false,
      user: ''
    };
  },


  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      //return value.charAt(0).toUpperCase() + value.slice(1); -> capitalize first 
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }); // -> capitalize each first words
    }
  }
});

/***/ }),

/***/ "zbiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('assign-contracts-all')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zg1b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            roles: [],
            employees: [],
            supervisor: [],
            operations: [],
            user_roles: '',
            belongs_to: '',
            employee_id: '',
            username: '',
            email: '',
            superior_name: {},
            password: 'Blueprint@111',
            error_handler: [],
            assign_to: '',
            sub_department_item: [],
            subordinates: []
        };
    },

    mounted: function mounted() {
        this.get_roles();
        this.get_employees();
        this.get_supervisor();
        this.get_superiorname();
        this.get_belongs();
        this.get_operation();
        this.get_sub_department();
    },
    methods: {
        concat_email: function concat_email() {
            if (this.username.length == 0) {
                this.email = "";
            } else {
                this.email = this.username + "@blueprintbusinesssolutionscorp.com";
            }

            console.log("test", this.email);
        },
        get_sub_department: function get_sub_department() {
            var _this = this;

            axios.get('api/subdepartment/all').then(function (response) {
                _this.sub_department_item = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_belongs: function get_belongs() {
            if (this.assign_to == 'admin') {
                this.superior_name = { 'full_name': 'ADMIN' };
                console.log(this.superior_name);
            }
        },
        get_employees: function get_employees() {
            var _this2 = this;

            axios.get('api/employeenotregistered').then(function (response) {
                _this2.employees = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_superiorname: function get_superiorname() {
            var _this3 = this;

            if (this.assign_to == 'supervisor' && this.belongs_to != '') {
                axios.get('api/superiorname/get/' + this.belongs_to).then(function (response) {
                    _this3.superior_name = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                });
            }
        },
        get_operation: function get_operation() {
            var _this4 = this;

            axios.get('api/operation').then(function (response) {
                _this4.operations = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_supervisor: function get_supervisor() {
            var _this5 = this;

            axios.get('api/supervisor').then(function (resp) {
                _this5.supervisor = resp.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        get_roles: function get_roles() {
            var _this6 = this;

            axios.get('api/allroles').then(function (response) {
                _this6.roles = response.data;
            }).catch(function (error) {
                console.log(error.response);
            });
        },
        formSubmit: function formSubmit(e) {
            var _this7 = this;

            e.preventDefault();

            console.log(this.subordinates);
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to register new user',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false
            }).then(function (isConfirm) {
                if (isConfirm === true) {
                    axios.post('api/register', {
                        role_id: _this7.user_roles,
                        name: _this7.username,
                        email: _this7.email,
                        password: _this7.password,
                        superior_name: _this7.superior_name.full_name,
                        employee_id: _this7.employee_id,
                        belongs_to: _this7.belongs_to,
                        subordinates: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this7.subordinates)
                    }).then(function (resp) {
                        if (resp.data.response == 'success') {
                            _this7.$swal('Save', resp.data.message, 'success');
                            _this7.$router.push({ name: 'users' });
                            _this7.username = '';
                            _this7.password = '';
                        } else if (resp.data.response == 'error') {
                            _this7.$swal('Error', resp.data.message, 'error');
                        }
                    }).catch(function (error) {
                        // if (error.response.status == 422){
                        //      this.error_handler = error.response.data.error_pointer  
                        // }
                        console.log(error);
                    });
                }
            });
        }
    },
    computed: {}

});

/***/ }),

/***/ "zlaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contact_info_vue__ = __webpack_require__("rXcQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9866c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contact_info_vue__ = __webpack_require__("npX0");
function injectStyle (ssrContext) {
  __webpack_require__("ND2J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_contact_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9866c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_contact_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zmQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nte-manual-input')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zrsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import {mapState} from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      item: {},
      emp_id: '',
      full_name: '',
      document_type: '',
      memoFiles: [],
      files: {},
      uploadReady: true,
      //INPUT
      file_added: '',
      error_handler: [],
      items: [],
      selected_user: '',
      selected: {},
      search: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year: '',
      //SORTING
      page_limit: '',
      start_page: 1,
      loading: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
      selectedRoute: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getAllEmployees();
    setTimeout(function () {
      _this.loading = false;
    }, 300);
  },

  methods: {
    goToRoute: function goToRoute() {
      if (this.selectedRoute) {
        this.$router.push(this.selectedRoute);
      }
    },
    getCurentUser: function getCurentUser() {
      var _this2 = this;

      axios.get('api/user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        _this2.currentUser = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getYear: function getYear() {
      var _this3 = this;

      if (this.filter_by_year == '') {
        this.get_employees();
      } else {
        axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year).then(function (response) {
          _this3.items = response.data;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    getAllEmployees: function getAllEmployees() {
      var _this4 = this;

      axios.get('api/contractsmemocdpq', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {
        // console.log(response.data)
        _this4.items = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    openFileDialog: function openFileDialog() {
      this.$refs.files.click(); // Opens the hidden file input
    },

    //FILE UPLOAD
    handleFileMemosUpload: function handleFileMemosUpload() {
      var uploadedContractFiles = event.target.files;
      if (!uploadedContractFiles.length) return;
      for (var i = 0; i < uploadedContractFiles.length; i++) {
        this.memoFiles.push(uploadedContractFiles[i]);
      }
      console.log('response => ', uploadedContractFiles);
    },
    removeMemoFilesUpload: function removeMemoFilesUpload(key) {
      this.memoFiles.splice(key, 1);
    },


    /*
    |----------------------------------------------------------------------
    |  TO SUBMIT FORM 
    |----------------------------------------------------------------------
    */
    formSubmit: function formSubmit() {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload these documents',
        type: 'warning',
        showCancelButton: true,
        showCloseButton: false
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          //Form data a files to upload
          var formData = new FormData();
          if (_this5.memoFiles.length > 0) {
            for (var i = 0; i < _this5.memoFiles.length; i++) {
              var file = _this5.memoFiles[i];
              formData.append('files[' + i + ']', file);
              //   console.log(formData);
            }
          } else {
            _this5.$swal({
              title: 'Empty document!',
              text: 'Please upload at least one document',
              type: 'error',
              showCloseButton: false
            });
            return;
          }

          //HTTP POST Request
          axios.post('api/assignmemos/cdpq', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then(function (resp) {
            _this5.$swal('Success', 'Memo has been successfully assigned', 'success');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp.data));
          }).catch(function (error) {
            if (error.response.status == 422) {
              _this5.error_handler = error.response.data.errors;
            }
            console.log('response => ', error.response);
          });
        }
      });
    }
  },
  computed: {
    offset: function offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit: function limit() {
      return this.offset + this.page_limit;
    },
    total_item: function total_item() {
      return this.items.length;
    },
    computedRequest: function computedRequest() {
      var _this6 = this;

      var filtered = this.items;
      // USE IN PAGINATION 
      var start = (this.curentPage - 1) * this.perPage;
      var end = this.curentPage * this.perPage;
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered;
        }

        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
          filtered = filtered.filter(function (item) {
            return item.full_name.toLowerCase().indexOf(_this6.search) > -1;
          });
          return filtered;
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort(function (a, b) {
            return a.full_name < b.full_name ? _this6.order_by : _this6.order_by;
          });
          return filtered;
        }
      } else {
        filtered = 0;
      }

      return filtered;
    },
    filePreview: function filePreview() {
      var data = window.axios.defaults.baseURL + '/upload/';
      return data;
    }
  }
});

/***/ }),

/***/ "ztaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_requirements_vue__ = __webpack_require__("bDRl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eed6ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_requirements_vue__ = __webpack_require__("sEys");
function injectStyle (ssrContext) {
  __webpack_require__("j/FY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_requirements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eed6ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ztwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('responsibility-form')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zykv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0612835a8ab63d1302bd.js